import React from "react";

export const backOSvg = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 63.48 35.97"
      {...customStyles}
    >
      <path d="M62.48,17H3.4L18.67,1.71A1,1,0,1,0,17.26.29l-17,17a1.05,1.05,0,0,0,0,1.45l17,17A1,1,0,0,0,18,36a1,1,0,0,0,.7-.29,1,1,0,0,0,0-1.42L3.4,19H62.48a1,1,0,0,0,0-2Z" />
    </svg>
  );
};

export const crossOSvg = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62.81 62.81"
      {...customStyles}
    >
      <path d="M32.82,31.41l29.7-29.7A1,1,0,1,0,61.1.29L31.41,30,1.71.29A1,1,0,0,0,.29,1.71L30,31.41.29,61.1a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l29.7-29.7L61.1,62.52a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42Z" />
    </svg>
  );
};

export const LmuBoltSvg = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 186.49 235.47"
      {...customStyles}
    >
      <title>Lmu-line_1</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M166.3,114.1l-45.83-10.46a2.17,2.17,0,0,1-1.32-3.33L181.1,8.4a2.17,2.17,0,0,0-3.06-3l-159,112.32a2.17,2.17,0,0,0,.77,3.89l46,10.51a2.17,2.17,0,0,1,1.31,3.33L5.39,227.07a2.17,2.17,0,0,0,3.05,3L167.07,118A2.17,2.17,0,0,0,166.3,114.1Z" />
        </g>
      </g>
    </svg>
  );
};

export const StatsSvg = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.95 112.91"
      {...customStyles}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Ñëîé_1" data-name="Ñëîé 1">
          <path d="M72.92,24.08,49.42.57A2.07,2.07,0,0,0,48,0H2A2,2,0,0,0,0,2V92.89a2,2,0,0,0,2,2H37.51c-.9-1.33-1.83-2.84-2.46-4H4V4H46V25.67a2,2,0,0,0,2,2H69.68V54.23a33.48,33.48,0,0,1,4,2.54V25.94a.77.77,0,0,0,0-.27A2,2,0,0,0,72.92,24.08ZM50,23.68V6.82L66.86,23.68Z" />
          <path d="M89.69,112.91a4.19,4.19,0,0,1-3-1.23L73.24,98.22a23,23,0,1,1,7.38-8.65l14.1,14.1a4.22,4.22,0,0,1,0,6l-2.07,2.05A4.14,4.14,0,0,1,89.69,112.91ZM73.53,92.84l16,16a.24.24,0,0,0,.29,0l2.08-2.06a.22.22,0,0,0,0-.31L75.66,90.26l.77-1.33A19.27,19.27,0,1,0,72.12,94Z" />
          <path d="M13.84,54.71a2,2,0,0,1-1.38-.55,2,2,0,0,1-.07-2.83l11-11.62a2,2,0,0,1,2.72-.17l4.64,3.81,8.18-8.17A2,2,0,0,1,41.57,35l10,7.85,6.23-6.48a2,2,0,0,1,2.88,2.77L53.2,46.94a2,2,0,0,1-2.67.19l-10-7.88-8.2,8.21a2,2,0,0,1-2.68.13L25,43.81,15.29,54.08A2,2,0,0,1,13.84,54.71Z" />
          <path d="M52.63,89.17a2,2,0,0,1-2-2V79.3a2,2,0,0,1,4,0v7.87A2,2,0,0,1,52.63,89.17Z" />
          <path d="M59.25,89.17a2,2,0,0,1-2-2V75.81a2,2,0,0,1,4,0V87.17A2,2,0,0,1,59.25,89.17Z" />
          <path d="M65.87,89.17a2,2,0,0,1-2-2V71.07a2,2,0,0,1,4,0v16.1A2,2,0,0,1,65.87,89.17Z" />
        </g>
      </g>
    </svg>
  );
};

export const pencilSvg = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      {...customStyles}
    >
      <path d="M62.08,4.55,59.45,1.92a6.58,6.58,0,0,0-9.29,0l-42,42a1,1,0,0,0-.22.31L.08,62.6a1,1,0,0,0,.21,1.1A1,1,0,0,0,1,64a1,1,0,0,0,.39-.08L19.77,56a1.06,1.06,0,0,0,.31-.21l42-42A6.57,6.57,0,0,0,62.08,4.55ZM9.38,46,18,54.62,2.9,61.09Zm9.56,8.15L9.86,45.05,45.92,9,55,18.08ZM60.66,12.42l-4.95,5L46.63,8.29l4.95-5a4.57,4.57,0,0,1,6.46,0L60.66,6A4.57,4.57,0,0,1,60.66,12.42Z" />
    </svg>
  );
};

export const InfoCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <text
        id="i"
        transform="translate(8 14)"
        fill="#fff"
        fontSize="13"
        fontFamily="Nunito-Regular, Nunito"
      >
        <tspan x="0" y="0">
          i
        </tspan>
      </text>
      <g
        id="Ellipse_3"
        data-name="Ellipse 3"
        fill="none"
        stroke="#fff"
        strokeWidth="1"
      >
        <circle cx="9.5" cy="9.5" r="9.5" stroke="none" />
        <circle cx="9.5" cy="9.5" r="9" fill="none" />
      </g>
      <text
        id="i-2"
        data-name="i"
        transform="translate(8 14)"
        fill="#fff"
        fontSize="13"
        fontFamily="Nunito-Regular, Nunito"
      >
        <tspan x="0" y="0">
          i
        </tspan>
      </text>
      <g
        id="Ellipse_4"
        data-name="Ellipse 4"
        fill="none"
        stroke="#fff"
        strokeWidth="1"
      >
        <circle cx="9.5" cy="9.5" r="9.5" stroke="none" />
        <circle cx="9.5" cy="9.5" r="9" fill="none" />
      </g>
    </svg>
  );
};

export const BicepSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="85.462"
      height="74.624"
      viewBox="0 0 85.462 74.624"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 -0.005)">
        <g id="icon" transform="translate(0 0.005)">
          <path
            id="Path_35"
            data-name="Path 35"
            d="M82.02,40.993c-5.84-7.3-21.228-8.585-25.184.686a15.242,15.242,0,0,0-7.3-5.3,17.636,17.636,0,0,0-18.8,4.38V39.709c0-6.161-.175-13.3,2.073-19.2a9.782,9.782,0,0,0,6.672,2.278c4.978-.234,9.679-.628,11.68-5.913,1.869-4.964-.292-10.687-3.737-14.366C45.01,0,44.105-.134,40.587.071a88.241,88.241,0,0,0-10.38.993c-5.723,1.037-10.482,9.825-13.227,14.6C8.76,29.576,1.212,44.95,0,61.316a.993.993,0,0,0,.511.876c21.695,14.293,53.741,17.432,76.428,3.256C85.2,60.308,88.546,49.154,82.02,40.993Zm-6.774,23.1c-11.869,6.935-26.454,9.242-40.017,8.059a74.691,74.691,0,0,1-20.235-4.657,67.9,67.9,0,0,1-10.22-4.964C.642,60.075,2.628,55.009,3.591,50.965A104.007,104.007,0,0,1,12.351,28.5C15.884,21.474,19.49,14.32,24.513,8.232a15.811,15.811,0,0,1,4.876-4.57c2.57-1.27,5.84-1.226,8.76-1.46,2.57-.161,5.2-.555,7.4,1.2a12.76,12.76,0,0,1,3.81,6.526c.774,2.92.54,7.139-2.146,9.11-1.883,1.46-4.5,1.46-6.8,1.65a10.219,10.219,0,0,1-2.1.175c-1.84-.219-5.066-2.234-3.431-4.526.7-.993,3.664-1.46,4.789-1.46a1.022,1.022,0,0,0,0-2.029c-2.453-.073-7.665,1.372-8,4.467a4.38,4.38,0,0,0,0,.759c-2.132,4.584-2.511,9.811-2.73,14.8-.131,2.73,0,5.5-.161,8.22-.38,5.066-3.883,9.1-7.3,12.6a1.032,1.032,0,1,0,1.46,1.46c3.372-3.4,6.132-6.716,7.3-10.877a1.329,1.329,0,0,0,.234-.19c4.832-5.84,11.68-8.468,18.979-5.577,2.7,1.066,5.738,3.153,6.745,6.059.292.861,1.767,1.066,1.956,0,2.146-11.519,19.709-8.351,23.812.117C85.553,52.323,82.181,60.046,75.246,64.09Z"
            transform="translate(0 -0.005)"
            fill="#27debf"
          />
          <path
            id="Path_36"
            data-name="Path 36"
            d="M43.781,37.794A13.359,13.359,0,0,1,33.2,41.633c-4.161-.263-7.986-.847-11.49-3.226-1.08-.73-2.1,1.037-1.022,1.767,4.117,2.789,8.935,3.416,13.826,3.562,4.38.117,7.49-1.664,10.7-4.5C46.176,38.363,44.716,36.932,43.781,37.794Z"
            transform="translate(9.303 17.254)"
            fill="#27debf"
          />
          <path
            id="Path_37"
            data-name="Path 37"
            d="M23.918,34.194a10.57,10.57,0,0,1,4.38-3.913,1.022,1.022,0,0,0-1.022-1.767,12.424,12.424,0,0,0-5.1,4.643C21.567,34.326,23.334,35.362,23.918,34.194Z"
            transform="translate(10.143 13.058)"
            fill="#27debf"
          />
          <path
            id="Path_38"
            data-name="Path 38"
            d="M28.144,29.639a1.022,1.022,0,1,0-.9-1.015A1.022,1.022,0,0,0,28.144,29.639Z"
            transform="translate(12.531 12.692)"
            fill="#27debf"
          />
        </g>
      </g>
    </svg>
  );
};

export const HeartMeterSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58.73 53.49"
      width="85px"
      height="75px"
      fill="#27debf"
    >
      <defs></defs>
      <title>Asset 2</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path
            className="cls-1"
            d="M45.32.32c-6.48-1-13.48,2.45-15.73,8.57A13.87,13.87,0,0,0,23.39,2C18.82-.55,14.33-.59,9.44,1.47,5.66,3.06,2.7,7.25,1.12,10.89c-2,4.6-1,10.23.26,14.89a.7.7,0,0,0,1.34-.37C.66,17.63,1,9,8.09,3.84,11.42,1.39,17.15.53,20.85,2.22c3.88,1.77,7.74,5.24,8,9.77a.7.7,0,0,0,1.39,0c.73-8.3,10.91-12.73,18-9.35,7.58,3.6,10.78,13.77,8.28,21.48C55,29,48.79,27.78,44.68,27.81c-2.33,0-4.67,0-7,0-.32,0-1.61,0-1.57,0-.37-.23-1.31-3-1.54-3.58a.69.69,0,0,0-1.36.18c-.46,3.61-1.41,7.12-2.15,10.68-.73-6-1-12-2-18a.71.71,0,0,0-1.35,0q-1.44,6.22-2.87,12.45l-1.29-5.78c-.14-.64-1.23-.68-1.34,0-.15,1-.39,3.56-1,4-.44.31-2.1,0-2.68,0l-7.59-.05c-2.76,0-7.1-.57-7,3.58.06,2.17,2.07,4.37,3.36,6a38.28,38.28,0,0,0,6.43,6.16c4.81,3.77,10.19,6.69,15.39,9.88a.72.72,0,0,0,.71,0A77.25,77.25,0,0,0,53.52,33.18c.55-.69-.43-1.68-1-1A73.27,73.27,0,0,1,37.35,47.07c-1.87,1.29-6,5-8.28,4.69-1.09-.16-2.6-1.55-3.55-2.12-1.47-.86-2.93-1.73-4.37-2.64a66,66,0,0,1-9.06-6.61c-1.68-1.51-10-9.51-4.53-11.22,2.08-.64,5.48,0,7.66,0l6.48,0a.7.7,0,0,0,.68-.51c.16-.53.31-1.05.46-1.58L24.13,33a.71.71,0,0,0,1.35,0l2.73-11.83c.79,6.19,1.07,12.44,2.1,18.61.14.84,1.28.52,1.37-.19.53-4.2,1.72-8.27,2.49-12.43a3.12,3.12,0,0,0,2.4,2.08c3.15.51,6.85,0,10,0,2.93,0,6.83.63,9.28-1.35,2.12-1.72,2.54-4.76,2.77-7.3C59.41,11.92,54.68,1.73,45.32.32Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const WheySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44.7 57.67"
      width="85px"
      height="75px"
      fill="#27debf"
    >
      <title>Asset 3</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M44.59,36.4c-.11-3-.22-6-.19-9,0-3.28.4-6.2-.73-9.35a13.07,13.07,0,0,0-3.48-5.67c-1.14-1-3.38-1.46-4.26-2.59a3.05,3.05,0,0,1-.28-1.85,12.22,12.22,0,0,0,1.71,0c.52,0,1-.27,1.06-.85.06-.79-.65-1-1.42-1,0-1.66.29-3.73-.16-5.32a.68.68,0,0,0-.48-.48c-2-.51-4.53,0-6.6,0-3.15.06-6.29.09-9.45.05-2.76,0-5.52,0-8.28,0C10.67.3,9-.18,7.94.85A.59.59,0,0,0,7.81,1h0a.57.57,0,0,0-.06.25s0,0,0,0c-.06,1.52,0,3,0,4.53-.77,0-1.42.22-1.29,1,.09.57.65.7,1.14.68a14.31,14.31,0,0,1,1.73,0,15.13,15.13,0,0,1,.15,1.7l0,0h0c-.31.53-1.73,1.1-2.2,1.45A17.22,17.22,0,0,0,2.1,16.46C-.66,21.67.05,27.49.16,33.16.22,36.42.26,39.69.3,43c0,3-.32,6.41.16,9.42.72,4.51,4.4,5,8.34,5,4.7,0,9.4-.16,14.11-.09,5.62.08,11.68.83,17.25-.09,3.93-.65,4.43-3.24,4.48-6.68C44.7,45.85,44.76,41.08,44.59,36.4ZM1.75,48c-.06-5.35-.12-10.7-.22-16a72.61,72.61,0,0,1,.06-8.35c13.78-.3,27.9-1.43,41.62.09,0,1.55-.16,3.12-.17,4.63,0,2.54,0,5,.12,7.55.2,3.9,0,7.82.05,11.72,0,.25,0,.5,0,.75-1.39-.07-2.69.24-4.12.31-2,.1-4-.21-6-.21-3.53,0-7.26-.2-10.76.06a68.22,68.22,0,0,1-10.21.08c-3.46-.23-6.89.12-10.34.22C1.76,48.53,1.75,48.26,1.75,48Zm9-38.9a14.14,14.14,0,0,0-.08-2.16c7.89-.35,15.8.42,23.68.13V9.32C26.44,9.18,18.56,9.23,10.7,9.09Zm5.15-7.44c3,0,6,.08,8.93.06,2.48,0,5-.09,7.44-.13,2.06,0,2.86-.41,3.35,1.61A2.2,2.2,0,0,1,35,5.67c-.5.33-3,.1-3.67.1-1.34,0-2.68,0-4-.09-2.73-.11-5.46-.2-8.19-.17-3,0-6,.09-9,.09-.52,0-.87,0-1.09,0A14.66,14.66,0,0,1,9.1,1.72C10.26,1.1,14.71,1.66,15.85,1.65ZM5.71,13.83c1.17-1.19,3.47-2.08,4.49-3.36,8.2.16,16.41.1,24.61.25C39,13,42,15.59,43,20.49a12,12,0,0,1,.22,1.79c-13.66-1.51-27.7-.4-41.42-.09A14.51,14.51,0,0,1,5.71,13.83ZM37.45,56c-8.34.4-16.75,0-25.1,0-1.94,0-3.94.14-5.88,0-3.91-.29-4.56-2.87-4.68-5.81,3.23-.1,6.45-.45,9.68-.26a76.89,76.89,0,0,0,10.84,0c3.31-.25,6.77,0,10.1-.05,2,0,4,.23,6,.21,1.58,0,3.24-.4,4.82-.31,0,.67,0,1.34,0,2C43,55.36,40.62,55.8,37.45,56Z" />
          <path d="M11.64,4.41c0-.53,0-1.05,0-1.57,0-.9-1.35-.89-1.39,0,0,.52,0,1,0,1.57A.7.7,0,0,0,11.64,4.41Z" />
          <path d="M23,4.41c0-.53,0-1.05,0-1.57,0-.9-1.35-.89-1.39,0,0,.52,0,1,0,1.57A.7.7,0,0,0,23,4.41Z" />
          <path d="M15.41,4.41c0-.53,0-1.05,0-1.57,0-.9-1.36-.89-1.4,0,0,.52,0,1,0,1.57A.7.7,0,0,0,15.41,4.41Z" />
          <path d="M19.19,4.41c0-.53,0-1.05,0-1.57,0-.9-1.35-.89-1.39,0,0,.52,0,1,0,1.57A.7.7,0,0,0,19.19,4.41Z" />
          <path d="M26.74,4.41c0-.53,0-1.05,0-1.57,0-.9-1.36-.89-1.4,0,0,.52,0,1,0,1.57A.7.7,0,0,0,26.74,4.41Z" />
          <path d="M30.52,4.41c0-.53,0-1.05,0-1.57,0-.9-1.35-.89-1.39,0,0,.52,0,1,0,1.57A.7.7,0,0,0,30.52,4.41Z" />
          <path d="M34.29,4.41c0-.53,0-1.05,0-1.57,0-.9-1.36-.89-1.4,0,0,.52,0,1,0,1.57A.7.7,0,0,0,34.29,4.41Z" />
          <path d="M13.74,44a.7.7,0,0,0,1.37-.18q.57-7.29.9-14.59c0-.9-1.36-.9-1.4,0-.16,3.7-.39,7.39-.65,11.08A91.25,91.25,0,0,1,11.57,28.8c-.11-.68-1.21-.65-1.35,0-.74,3.63-1.28,7.43-2.13,11.1-.32-3.63-.64-7.27-1-10.9-.08-.88-1.48-.89-1.39,0,.48,4.94.87,9.89,1.35,14.83A.7.7,0,0,0,8.43,44a87.52,87.52,0,0,0,2.42-11A59.71,59.71,0,0,0,13.74,44Z" />
          <path d="M19.37,43.43a55.27,55.27,0,0,1-.7-6.52c.68,0,1.38,0,2.07,0s1.56.08,2.35.09c.07,2.26.19,4.53.34,6.82.06.89,1.46.89,1.39,0-.33-4.85-.48-9.59-.47-14.45a.7.7,0,0,0-1.39,0c0,2.1,0,4.17.09,6.24-.77,0-1.54-.06-2.31-.1s-1.42,0-2.12,0a58.83,58.83,0,0,1,.14-6.08c.06-.9-1.33-.89-1.4,0A59,59,0,0,0,18,43.8C18.17,44.68,19.51,44.31,19.37,43.43Z" />
          <path d="M26.41,43.4c.65,2.15,3.31,1.7,5.14,1.39.89-.15.51-1.5-.37-1.35-2.4.41-3.05-.15-3.57-2.51a20.3,20.3,0,0,1-.2-3.4,23.77,23.77,0,0,0,3.48.09c.89,0,.9-1.43,0-1.39a26,26,0,0,1-3.53-.1q-.12-3-.14-6.05l3.67.05a.7.7,0,0,0,0-1.39l-4.19-.06a1.08,1.08,0,0,0-.89.82c0,2.48.07,5,.18,7.44C26.08,38.9,25.84,41.49,26.41,43.4Z" />
          <path d="M35.48,37.64a.5.5,0,0,0,.08.12,49.11,49.11,0,0,0,.32,6.06c.1.88,1.49.89,1.39,0a49.43,49.43,0,0,1-.32-6.2,8.46,8.46,0,0,0,.93-2.81q.73-2.7,1.35-5.43c.2-.87-1.15-1.24-1.34-.37-.3,1.31-.61,2.62-1,3.93-.12.45-.35,1.92-.65,2.93-.87-2.19-1.73-4.38-2.55-6.59-.31-.83-1.66-.47-1.34.37C33.4,32.32,34.42,35,35.48,37.64Z" />
          <path d="M5.59,20.23a7.12,7.12,0,0,1,4.09-4.76c.82-.34.46-1.69-.37-1.34a8.56,8.56,0,0,0-5.06,5.73A.7.7,0,0,0,5.59,20.23Z" />
          <path d="M11.24,14.73a.7.7,0,0,0,0-1.39A.7.7,0,0,0,11.24,14.73Z" />
        </g>
      </g>
    </svg>
  );
};

export const TreadMillSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61.31 44.75"
      fill="#27debf"
      width="85px"
      height="75px"
    >
      <title>Asset 4</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M61.17,37.15a3.21,3.21,0,0,0-1.71-2.66,6.43,6.43,0,0,0-2.31-.27c-1.09,0-2.17-.06-3.25,0-.25-.7-.53-1.4-.78-2.11C52,28.91,50.88,25.72,50,22.46c-.76-2.81-1.91-5.65-2.53-8.47,2.13-.24,4.27-.48,6.39-.76s5.63-.11,5.42-2.9c-.17-2.44-1.42-2.94-3-2.89-.51-2-1.71-7.69-4.19-7.43C50.56.17,48.24,2.55,47,3.35a77.35,77.35,0,0,0-7.76,5.58.7.7,0,0,0-.16.19c-.69.06-1.38.11-2.06.18-5.53.5-11.09,1-16.61,1.61-2.28.26-5.26.15-4.94,3.1s2.55,2.72,4.91,2.6q9.08-.48,18.1-1.59a.77.77,0,0,0,0,.15c2.31,6.32,4.45,12.7,6.55,19.09-13.56.22-27.15-.39-40.68.68-3.66.3-4.77,1-4.27,4.89.31,2.46,1.6,2.67,4,2.73l1.64,0a.59.59,0,0,0-.06.2c-.27,2.62,3.46,1.87,5.07,1.82.91,0,2.47.26,3.3-.18a1.87,1.87,0,0,0,.73-1.68c11,.13,22,.07,32.93.14A3.35,3.35,0,0,0,48.59,44c1.38,1,6.25.92,7.54.11a1.48,1.48,0,0,0,.78-1.74c1.37-.06,2.61-.2,3.56-1.39A4.47,4.47,0,0,0,61.17,37.15ZM51,2.34c.16-.11,1-.91,1.18-.87.4.09.77,1.32,1,1.74a23,23,0,0,1,1.63,4.37c-.52.08-1.06.17-1.58.23-3.89.48-7.83.79-11.75,1.11C44.57,6.54,47.89,4.58,51,2.34ZM17,14.11c-.56-2.33,7.76-2.19,9.56-2.38,3.7-.38,7.39-.75,11.1-1.09,3.29-.31,6.55-.82,9.86-1,1.53-.08,3.06-.16,4.59-.33.88-.09,4.38-1.07,5.2-.41,2.1,1.69-1.59,2.65-2.59,2.79-1.83.27-3.68.48-5.53.69-3.4.38-6.81.74-10.2,1.16-3.78.47-7.56.87-11.36,1.17C25.67,14.89,17.52,16.35,17,14.11ZM12.76,43.16a16.81,16.81,0,0,1-2,.06c-.46,0-3.76.38-3.68-.43a.52.52,0,0,0,0-.18c2.12,0,4.23.09,6.35.11C13.38,43.05,13.25,43.08,12.76,43.16ZM9,41.22a48.41,48.41,0,0,1-5.39-.06c-2.07-.26-2-.39-2.12-1.95-.09-1.26-.16-1.84.84-2.51,1.84-1.21,6.64-.68,8.87-.77,11.45-.5,22.91-.08,34.36-.28.11.32.21.64.32,1,.38,1.16.69,3.2,1.26,4.89Q28,41.37,9,41.22Zm42.78,1.83c-2.09-.2-2.62-.81-3.22-2.69s-1.22-3.76-1.84-5.63l0-.08c-.28-.85-.55-1.7-.83-2.55C43.9,26.34,42,20.57,39.88,14.86c2.06-.25,4.13-.48,6.2-.71a.22.22,0,0,1,0,.08c.49,2.28,1.55,4.41,2.09,6.7s1.26,4.63,2,6.9c.81,2.48,1.68,4.93,2.58,7.37h0l.18.51c.55,1.5,2.54,4.69,2.37,6.27C55.18,43.3,53,43.17,51.74,43.05Zm7.85-3.23C58.87,41,57.65,41,56.43,41l-.12-.3c-.66-1.7-1.27-3.4-1.9-5.11.91,0,1.82,0,2.74,0,1.23,0,2.18,0,2.55,1.29A3.74,3.74,0,0,1,59.59,39.82Z" />
          <path d="M45.25,19.45c-.3-.84-1.64-.48-1.34.37,2.06,5.85,3.85,11.78,6,17.59.31.84,1.66.48,1.35-.37C49.11,31.23,47.31,25.3,45.25,19.45Z" />
          <path d="M27.55,23.35a.7.7,0,0,0,0-1.39c-3.52,0-7-.13-10.55-.14a.7.7,0,0,0,0,1.4C20.51,23.22,24,23.36,27.55,23.35Z" />
          <path d="M10.06,23.29c.8,0,1.61,0,2.41,0a.7.7,0,0,0,0-1.4c-.8,0-1.61,0-2.41,0A.7.7,0,0,0,10.06,23.29Z" />
          <path d="M9.77,29.14c5.06-.28,10.2,0,15.27-.08a.7.7,0,0,0,0-1.39c-5.08.1-10.21-.2-15.27.08C8.88,27.8,8.87,29.19,9.77,29.14Z" />
          <path d="M35.12,29.2c.9.07.89-1.32,0-1.39-2-.15-4,0-6,0a.7.7,0,0,0,0,1.4C31.09,29.19,33.11,29.05,35.12,29.2Z" />
          <path d="M3.51,29.15a15.63,15.63,0,0,1,2.56,0c.89.09.89-1.31,0-1.39a15.63,15.63,0,0,0-2.56,0C2.62,27.84,2.61,29.23,3.51,29.15Z" />
        </g>
      </g>
    </svg>
  );
};

export const WeightScale = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.54 53.28"
      fill="#27debf"
      width="85px"
      height="75px"
    >
      <title>Asset 5</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M51,6.83c-3.76-4.26-10.61-2.6-15.69-2.66C33.61,1.74,30.73.41,27.08,0a10.19,10.19,0,0,0-8.57,4.36c-3.59,0-7.24-.29-10.81,0-1.95.16-3.87.56-5.19,2.09a10,10,0,0,0-2,5.82C.3,15.33.32,18.47.2,21.54.07,25,.34,28.41.26,31.84c-.1,4-.4,8-.18,12,.17,3.31.61,7.78,4.43,8.61,6.41,1.39,13.79.57,20.31.47,6.94-.11,13.9.39,20.83-.08,5.2-.36,7.44-1.72,7.46-7.2,0-7.24,0-14.47.09-21.71C53.28,18.75,54.72,11.09,51,6.83ZM27.08,1.4c4.6.51,8.2,2.87,8.41,7.82s-3.32,9.47-8.55,9.44a9,9,0,0,1-8.8-8.74A8.73,8.73,0,0,1,27.08,1.4ZM51.85,21.27c-.1,5.45-.13,10.91-.14,16.36v7.53a10.92,10.92,0,0,1-.26,3.75c-1.07,2.62-4.14,2.47-6.38,2.6-5.21.31-10.44.08-15.65,0s-10.45.23-15.68.1a65,65,0,0,1-7.52-.39C3,50.76,2,48.56,1.63,45.71c-.81-5.59.11-11.44.05-17.06-.05-5.34,0-10.67.22-16,.21-4.45,2.46-6.73,7-6.93,2.92-.13,5.86,0,8.78,0a9.37,9.37,0,0,0-.93,3.64A10.6,10.6,0,0,0,27,20.18,10.14,10.14,0,0,0,36.9,9.8,11,11,0,0,0,36,5.55c1.7,0,3.4-.1,5.1-.06,2.22,0,5.23-.36,7.15.82C53,9.23,52,16.49,51.85,21.27Z" />
          <path d="M25.58,11.1a1.65,1.65,0,0,0,2.52-.22,1.77,1.77,0,0,0,0-2.14A.58.58,0,0,0,28,8.52c.38-1,.74-2.06,1.11-3.1.3-.84-1-1.21-1.35-.37L26.75,8C25.19,8.06,24,9.89,25.58,11.1Zm1.2-1.71.18.08,0,0c.42.31-.33,1.09-.7.36C26.11,9.51,26.46,9.37,26.78,9.39Z" />
          <path d="M47.26,28c.08-2.21.54-5.28-.22-7.4a3.74,3.74,0,0,0-3.14-2.51c-1.66-.25-5.08-.37-6.66.44-.77.4-1.36,1.5-2,2.07a12.56,12.56,0,0,1-5,2.59C25.7,24.5,21.31,23,17.83,20c-2-1.8-7.58-1.85-9.9-.72-3.1,1.52-2,5.8-2,8.56.14,5.21-.54,10.91.36,16.05.42,2.37,1.55,3.66,3.92,4.11a71.47,71.47,0,0,0,9.72.62c3.21.15,6.43,0,9.64-.16,2.95-.15,5.9-.34,8.86-.38,2.35,0,4.6.5,6.66-.81,3.41-2.17,2.24-6.56,2.1-10.07C47.09,34.11,47.16,31.09,47.26,28ZM45.68,44.4c-1,2.4-3.07,2.16-5.38,2.25-5.7.2-11.43.58-17.14.59-2.8,0-5.54-.31-8.32-.48-2.53-.16-6,.67-7-2.35-.75-2.22-.39-5.1-.37-7.42,0-2.66,0-5.32-.09-8S6.1,21.66,9.22,20.35c1.64-.69,6.27-.62,7.63.59,3.11,2.7,7,4.55,11.23,4.14a15.65,15.65,0,0,0,5.74-1.76c1.8-1,3.15-3.06,5.07-3.67a11.11,11.11,0,0,1,3.45-.12c1.75-.36,2.93.55,3.51,2.74,0,.64.07,1.28.08,1.92,0,2.77-.19,5.53-.21,8.3s.17,5.29.24,7.94A10.18,10.18,0,0,1,45.68,44.4Z" />
          <path d="M21,9.3A5.37,5.37,0,0,1,23.47,5c.78-.44.08-1.64-.71-1.2A6.82,6.82,0,0,0,19.59,9.3C19.51,10.19,20.9,10.19,21,9.3Z" />
          <path d="M20.15,10.73a.7.7,0,0,0,0,1.39A.7.7,0,0,0,20.15,10.73Z" />
        </g>
      </g>
    </svg>
  );
};

export const AppleSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50.16 53.08"
      fill="#27debf"
      width="85px"
      height="75px"
    >
      <title>Asset 6</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M42.09,11.71a10.53,10.53,0,0,0-6.41-.22c.12-.13.26-.24.38-.38A11.35,11.35,0,0,0,38,.73a.53.53,0,0,0-.08-.15A.59.59,0,0,0,37.25,0,13.52,13.52,0,0,0,25.63,9.31,19.8,19.8,0,0,0,18.87.21a.55.55,0,0,0-.59-.08l-.06,0-.11.08L18,.31A11.35,11.35,0,0,0,16,4.89a.61.61,0,0,0,.15.61.6.6,0,0,0,.34.25,11.63,11.63,0,0,1,7.83,8.08c-4.3-.72-8-3.44-12.62-2.86a12.79,12.79,0,0,0-9.85,7.69C-3,29.06,2.55,41.53,9.33,49.71c3.56,4.29,6.86,3.82,11.73,2.21,3.52-1.17,5.92-.5,9.35.36a15.52,15.52,0,0,0,6,.67c4.73-.75,7.77-6.49,9.48-10.42,2.5-5.78,4.43-11.71,4.25-18.08C50,19.17,47.28,13.68,42.09,11.71ZM36.74,1.46a9.8,9.8,0,0,1-2.12,9.17c-2.07,2.12-5.26,2.83-8.14,3.25a.52.52,0,0,0,0-.18A11.85,11.85,0,0,1,36.74,1.46ZM17.47,4.65A10.07,10.07,0,0,1,18.66,1.8a17.94,17.94,0,0,1,5.91,9A13.1,13.1,0,0,0,17.47,4.65ZM39.54,49.72c-4.63,4.33-9.79-.27-15-.06-2.48.11-4.66,1.41-7,2-4.23,1.06-6.72-2-8.82-5.19-3.56-5.39-6.85-11.23-7.27-17.8S3.89,13.8,11.2,12.45c5.23-1,9.23,2.53,14.21,2.91a.58.58,0,0,0,.3,0,15.36,15.36,0,0,0,4.21-.76A18.35,18.35,0,0,0,31.86,14c3-1,5.87-2.08,8.93-1.24C49.12,15,49.61,25.37,48,32.29,46.69,38.22,44.08,45.49,39.54,49.72Z" />
          <path d="M12.75,16.54c-4.7,1.94-7.08,7.87-6.29,12.65.15.88,1.49.51,1.35-.37-.66-3.95,1.37-9.31,5.31-10.94C13.94,17.55,13.58,16.2,12.75,16.54Z" />
          <path d="M7.39,32.07a.7.7,0,0,0,0,1.39A.7.7,0,0,0,7.39,32.07Z" />
        </g>
      </g>
    </svg>
  );
};

export const SmallBottleSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39.68 61.39"
      fill="#27debf"
      width="85px"
      height="75px"
    >
      <title>Asset 7</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M38.92,18.94c-.57-2.17-2.62-4.18-4.73-5.52l.2-.05c2.78-.87,1.81-4.76,1.79-7,0-3.88.36-5.47-3.92-5.85C27.17,0,22.07.05,17,0,14,0,11,0,8,.17c-1.14.07-3-.08-3.85,1-1.27,1.64-.57,6.34-.58,8.18,0,2.45.12,4,2.35,4.26C3.29,15.67,1.18,17.71.72,21.43.09,26.53.41,32,.34,37.08c-.1,7.94-2.72,22.57,8.31,24,5.5.7,11.33,0,16.87.16,3.66.07,8.29.72,10.79-2.54C39.18,55,39.69,49,39.6,44.46s0-8.91,0-13.35C39.65,27.17,39.93,22.79,38.92,18.94ZM5,5.69c0-.71-.17-2.32.19-3,.93-1.67,5.2-1.29,6.72-1.32,3.69,0,7.38,0,11.07.05,2.93,0,7.09-.5,9.86.47,2.21.76,1.94,2.13,1.95,4a21.62,21.62,0,0,1,0,3.94C34.37,12.07,33,12.08,31,12.16c-1.56.05-3.12.14-4.68.14-6.45,0-13-.54-19.39-.08C4.07,12.33,5,7.56,5,5.69ZM19.85,27.25c1.46,0,4.6-.77,6-.2.6-.22.82,0,.65.61,0,.85.07,1.7.06,2.55,0,1.43-.09,2.85-.18,4.27A79.44,79.44,0,0,0,26,43.86c.05.88.51,2.41.29,3.28-.43,1.71-1.62,1.09-3.32,1q-5.21-.27-10.43-.13c-3.56.09-7.44.85-10.89-.22,0-1.58.06-3.13.07-4.51,0-5.42.18-10.84.22-16.26C7.89,27.07,13.87,27.37,19.85,27.25ZM38,49.42c-.5,3-1.26,8.18-4.26,9.78-2.19,1.18-5.84.67-8.19.63-5.62-.12-12,.84-17.48-.26-5.15-1-6.23-5.64-6.39-10.33,3.7,1,7.73.24,11.51.16,4.57-.09,9.13.06,13.69.39a.72.72,0,0,0,.7-.7c.29-3.43-.3-6.9-.11-10.36a95.1,95.1,0,0,0,.31-12.4.72.72,0,0,0-.7-.7c-8.39.09-16.74.05-25.14,0a20,20,0,0,1,.5-5.74c.92-3,3.45-4.53,5.78-6.34,4.14-.22,8.39-.12,12.5,0,2.61.06,5.2.19,7.81.11,1,0,2.14,0,3.28,0,4.15,1.76,5.93,4.87,6.25,9,.34,4.34.23,8.73.19,13.08S38.7,45,38,49.42Z" />
          <path d="M9.27,9.07c-.07-1.48-.1-3-.08-4.45a.7.7,0,0,0-1.4,0c0,1.49,0,3,.09,4.45C7.93,10,9.32,10,9.27,9.07Z" />
          <path d="M31.77,9.07c-.07-1.48-.1-3-.08-4.45a.7.7,0,0,0-1.4,0c0,1.49,0,3,.09,4.45C30.43,10,31.82,10,31.77,9.07Z" />
          <path d="M14.9,9.07c-.08-1.48-.11-3-.09-4.45a.7.7,0,0,0-1.39,0c0,1.49,0,3,.09,4.45C13.55,10,15,10,14.9,9.07Z" />
          <path d="M26.15,9.07c-.08-1.48-.11-3-.09-4.45a.7.7,0,0,0-1.39,0c0,1.49,0,3,.09,4.45C24.8,10,26.2,10,26.15,9.07Z" />
          <path d="M20.52,9.07c-.07-1.48-.1-3-.08-4.45a.7.7,0,0,0-1.4,0c0,1.49,0,3,.09,4.45C19.18,10,20.57,10,20.52,9.07Z" />
          <path d="M9.1,44c1.59-.16,2.38-1.36,3.28-2.52.43-.56,1-1.18,1.58-1.85-.18,2.26-.37,5.17,1.41,6.64,2.05,1.71,5.74.94,6.59-1.65a28.23,28.23,0,0,0,.74-5.27c.24-1.93,1-4.4.31-6.31-.9-2.53-3.43-3.25-5.7-2.43a4.58,4.58,0,0,0-4.22-2.16c-2,.18-3,1.63-4.1,3.07C7.28,33.9,3.34,38,4.53,41.21A4.67,4.67,0,0,0,9.1,44Zm11.74-1c-.89,3.91-4.83,3.33-5.47-.56a17.83,17.83,0,0,1,0-3.65,23.78,23.78,0,0,0,6.13.36C21.32,40.82,21,42.29,20.84,43Zm.84-5.25a22,22,0,0,1-5.9-.31c1.34-1.76,2.38-3.68,2-5.56C21.49,30.35,22,34.11,21.68,37.77ZM15.21,30.6c1.58,1,1.54,2.57.64,4A28.74,28.74,0,0,1,14.19,37a22.17,22.17,0,0,1-5-3.34c.34-.47.68-.95,1-1.42C11.41,30.62,13.23,29.32,15.21,30.6Zm-9,7.77A8.14,8.14,0,0,1,7,37c.44-.75.91-1.47,1.4-2.18a23,23,0,0,0,5,3.32c-.76.94-1.53,1.87-2.25,2.8C10.21,42,8.24,43.26,7,42A5.37,5.37,0,0,1,6.21,38.37Z" />
          <path d="M28.32,15.71c-.88-.15-1.26,1.19-.37,1.35a7.23,7.23,0,0,1,5.33,3.48c1,1.91.86,4.27,1,6.38,0,.89,1.43.9,1.39,0-.12-2.62,0-5.37-1.49-7.64A8.63,8.63,0,0,0,28.32,15.71Z" />
          <path d="M34.92,29.2a.7.7,0,0,0,0,1.39A.7.7,0,0,0,34.92,29.2Z" />
        </g>
      </g>
    </svg>
  );
};

export const TallBottleSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.51 61.49"
      fill="#27debf"
      width="85px"
      height="75px"
    >
      <title>Asset 8</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M25,33.76c0-1.63.41-4-.35-5.53-.89-1.79-1.68-2.71-.51-4.71.32-.54.86-.76,1.09-1.39.92-2.47-.5-5.68-1.73-7.73a12,12,0,0,0-1.91-2.57c-1.55-1.45-1.94-1.95-1.93-4.3.39,0,.78,0,1.17,0,.89,0,.89-1.43,0-1.4l-.49,0c.11-1.64.57-4.88-.71-5.65S14.84.18,13.28.19c-1.95,0-4.44-.26-6.34.25C4.79,1,5.51,4.35,5.51,6.23H5.22a.7.7,0,0,0,0,1.4h.94c0,1.88,0,2.47-1.37,3.73A14,14,0,0,0,3.12,13,12.21,12.21,0,0,0,.35,20.3c0,1.91.35,2,1.27,3.44C3.7,27,.79,27.29.3,29.9c-.68,3.61,0,8,0,11.74,0,2.71.07,5.42.09,8.13,0,2.44-.36,5.21.06,7.61.68,3.92,4.58,3.83,7.75,4s6.23,0,9.35,0c2.5,0,4.52,0,6.2-2.07,2.48-3.08,1.28-9,1.26-12.63C25,42.38,25,38.07,25,33.76ZM1.69,32.81c0-.34,0-.63,0-.9,7.28-.48,14.58,0,21.87-.27.1,7,.06,14,.11,21v0c-3.61.84-7.11.26-10.77.32s-7.36.34-11.08.13C1.83,46.38,1.69,39.59,1.69,32.81Zm5.36-30c.39-1.42.55-.92,1.54-1.09a29.34,29.34,0,0,1,4.69-.13,17.74,17.74,0,0,1,4.31,0c1.86.5,1.43,2.8,1.34,4.54-4,.13-8,.15-12,.09A16.13,16.13,0,0,1,7.05,2.81ZM4,24.56c-.31-.9-1.06-1.26-1.57-2a3.93,3.93,0,0,1-.57-3,10.32,10.32,0,0,1,5.4-8,.71.71,0,0,0,.34-.6c0-1.1,0-2.2,0-3.3,3.57.05,7.13,0,10.7-.08,0,1.13,0,2.25,0,3.38a.69.69,0,0,0,.34.6A10.6,10.6,0,0,1,23.66,18a5.34,5.34,0,0,1-.31,4.31c-.4.65-1,1.05-1.33,1.78a3.53,3.53,0,0,0,0,3c.34.81,1.21,1.37,1.48,2.21a3.16,3.16,0,0,1,.09.9c-7.26.24-14.52-.2-21.77.26A7,7,0,0,1,3.11,28C3.89,26.9,4.43,26,4,24.56ZM19.61,60c-2.38.54-5.71.07-8.14.08A37.33,37.33,0,0,1,6,59.84c-1-.16-2.62-.24-3.35-1-.92-1-.79-2.82-.79-4.08a1.33,1.33,0,0,0,0-.2c4.11.22,8.15-.21,12.24-.13,3.28.06,6.39.37,9.6-.29C23.58,56.83,23,59.25,19.61,60Z" />
          <path d="M9.05,44c.59,0,1.17-.06,1.75-.1a31.93,31.93,0,0,1-1.68,6c-.29.65.56,1.52,1.1.84l.1-.14h0c2.43-3.09,4.68-6.32,7.11-9.41A.71.71,0,0,0,17,40c-.91-.05-1.83-.08-2.75-.11.19-1.63.34-3.26.51-4.89a.52.52,0,0,0,0-.37.59.59,0,0,0-.68-.44.66.66,0,0,0-.6.3c-1.84,2.72-3.29,5.68-5,8.51A.7.7,0,0,0,9.05,44Zm3.31-.66a.7.7,0,0,0-.67-.88c-.47,0-.93,0-1.39.08.92-1.62,1.81-3.25,2.75-4.85-.1.94-.19,1.89-.31,2.83-.05.38.36.68.69.7l2.17.08q-2,2.64-4,5.31C11.85,45.52,12.08,44.42,12.36,43.33Z" />
          <path d="M9.43,4.58V3.32A.7.7,0,0,0,8,3.32V4.58A.7.7,0,0,0,9.43,4.58Z" />
          <path d="M12.17,4.58V3.32a.7.7,0,0,0-1.39,0V4.58A.7.7,0,0,0,12.17,4.58Z" />
          <path d="M14.91,4.58V3.32a.7.7,0,0,0-1.39,0V4.58A.7.7,0,0,0,14.91,4.58Z" />
          <path d="M17.65,4.58V3.32a.7.7,0,0,0-1.39,0V4.58A.7.7,0,0,0,17.65,4.58Z" />
          <path d="M5.51,21c0-2.22.62-4.43,2.64-5.61a.69.69,0,0,0-.7-1.2C5,15.6,4.12,18.27,4.11,21A.7.7,0,0,0,5.51,21Z" />
          <path d="M9.27,14.45a.7.7,0,0,0,0-1.4A.7.7,0,0,0,9.27,14.45Z" />
        </g>
      </g>
    </svg>
  );
};

export const BmiIcon = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 51.19 61.12"
      {...customStyles}
    >
      <title>Timer</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M50.93,32a27.17,27.17,0,0,0-6.22-14.55,28.23,28.23,0,0,1,2-2.12,3.86,3.86,0,0,0,1.1.81c.82.25,1.36-.48,1.84-1.07s1.18-1.5.8-2.37-1.86-1.87-2.67-2.55-2-1.92-3.17-2.3-1.75.36-2.35,1.12c-.48.59-1.05,1.08-.71,1.85a3.66,3.66,0,0,0,.76,1c-.56.6-1.11,1.2-1.64,1.81a24.44,24.44,0,0,0-9.93-3.84c0-.6-.08-1.18-.08-1.77A4.09,4.09,0,0,0,32,7.84c1.15-.41,1.17-1,1.24-2.24.07-1.45.28-3.92-1-4.9C30.67-.44,27.12.15,25.37.15c-3.46.11-8.29-.95-8.49,3.58,0,.92-.33,3,.5,3.73a4.17,4.17,0,0,0,2.31.67c0,.64,0,1.29,0,1.94a.42.42,0,0,0,0,.16,26.15,26.15,0,0,0-18,15.71C-2.1,35.77.36,48.52,8.89,55.3c3.21,2.54,6.7,4.77,10.79,5.37,6.23.92,13.14.59,18.8-2.45a27.38,27.38,0,0,0,9.73-9.28C51.08,44.22,51.59,37.33,50.93,32ZM44.34,9.26c.67.11,1.92,1.44,2.43,1.84a12.38,12.38,0,0,1,1.9,1.63c.5.65.08,1.45-.54,1.93a29.52,29.52,0,0,1-2.77-2.18,11.84,11.84,0,0,1-2.45-2.19C43.27,9.78,43.86,9.19,44.34,9.26Zm-1,3.46c.45.33.9.64,1.27.93l1,.77c-.61.64-1.25,1.27-1.82,2-.43-.46-.86-.91-1.34-1.34-.22-.2-.47-.37-.7-.56C42.25,13.87,42.8,13.3,43.34,12.72ZM18.27,5.54a5.24,5.24,0,0,1,0-1.81c.29-1.56,1.15-1.76,2.76-2a34.68,34.68,0,0,1,4.33-.18c1.29,0,2.62-.06,3.92.06s2,.06,2.44,1.47a5.83,5.83,0,0,1,.11,2.53c-.49,1.31-1.55.9-3,.94s-3.11.1-4.67.11S18.85,7.17,18.27,5.54Zm2.81,2.61c1,0,2-.1,2.63-.1,1.55,0,3.1-.06,4.65-.11l.88,0c0,.54,0,1.08.07,1.62a30.39,30.39,0,0,0-3.13-.24,28.31,28.31,0,0,0-5.06.57C21.09,9.33,21.09,8.74,21.08,8.15ZM48.55,44.71c-1.34,4.49-4.95,8.12-8.64,10.88-4.47,3.34-10,4.18-15.5,4.06a20.84,20.84,0,0,1-12.23-3.72A24.59,24.59,0,0,1,2,30,25.1,25.1,0,0,1,26.18,10.74c11.19.23,20.14,7,22.8,18A31.78,31.78,0,0,1,48.55,44.71Z" />
          <path d="M38.6,18.64s-.05,0-.07,0a.27.27,0,0,0-.07-.08,21.73,21.73,0,0,0-25.72.21A22.63,22.63,0,0,0,5,42.6C7.23,50.73,18.05,57.33,26.2,56.83c2.56-.16,5.62-.6,7.83-1.95a33.77,33.77,0,0,0,9.68-9.41C49.75,36.44,46.8,25,38.6,18.64Zm6.6,12.57a19.2,19.2,0,0,1-5.3,16.68c-2.82,3-5.81,6-9.92,6.93a18.14,18.14,0,0,1-13.12-1.57C12.24,50.67,7.09,46.49,6.05,41A22.06,22.06,0,0,1,9.18,24.41c6.55-9.4,19.34-11.11,28.53-4.7C41.36,22.58,44.39,26.56,45.2,31.21Z" />
          <path d="M34.91,24.5l-8,8.1a2.74,2.74,0,0,0-3.53-.11c-1.19.95-1.69,3.36-.57,4.55a3.47,3.47,0,0,0,4.45.26,2.81,2.81,0,0,0,.54-3.62l8.09-8.2A.69.69,0,0,0,34.91,24.5ZM24,36.23c-.62-.46-.48-1.74-.08-2.33a1.43,1.43,0,0,1,2.33,0s.05,0,.07.06a.2.2,0,0,0,0,.08C27.78,35.68,25.6,37.42,24,36.23Z" />
          <path d="M17.54,20.9C12.86,23.39,10.45,28,9.25,33c-.21.88,1.13,1.25,1.34.38,1.12-4.67,3.27-9,7.65-11.3C19,21.68,18.33,20.48,17.54,20.9Z" />
          <path d="M9.57,36.27a.7.7,0,0,0,0,1.39A.7.7,0,0,0,9.57,36.27Z" />
          <path d="M26,5c-.05-.67-.1-1.33-.14-2-.07-.89-1.46-.9-1.4,0l.15,2C24.65,5.86,26.05,5.87,26,5Z" />
          <path d="M29.57,4.43c0-.54,0-1.08-.05-1.63,0-.89-1.43-.9-1.4,0l.06,1.63C28.21,5.33,29.6,5.33,29.57,4.43Z" />
          <path d="M22,5a7.74,7.74,0,0,1-.07-1.8c.06-.89-1.34-.89-1.39,0a9.85,9.85,0,0,0,.11,2.17C20.75,6.22,22.09,5.85,22,5Z" />
        </g>
      </g>
    </svg>
  );
};

export const MacrosIcon = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37.64 61.61"
      {...customStyles}
    >
      <title>watch</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="icon">
          <path d="M37.5,22.17c0-1.44.35-4.69-1.29-5.49a3,3,0,0,0-2.62.09c-.13-1.86-.63-3.55-2-4.5a8,8,0,0,0-3.73-1.19c.06-2.55.65-6.44,0-8.86-.2-.76-.21-1.24-.93-1.75C25.84-.3,23.37.11,22.16.11c-2.14,0-4.28.08-6.42.07s-4.09,0-6.13.06c-1,0-2.75-.17-3.58.5S5.53,2.13,5.53,3c0,2.68,0,5.37,0,8.06a5.9,5.9,0,0,0-1.94.33C0,12.82.43,18.91.23,22A136.15,136.15,0,0,0,.29,38.9c.19,2.94-.51,8.74,2.57,10.44a7.4,7.4,0,0,0,2.74.75c-.07,2.8-.56,6.27,0,9a2.52,2.52,0,0,0,1.24,2.09c1.27.71,3.51.33,4.9.32,1.94,0,3.88-.07,5.83-.07,1.78,0,3.56,0,5.35,0,1.23,0,3.41.27,4.43-.47.79-.57.56-1.41.56-2.32,0-2.76,0-5.52,0-8.28H28a5.17,5.17,0,0,0,3.71-1.08c2.74-2.56,1.42-7.72,1.45-11,0-3.72.08-7.43.12-11.15a3.63,3.63,0,0,0,3.05.18C38.17,26.62,37.54,23.69,37.5,22.17ZM7.73,1.75c.79-.46,2.87-.15,3.78-.17,1.41,0,2.82,0,4.23,0,2.65,0,5.3-.08,8-.07,2.34,0,2.74,1.84,2.75,3.92,0,1.86,0,3.72,0,5.58H26c-3,0-6.08.13-9.1.19-2.68-.1-5.35,0-8,0-.61,0-1.26,0-1.92-.09C6.85,9,6,2.76,7.73,1.75ZM26.5,55.63c0,2,.42,3.69-1.75,4.3s-4.95.1-7.19.11-4.79.07-7.18.07a5.85,5.85,0,0,1-2,0C7.23,59.56,7.16,57.51,7,56.47a37.73,37.73,0,0,1,0-6.29c1,0,1.92,0,2.74,0,3.3.12,6.59,0,9.9-.07,2.29,0,4.57.1,6.85.15C26.51,52.08,26.51,53.86,26.5,55.63Zm5.33-14.79c0,.9.16,1.8.16,2.71,0,2.11-.81,4.55-3.09,5.38-1.82.67-5.4-.2-7.29-.19-2.65,0-5.29.13-7.93.15-2.11,0-7.57.64-9.31-.52-2.71-1.82-2.46-6-2.65-8.88q-.24-3.62-.3-7.23A110.4,110.4,0,0,1,2,17.94c.28-2.49,1-4.58,3.83-5.4a13.86,13.86,0,0,1,3.08,0c2.68,0,5.35-.1,8,0,2.44-.05,4.86,0,7.29-.11,2.59-.16,5.72-.43,7.06,2.12,1.13,2.16.7,4.89.69,7.31q0,3.32,0,6.63C31.86,32.61,31.61,36.76,31.83,40.84Zm3.81-15a1.57,1.57,0,0,1-2.24-.31l-.09-.09c0-.63,0-1.26,0-1.88,0-1.38.25-3.25.3-5.11a.5.5,0,0,0,.08-.07,1.41,1.41,0,0,1,2.12,0c.42.67.24,2.67.26,3.46s0,1.75,0,2.62S36.23,25.37,35.64,25.81Z" />
          <path d="M25.85,23l-.09,0h-.1l-.09,0h-.06c-1.73-.15-3.52.55-3.88,2.45a3.58,3.58,0,0,0,1.25,3.27c-.74,1.22-1.69,2.29-2.32,3.57l-.22,0-.09,0h-.1l-.09,0H20a4.81,4.81,0,0,0-1.42.08A40.42,40.42,0,0,0,16,28.6a3.56,3.56,0,0,0,1.34-2A3.25,3.25,0,0,0,14.83,23l-.09,0h-.1l-.09,0h-.06c-1.74-.15-3.52.55-3.88,2.45A3.61,3.61,0,0,0,12,28.8a21.37,21.37,0,0,0-2.52,3.42l-.18,0s-.05,0-.08,0h-.1l-.09,0H9c-1.74-.16-3.52.54-3.88,2.45a3.53,3.53,0,0,0,2.68,4,3.81,3.81,0,0,0,4-2.73,3.14,3.14,0,0,0-1.1-3,24.88,24.88,0,0,1,2.58-3.46s0,0,0,0a3.1,3.1,0,0,0,1.53-.17.62.62,0,0,0,.14.36c.82,1,1.58,2.1,2.3,3.2a2.79,2.79,0,0,0-1.16,1.82,3.53,3.53,0,0,0,2.68,4,3.8,3.8,0,0,0,4-2.73,3.16,3.16,0,0,0-1-2.93c.64-1.28,1.6-2.36,2.33-3.59a1.52,1.52,0,0,1,.2.06,3.8,3.8,0,0,0,4-2.73A3.24,3.24,0,0,0,25.85,23ZM10.33,35.88a2.42,2.42,0,0,1-2.48,1.28,2.17,2.17,0,0,1-1.38-2.34A2,2,0,0,1,8.85,33.5h.08a.45.45,0,0,0,.11,0A1.79,1.79,0,0,1,10.33,35.88Zm3-7.91A2.18,2.18,0,0,1,12,25.62a2,2,0,0,1,2.39-1.31h.08a.29.29,0,0,0,.1,0,1.79,1.79,0,0,1,1.29,2.36A2.43,2.43,0,0,1,13.36,28Zm8,7.91a2.41,2.41,0,0,1-2.48,1.28,2.17,2.17,0,0,1-1.38-2.34,2,2,0,0,1,2.39-1.32H20a.29.29,0,0,0,.1,0A1.79,1.79,0,0,1,21.35,35.88Zm5.52-9.19A2.45,2.45,0,0,1,24.38,28,2.2,2.2,0,0,1,23,25.62a2,2,0,0,1,2.39-1.31h.08s.06,0,.1,0A1.8,1.8,0,0,1,26.87,26.69Z" />
          <path d="M6.46,16.2c.79-.43.09-1.63-.7-1.21-2.56,1.38-2.24,5.06-2.14,7.52,0,.9,1.43.9,1.39,0C4.94,20.64,4.51,17.25,6.46,16.2Z" />
          <path d="M9.11,14.88v-.07a.7.7,0,0,0-1.39,0v.07A.7.7,0,0,0,9.11,14.88Z" />
        </g>
      </g>
    </svg>
  );
};

export const FoodSvg = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="966.647"
      height="715.061"
      viewBox="0 0 966.647 715.061"
      {...customStyles}
    >
      <g id="food-ns" transform="translate(0)">
        <g id="Layer_2" data-name="Layer 2" transform="translate(0)">
          <g id="Layer_1" data-name="Layer 1">
            <path
              id="Path_1386"
              data-name="Path 1386"
              d="M521.69,121.414l-.251.683c.084-.237.181-.46.265-.683l.279-.627Zm-5.465,80.862c.655-3.471,1.394-7.347,2.37-11.53.139-.613.265-1.241.4-1.868-.14.627-.265,1.255-.418,1.868C517.675,194.915,516.867,198.777,516.225,202.276Zm48.141-153.79c-.99-2.119-9.174-8.2-19.964-15l-4.182-2.593-1.6-.976-2.663-1.6L532.9,26.528l-4.35-2.5-3.234-1.785c-1.548-.837-3.067-1.659-4.6-2.44-2.537-1.394-5.047-2.593-7.515-3.778-.976-.474-1.952-.934-2.914-1.394-1.394-.669-2.788-1.283-4.182-1.854-.906-.39-1.812-.767-2.691-1.115s-1.743-.655-2.579-.962-1.659-.572-2.454-.836-1.729-.53-2.509-.725l-1.548-.39-1.394-.279h-.084l-1.394-.209c-.418,0-.837-.084-1.241-.1-6.553-.321-19.1,2.788-32.275,6.692h0c-4.894,1.492-9.885,3.1-14.695,4.7h0c-2.691.892-5.3,1.785-7.807,2.649-1.018.362-1.994.711-2.956,1.032l-2.788,1-2.719.976-.307.112L422.064,27h0l-5.1,1.854-.6.223-.572.209-3.374,1.269-.655.265h0l-.321.112h0a3.181,3.181,0,0,0,.084.725c.084.376.07.516.125.864.237,1.617.613,4.447,1.129,8.253.07.5.139,1.032.209,1.561a1.091,1.091,0,0,0,.07.46,10.907,10.907,0,0,0,.181,1.283c.4,2.97.864,6.385,1.394,10.15h0c1.241,9.09,2.788,20.257,4.392,32.61,1,7.515,2.063,15.461,3.165,23.7v.153c.279,2.049.572,4.085.837,6.162,1.227,9.2,2.468,18.891,3.695,28.706.223,1.952.474,3.9.7,5.869L428.811,163c.1.878.2,1.757.307,2.635.167,1.394.321,2.691.474,4.029a7.8,7.8,0,0,0,.111.823c1.018,8.588,1.98,17.009,2.886,25.011.084.823.181,1.645.279,2.468.181,1.631.376,3.248.544,4.838.125,1.171.265,2.328.376,3.471.2,1.7.39,3.374.572,5.019l.084.781c.223,1.98.418,3.89.641,5.758.265,2.412.516,4.74.767,6.971.111,1.157.237,2.272.349,3.388a3.011,3.011,0,0,0,.07.474c.167,1.6.335,3.165.488,4.643.111,1,.209,1.98.307,2.914.084.683.153,1.394.209,1.994.139,1.3.265,2.523.39,3.681.139,1.394.265,2.691.4,3.876s.237,2.273.321,3.248c.1.753.167,1.394.223,2.063v.586a2.516,2.516,0,0,0,.07.7,5.234,5.234,0,0,1,0,.613v.39a4.324,4.324,0,0,0,0,.488v.112a1.391,1.391,0,0,1,0,.237v.265a5.479,5.479,0,0,0,.5,1.9,5.77,5.77,0,0,0,.474.92,6.644,6.644,0,0,0,.363.586c.265.39.572.781.906,1.185a4.741,4.741,0,0,0,.362.4.376.376,0,0,0,.1.112,10.608,10.608,0,0,0,.781.809,3.692,3.692,0,0,0,.474.46c.5.46,1.032.92,1.6,1.394.795.641,1.659,1.283,2.579,1.924s1.547,1.032,2.384,1.548l.279.181,1.046.613a5.277,5.277,0,0,0,.474.279l.892.516c2.356,1.311,4.921,2.579,7.584,3.75l1.241.53c.586.251,1.185.5,1.784.725l.627.265c.335.125.655.265.99.376l1.394.516.4.139,1.394.516,1.617.53c.53.167,1.06.349,1.589.5,2.147.655,4.252,1.213,6.274,1.645l.99.2h.237l1.2.237,1.185.181,1.143.167.781.1h.349l1.073.084h2.356a39.919,39.919,0,0,0,5.577-.446c.586-.084,1.213-.167,1.84-.279l1.561-.279c.767-.139,1.589-.307,2.426-.488l.39-.084h.125l1.645-.376,1.1-.265,1.115-.279,2.231-.572h0l1.157-.321c.795-.209,1.589-.446,2.37-.683l.376-.112,1.115-.349.92-.293c.809-.237,1.631-.516,2.44-.795l.948-.307c1.492-.516,2.983-1.06,4.5-1.617.655-.265,1.324-.5,1.98-.781l1.255-.488,2.482-1.018a2.6,2.6,0,0,1,.279-.139l.948-.4q.627-.251,1.213-.544l.265-.112c.181-.084.362-.153.53-.251.725-.307,1.394-.641,2.119-.976,1.255-.6,2.51-1.227,3.722-1.854.209-.112.418-.237.627-.335.488-.251.962-.516,1.394-.781l.167-.084,1.046-.586h.111l.335-.181h.209c.5-.293.99-.572,1.478-.878a68.327,68.327,0,0,0,7.264-4.991c.418-.321.823-.655,1.213-.976s.795-.683,1.171-1.018l1.018-.948a31.059,31.059,0,0,0,3.513-3.9,2.66,2.66,0,0,0,.349-.46A5.673,5.673,0,0,0,553,248c.223-.335.446-.669.641-.99s.39-.669.586-1a.221.221,0,0,0,0-.1.765.765,0,0,0,.112-.209,2.624,2.624,0,0,1,.139-.279,4.338,4.338,0,0,0,.279-.572v-.167c.1-.209.2-.432.279-.655s.209-.544.307-.837.321-.934.474-1.394l.084-.279c.265-.892.516-1.84.753-2.872s.446-1.9.669-2.914a.2.2,0,0,0,0-.1v-.2a3.636,3.636,0,0,0,.181-.823c.962-4.754,1.826-10.387,2.579-16.73v-.362c0-.446.112-.892.139-1.394h0c.153-1.311.321-2.621.446-3.959l.544-5.326c.321-3.541.641-7.11.892-10.665,0-.572.1-1.143.153-1.7.864-11.655,1.534-24.314,2.036-37.168.2-4.81.349-9.634.474-14.444C566.457,96.306,565.732,51.5,564.366,48.486Zm-51.152,146.75v-3.987c0-1.338.084-2.691.167-4.043s.139-2.788.237-4.085.209-2.788.335-4.182.223-2.51.363-3.764.251-2.5.4-3.75c.209-1.868.446-3.722.669-5.577.112-.906.251-1.8.363-2.7.223-1.785.474-3.541.739-5.27.125-.836.237-1.7.362-2.537a.576.576,0,0,0,0-.153c.167-1.06.321-2.119.488-3.151s.293-2.049.46-3.039.279-1.91.432-2.788c.418-2.788.781-5.4,1.115-7.752.223-1.631.4-3.151.558-4.531,0-.46.1-.906.139-1.394.084-1.046.153-2.008.181-2.788a1.1,1.1,0,0,0,0-.307,2.056,2.056,0,0,0,0-.293q0-.293,0-.544a14.825,14.825,0,0,1,.1-1.617v-.237a.574.574,0,0,1,0-.223,8.291,8.291,0,0,1,.209-1.52.126.126,0,0,0,0-.1v-.112a.53.53,0,0,0,0-.237v-.641h0c.112-.349.2-.711.293-1.074h0c.07-.237.167-.474.237-.7s.181-.46.265-.683l.279-.627a1.043,1.043,0,0,1,.084-.181,18.99,18.99,0,0,1,1.157-2.091,19.848,19.848,0,0,1,1.241-1.757s0,0,0-.084a19.7,19.7,0,0,1,1.394-1.52,9.773,9.773,0,0,1,.767-.753l.53-.488.53-.474h0a48.473,48.473,0,0,1,1.018,7.71h0c.112,1.534.153,3.137.153,4.768v2.816a17.266,17.266,0,0,1-.112,2.384q-.188,4.015-.655,8.365a12.734,12.734,0,0,1-.223,1.91c-.432,3.778-1,7.668-1.645,11.6-.112.613-.209,1.241-.321,1.854-.181,1.115-.376,2.2-.572,3.318-.139.7-.265,1.394-.39,2.119-.39,2.119-.809,4.182-1.227,6.371-.251,1.2-.474,2.384-.725,3.569l-.125.655c-.265,1.185-.5,2.384-.753,3.583l-.167.809c-1,4.74-2.008,9.327-2.928,13.663-.139.627-.265,1.255-.418,1.868-.906,4.182-1.715,8.03-2.356,11.53-.223,1.171-.418,2.3-.586,3.36-.084.488-.167.962-.237,1.394-.111.767-.209,1.492-.321,2.189-.139,1.143-.251,2.189-.321,3.179v.084a.45.45,0,0,1,0,.125.691.691,0,0,0,0,.167c-.153-.767-.293-1.575-.432-2.384-.084-.558-.167-1.143-.237-1.715s-.2-1.394-.265-2.133a3.461,3.461,0,0,0-.1-.99c0-.655-.125-1.394-.167-2.035s-.125-1.785-.167-2.7,0-1.785-.1-2.691v-2.886Zm5.368-4.489c-.906,4.182-1.715,8.03-2.356,11.53.655-3.471,1.394-7.347,2.37-11.53.139-.613.265-1.241.4-1.868C518.86,189.505,518.735,190.133,518.582,190.746Zm3.109-69.332-.251.683c.084-.237.181-.46.265-.683l.279-.627Z"
              transform="translate(162.175 3.21)"
              fill="#f0e7c9"
            />
            <path
              id="Path_1387"
              data-name="Path 1387"
              d="M495.5,90.239a19.014,19.014,0,0,0-1.157,2.091,38.671,38.671,0,0,1,2.4-3.848,19.839,19.839,0,0,0-1.241,1.757Zm15-1.018c-.279-5.842-.488-9.341-.488-9.341h-.153c-1.018,0-6.594.07-12.338,7.528-.237.321-.5.655-.725.99a19.7,19.7,0,0,1,1.394-1.52,9.757,9.757,0,0,1,.767-.753h0c.167-.153.335-.321.53-.474s.349-.321.53-.46h0a48.48,48.48,0,0,1,1.018,7.71h0c.111,1.534.153,3.137.153,4.768v2.816a17.256,17.256,0,0,1-.112,2.384q-.188,4.015-.655,8.365a12.734,12.734,0,0,1-.223,1.91c-.432,3.778-1,7.668-1.645,11.6-.112.613-.209,1.241-.321,1.854-.2,1.1-.376,2.2-.572,3.318-.139.7-.265,1.394-.39,2.119-.39,2.119-.809,4.183-1.227,6.371-.251,1.2-.474,2.384-.725,3.569l-.125.655c-.265,1.185-.5,2.384-.753,3.583l-.167.809c-1,4.74-2.008,9.327-2.928,13.663-.139.627-.265,1.255-.4,1.868-.906,4.182-1.715,8.058-2.37,11.53-.223,1.171-.418,2.3-.586,3.36-.084.488-.167.962-.237,1.394-.112.767-.209,1.492-.321,2.189-.153,1.143-.265,2.2-.349,3.193a.923.923,0,0,1,0,.2.685.685,0,0,0,0,.167c-.153-.767-.293-1.575-.432-2.384-.084-.558-.167-1.143-.237-1.715s-.2-1.394-.265-2.133a3.463,3.463,0,0,0-.1-.99c0-.655-.125-1.394-.167-2.035s-.125-1.785-.167-2.7,0-1.785-.1-2.691v-2.886h0v-3.987c0-1.338.084-2.691.167-4.043s.139-2.788.237-4.085.209-2.788.335-4.182.223-2.51.362-3.764.251-2.5.4-3.75c.209-1.868.446-3.722.669-5.577.112-.906.251-1.8.362-2.7.237-1.785.488-3.541.739-5.27.125-.836.237-1.7.363-2.537a.571.571,0,0,0,0-.153c.181-1.06.321-2.119.488-3.151s.293-2.049.46-3.039.279-1.91.432-2.788c.418-2.788.795-5.4,1.115-7.752.237-1.631.418-3.151.558-4.531,0-.46.1-.906.139-1.394.1-1.046.167-1.994.2-2.788a1.134,1.134,0,0,0,0-.307,2.047,2.047,0,0,0,0-.293q0-.293,0-.544a15.327,15.327,0,0,1,.084-1.631,1.272,1.272,0,0,1,0-.223.573.573,0,0,1,0-.223,8.286,8.286,0,0,1,.209-1.52.126.126,0,0,0,0-.1.237.237,0,0,0,0-.1.827.827,0,0,0,0-.237,1.379,1.379,0,0,1,0-.167v-.488h0c.111-.349.2-.711.293-1.073h0c.07-.237.167-.474.237-.7l.251-.683.293-.627a4.186,4.186,0,0,0-.209.432,78.717,78.717,0,0,0-7.041,21.888,299.241,299.241,0,0,0-4.545,37.559c-.934,16.381-.474,32.47,2.328,43.637,2.426,9.676,6.58,15.629,13.091,14.876,2.984-.362,5.354-3.513,7.222-8.644,3.792-10.456,5.507-29.054,6.148-48.656.139-4.475.223-9.006.265-13.5.446-20.355-.265-39.9-.767-51.012Zm-15,1.018a19.014,19.014,0,0,0-1.157,2.091,38.671,38.671,0,0,1,2.4-3.848,19.839,19.839,0,0,0-1.241,1.757Zm0,0a19.014,19.014,0,0,0-1.157,2.091,38.671,38.671,0,0,1,2.4-3.848,19.839,19.839,0,0,0-1.241,1.757Z"
              transform="translate(189.899 31.486)"
              fill="#f7f0d7"
            />
            <path
              id="Path_1388"
              data-name="Path 1388"
              d="M473.79,247.393c-16.2-3.458-37.642-14.388-38.158-22.307-.293-3.695-4.252-41.964-9.229-84.04-2.133-17.971-4.406-36.667-6.692-53.661L472.3,83.3s-.376,2.579-.795,7.584c-4.113,4.754-9.411,21.861-9.411,21.861S462.65,187.584,473.79,247.393Z"
              transform="translate(165.435 32.834)"
              fill="#baa38a"
            />
            <path
              id="Path_1389"
              data-name="Path 1389"
              d="M470.857,246.342a19.827,19.827,0,0,1-2.37-.1,13.136,13.136,0,0,1-1.9-.209c-.655-.1-1.534-.2-2.328-.349s-1.6-.293-2.426-.474c-11.153-59.754-11.7-134.662-11.7-134.662s5.3-17.106,9.411-21.861c-.558,6.594-1.213,17.4-1.241,32.066C458.212,149.071,460.61,191.886,470.857,246.342Z"
              transform="translate(177.43 34.958)"
              fill="#d1bfab"
            />
            <path
              id="Path_1390"
              data-name="Path 1390"
              d="M476.434,246.239a42.159,42.159,0,0,1-5.577.446,19.827,19.827,0,0,1-2.37-.1,13.136,13.136,0,0,1-1.9-.209c-.655-.1-1.534-.2-2.328-.349s-1.6-.293-2.426-.474c-11.153-59.754-11.7-134.662-11.7-134.662s5.3-17.106,9.411-21.861c3.081-3.555,5.479-.209,4.559,22.307C462.325,153.43,472.349,221.075,476.434,246.239Z"
              transform="translate(177.43 34.615)"
              fill="#f5f0ed"
            />
            <path
              id="Path_1391"
              data-name="Path 1391"
              d="M472.29,83.25S470.3,93.19,470.3,118.9c-6.441,9.327-20.285,20.411-28.692,23.952-4.894,2.063-10.387.446-15.182-1.854-2.133-17.971-4.406-36.667-6.692-53.661Z"
              transform="translate(165.443 32.814)"
              fill="#c9b3b4"
            />
            <path
              id="Path_1392"
              data-name="Path 1392"
              d="M564.34,48.522c-35.5,2.649-76.818,23.073-76.818,23.073l-70.489-13.83s-.962-1.269-2.468-3.444C412.627,40,411.4,30.969,411.4,30.969S472.548,7.282,490.31,8.147,561.747,42.805,564.34,48.522Z"
              transform="translate(162.16 3.202)"
              fill="ivory"
            />
            <path
              id="Path_1393"
              data-name="Path 1393"
              d="M424.027,24.51s-28.734,26.879-44.7,51.584l16.144,16.019,36.165,14.053,68.523-41.03C458.058,31.314,424.027,24.51,424.027,24.51Z"
              transform="translate(149.519 9.661)"
              fill="#fef6e5"
            />
            <path
              id="Path_1394"
              data-name="Path 1394"
              d="M487.213,87.625a84.681,84.681,0,0,1-14.555,42.313,4.019,4.019,0,0,1-.446.6h0L451.941,138.8l-22.432,8.755a46.7,46.7,0,0,1-11.836,0v-.209c-.07-.293-.153-.948-.265-1.868-1.157-8.463-5.158-40.724.293-50.8,0,0,9.2-6.106,21.219-13.7,15.74-9.982,36.248-22.558,47.29-27.381C487.994,52.868,487.213,87.625,487.213,87.625Z"
              transform="translate(163.541 21.12)"
              fill="#e6d6ba"
            />
            <path
              id="Path_1395"
              data-name="Path 1395"
              d="M471.688,118.463h0l-20.271,8.267-22.432,8.755a46.7,46.7,0,0,1-11.836,0v-.209L416.2,123.97s21.833-4.935,39.8-14.918a92.49,92.49,0,0,0,28.232-24.8C485.086,94.72,472.468,117.1,471.688,118.463Z"
              transform="translate(164.052 33.208)"
              fill="#faf3f0"
            />
            <path
              id="Path_1396"
              data-name="Path 1396"
              d="M432.026,144.331a.612.612,0,0,1,0,.209,48.2,48.2,0,0,1-18.821-6.218l-17.636-10.177A31.55,31.55,0,0,1,382.714,114.2a32.178,32.178,0,0,1-2.984-13.5,133.045,133.045,0,0,1,0-39.218s18.124,14.067,52.3,30.225c-3.708,13.733-1.241,38.409-.181,50.8C431.928,143.063,432,143.746,432.026,144.331Z"
              transform="translate(149.104 24.237)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1397"
              data-name="Path 1397"
              d="M485.833,111.911a6.783,6.783,0,0,1-.474.655l-20.3,8.365-22.432,8.755a46.7,46.7,0,0,1-11.836,0,48.2,48.2,0,0,1-18.821-6.218l-17.636-10.177A31.55,31.55,0,0,1,381.48,99.35c1.868,1.743,3.973,3.722,6.274,5.981,13.356,13.077,38.688,21.958,38.688,21.958a32.07,32.07,0,0,0,4.057.376h.111a68.553,68.553,0,0,0,9.968-.376C448.037,126.355,476.451,115.592,485.833,111.911Z"
              transform="translate(150.366 39.16)"
              fill="#e7dcdd"
            />
            <path
              id="Path_1398"
              data-name="Path 1398"
              d="M490.658,89.39l-.251.683a2.943,2.943,0,0,1-.237.7,2.2,2.2,0,0,1,.209-.669,6.287,6.287,0,0,1,.279-.711Z"
              transform="translate(193.208 35.234)"
              fill="#e6d6ba"
            />
            <path
              id="Path_1399"
              data-name="Path 1399"
              d="M495.455,84.35h0a9.767,9.767,0,0,0-.767.753,19.7,19.7,0,0,0-1.394,1.52v.084a19.85,19.85,0,0,0-1.241,1.757,19.016,19.016,0,0,0-1.157,2.091,1.047,1.047,0,0,0-.084.181l-.293.627a.584.584,0,0,1,.084-.2,1.3,1.3,0,0,1,.112-.307,1.047,1.047,0,0,1,.139-.335c.112-.321.307-.641.446-.948a6.005,6.005,0,0,1,.474-.823,1.045,1.045,0,0,1,.209-.335,22.214,22.214,0,0,1,1.561-2.189l.53-.6a10.08,10.08,0,0,1,1.38-1.283Z"
              transform="translate(193.346 33.248)"
              fill="#e6d6ba"
            />
            <path
              id="Path_1400"
              data-name="Path 1400"
              d="M527.166,130.687c-2.523,25.792-7.487,53.7-9.271,65.066-.363,2.328-.6,3.945-.655,4.74-.613,9.09-10.233,12.143-21.93,11.153a2.788,2.788,0,0,1-1.506-.725h0c-1.84-1.659-3.109-5.995-3.959-12.073-1.269-9.062-1.617-22.014-1.52-35.635.139-.613.265-1.241.4-1.868.92-4.336,1.924-8.923,2.928-13.663l.167-.809c.251-1.2.488-2.4.753-3.583l.125-.655c.251-1.185.474-2.37.725-3.569.418-2.119.836-4.182,1.227-6.371.125-.711.251-1.394.39-2.119.2-1.115.376-2.217.572-3.318.112-.613.209-1.241.321-1.854.641-3.932,1.213-7.821,1.645-11.6.1-.641.167-1.269.223-1.91q.46-4.182.655-8.365c0-.809.1-1.6.112-2.384V98.329c0-1.631,0-3.234-.153-4.768h0a48.473,48.473,0,0,0-1.018-7.71h.07l.139-.1c.265-.251.572-.446.85-.683s.962-.669,1.394-.976a33.459,33.459,0,0,1,4.824-2.454l.725-.293h.07l.432-.139,1.394-.53c.906-.321,1.784-.572,2.635-.809a42.116,42.116,0,0,1,7.821-1.394C529.7,74.614,530.038,101.27,527.166,130.687Z"
              transform="translate(192.474 30.785)"
              fill="#e6d6ba"
            />
            <path
              id="Path_1401"
              data-name="Path 1401"
              d="M490.658,89.39l-.251.683a2.943,2.943,0,0,1-.237.7,2.2,2.2,0,0,1,.209-.669,6.287,6.287,0,0,1,.279-.711Z"
              transform="translate(193.208 35.234)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1402"
              data-name="Path 1402"
              d="M495.455,84.35h0a9.767,9.767,0,0,0-.767.753,19.7,19.7,0,0,0-1.394,1.52v.084a19.85,19.85,0,0,0-1.241,1.757,19.016,19.016,0,0,0-1.157,2.091,1.047,1.047,0,0,0-.084.181l-.293.627a.584.584,0,0,1,.084-.2,1.3,1.3,0,0,1,.112-.307,1.047,1.047,0,0,1,.139-.335c.112-.321.307-.641.446-.948a6.005,6.005,0,0,1,.474-.823,1.045,1.045,0,0,1,.209-.335,22.214,22.214,0,0,1,1.561-2.189l.53-.6a10.08,10.08,0,0,1,1.38-1.283Z"
              transform="translate(193.346 33.248)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1403"
              data-name="Path 1403"
              d="M511.711,139.634c-.6,4.684-1.283,9.369-1.966,13.942-3.541,23.241-7.863,43.735-8.128,47.262v.613a10.623,10.623,0,0,1-6.692,8.7h0c-2.384-1.729-4.963-6.232-6.873-12.882a74.743,74.743,0,0,1-2.44-13.049.084.084,0,0,1,0-.07c.083-.99.2-2.049.348-3.193.112-.7.209-1.394.321-2.189.07-.474.153-.948.237-1.394.167-1.06.362-2.189.586-3.36.655-3.471,1.394-7.347,2.37-11.53.139-.613.265-1.241.4-1.868.92-4.336,1.924-8.923,2.928-13.663l.167-.809c.251-1.2.488-2.4.753-3.583l.125-.655c.251-1.185.474-2.37.725-3.569.418-2.119.836-4.182,1.227-6.371.125-.711.251-1.394.39-2.119.2-1.115.376-2.217.572-3.318.112-.613.209-1.241.321-1.854.641-3.932,1.213-7.821,1.645-11.6.1-.641.167-1.269.223-1.91q.46-4.182.655-8.365c0-.809.1-1.6.111-2.384V97.6c0-1.631,0-3.234-.153-4.768h0a48.48,48.48,0,0,0-1.018-7.71h.07l.139-.1c.265-.251.572-.446.85-.683s.962-.669,1.394-.976a33.456,33.456,0,0,1,4.824-2.454l.725-.293h.07l.432-.139,1.394-.53a10.443,10.443,0,0,1,2.788,3.918C515.963,93.85,514.639,116.714,511.711,139.634Z"
              transform="translate(191.409 31.513)"
              fill="#baa38a"
            />
            <path
              id="Path_1404"
              data-name="Path 1404"
              d="M411.658,24.51l-.948.753v.084l.265-.223s33.99,6.79,76,40.5l.809-.488C445.69,31.314,411.658,24.51,411.658,24.51Z"
              transform="translate(161.888 9.661)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1405"
              data-name="Path 1405"
              d="M469.993,53.664l-1.394.669v.349l.837-.4c1.854-.836,1.1,33.948,1.1,33.948a84.89,84.89,0,0,1-14.667,42.452l.237-.112s13.175-16.591,15.057-42.968C471.08,87.6,471.833,52.828,469.993,53.664Z"
              transform="translate(179.688 21.147)"
              fill="#c9b3b4"
            />
            <path
              id="Path_1406"
              data-name="Path 1406"
              d="M422.091,109.161c0,11.307-8,15.866-17.859,10.177S386.4,99.862,386.4,88.569s7.989-15.866,17.845-10.177S422.091,97.84,422.091,109.161Z"
              transform="translate(152.306 29.935)"
              fill="#c9b3b4"
            />
            <path
              id="Path_1407"
              data-name="Path 1407"
              d="M417.865,111.248c0,11.307-7.989,15.866-17.845,10.177s-17.859-19.518-17.859-30.8,8-15.866,17.859-10.177S417.865,99.927,417.865,111.248Z"
              transform="translate(150.634 30.748)"
              fill="#d7dddd"
            />
            <path
              id="Path_1408"
              data-name="Path 1408"
              d="M416.1,112.328c0,11.307-8.016,15.866-17.873,10.177a31.23,31.23,0,0,1-7.668-6.441,40.208,40.208,0,0,1-10.177-24.37c0-11.293,7.989-15.852,17.845-10.15S416.1,101.021,416.1,112.328Z"
              transform="translate(149.933 31.173)"
              fill="#c5cece"
            />
            <path
              id="Path_1409"
              data-name="Path 1409"
              d="M507.664,84.01a9.4,9.4,0,0,1-2.328,5.423h0c-3.667,3.848-9.438,3.6-9.438,3.6h0l-1.018-7.71h.07l.139-.1a45.437,45.437,0,0,1,7.849-4.406h.07c.572-.237,1.143-.474,1.743-.669a23.333,23.333,0,0,1,2.788-.809,15,15,0,0,1,.125,4.67Z"
              transform="translate(195.064 31.273)"
              fill="#c9b3b4"
            />
            <path
              id="Path_1410"
              data-name="Path 1410"
              d="M508.5,83.2l-2.259,1.311V44.751L508.5,43.44Z"
              transform="translate(199.542 17.123)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1411"
              data-name="Path 1411"
              d="M504.059,84.406,501.8,85.7V45.941l2.259-1.311Z"
              transform="translate(197.792 17.592)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1412"
              data-name="Path 1412"
              d="M499.619,85.592,497.36,86.9V47.141l2.259-1.311Z"
              transform="translate(196.042 18.065)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1413"
              data-name="Path 1413"
              d="M495.182,86.782l-2.273,1.311V48.331l2.273-1.311Z"
              transform="translate(194.288 18.534)"
              fill="#cbb9a6"
            />
            <path
              id="Path_1414"
              data-name="Path 1414"
              d="M432.832,28.73a129.953,129.953,0,0,0-26.489,23.84A261.168,261.168,0,0,0,386.42,79.059s14.555,10.317,27.3,16.242c0,0,16.033-18.124,27.7-29.027s27.758-19.518,27.758-19.518S448.879,32.62,432.832,28.73Z"
              transform="translate(152.313 11.324)"
              fill="#fffaf7"
            />
            <path
              id="Path_1415"
              data-name="Path 1415"
              d="M459.661,50.447a203.956,203.956,0,0,1,39.58-12.9c22.014-4.67,36.011-7.445,36.011-7.445S517.366,17.893,505.71,14.38s-83.05,18.027-83.05,18.027S447.267,42.862,459.661,50.447Z"
              transform="translate(166.598 5.515)"
              fill="#fff"
            />
            <path
              id="Path_1416"
              data-name="Path 1416"
              d="M549.883,171.2a72.153,72.153,0,0,1-2.049,7.779c-5.883,17.5-44.767,31.7-63.894,34.394a36.067,36.067,0,0,1-14.611-.627c-16.2-3.458-37.642-14.388-38.158-22.307a7.885,7.885,0,0,0-.139-1.561c3.639,3.485,11.335,9.2,26.6,15.475,24.956,10.233,46.816,1.213,68.844-10.359C545.059,184.124,549.074,174.1,549.883,171.2Z"
              transform="translate(169.897 67.481)"
              fill="#e7dcdd"
            />
            <path
              id="Path_1417"
              data-name="Path 1417"
              d="M488.3,195.442c-.084,18.765-22.878,91.764-46.579,112.7-.167.167-.362.307-.53.474-23.84,20.675-61.594,30.992-99.069,25.444A129.992,129.992,0,0,1,277.9,305.748c-20.913-17.3-43.861-84.417-46.37-107.825-.139-1.394-.223-2.7-.223-3.806,0,0,12.757-26.852,37.977-41.2,50.371-28.734,131.832-28.873,181.925-.335,17.329,9.885,28.427,26.629,33.641,35.983a76.535,76.535,0,0,1,3.444,6.873Z"
              transform="translate(91.175 51.744)"
              fill="#e6b85c"
            />
            <path
              id="Path_1418"
              data-name="Path 1418"
              d="M428.959,179.243c-.084,18.765-22.878,91.764-46.579,112.7-.167.167-.362.307-.53.474,21.582-48.6,31.383-106.528,31.383-106.528,4.74-5.381,8.8-9.913,12.283-13.523a76.557,76.557,0,0,1,3.444,6.873Z"
              transform="translate(150.512 67.942)"
              fill="#d29544"
            />
            <path
              id="Path_1419"
              data-name="Path 1419"
              d="M342.055,315.22A129.992,129.992,0,0,1,277.84,286.9c-20.912-17.3-43.86-84.417-46.37-107.825,33.781,15.015,79.063,44.181,79.063,44.181S320.041,282.9,342.055,315.22Z"
              transform="translate(91.238 70.587)"
              fill="#d29544"
            />
            <path
              id="Path_1420"
              data-name="Path 1420"
              d="M443.582,287.476c-37.977,33.571-112.216,40.263-163.8-2.4-22.084-18.25-46.4-92.015-46.579-111.268-1.227,2.175-1.882,3.527-1.882,3.527-.112,18.765,24.37,93.27,46.579,111.645,51.584,42.647,125.823,35.955,163.814,2.384,7.891-6.971,15.7-19.769,22.585-34.38C457.886,269.952,450.776,281.119,443.582,287.476Z"
              transform="translate(91.178 68.51)"
              fill="#9c620e"
            />
            <path
              id="Path_1421"
              data-name="Path 1421"
              d="M451.154,247.122c-50.037,28.957-131.5,28.776-181.869-.321-22.307-12.854-34.743-29.194-37.419-45.924-1.854-11.558.962-23.31,8.463-34.241,6.246-9.062,15.712-17.553,28.4-24.872,50.064-28.915,131.512-28.776,181.9.335S501.344,218.193,451.154,247.122Z"
              transform="translate(91.176 47.368)"
              fill="#f2d07c"
            />
            <path
              id="Path_1422"
              data-name="Path 1422"
              d="M464.358,207.822A38.954,38.954,0,0,1,461,213.4c-.6.864-1.227,1.757-1.938,2.621a34.193,34.193,0,0,1-2.579,3.067h0a78.924,78.924,0,0,1-19.518,15.336l-1.394.781c-2.788,1.534-5.744,3.025-8.769,4.378a153.358,153.358,0,0,1-35.258,10.6,194.449,194.449,0,0,1-24.509,2.788c-1.785.07-3.541.112-5.382.223s-3.695,0-5.577,0c-2.314,0-4.67,0-6.971-.153-1.757,0-3.513-.112-5.228-.223a27.351,27.351,0,0,1-3.025-.223,184.78,184.78,0,0,1-32.791-5.3,149.268,149.268,0,0,1-21.261-7.18c-3.736-1.645-7.361-3.36-10.791-5.3-.669-.376-1.311-.711-1.938-1.087a76.372,76.372,0,0,1-21.86-18.124c-.781-1.018-1.534-2.021-2.2-3.025a36.329,36.329,0,0,1-3.36-5.758c-9.369-19.044-2.049-40.04,22.042-55.906,2.091-1.394,4.364-2.788,6.762-4.113,19.518-10.763,44.293-16.73,69.708-17.887,32.066-1.492,65.177,4.559,89.826,18.124a87.261,87.261,0,0,1,7.626,4.67c13.942,9.369,22.307,20.536,24.83,31.926A35.816,35.816,0,0,1,464.358,207.822Z"
              transform="translate(95.665 50.726)"
              fill="#d29544"
            />
            <path
              id="Path_1423"
              data-name="Path 1423"
              d="M422.281,201.242a38.233,38.233,0,0,1-3.346,5.646,44.466,44.466,0,0,1-4.531,5.688h0a78.407,78.407,0,0,1-19.518,15.266q-.669.418-1.394.795c-2.788,1.548-5.744,3.011-8.769,4.364a153.358,153.358,0,0,1-35.272,10.624,207.172,207.172,0,0,0,16.577-16.507c14.959-17.5,28.371-60.075,34.506-81.768,14.039,9.383,22.307,20.536,24.858,31.954a35.969,35.969,0,0,1-3.109,23.938Z"
              transform="translate(137.741 57.292)"
              fill="#a46210"
            />
            <path
              id="Path_1424"
              data-name="Path 1424"
              d="M341.731,253.1c-1.757,0-3.5-.139-5.214-.223-1.018,0-2.035-.139-3.011-.223a186.224,186.224,0,0,1-32.8-5.3,150.85,150.85,0,0,1-21.247-7.18c-8.616-18.71-17.859-48.447-18.124-89.227,2.105-1.394,4.392-2.788,6.79-4.113,19.518-10.735,44.293-16.73,69.708-17.887-.2,30.992,1.046,73.626,8.086,98.986C349.218,239.8,346.848,247.747,341.731,253.1Z"
              transform="translate(103.007 50.828)"
              fill="#dca855"
            />
            <path
              id="Path_1425"
              data-name="Path 1425"
              d="M428.054,210.376q-.669.418-1.394.795c-2.788,1.548-5.744,3.011-8.769,4.364-17.553,7.863-38.4,12.31-59.754,13.468-1.8,0-3.583.112-5.381.2s-3.694,0-5.577,0c-4.085,0-8.17-.139-12.227-.362-1.018,0-2.035-.139-3.011-.223a186.221,186.221,0,0,1-32.8-5.3,137.773,137.773,0,0,1-32.066-12.548l-1.91-1.1c1.394-.85,2.788-1.659,4.252-2.482,42.383-23.38,111.24-23.241,153.832.279C424.917,208.494,426.493,209.414,428.054,210.376Z"
              transform="translate(104.517 74.787)"
              fill="#c07f2e"
            />
            <path
              id="Path_1426"
              data-name="Path 1426"
              d="M456.372,201.649a34.194,34.194,0,0,1-2.579,3.067h0a78.924,78.924,0,0,1-19.518,15.336l-1.394.781c-2.788,1.534-5.744,3.025-8.769,4.378a153.356,153.356,0,0,1-35.258,10.6,194.448,194.448,0,0,1-24.509,2.788c-1.784.07-3.541.112-5.381.223s-3.695,0-5.577,0c-2.314,0-4.67,0-6.971-.153-1.757,0-3.513-.112-5.228-.223a27.345,27.345,0,0,1-3.025-.223,184.783,184.783,0,0,1-32.791-5.3,149.266,149.266,0,0,1-21.261-7.18c-3.736-1.645-7.361-3.36-10.791-5.3-.669-.376-1.311-.711-1.938-1.087A76.373,76.373,0,0,1,249.52,201.23a75.286,75.286,0,0,1,15.461-13.342c2.175-1.394,4.489-2.788,6.971-4.183,19.755-10.9,44.976-16.953,70.824-18.194,32.568-1.492,66.139,4.629,91.164,18.459a86.945,86.945,0,0,1,7.7,4.74A71.772,71.772,0,0,1,456.372,201.649Z"
              transform="translate(98.352 65.153)"
              fill="#f3ecae"
            />
            <path
              id="Path_1427"
              data-name="Path 1427"
              d="M398.883,98.792l-10.177,11.572a37.08,37.08,0,0,1-3.555-4.6c2.077-5.939,9.2-12.213,9.2-12.213Z"
              transform="translate(151.813 36.874)"
              fill="#9fa29c"
            />
            <path
              id="Path_1428"
              data-name="Path 1428"
              d="M408.524,98.175a5.716,5.716,0,0,0-2.621-4.5,1.687,1.687,0,0,0-1.994,0h0l-43.219,25,3.764,6.246,43.219-24.844-.084-.139a1.659,1.659,0,0,0,.934-1.757Z"
              transform="translate(142.172 36.794)"
              fill="#d7dddd"
            />
            <path
              id="Path_1429"
              data-name="Path 1429"
              d="M407.44,95.916c.181-.669-.7-1.087-1.966-.948a4.559,4.559,0,0,0-1.9.655h0l-43.5,24.342,2.872,1.269,43.512-24.3h0a1.91,1.91,0,0,0,.976-1.018Z"
              transform="translate(141.931 37.422)"
              fill="#ecf3f3"
            />
            <path
              id="Path_1430"
              data-name="Path 1430"
              d="M309.945,207.123a16.885,16.885,0,0,1-4.894-.7c-12.91-3.918-19.923-12.952-20.271-26.141l6.971-.2c.265,10.177,5.27,16.591,15.336,19.63,14.444,4.336,43.93-24.509,78.952-77.181a19.267,19.267,0,0,0,2.788-6.4l6.845,1.492a26.308,26.308,0,0,1-3.806,8.783C366.854,164.044,333.144,207.123,309.945,207.123Z"
              transform="translate(112.251 45.778)"
              fill="#c6cfcf"
            />
            <path
              id="Path_1431"
              data-name="Path 1431"
              d="M309.555,203.459a15.043,15.043,0,0,1-4.35-.613c-12.171-3.681-18.5-11.85-18.835-24.258l2.956-.084c.293,11.153,5.772,18.194,16.73,21.512,22.028,6.706,64.132-52.323,81.224-77.99a20.912,20.912,0,0,0,3.081-7.1l2.9.627a24.036,24.036,0,0,1-3.513,8.1C369.393,154.273,333.033,203.459,309.555,203.459Z"
              transform="translate(112.877 45.301)"
              fill="#dae4e4"
            />
            <path
              id="Path_1432"
              data-name="Path 1432"
              d="M283.971,153.149,277,152.41c1.394-13.272,35.969-26.782,102.778-40.11l1.394,6.859C310.585,133.254,284.7,146.276,283.971,153.149Z"
              transform="translate(109.184 44.265)"
              fill="#d8dede"
            />
            <path
              id="Path_1433"
              data-name="Path 1433"
              d="M281.392,152.38l-2.942-.321c1.6-15.336,55.906-29.277,101.175-38.34l.572,2.9C319.411,128.763,282.465,142.133,281.392,152.38Z"
              transform="translate(109.756 44.824)"
              fill="#ecf3f3"
            />
            <path
              id="Path_1434"
              data-name="Path 1434"
              d="M395.582,116.749h0a4.073,4.073,0,0,0-.335-.906,5.014,5.014,0,0,0-.363-.725,5.575,5.575,0,0,0-1.171-1.394,6.3,6.3,0,0,0-.739-.53h0a6.3,6.3,0,0,0-1.394-.613h0a2.786,2.786,0,0,0-.558-.167h0a8.952,8.952,0,0,0-2.44-.167l-1.06.084h0a18.122,18.122,0,0,0-3.011.669l-2.5.739h0c-1.492.46-3.025.92-4.6,1.394h0c-5.577,1.715-11.585,3.667-17.831,5.814h0c-2.523.85-5.061,1.757-7.626,2.677h0c-2.886,1.032-5.8,2.119-8.672,3.207h0l-.655.265c-.53.2-1.046.418-1.589.613-6.622,2.579-13.077,5.312-18.988,8.128h0q-4.489,2.133-8.477,4.35a74.206,74.206,0,0,0-12.366,8.24h0a27.953,27.953,0,0,0-3.792,3.834q-2.788,3.513-4.977,6.608h0a53.4,53.4,0,0,0-6.079,10.791h0a1.214,1.214,0,0,0-.139.349,12.656,12.656,0,0,0-.488,1.394,16.551,16.551,0,0,0-.6,2.342,13.568,13.568,0,0,0-.223,3.834,6.728,6.728,0,0,0,.209,1.2h0a5.331,5.331,0,0,0,.2.781c.084.279.2.572.307.864l.125.265a6,6,0,0,0,.446.837q.046.081.084.167a10.581,10.581,0,0,0,1.394,1.7,10.943,10.943,0,0,0,3.457,2.231,15.765,15.765,0,0,0,1.561.516,24.147,24.147,0,0,0,6.511.781,21.381,21.381,0,0,0,2.635-.112h0a30.238,30.238,0,0,0,4.322-.432c1.143-.153,2.328-.335,3.583-.572s2.272-.432,3.471-.7A48.8,48.8,0,0,0,320,183.1c1.785-.669,3.6-1.394,5.423-2.286h0c1.394-.683,2.872-1.394,4.336-2.2a165.241,165.241,0,0,0,26.21-18.291c.362-.307.739-.6,1.1-.92,3.918-3.29,7.738-6.692,11.432-10.122l3.527-3.318h0c1.534-1.464,3.053-2.956,4.531-4.392l2.384-2.356c1.994-2.022,3.9-3.973,5.744-5.9h0l2.328-2.426h0c.6-.641,1.2-1.269,1.771-1.9s1.143-1.2,1.673-1.8h0c.795-.836,1.52-1.617,2.245-2.412a15.18,15.18,0,0,0,2.384-3.332,11.134,11.134,0,0,0,.516-1.129h0v-.209a6.235,6.235,0,0,0,.237-.906.857.857,0,0,1,.07-.418h0a5.27,5.27,0,0,0,0-1.227h0A8.427,8.427,0,0,0,395.582,116.749ZM291.55,176.224a13.2,13.2,0,0,1,1.073-4h0c1.324-3.276,4.182-8.2,9.954-15.419,3.82-4.754,12.743-10.289,25.959-16.27,1.185-.544,2.4-1.074,3.653-1.6q4.057-1.771,8.588-3.583c8.156-3.248,17.4-6.58,27.646-9.94h0c5.688-1.882,11.7-3.75,17.971-5.577l.655-.2c.335-.084.627-.139.906-.181l-.321.418c-.125.139-.251.293-.4.446-1.882,2.063-4.183,4.489-6.734,7.18-3.039,3.207-6.525,6.748-10.331,10.442l-2.7,2.635a269.21,269.21,0,0,1-28.957,24.314c-3.165,2.231-6.316,4.294-9.425,6.12a83.931,83.931,0,0,1-10,5.033,47.178,47.178,0,0,1-7.389,2.384,3.163,3.163,0,0,1-.349.084,70.556,70.556,0,0,1-9.759,1.506c-7.738.613-9.425-1.283-9.759-1.785v-.07h0a3.415,3.415,0,0,1-.293-1.645C291.536,176.433,291.55,176.336,291.55,176.224Z"
              transform="translate(112.284 44.235)"
              fill="#c5cece"
            />
            <path
              id="Path_1435"
              data-name="Path 1435"
              d="M381,127.916c-3.109,3.221-6.608,6.734-10.359,10.373-.892.864-1.812,1.729-2.788,2.593a256.9,256.9,0,0,1-28.4,23.617c2.788-.823,5.577-1.673,8.518-2.51,2.384-1.826,4.768-3.736,7.11-5.688,5.744-4.782,11.335-9.871,16.563-14.89.864-.823,1.715-1.645,2.551-2.482s1.645-1.589,2.426-2.4h0c1.882-2.677,3.778-5.465,5.688-8.3l2.649-3.945c.363-.53.7-1.1,1-1.645C384.474,124.263,382.815,126.034,381,127.916ZM393.787,113.6l-.1-.153a3.876,3.876,0,0,0-2.245-1.492h-.1a5.744,5.744,0,0,0-1.394-.181,10.665,10.665,0,0,0-2.788.279c-.46.1-.948.209-1.478.376h0L380.459,114h0l-4.071,1.269h0c-5.772,1.8-12.046,3.862-18.473,6.093h0c-2.342.823-4.712,1.659-7.068,2.523-2.788,1.046-5.73,2.119-8.56,3.221h-.153a3.781,3.781,0,0,1-.544.237c-.53.2-1.046.418-1.589.613-6.5,2.593-12.8,5.3-18.473,8.086h0c-2.872,1.394-5.577,2.788-8.072,4.28h0c-6.19,3.541-11.084,7.152-13.942,10.693a17.313,17.313,0,0,0-1.046,1.394h0q-7.264,9.229-9.759,15.6h0a15.992,15.992,0,0,0-1.394,6.385h0a4.784,4.784,0,0,0,0,.781h0a8.043,8.043,0,0,0,.572,2.119,6.977,6.977,0,0,0,.474.906,7.222,7.222,0,0,0,2.51,2.426,16.939,16.939,0,0,0,8.658,1.84,20.054,20.054,0,0,0,2.384-.1h0a54.851,54.851,0,0,0,6.455-.753c.572-.084,1.129-.2,1.715-.321h0c.976-.153,1.966-.376,3-.586a61.343,61.343,0,0,0,15.238-5.883,139.234,139.234,0,0,0,19.769-12.952c2.384-1.826,4.768-3.736,7.11-5.688,5.744-4.782,11.335-9.871,16.563-14.89.864-.823,1.715-1.645,2.551-2.482s1.645-1.589,2.426-2.4h0c1.3-1.283,2.579-2.565,3.806-3.82h0c1.394-1.394,2.649-2.7,3.89-4.015s2.4-2.537,3.541-3.75,2.008-2.147,2.942-3.165l.558-.613h0l.07-.084a11.433,11.433,0,0,0,1.394-1.812.53.53,0,0,0,.139-.181h0a8.362,8.362,0,0,0,.878-1.715h0a1.566,1.566,0,0,1,.112-.362,4.947,4.947,0,0,0,.181-.906,3.583,3.583,0,0,0-.46-2.4Zm-4.852,5.9c-.335.362-.669.739-1.046,1.115-.572.655-1.2,1.311-1.84,2.008-1.534,1.645-3.234,3.416-5.047,5.3-3.109,3.221-6.608,6.734-10.359,10.373-.892.864-1.812,1.729-2.788,2.593a256.9,256.9,0,0,1-28.4,23.617,123.485,123.485,0,0,1-11.376,7.138,72.715,72.715,0,0,1-10.01,4.615,45.154,45.154,0,0,1-5.73,1.673l-1.269.265a54.08,54.08,0,0,1-13.133,1.394h0c-4.057-.209-6.065-1.311-6.971-2.551l-.125-.181a.491.491,0,0,1-.07-.112,1.717,1.717,0,0,1-.2-.349c-.809-1.715-.92-5.256,3.193-12.338h0a92.629,92.629,0,0,1,7.821-11.153c3.5-4.35,10.512-8.895,19.239-13.286h0c2.147-1.087,4.406-2.147,6.72-3.207l1.757-.795c9.076-4.043,19.142-7.863,28.664-11.153h0c2.886-1.018,5.73-1.994,8.476-2.9h.07c3.653-1.227,7.1-2.342,10.3-3.346l3.945-1.241h0l5.577-1.7c.376-.112.739-.209,1.087-.279l.586-.125a8.821,8.821,0,0,1,1.478-.139c.962,0,1.52.223,1.687.474a.627.627,0,0,1,.084.362,2.231,2.231,0,0,1-.223.892c0,.1-.084.2-.125.307a11.517,11.517,0,0,1-1.673,2.3l-.084.084C389.172,119.23,389.061,119.37,388.935,119.5ZM381,127.86c-3.109,3.221-6.608,6.734-10.359,10.373-.892.864-1.812,1.729-2.788,2.593a256.9,256.9,0,0,1-28.4,23.617c2.788-.823,5.577-1.673,8.518-2.51,2.384-1.826,4.768-3.736,7.11-5.688,5.744-4.782,11.335-9.871,16.563-14.89.864-.823,1.715-1.645,2.551-2.482s1.645-1.589,2.426-2.4h0c1.882-2.677,3.778-5.465,5.688-8.3l2.649-3.945c.363-.53.7-1.1,1-1.645q-2.238,2.51-4.963,5.326Z"
              transform="translate(113.243 44.054)"
              fill="#d9e3e3"
            />
            <path
              id="Path_1436"
              data-name="Path 1436"
              d="M319.9,188.482c-16.242,0-28.023-3.513-35.119-10.5-6.246-6.134-8.825-14.681-7.7-25.43l6.971.739c-.892,8.5,1,15.141,5.646,19.686,7.877,7.752,23.7,10.233,47.109,7.375,35.314-4.336,50.343-38.409,56.157-58.346.07-.223.139-.46-.293-.92-1.31-1.394-5.7-2.914-11.418-1.785l-1.394-6.859c7.264-1.394,14.485.112,17.957,3.9a7.724,7.724,0,0,1,1.854,7.626c-5.061,17.329-21.261,58.332-62.026,63.337a144.983,144.983,0,0,1-17.748,1.171Z"
              transform="translate(109.115 44.12)"
              fill="#d8dede"
            />
            <path
              id="Path_1437"
              data-name="Path 1437"
              d="M319.257,185.889c-15.643,0-26.921-3.318-33.641-9.926-5.772-5.674-8.156-13.663-7.1-23.771l2.942.321c-.962,9.146,1.143,16.326,6.232,21.345,8.365,8.2,24.746,10.874,48.8,7.933,36.471-4.461,51.9-39.371,57.858-59.782a2.788,2.788,0,0,0-.739-2.788c-1.952-2.133-7.138-3.625-13.314-2.4l-.572-2.9c6.594-1.394,13.049,0,16.061,3.29a5.744,5.744,0,0,1,1.394,5.688c-4.949,16.995-20.759,57.049-60.339,61.887A145.087,145.087,0,0,1,319.257,185.889Z"
              transform="translate(109.686 44.692)"
              fill="#ecf3f3"
            />
            <path
              id="Path_1438"
              data-name="Path 1438"
              d="M284.784,184.171c-.349-13.091,5.786-30.672,18.264-52.142,15.252-26.336,59.74-27,84.863-25.095a8.365,8.365,0,0,1,6.148,3.346c2.021,2.788,2.607,6.692,1.631,11.153l-6.845-1.492c.613-2.788.167-4.754-.4-5.577a1.311,1.311,0,0,0-1.06-.544c-18.933-1.464-64.438-2.286-78.282,21.582-11.809,20.369-17.636,36.653-17.316,48.433Z"
              transform="translate(112.247 41.893)"
              fill="#c6cfcf"
            />
            <path
              id="Path_1439"
              data-name="Path 1439"
              d="M285,182.756c-.335-12.715,5.716-29.891,18-51.068,14.708-25.36,58.29-25.959,82.967-24.049,3.876.307,6.72,1.617,8.449,3.9s2.272,5.744,1.394,9.954l-2.9-.6c.7-3.346.39-5.883-.878-7.57s-3.3-2.509-6.3-2.788c-19.309-1.492-65.777-2.286-80.192,22.572-11.99,20.7-17.915,37.35-17.58,49.507Z"
              transform="translate(112.334 42.164)"
              fill="#dae4e4"
            />
            <path
              id="Path_1440"
              data-name="Path 1440"
              d="M550.453,115.17c-.5,12.854-1.171,25.513-2.035,37.168,0,.558-.112,1.129-.153,1.7-.251,3.555-.572,7.124-.892,10.665l-.544,5.326c-.125,1.394-.293,2.649-.446,3.959h0a13.093,13.093,0,0,1-.139,1.394v.362c-.669,5.577-2.091,11.153-2.579,16.73a3.633,3.633,0,0,1-.181.823v.2a.194.194,0,0,1,0,.1c-.223,1.018-.432,1.994-.669,2.914s-.488,1.98-.753,2.872a1.246,1.246,0,0,1-.084.279c-.153.5-.307.976-.474,1.394s-.2.558-.307.837-.181.446-.279.655v.167c-.125.279-.265.572-.418.85a.764.764,0,0,1-.112.209.221.221,0,0,1,0,.1c-.2.335-.376.669-.585,1,0,.125-.167.251-.251.39-3.6,5.8-9.759,10.205-15.67,13.649l-1.2.7h-.1l-.446.251-1.046.586-.167.084c-.474.265-.948.53-1.394.781l-.627.335c-1.213.627-2.468,1.255-3.722,1.854-.7.335-1.394.669-2.119.976a3.68,3.68,0,0,1-.53.251l-.265.112c-.711.335-1.394.655-2.161.948l-2.788,1.157-1.255.488-1.98.781c-1.52.558-3.011,1.1-4.5,1.617l-.795.265h-.153c-.809.279-1.631.558-2.44.795-.307.112-.627.209-.92.293l-1.115.349-.376.112c-.781.237-1.575.474-2.37.683l-1.213.349-2.231.572c-.376.112-.753.2-1.115.279l-1.1.265-1.645.376h-.125l-.39.084c-.837.181-1.659.349-2.426.488l-1.561.279c-.627.112-1.255.2-1.84.279a39.911,39.911,0,0,1-5.577.446h-2.063l-1.073-.084h-.167l-.962-.112-1.143-.167-1.185-.181-1.2-.237h-.237l-.99-.2c-2.022-.432-4.183-.99-6.274-1.645-.53-.153-1.06-.335-1.589-.5l-1.617-.53-1.394-.516-.4-.139-1.394-.516c-.335-.112-.655-.251-.99-.39-.1-1.715-.181-3.43-.251-5.131q-.7-14.067-.837-28.162v-2.7c0-10.233-.809-20.369-.976-30.672a5.438,5.438,0,0,1,.5-2.914c1.143-1.91,3.876-1.743,6.079-1.575a33.293,33.293,0,0,0,13.189-2.049,51.347,51.347,0,0,0,6.3-3.039l14.834-8c1.575-.85,3.513-1.854,5.186-2.788.934-.544,4.182-3.471,5.131-3.29,2.063.362.809,7.431.781,8.867s0,2.677,0,4.015v2.886a24.667,24.667,0,0,0,.1,2.691c.1.892.1,1.812.167,2.7s.1,1.394.167,2.035a3.367,3.367,0,0,0,.1.99c.07.725.167,1.394.265,2.133s.153,1.157.237,1.715c.139.809.279,1.617.432,2.384a.679.679,0,0,1,0-.167.923.923,0,0,0,0-.2c.084-.99.2-2.049.349-3.193.112-.7.209-1.394.321-2.189.07-.474.153-.948.237-1.394.167-1.06.362-2.189.586-3.36.641-3.5,1.394-7.361,2.356-11.53.153-.613.279-1.241.418-1.868.92-4.336,1.924-8.923,2.928-13.663a94.382,94.382,0,0,1,16.563-6.622l.753-.209c.572-.139,1.143-.279,1.7-.446s1.032-.321,1.534-.516a24.147,24.147,0,0,0,4.615-2.788l6.19-4.294c1.757-1.213,2.161-2.035,4.182-2.147h.237a41.34,41.34,0,0,0,6.58-.864Z"
              transform="translate(176.353 45.396)"
              fill="#e7dddd"
            />
            <path
              id="Path_1441"
              data-name="Path 1441"
              d="M415.148,310.306l-4.392,9.55-14.011,5.674-17.106-.892-12.171-7.027-1.547-9.885.781-.613.767,4.949,12.171,7.027,17.106.906,14.011-5.674-.683-10.261,3.458,4.252Z"
              transform="translate(144.233 119.85)"
              fill="#7e8e87"
            />
            <path
              id="Path_1442"
              data-name="Path 1442"
              d="M402.779,306.482l-1.617,3.541-2.774,6.009-.683-10.261-.4-6.051Z"
              transform="translate(156.602 118.139)"
              fill="#eae182"
            />
            <path
              id="Path_1443"
              data-name="Path 1443"
              d="M402.813,246.6l-12.338-3.346-13.119,2.008-7.765,6.413,1.227,7.821,9.648,5.577,13.537.7,11.111-4.475,3.485-7.57Z"
              transform="translate(145.68 95.881)"
              fill="#cae7eb"
            />
            <path
              id="Path_1444"
              data-name="Path 1444"
              d="M400.517,245.819c-7.124-4.113-18.64-4.182-25.722,0s-7.04,10.735.084,14.848,18.64,4.182,25.722,0S407.641,249.932,400.517,245.819Z"
              transform="translate(145.648 95.667)"
              fill="#9bb6be"
            />
            <path
              id="Path_1445"
              data-name="Path 1445"
              d="M398.076,246.7a22.892,22.892,0,0,0-20.759,0c-5.716,3.3-5.688,8.658.07,11.99a22.934,22.934,0,0,0,20.759,0C403.862,255.347,403.82,249.98,398.076,246.7Z"
              transform="translate(147.043 96.261)"
              fill="#abd2d6"
            />
            <path
              id="Path_1446"
              data-name="Path 1446"
              d="M398.076,243.921a22.976,22.976,0,0,0-20.759,0c-5.716,3.3-5.688,8.672.07,11.99a22.976,22.976,0,0,0,20.759,0C403.862,252.606,403.82,247.239,398.076,243.921Z"
              transform="translate(147.043 95.168)"
              fill="#cae7eb"
            />
            <path
              id="Path_1447"
              data-name="Path 1447"
              d="M369.891,289.4l-1.506,19.435-.446,5.925-.5,5.981-.767-4.963-.781-4.907c.572-1.6,1.715-15.029,2.788-28.817Z"
              transform="translate(144.221 111.174)"
              fill="#3a3329"
            />
            <path
              id="Path_1448"
              data-name="Path 1448"
              d="M371.471,257.125l-1.7,36.123-.683,9.062-1.157-7.347v-.181c1.227-15.475,2.314-45.492,2.314-45.492Z"
              transform="translate(145.025 98.261)"
              fill="#788f98"
            />
            <path
              id="Path_1449"
              data-name="Path 1449"
              d="M380.289,294.737l-.167,5.214-.2,5.577-.725,20.16-12.171-7.027.46-5.981.446-5.925,1.506-19.435.2,1.255Z"
              transform="translate(144.671 113.251)"
              fill="#4e4638"
            />
            <path
              id="Path_1450"
              data-name="Path 1450"
              d="M380.778,260.473l-.349,24.286-.823,22.753-10.651-6.162-.2-1.255.683-9.062,1.7-36.123Z"
              transform="translate(145.352 100.477)"
              fill="#8aa3ac"
            />
            <path
              id="Path_1451"
              data-name="Path 1451"
              d="M392.866,324.5l-17.106-.906.725-20.16.2-5.577.167-5.214.153.084,15.155.781.084-.028.084,3.639.112,5.577Z"
              transform="translate(148.112 115.348)"
              fill="#605646"
            />
            <path
              id="Path_1452"
              data-name="Path 1452"
              d="M391.932,306.776l-.084.028-15.155-.781-.153-.084.823-22.753.349-24.286,13.565.711.167,22.92Z"
              transform="translate(148.419 102.049)"
              fill="#9bb6be"
            />
            <path
              id="Path_1453"
              data-name="Path 1453"
              d="M402.219,320.111l-14.011,5.674-.432-21.8-.112-5.577-.084-3.639,12.366-4.977.223-.418.962,14.43.4,6.051Z"
              transform="translate(152.771 114.059)"
              fill="#786956"
            />
            <path
              id="Path_1454"
              data-name="Path 1454"
              d="M400.355,302.393v.056l-.223.418-12.366,4.977-.488-24.245-.167-22.92,11.112-4.489,1.213,32.526v.014l.014.014Z"
              transform="translate(152.585 100.981)"
              fill="#abd2d6"
            />
            <path
              id="Path_1455"
              data-name="Path 1455"
              d="M403.051,312.863l-1.617,3.541-2.774,6.009-.683-10.261-.4-6.051-.962-14.43v-.056l3.973-8.086Z"
              transform="translate(156.33 111.758)"
              fill="#8f8373"
            />
            <path
              id="Path_1456"
              data-name="Path 1456"
              d="M401.186,296.447l-3.973,8.086-.906-13.649-.014-.014v-.014L395.08,258.33l3.472-7.57Z"
              transform="translate(155.727 98.841)"
              fill="#b8dfe5"
            />
            <path
              id="Path_1457"
              data-name="Path 1457"
              d="M367.468,312.591v5.549l-1.547-9.885V302.72l.781,4.921Z"
              transform="translate(144.233 119.322)"
              fill="#60808c"
            />
            <path
              id="Path_1458"
              data-name="Path 1458"
              d="M379.2,316.827v5.549l-12.171-7.027V309.8Z"
              transform="translate(144.671 122.112)"
              fill="#799baa"
            />
            <path
              id="Path_1459"
              data-name="Path 1459"
              d="M392.866,315.746v5.535l-17.106-.892V314.84Z"
              transform="translate(148.112 124.099)"
              fill="#8aaebe"
            />
            <path
              id="Path_1460"
              data-name="Path 1460"
              d="M402.041,311.42v5.535l-14.011,5.674v-5.535Z"
              transform="translate(152.948 122.751)"
              fill="#99c2d0"
            />
            <path
              id="Path_1461"
              data-name="Path 1461"
              d="M402.482,304.57V310.1l-4.392,9.564v-5.535Z"
              transform="translate(156.913 120.051)"
              fill="#a7dfe8"
            />
            <path
              id="Path_1462"
              data-name="Path 1462"
              d="M411.9,286.829l-3.973,8.086v.056l-.223.418-12.366,4.977-.084.028-15.155-.781-.153-.084-10.651-6.162-.2-1.255-1.157-7.347-.028-.153.028-.028,1.84-1.534,6.818-5.632,4.169-.641,10.54-1.617,3.541.962,10.289,2.788L407,281.239v.014l.014.014Z"
              transform="translate(145.017 108.458)"
              fill="#918a75"
            />
            <path
              id="Path_1463"
              data-name="Path 1463"
              d="M407.047,247.284c-.962,2.454-1.645,5.158-5.047,7.124a5.586,5.586,0,0,1-.641.335,27.619,27.619,0,0,1-13.231,2.788,28.83,28.83,0,0,1-10.526-2.077h0a20.124,20.124,0,0,1-2.231-1.2c-3.778-2.189-3.876-5.27-4.852-7.975a10.86,10.86,0,0,0,4.336,4.7c.223.153.474.293.711.432a26.949,26.949,0,0,0,12.757,3.234A28.412,28.412,0,0,0,401.512,252c.349-.167.683-.349,1-.53A12.186,12.186,0,0,0,407.047,247.284Z"
              transform="translate(146.046 97.075)"
              fill="#a2a9a5"
            />
            <path
              id="Path_1464"
              data-name="Path 1464"
              d="M408.133,249.325c-.1.265-.209.516-.321.781a9.3,9.3,0,0,0-.432,1.018,12.185,12.185,0,0,1-4.587,4.294c-.321.181-.655.363-1,.53A28.413,28.413,0,0,1,388.6,258.6a26.949,26.949,0,0,1-12.771-3.165c-.237-.139-.488-.279-.711-.432a10.861,10.861,0,0,1-4.336-4.7.721.721,0,0,0-.112-.265,6.968,6.968,0,0,0-.446-.99,9.633,9.633,0,0,1-.349-4.894,13.355,13.355,0,0,1,3.918-7.668l.181-.181c.46-.446.5.976.558,2.635a13.334,13.334,0,0,0,.07,1.673c0,1.394.279,2.509.85,2.286h.1c6.3-3.639,15.963-4.182,23.241-1.52a20.492,20.492,0,0,1,3.388,1.506c1.2.711,1.3-.795,1.394-2.37.1-1.311.237-2.649,1.046-2.788C405.749,237.53,410.294,243.3,408.133,249.325Z"
              transform="translate(145.727 93.11)"
              fill="#c3c8c6"
            />
            <path
              id="Path_1465"
              data-name="Path 1465"
              d="M402.267,237.743c-7.445-4.294-19.518-4.322-26.879,0s-7.361,11.223.084,15.531,19.518,4.322,26.879,0S409.712,242.038,402.267,237.743Z"
              transform="translate(145.793 92.437)"
              fill="#dfe3e0"
            />
            <path
              id="Path_1466"
              data-name="Path 1466"
              d="M377.892,259.318a20.144,20.144,0,0,1-2.217-1.157c-3.778-2.189-3.876-5.27-4.852-7.975a.721.721,0,0,0-.112-.265,6.971,6.971,0,0,0-.446-.99,9.634,9.634,0,0,1-.349-4.894,13.356,13.356,0,0,1,3.918-7.668c.251.767.5,1.6.739,2.454.349,1.394.669,2.788.92,3.959a2.235,2.235,0,0,0,.139.586c.46,2.272.711,3.987.711,3.987s-1.84,3.207-1.7,4.475a13.4,13.4,0,0,0,.516,3.053A10.234,10.234,0,0,0,377.892,259.318Z"
              transform="translate(145.743 93.169)"
              fill="#aeaeb4"
            />
            <path
              id="Path_1467"
              data-name="Path 1467"
              d="M387.554,246.867a79.314,79.314,0,0,0-13.342-5.437c.46,2.272.711,3.987.711,3.987s-1.84,3.207-1.7,4.475a13.4,13.4,0,0,0,.516,3.053,10.233,10.233,0,0,0,2.788,4.378h0a28.831,28.831,0,0,0,10.526,2.077l.139-2.788s.46-.474.613-2.788a66.92,66.92,0,0,0-.251-6.957Z"
              transform="translate(147.108 95.163)"
              fill="#dcdcdf"
            />
            <path
              id="Path_1468"
              data-name="Path 1468"
              d="M399.9,248.9c-.1.265-.209.516-.321.781a9.284,9.284,0,0,0-.432,1.018c-.962,2.454-1.645,5.158-5.047,7.124a5.585,5.585,0,0,1-.641.335v-2.342l.111-.293a6.97,6.97,0,0,0,.641-3.43c-.362-.99-1.52-4.629-1.52-4.629a47.154,47.154,0,0,1-2.105-6.622,20.5,20.5,0,0,1,3.36,1.617c1.2.711,1.3-.795,1.394-2.37.1-1.311.237-2.649,1.046-2.788C397.519,237.106,402.064,242.878,399.9,248.9Z"
              transform="translate(153.957 93.534)"
              fill="#4d4d4d"
            />
            <path
              id="Path_1469"
              data-name="Path 1469"
              d="M400.13,235.582c-6.608-3.82-17.288-3.834-23.854,0s-6.525,9.968.07,13.774,17.288,3.834,23.854,0S406.78,239.388,400.13,235.582Z"
              transform="translate(146.383 91.727)"
              fill="#dfe3e1"
            />
            <path
              id="Path_1470"
              data-name="Path 1470"
              d="M399.09,235.4c-6.19-3.583-16.2-3.6-22.307,0s-6.12,9.327.07,12.91,16.2,3.583,22.307,0S405.295,238.97,399.09,235.4Z"
              transform="translate(146.711 91.726)"
              fill="#4d4d4d"
            />
            <path
              id="Path_1471"
              data-name="Path 1471"
              d="M381.664,234.57a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0C382.082,235.239,382.082,234.807,381.664,234.57Z"
              transform="translate(149.737 92.389)"
              fill="#eaeaec"
            />
            <path
              id="Path_1472"
              data-name="Path 1472"
              d="M381.684,234.61a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0C382.1,235.223,382.1,234.847,381.684,234.61Z"
              transform="translate(149.745 92.405)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1473"
              data-name="Path 1473"
              d="M380.445,235.1a2.147,2.147,0,0,1,1.52-.223h0a.53.53,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.655.655,0,0,1,.251-.307Z"
              transform="translate(149.742 92.401)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1474"
              data-name="Path 1474"
              d="M384.143,234.159a1.673,1.673,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0C384.561,234.772,384.561,234.4,384.143,234.159Z"
              transform="translate(150.714 92.229)"
              fill="#eaeaec"
            />
            <path
              id="Path_1475"
              data-name="Path 1475"
              d="M384.164,234.2a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0C384.638,234.813,384.638,234.437,384.164,234.2Z"
              transform="translate(150.722 92.244)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1476"
              data-name="Path 1476"
              d="M382.925,234.674a2.217,2.217,0,0,1,1.52-.209h0a.558.558,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.669.669,0,0,1,.251-.335Z"
              transform="translate(150.72 92.243)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1477"
              data-name="Path 1477"
              d="M386.6,234.52a1.631,1.631,0,0,0-1.478,0c-.418.237-.418.613,0,.85a1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(151.677 92.37)"
              fill="#eaeaec"
            />
            <path
              id="Path_1478"
              data-name="Path 1478"
              d="M386.616,234.57a1.631,1.631,0,0,0-1.478,0c-.418.223-.418.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(151.685 92.389)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1479"
              data-name="Path 1479"
              d="M385.365,235.044a2.216,2.216,0,0,1,1.52-.209h0a.5.5,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.209-.4.558,0,.795a.669.669,0,0,1,.251-.321Z"
              transform="translate(151.681 92.389)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1480"
              data-name="Path 1480"
              d="M388.115,235.74a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(152.277 92.851)"
              fill="#eaeaec"
            />
            <path
              id="Path_1481"
              data-name="Path 1481"
              d="M388.135,235.78a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(152.285 92.866)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1482"
              data-name="Path 1482"
              d="M386.88,236.268a2.077,2.077,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.613.613,0,0,1,.251-.321Z"
              transform="translate(152.286 92.866)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1483"
              data-name="Path 1483"
              d="M386.766,237.33a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(151.745 93.477)"
              fill="#eaeaec"
            />
            <path
              id="Path_1484"
              data-name="Path 1484"
              d="M386.786,237.37a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(151.752 93.493)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1485"
              data-name="Path 1485"
              d="M385.53,237.858a2.077,2.077,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.714,1.714,0,0,0-1.52,0,.432.432,0,0,0,0,.809.613.613,0,0,1,.251-.321Z"
              transform="translate(151.754 93.493)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1486"
              data-name="Path 1486"
              d="M384.8,238.69a1.659,1.659,0,0,0-1.492,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,.014-.85Z"
              transform="translate(150.966 94.013)"
              fill="#eaeaec"
            />
            <path
              id="Path_1487"
              data-name="Path 1487"
              d="M384.817,238.73a1.659,1.659,0,0,0-1.492,0,.45.45,0,0,0,0,.85,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,.014-.85Z"
              transform="translate(150.974 94.029)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1488"
              data-name="Path 1488"
              d="M383.565,239.188a2.077,2.077,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809A.614.614,0,0,1,383.565,239.188Z"
              transform="translate(150.972 94.017)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1489"
              data-name="Path 1489"
              d="M379.505,235.47a1.631,1.631,0,0,0-1.478,0c-.418.223-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(148.884 92.744)"
              fill="#eaeaec"
            />
            <path
              id="Path_1490"
              data-name="Path 1490"
              d="M379.505,235.51a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(148.884 92.76)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1491"
              data-name="Path 1491"
              d="M378.29,236a2.147,2.147,0,0,1,1.52-.223h0a.53.53,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.613.613,0,0,1,.251-.307Z"
              transform="translate(148.9 92.756)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1492"
              data-name="Path 1492"
              d="M377.126,236.74a1.631,1.631,0,0,0-1.478,0c-.418.237-.418.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(147.944 93.245)"
              fill="#eaeaec"
            />
            <path
              id="Path_1493"
              data-name="Path 1493"
              d="M377.143,236.79a1.631,1.631,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.864Z"
              transform="translate(147.955 93.265)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1494"
              data-name="Path 1494"
              d="M375.9,237.264a2.147,2.147,0,0,1,1.52-.209h0a.5.5,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.67.67,0,0,1,.251-.335Z"
              transform="translate(147.949 93.264)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1495"
              data-name="Path 1495"
              d="M379.507,238.05a1.631,1.631,0,0,0-1.478,0c-.418.237-.418.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(148.882 93.761)"
              fill="#eaeaec"
            />
            <path
              id="Path_1496"
              data-name="Path 1496"
              d="M379.553,238.12a1.631,1.631,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.864Z"
              transform="translate(148.905 93.789)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1497"
              data-name="Path 1497"
              d="M378.3,238.608a2.147,2.147,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.669.669,0,0,1,.251-.321Z"
              transform="translate(148.904 93.789)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1498"
              data-name="Path 1498"
              d="M381.945,239.42a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(149.845 94.301)"
              fill="#eaeaec"
            />
            <path
              id="Path_1499"
              data-name="Path 1499"
              d="M381.966,239.46a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(149.853 94.317)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1500"
              data-name="Path 1500"
              d="M380.71,239.948a2.147,2.147,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.669.669,0,0,1,.251-.321Z"
              transform="translate(149.854 94.317)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1501"
              data-name="Path 1501"
              d="M384.356,240.76a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(150.795 94.829)"
              fill="#eaeaec"
            />
            <path
              id="Path_1502"
              data-name="Path 1502"
              d="M384.376,240.8a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(150.803 94.845)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1503"
              data-name="Path 1503"
              d="M383.15,241.288a2.147,2.147,0,0,1,1.52-.209h0a.585.585,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809A.613.613,0,0,1,383.15,241.288Z"
              transform="translate(150.815 94.845)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1504"
              data-name="Path 1504"
              d="M386.766,242.1a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(151.745 95.358)"
              fill="#eaeaec"
            />
            <path
              id="Path_1505"
              data-name="Path 1505"
              d="M386.786,242.14a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(151.752 95.373)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1506"
              data-name="Path 1506"
              d="M385.53,242.628a2.078,2.078,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809A.613.613,0,0,1,385.53,242.628Z"
              transform="translate(151.754 95.373)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1507"
              data-name="Path 1507"
              d="M388.914,243.43a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0C389.332,244.043,389.332,243.667,388.914,243.43Z"
              transform="translate(152.594 95.882)"
              fill="#eaeaec"
            />
            <path
              id="Path_1508"
              data-name="Path 1508"
              d="M388.934,243.47a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(152.602 95.898)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1509"
              data-name="Path 1509"
              d="M387.7,243.958a2.077,2.077,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809A.725.725,0,0,1,387.7,243.958Z"
              transform="translate(152.6 95.897)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1510"
              data-name="Path 1510"
              d="M388.478,322.4l-4.392,9.55-14.011,5.674-17.106-.906L340.8,329.687l-1.548-9.871.781-.627.767,4.963,12.171,7.027,17.106.892,14.011-5.66L383.4,316.15l3.457,4.238Z"
              transform="translate(133.721 124.615)"
              fill="#7e8e87"
            />
            <path
              id="Path_1511"
              data-name="Path 1511"
              d="M376.109,318.572l-1.617,3.527-2.774,6.023-.683-10.261-.4-6.051Z"
              transform="translate(146.09 122.904)"
              fill="#eae182"
            />
            <path
              id="Path_1512"
              data-name="Path 1512"
              d="M376.143,258.672,363.8,255.34l-13.119,2.008-7.765,6.413,1.227,7.821,9.648,5.563,13.537.711,11.112-4.475,3.485-7.584Z"
              transform="translate(135.167 100.646)"
              fill="#cae7eb"
            />
            <path
              id="Path_1513"
              data-name="Path 1513"
              d="M373.847,257.88c-7.124-4.113-18.64-4.182-25.722,0s-7.04,10.735.084,14.848,18.64,4.183,25.722,0S380.971,262.062,373.847,257.88Z"
              transform="translate(135.135 100.421)"
              fill="#9bb6be"
            />
            <path
              id="Path_1514"
              data-name="Path 1514"
              d="M371.406,258.752a22.934,22.934,0,0,0-20.759,0c-5.716,3.29-5.688,8.658.07,11.976a22.934,22.934,0,0,0,20.759,0C377.192,267.438,377.15,262.084,371.406,258.752Z"
              transform="translate(136.531 101.012)"
              fill="#abd2d6"
            />
            <path
              id="Path_1515"
              data-name="Path 1515"
              d="M371.406,256.012a22.934,22.934,0,0,0-20.759,0c-5.716,3.3-5.688,8.672.07,11.99a22.934,22.934,0,0,0,20.759,0C377.192,264.7,377.164,259.33,371.406,256.012Z"
              transform="translate(136.531 99.932)"
              fill="#cae7eb"
            />
            <path
              id="Path_1516"
              data-name="Path 1516"
              d="M343.213,301.487l-1.52,19.435-.446,5.925-.46,5.981-.767-4.963-.781-4.907c.572-1.6,1.715-15.029,2.788-28.817Z"
              transform="translate(133.717 115.94)"
              fill="#b9c1bd"
            />
            <path
              id="Path_1517"
              data-name="Path 1517"
              d="M344.8,269.215l-1.7,36.137-.683,9.062-1.157-7.347v-.209c1.227-15.461,2.314-45.478,2.314-45.478Z"
              transform="translate(134.513 103.027)"
              fill="#788f98"
            />
            <path
              id="Path_1518"
              data-name="Path 1518"
              d="M353.632,306.827l-.181,5.214-.2,5.577-.725,20.16-12.171-7.027.46-5.981.446-5.925,1.506-19.435.2,1.255Z"
              transform="translate(134.158 118.017)"
              fill="#cfd5d3"
            />
            <path
              id="Path_1519"
              data-name="Path 1519"
              d="M354.108,272.567l-.349,24.286-.809,22.753-10.665-6.162-.2-1.255.683-9.062,1.7-36.137Z"
              transform="translate(134.84 105.238)"
              fill="#8aa3ac"
            />
            <path
              id="Path_1520"
              data-name="Path 1520"
              d="M366.2,336.573l-17.106-.892.725-20.16.2-5.577.181-5.214.139.07,15.155.795.084-.042.084,3.653.111,5.577Z"
              transform="translate(137.599 120.114)"
              fill="#e3e7e5"
            />
            <path
              id="Path_1521"
              data-name="Path 1521"
              d="M365.258,318.852l-.084.042-15.155-.795-.139-.07.809-22.753.349-24.286,13.565.7.167,22.934Z"
              transform="translate(137.911 106.815)"
              fill="#9bb6be"
            />
            <path
              id="Path_1522"
              data-name="Path 1522"
              d="M375.549,332.205l-14.011,5.66-.432-21.791-.112-5.577-.084-3.653,12.366-4.977.223-.418.962,14.444.4,6.051Z"
              transform="translate(142.258 118.821)"
              fill="#f7fffa"
            />
            <path
              id="Path_1523"
              data-name="Path 1523"
              d="M373.685,314.483v.042l-.223.418L361.1,319.92l-.488-24.231-.167-22.934,11.111-4.475,1.213,32.512v.028l.014.014Z"
              transform="translate(142.073 105.746)"
              fill="#abd2d6"
            />
            <path
              id="Path_1524"
              data-name="Path 1524"
              d="M376.381,324.953l-1.617,3.527-2.774,6.023-.683-10.261-.4-6.051-.962-14.444v-.042l3.973-8.086Z"
              transform="translate(145.818 116.523)"
              fill="#f7fffb"
            />
            <path
              id="Path_1525"
              data-name="Path 1525"
              d="M374.516,308.537l-3.973,8.086-.906-13.649-.014-.014v-.028L368.41,270.42l3.471-7.57Z"
              transform="translate(145.215 103.606)"
              fill="#b8dfe5"
            />
            <path
              id="Path_1526"
              data-name="Path 1526"
              d="M340.8,324.681v5.535l-1.548-9.871V314.81l.781,4.907Z"
              transform="translate(133.721 124.087)"
              fill="#60808c"
            />
            <path
              id="Path_1527"
              data-name="Path 1527"
              d="M352.531,328.917v5.535l-12.171-7.027V321.89Z"
              transform="translate(134.158 126.878)"
              fill="#799baa"
            />
            <path
              id="Path_1528"
              data-name="Path 1528"
              d="M366.2,327.822v5.549l-17.106-.906V326.93Z"
              transform="translate(137.599 128.864)"
              fill="#8aaebe"
            />
            <path
              id="Path_1529"
              data-name="Path 1529"
              d="M375.371,323.51v5.535l-14.011,5.674V329.17Z"
              transform="translate(142.436 127.516)"
              fill="#99c2d0"
            />
            <path
              id="Path_1530"
              data-name="Path 1530"
              d="M375.812,316.66v5.535l-4.392,9.564V326.21Z"
              transform="translate(146.401 124.816)"
              fill="#a7dfe8"
            />
            <path
              id="Path_1531"
              data-name="Path 1531"
              d="M385.226,298.919l-3.973,8.086v.042l-.223.418-12.366,4.977-.084.042-15.155-.795-.139-.07-10.665-6.162-.2-1.255-1.157-7.347-.028-.153.028-.042,1.84-1.52,6.831-5.632,4.155-.641,10.526-1.617,3.555.962L378.464,291l1.868,2.314v.028l.014.014Z"
              transform="translate(134.505 113.224)"
              fill="#e4e5e5"
            />
            <path
              id="Path_1532"
              data-name="Path 1532"
              d="M380.389,259.306c-.962,2.44-1.645,5.158-5.047,7.124a5.573,5.573,0,0,1-.641.335,27.576,27.576,0,0,1-13.231,2.788,29.125,29.125,0,0,1-10.526-2.077h0a18.117,18.117,0,0,1-2.272-1.115c-3.778-2.175-3.876-5.256-4.852-7.961a10.945,10.945,0,0,0,4.336,4.7l.711.432a26.949,26.949,0,0,0,12.757,3.234,28.231,28.231,0,0,0,13.119-2.649c.349-.153.683-.335,1-.516A12.185,12.185,0,0,0,380.389,259.306Z"
              transform="translate(135.522 101.852)"
              fill="#a2a9a5"
            />
            <path
              id="Path_1533"
              data-name="Path 1533"
              d="M381.459,261.4a.209.209,0,0,0,0,.084c-.1.265-.209.516-.321.767a9.473,9.473,0,0,0-.432,1.032,12.185,12.185,0,0,1-4.587,4.294c-.321.181-.655.362-1,.516a28.232,28.232,0,0,1-13.189,2.663,26.949,26.949,0,0,1-12.757-3.234l-.711-.432a10.944,10.944,0,0,1-4.336-4.7.721.721,0,0,0-.112-.265,6.966,6.966,0,0,0-.446-.99,9.634,9.634,0,0,1-.349-4.894,13.314,13.314,0,0,1,3.918-7.668,2.223,2.223,0,0,1,.181-.181c.46-.446.516.976.558,2.621a13.434,13.434,0,0,0,.07,1.687c.07,1.394.279,2.509.864,2.286h.084c6.3-3.639,15.963-4.182,23.255-1.52a19.752,19.752,0,0,1,3.43,1.561c1.2.711,1.3-.795,1.394-2.37.1-1.311.237-2.649,1.06-2.788S383.62,255.392,381.459,261.4Z"
              transform="translate(135.219 97.875)"
              fill="#c3c8c6"
            />
            <path
              id="Path_1534"
              data-name="Path 1534"
              d="M375.6,249.835c-7.445-4.308-19.518-4.322-26.879,0s-7.361,11.223.084,15.531,19.518,4.322,26.879,0S383.042,254.129,375.6,249.835Z"
              transform="translate(135.281 97.2)"
              fill="#dfe3e0"
            />
            <path
              id="Path_1535"
              data-name="Path 1535"
              d="M351.238,271.392a18.114,18.114,0,0,1-2.273-1.115c-3.778-2.175-3.876-5.256-4.852-7.961a.721.721,0,0,0-.111-.265,6.972,6.972,0,0,0-.446-.99,9.634,9.634,0,0,1-.349-4.894,13.314,13.314,0,0,1,3.918-7.668c.265.767.5,1.589.739,2.44.349,1.394.669,2.788.934,3.973a2,2,0,0,0,.125.572c.46,2.272.711,3.987.711,3.987s-1.84,3.221-1.7,4.489a13.4,13.4,0,0,0,.516,3.053,10.315,10.315,0,0,0,2.788,4.378Z"
              transform="translate(135.215 97.95)"
              fill="#aeaeb4"
            />
            <path
              id="Path_1536"
              data-name="Path 1536"
              d="M360.884,258.961a80.134,80.134,0,0,0-13.342-5.451c.46,2.272.711,3.987.711,3.987s-1.84,3.221-1.7,4.489a13.4,13.4,0,0,0,.516,3.053,10.317,10.317,0,0,0,2.788,4.378h0a29.125,29.125,0,0,0,10.526,2.077l.139-2.788s.46-.474.613-2.788A66.887,66.887,0,0,0,360.884,258.961Z"
              transform="translate(136.596 99.925)"
              fill="#dcdcdf"
            />
            <path
              id="Path_1537"
              data-name="Path 1537"
              d="M373.229,260.972a.21.21,0,0,0,0,.084c-.1.265-.209.516-.321.767a9.477,9.477,0,0,0-.432,1.032c-.962,2.44-1.645,5.158-5.047,7.124a5.57,5.57,0,0,1-.641.335v-2.342l.112-.307a6.971,6.971,0,0,0,.641-3.416c-.363-.99-1.52-4.629-1.52-4.629A46.107,46.107,0,0,1,363.93,253a19.752,19.752,0,0,1,3.43,1.561c1.2.711,1.3-.795,1.394-2.37.1-1.311.237-2.649,1.06-2.788S375.39,254.963,373.229,260.972Z"
              transform="translate(143.449 98.304)"
              fill="#4d4d4d"
            />
            <path
              id="Path_1538"
              data-name="Path 1538"
              d="M373.49,247.66c-6.608-3.806-17.288-3.834-23.854,0s-6.525,9.954.07,13.774,17.288,3.834,23.854,0S380.1,251.48,373.49,247.66Z"
              transform="translate(135.883 96.49)"
              fill="#dfe3e1"
            />
            <path
              id="Path_1539"
              data-name="Path 1539"
              d="M372.423,247.478c-6.19-3.569-16.2-3.583-22.307,0s-6.12,9.327,0,12.9,16.2,3.6,22.307,0S378.627,251.061,372.423,247.478Z"
              transform="translate(136.197 96.49)"
              fill="#4d4d4d"
            />
            <path
              id="Path_1540"
              data-name="Path 1540"
              d="M356,246.1a1.673,1.673,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.659,1.659,0,0,0,1.492,0C356.422,246.712,356.422,246.336,356,246.1Z"
              transform="translate(139.623 96.936)"
              fill="#eaeaec"
            />
            <path
              id="Path_1541"
              data-name="Path 1541"
              d="M356.026,246.14a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.659,1.659,0,0,0,1.492,0C356.444,246.753,356.444,246.377,356.026,246.14Z"
              transform="translate(139.628 96.95)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1542"
              data-name="Path 1542"
              d="M354.785,246.614a2.2,2.2,0,0,1,1.52-.209h0a.642.642,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.669.669,0,0,1,.251-.335Z"
              transform="translate(139.628 96.95)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1543"
              data-name="Path 1543"
              d="M353.364,246.77a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(138.582 97.198)"
              fill="#eaeaec"
            />
            <path
              id="Path_1544"
              data-name="Path 1544"
              d="M353.383,246.819a1.673,1.673,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0C353.8,247.432,353.8,247.056,353.383,246.819Z"
              transform="translate(138.59 97.219)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1545"
              data-name="Path 1545"
              d="M352.155,247.293a2.147,2.147,0,0,1,1.52-.209h0a.5.5,0,0,0-.251-.265,1.757,1.757,0,0,0-1.52,0c-.39.223-.4.572,0,.809A.711.711,0,0,1,352.155,247.293Z"
              transform="translate(138.591 97.219)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1546"
              data-name="Path 1546"
              d="M351.174,247.81a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(137.719 97.608)"
              fill="#eaeaec"
            />
            <path
              id="Path_1547"
              data-name="Path 1547"
              d="M351.194,247.86a1.631,1.631,0,0,0-1.478,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0C351.626,248.473,351.626,248.125,351.194,247.86Z"
              transform="translate(137.726 97.628)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1548"
              data-name="Path 1548"
              d="M349.955,248.334a2.216,2.216,0,0,1,1.52-.209h0a.5.5,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.209-.4.558,0,.795a.809.809,0,0,1,.251-.321Z"
              transform="translate(137.724 97.628)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1549"
              data-name="Path 1549"
              d="M349.977,249.33a1.631,1.631,0,0,0-1.478,0c-.418.237-.418.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(137.243 98.207)"
              fill="#eaeaec"
            />
            <path
              id="Path_1550"
              data-name="Path 1550"
              d="M350,249.37a1.631,1.631,0,0,0-1.478,0c-.418.237-.418.613,0,.85a1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(137.25 98.223)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1551"
              data-name="Path 1551"
              d="M348.74,249.858a2.077,2.077,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.614.614,0,0,1,.251-.321Z"
              transform="translate(137.252 98.223)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1552"
              data-name="Path 1552"
              d="M350.225,251.05a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(137.343 98.885)"
              fill="#eaeaec"
            />
            <path
              id="Path_1553"
              data-name="Path 1553"
              d="M350.243,251.049a1.673,1.673,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.864Z"
              transform="translate(137.352 98.887)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1554"
              data-name="Path 1554"
              d="M348.99,251.523a2.147,2.147,0,0,1,1.52-.209h0a.5.5,0,0,0-.251-.265,1.757,1.757,0,0,0-1.52,0,.432.432,0,0,0,0,.809.67.67,0,0,1,.251-.335Z"
              transform="translate(137.351 98.886)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1555"
              data-name="Path 1555"
              d="M352.623,251.68a1.631,1.631,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.659,1.659,0,0,0,1.492,0C353.042,252.293,353.042,251.917,352.623,251.68Z"
              transform="translate(138.29 99.134)"
              fill="#eaeaec"
            />
            <path
              id="Path_1556"
              data-name="Path 1556"
              d="M352.646,251.72a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.659,1.659,0,0,0,1.492,0C353.064,252.333,353.064,251.957,352.646,251.72Z"
              transform="translate(138.296 99.149)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1557"
              data-name="Path 1557"
              d="M351.405,252.184a2.2,2.2,0,0,1,1.52-.209h0a.5.5,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.669.669,0,0,1,.251-.335Z"
              transform="translate(138.295 99.145)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1558"
              data-name="Path 1558"
              d="M355.643,251.05a1.631,1.631,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.659,1.659,0,0,0,1.492,0,.46.46,0,0,0-.014-.864Z"
              transform="translate(139.481 98.885)"
              fill="#eaeaec"
            />
            <path
              id="Path_1559"
              data-name="Path 1559"
              d="M355.666,251.05a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.659,1.659,0,0,0,1.492,0C356.084,251.691,356.084,251.315,355.666,251.05Z"
              transform="translate(139.486 98.885)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1560"
              data-name="Path 1560"
              d="M354.425,251.544a2.2,2.2,0,0,1,1.52-.209h0a.572.572,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.558,0,.809a.669.669,0,0,1,.251-.335Z"
              transform="translate(139.486 98.893)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1561"
              data-name="Path 1561"
              d="M358.163,249.99a1.631,1.631,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.864Z"
              transform="translate(140.474 98.467)"
              fill="#eaeaec"
            />
            <path
              id="Path_1562"
              data-name="Path 1562"
              d="M358.186,250.05a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0C358.632,250.65,358.632,250.273,358.186,250.05Z"
              transform="translate(140.479 98.491)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1563"
              data-name="Path 1563"
              d="M356.947,250.514a2.2,2.2,0,0,1,1.52-.209h0a.641.641,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.4.223-.4.558,0,.809a.613.613,0,0,1,.251-.335Z"
              transform="translate(140.478 98.487)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1564"
              data-name="Path 1564"
              d="M360.927,249.35a1.659,1.659,0,0,0-1.492,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,.014-.85Z"
              transform="translate(141.558 98.215)"
              fill="#eaeaec"
            />
            <path
              id="Path_1565"
              data-name="Path 1565"
              d="M360.947,249.39a1.659,1.659,0,0,0-1.492,0,.46.46,0,0,0,0,.864,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,.014-.864Z"
              transform="translate(141.566 98.231)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1566"
              data-name="Path 1566"
              d="M359.7,249.878a2.147,2.147,0,0,1,1.52-.209h0a.586.586,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.809.809,0,0,1,.251-.321Z"
              transform="translate(141.563 98.231)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1567"
              data-name="Path 1567"
              d="M363.685,250.29a1.631,1.631,0,0,0-1.478,0c-.418.223-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(142.648 98.586)"
              fill="#eaeaec"
            />
            <path
              id="Path_1568"
              data-name="Path 1568"
              d="M363.705,250.33a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(142.656 98.601)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1569"
              data-name="Path 1569"
              d="M362.45,250.818a2.077,2.077,0,0,1,1.52-.209h0a.585.585,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.613.613,0,0,1,.251-.321Z"
              transform="translate(142.656 98.601)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1570"
              data-name="Path 1570"
              d="M365.213,251.41a1.631,1.631,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.673,1.673,0,0,0,1.478,0,.46.46,0,0,0,0-.864Z"
              transform="translate(143.253 99.027)"
              fill="#eaeaec"
            />
            <path
              id="Path_1571"
              data-name="Path 1571"
              d="M365.236,251.46a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0A.461.461,0,0,0,365.236,251.46Z"
              transform="translate(143.258 99.047)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1572"
              data-name="Path 1572"
              d="M364,251.934a2.175,2.175,0,0,1,1.506-.209h0a.5.5,0,0,0-.251-.265,1.687,1.687,0,0,0-1.506,0c-.4.209-.4.558,0,.795a.641.641,0,0,1,.251-.321Z"
              transform="translate(143.257 99.047)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1573"
              data-name="Path 1573"
              d="M365.226,253.47a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0A.455.455,0,0,0,365.226,253.47Z"
              transform="translate(143.254 99.839)"
              fill="#eaeaec"
            />
            <path
              id="Path_1574"
              data-name="Path 1574"
              d="M365.246,253.51a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.85Z"
              transform="translate(143.262 99.855)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1575"
              data-name="Path 1575"
              d="M364.007,254a2.091,2.091,0,0,1,1.506-.209h0a.585.585,0,0,0-.251-.279,1.687,1.687,0,0,0-1.506,0c-.4.223-.4.572,0,.809A.641.641,0,0,1,364.007,254Z"
              transform="translate(143.26 99.855)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1576"
              data-name="Path 1576"
              d="M363.675,254.92a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(142.644 100.411)"
              fill="#eaeaec"
            />
            <path
              id="Path_1577"
              data-name="Path 1577"
              d="M363.693,254.959a1.673,1.673,0,0,0-1.478,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0,.46.46,0,0,0,0-.864Z"
              transform="translate(142.654 100.428)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1578"
              data-name="Path 1578"
              d="M362.44,255.448a2.147,2.147,0,0,1,1.52-.209h0a.585.585,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809.669.669,0,0,1,.251-.321Z"
              transform="translate(142.652 100.426)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1579"
              data-name="Path 1579"
              d="M360.917,255.519a1.7,1.7,0,0,0-1.492,0,.46.46,0,0,0,0,.864,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,.014-.864Z"
              transform="translate(141.554 100.649)"
              fill="#eaeaec"
            />
            <path
              id="Path_1580"
              data-name="Path 1580"
              d="M360.938,255.56a1.659,1.659,0,0,0-1.492,0,.45.45,0,0,0,0,.85,1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,.014-.85Z"
              transform="translate(141.562 100.663)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1581"
              data-name="Path 1581"
              d="M359.685,256.034a2.217,2.217,0,0,1,1.52-.209h0a.558.558,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809a.754.754,0,0,1,.251-.335Z"
              transform="translate(141.559 100.663)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1582"
              data-name="Path 1582"
              d="M358.245,255.93a1.631,1.631,0,0,0-1.478,0c-.418.223-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(140.504 100.809)"
              fill="#eaeaec"
            />
            <path
              id="Path_1583"
              data-name="Path 1583"
              d="M358.265,255.97a1.631,1.631,0,0,0-1.478,0c-.418.237-.4.613,0,.85a1.631,1.631,0,0,0,1.478,0,.446.446,0,0,0,0-.85Z"
              transform="translate(140.512 100.825)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1584"
              data-name="Path 1584"
              d="M357.01,256.462a2.147,2.147,0,0,1,1.52-.223h0a.53.53,0,0,0-.251-.279,1.715,1.715,0,0,0-1.52,0,.432.432,0,0,0,0,.809A.614.614,0,0,1,357.01,256.462Z"
              transform="translate(140.512 100.82)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1585"
              data-name="Path 1585"
              d="M355.246,255.46a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.659,1.659,0,0,0,1.492,0A.472.472,0,0,0,355.246,255.46Z"
              transform="translate(139.32 100.624)"
              fill="#eaeaec"
            />
            <path
              id="Path_1586"
              data-name="Path 1586"
              d="M355.266,255.5a1.631,1.631,0,0,0-1.478,0,.446.446,0,0,0,0,.85,1.659,1.659,0,0,0,1.492,0C355.684,256.127,355.684,255.737,355.266,255.5Z"
              transform="translate(139.328 100.639)"
              fill="#3b3d4e"
            />
            <path
              id="Path_1587"
              data-name="Path 1587"
              d="M354.025,255.988a2.133,2.133,0,0,1,1.52-.223h0a.641.641,0,0,0-.251-.265,1.715,1.715,0,0,0-1.52,0c-.39.223-.4.572,0,.809A.557.557,0,0,1,354.025,255.988Z"
              transform="translate(139.328 100.639)"
              fill="#b3b8b5"
            />
            <path
              id="Path_1588"
              data-name="Path 1588"
              d="M221.319,204.588,114.01,142.255,219.994,81.72,327.3,144.053l-8.714,7.57.014,33.167Z"
              transform="translate(44.939 32.211)"
              fill="#88999f"
            />
            <path
              id="Path_1589"
              data-name="Path 1589"
              d="M255.739,133.263,148.43,70.93l58,15.043,107.309,62.333Z"
              transform="translate(58.506 27.958)"
              fill="#d4cfed"
            />
            <path
              id="Path_1590"
              data-name="Path 1590"
              d="M296.96,126.44v12.617l-.028,214.1v37.628L190.99,451.322V186.947Z"
              transform="translate(75.282 49.838)"
              fill="#d7d2f0"
            />
            <path
              id="Path_1591"
              data-name="Path 1591"
              d="M221.333,187.463V451.839l-50.12-29.11-57.2-33.223V125.13Z"
              transform="translate(44.939 49.322)"
              fill="#aeb1c5"
            />
            <path
              id="Path_1592"
              data-name="Path 1592"
              d="M255.739,113.6,148.43,51.25V78.687L255.739,141.02Z"
              transform="translate(58.506 20.201)"
              fill="#aeb1c5"
            />
            <path
              id="Path_1593"
              data-name="Path 1593"
              d="M269.306,133.263,162,70.93,114.01,146.508l107.309,62.333Z"
              transform="translate(44.939 27.958)"
              fill="#c5c0de"
            />
            <path
              id="Path_1594"
              data-name="Path 1594"
              d="M296.964,128.318l-54.47-6.678L190.98,188.853Z"
              transform="translate(75.278 47.946)"
              fill="#eae5ff"
            />
            <path
              id="Path_1595"
              data-name="Path 1595"
              d="M774.772,273.422h0l-24.691,8.63-.209-.125L724.9,266.995l-1.659-.976-7.264-4.378-3.708-2.217a43.832,43.832,0,0,0-25.667-5.688,42.436,42.436,0,0,0-8.63,1.617,45.392,45.392,0,0,0-9.62,4.071l-53.508,30.867-.377.209-49.437,28.58-50.469,29.11-18.919,10.93-1.91,1.1-10.972,6.385-13.733,2.454L435,375.238v16.577h.125a13.119,13.119,0,0,0,2.886,9.759,14.622,14.622,0,0,0,3.583,3.025l12.366,7.305,22.822,13.523,20.7,12.283a38.3,38.3,0,0,0,6.762,3.109,43.457,43.457,0,0,0,31.466-.39,44.2,44.2,0,0,0,5.688-2.719l51.236-29.584,1.994-1.157L705.468,343l.391-.209,6.58-3.778,23.046-13.356,32.721-18.877a12.9,12.9,0,0,0,6.511-12.617h.084Zm-71.9,0a55.014,55.014,0,0,1,9.522,5.995c.641.5,1.241.976,1.8,1.478.335.307.544.6.836.85a34.07,34.07,0,0,1-4.378-.669,49.675,49.675,0,0,1-5.186-1.324c-.628-.209-1.311-.418-1.994-.683-1.227-.46-2.51-.934-3.778-1.534-.349-.125-.641-.251-.934-.376h0a55.43,55.43,0,0,1-13.607-8.672,1.812,1.812,0,0,1-.432-.432l-.418-.418a54.259,54.259,0,0,1,18.57,5.828Z"
              transform="translate(171.462 99.949)"
              fill="#cf934e"
            />
            <path
              id="Path_1596"
              data-name="Path 1596"
              d="M504.276,347.54v59.587A38.454,38.454,0,0,1,497.514,404L441.58,370.892a13.063,13.063,0,0,1-6.455-12.784H435V341.545l47.778-8.658,10.986-6.357Z"
              transform="translate(171.462 128.707)"
              fill="#a15c16"
            />
            <path
              id="Path_1597"
              data-name="Path 1597"
              d="M516.114,341.6v59.224a43.484,43.484,0,0,1-31.424.363V341.6Z"
              transform="translate(191.048 134.647)"
              fill="#b56719"
            />
            <path
              id="Path_1598"
              data-name="Path 1598"
              d="M798.372,356.406h-.084a16.73,16.73,0,0,1-8.365,16.2l-290.99,168.08a53.807,53.807,0,0,1-7.347,3.527,55.836,55.836,0,0,1-40.333.488,50.314,50.314,0,0,1-8.672-4.015L308.5,463.311a16.73,16.73,0,0,1-8.365-16.4H300V425.64l61.343-11.153,14.109-8.156L599.481,276.995a56.352,56.352,0,0,1,56.352,0l110.753,63.922,31.745-5.758Z"
              transform="translate(118.25 106.206)"
              fill="#cf934e"
            />
            <path
              id="Path_1599"
              data-name="Path 1599"
              d="M451.253,367.672V505.987a50.3,50.3,0,0,1-8.672-4.015L308.5,424.6a16.73,16.73,0,0,1-8.365-16.4H300V386.939l61.343-11.153,14.109-8.156Z"
              transform="translate(118.25 144.907)"
              fill="#99601a"
            />
            <path
              id="Path_1600"
              data-name="Path 1600"
              d="M448.823,367.66V505.487a55.836,55.836,0,0,1-40.333.488V367.66Z"
              transform="translate(161.013 144.919)"
              fill="#ad6d1d"
            />
            <path
              id="Path_1601"
              data-name="Path 1601"
              d="M827.785,279.131a8.559,8.559,0,0,0-.307-1.283,6.082,6.082,0,0,0-.376-1.143,3.29,3.29,0,0,0-.391-1.018,6.537,6.537,0,0,0-.627-1.2,10.34,10.34,0,0,0-.892-1.311h0a9.933,9.933,0,0,0-1.018-1.143,13.425,13.425,0,0,0-2.788-2.091L797.964,256l-7.654-4.545-11.558-6.845-4.977-2.942-8.365-4.921a44.028,44.028,0,0,0-43.916,0l-51.222,29.584-14.457-8.365a56.38,56.38,0,0,0-56.366,0L308.5,426.006a16.633,16.633,0,0,0-8.3,12.366c-.084.85-.125,1.659-.125,2.468a16.733,16.733,0,0,0,1.185,5.953h0a16.34,16.34,0,0,0,7.236,8.365l21.721,12.547,11.056,6.427,12.073,6.971h.084l17.8,10.289,10.122,5.828,7.319,4.183,18.013,10.414,19.727,11.39,16.117,9.313c1.1.627,2.217,1.227,3.36,1.785a50.022,50.022,0,0,0,5.312,2.245c.85.307,1.7.6,2.551.85a56.714,56.714,0,0,0,45.143-4.88L774.807,373.265l15.141-8.755a16.925,16.925,0,0,0,2.635-27.3,15.153,15.153,0,0,0-2.635-1.91l-1.394-.767-11.432-6.58-8.477-4.893,51.988-30.016.767-.418a13.314,13.314,0,0,0,6.511-10.247,16.071,16.071,0,0,0,0-2.008ZM767.376,289.88c.335.307.544.6.836.85a34.091,34.091,0,0,1-4.378-.669,49.716,49.716,0,0,1-5.186-1.324c-.627-.209-1.31-.418-1.994-.683-1.227-.46-2.51-.934-3.778-1.534-.349-.125-.641-.251-.934-.376h0a55.431,55.431,0,0,1-13.607-8.672,1.812,1.812,0,0,1-.432-.432l-.418-.418a54.263,54.263,0,0,1,18.612,5.786,55.009,55.009,0,0,1,9.522,5.995c.6.5,1.2.976,1.757,1.478Z"
              transform="translate(118.281 91.006)"
              fill="#edc672"
            />
            <path
              id="Path_1602"
              data-name="Path 1602"
              d="M827.446,276.081a8.552,8.552,0,0,0-.307-1.283,6.087,6.087,0,0,0-.376-1.143,3.292,3.292,0,0,0-.391-1.018,6.539,6.539,0,0,0-.627-1.2,10.344,10.344,0,0,0-.892-1.311h0a9.93,9.93,0,0,0-1.018-1.143,13.426,13.426,0,0,0-2.788-2.091l-23.422-13.942-7.654-4.545-11.558-6.845-4.977-2.942c-1.06.349-2.133.725-3.151,1.115a481.863,481.863,0,0,0-57.161,27.033c-11.265,6.12-22.53,12.283-33.836,18.319a.572.572,0,0,1-.167.125q-7.835,4.28-15.74,8.5a1.785,1.785,0,0,1-.377.223l-11.153,5.995a27.884,27.884,0,0,1,2.468-11.014.951.951,0,0,1,.126-.307c3.025-7.779,7.1-15.336,2.342-21.456-5.144-6.636-15.6-4-23.338-.683a.125.125,0,0,1-.084,0c-3.834,1.659-7.654,3.318-11.488,5.019-3.611,1.52-7.18,3.1-10.749,4.712-6.329,2.788-12.673,5.577-18.961,8.5q-18.487,8.365-36.778,17.009c-39.748,18.738-79.063,38.423-118.183,58.485q-37.489,19.253-74.727,38.911L340.06,410.925c-3.067,1.617-6.218,3.276-9.271,5.061a110.007,110.007,0,0,0-15.015,10.163,58.889,58.889,0,0,0-10.582,10.665,39.5,39.5,0,0,0-4.252,6.971h0a16.34,16.34,0,0,0,7.236,8.365L329.9,464.7l11.056,6.427,12.073,6.971h.084l17.8,10.289,10.122,5.828,7.319,4.182,18.013,10.414,19.727,11.39,16.117,9.313c1.1.627,2.217,1.227,3.36,1.785a50.018,50.018,0,0,0,5.312,2.245c.85.307,1.7.6,2.551.85a196.778,196.778,0,0,0,37.113-13.509,5.287,5.287,0,0,0,.683-.349c44.083-20.578,82.939-49.869,121.292-80.095,11.307-8.881,22.586-17.845,33.892-26.7.335-.293.725-.586,1.1-.892,18.71-14.625,37.643-28.943,57.342-42.034q7.529-5.033,15.224-9.871c9.4-5.953,18.961-11.767,28.441-17.678a1.465,1.465,0,0,1,.335-.209c9.48-5.911,18.877-11.864,28.023-18.124l-8.574-4.921,51.988-30.016c2.049-1.994,4.085-4.043,6.037-6.162a12.922,12.922,0,0,0,1.241-4.5,16.084,16.084,0,0,0,0-2.008ZM767.037,286.83c.335.307.544.6.836.85a34.092,34.092,0,0,1-4.378-.669,49.7,49.7,0,0,1-5.186-1.324c-.627-.209-1.311-.418-1.994-.683-1.227-.46-2.51-.934-3.778-1.534-.349-.125-.641-.251-.934-.376h0A55.431,55.431,0,0,1,738,274.422a1.812,1.812,0,0,1-.432-.432l-.418-.418a54.261,54.261,0,0,1,18.612,5.786,55.007,55.007,0,0,1,9.522,5.995c.6.5,1.2.976,1.757,1.478Z"
              transform="translate(118.62 94.056)"
              fill="#fcf7f0"
            />
            <path
              id="Path_1603"
              data-name="Path 1603"
              d="M468.249,535.632s55.125-11.153,143.989-57.5,83.915-43.219,83.845-44.613a66.348,66.348,0,0,0-20.536-21c-10.833-7.18-18.375-7.417-18.375-7.417s-184.03,99.655-212.54,133.2C444.214,538.866,460.6,537.012,468.249,535.632Z"
              transform="translate(175.256 159.68)"
              fill="#aeb8c4"
            />
            <path
              id="Path_1604"
              data-name="Path 1604"
              d="M725.971,358.427s8.839,16.9-5.758,29.11S628.2,434.618,628.2,434.618a39.692,39.692,0,0,1-15.559-3.695c-7.292-3.639-8.769-5.061-8.769-5.061s87.54-53.215,96.114-56.784S716.8,353.13,725.971,358.427Z"
              transform="translate(238.025 140.767)"
              fill="#2c2c2c"
            />
            <path
              id="Path_1605"
              data-name="Path 1605"
              d="M444.63,538.79s78.993-16.228,167.662-62.877,83.8-44.042,83.8-44.042-6.218-10.986-20.48-20.425c-10.833-7.18-18.375-7.417-18.375-7.417S469.544,506.39,444.63,538.79Z"
              transform="translate(175.258 159.254)"
              fill="#d7dce2"
            />
            <path
              id="Path_1606"
              data-name="Path 1606"
              d="M603.37,460.171C514.7,506.82,444.63,534.257,444.63,534.257s78.993-16.228,167.662-62.877,83.8-44.042,83.8-44.042-3.639-5.674-12.45-11.809C674.932,420.019,656.167,432.385,603.37,460.171Z"
              transform="translate(175.258 163.787)"
              fill="#eeeff1"
            />
            <path
              id="Path_1607"
              data-name="Path 1607"
              d="M616.434,404.908s7.542.251,18.389,7.417c13.649,9.048,19.518,19.713,20.411,20.383l1.757-.837s-6.218-10.986-20.48-20.425c-10.833-7.18-18.375-7.417-18.375-7.417S583.6,422.349,543.84,445.311C582.849,422.74,616.434,404.908,616.434,404.908Z"
              transform="translate(214.363 159.254)"
              fill="#b3bdc8"
            />
            <path
              id="Path_1608"
              data-name="Path 1608"
              d="M606.945,421.942c.112-.446,38.7-21.024,38.7-21.024L615.3,397,592,410.7Z"
              transform="translate(233.346 156.483)"
              fill="#d7dce2"
            />
            <path
              id="Path_1609"
              data-name="Path 1609"
              d="M603.85,398.418v5.8l1.422-.837,17.023,10.456v.85l7.152,4.935,22.209-18.138L648.087,389.9Z"
              transform="translate(238.017 153.685)"
              fill="#2c2c2c"
            />
            <path
              id="Path_1610"
              data-name="Path 1610"
              d="M722.29,357.083s12.547,5.256-2.077,17.469S628.2,421.633,628.2,421.633a39.831,39.831,0,0,1-15.559-3.681c-7.292-3.653-8.769-5.061-8.769-5.061s87.54-53.229,96.114-56.8S713.117,351.757,722.29,357.083Z"
              transform="translate(238.025 139.239)"
              fill="#585858"
            />
            <path
              id="Path_1611"
              data-name="Path 1611"
              d="M625.065,390.695a7.348,7.348,0,0,1,6.65,0c1.84,1.06,1.84,2.788,0,3.834a7.319,7.319,0,0,1-6.636,0C623.253,393.469,623.239,391.754,625.065,390.695Z"
              transform="translate(245.842 153.685)"
              fill="#e2e5ea"
            />
            <path
              id="Path_1612"
              data-name="Path 1612"
              d="M666.945,366.515a7.347,7.347,0,0,1,6.65,0c1.84,1.06,1.84,2.788,0,3.834a7.319,7.319,0,0,1-6.636,0C665.133,369.289,665.119,367.574,666.945,366.515Z"
              transform="translate(262.349 144.154)"
              fill="#e2e5ea"
            />
            <path
              id="Path_1613"
              data-name="Path 1613"
              d="M611.37,411.268l2.788,2.022,5.019-2.649.028-3.611Z"
              transform="translate(240.981 160.437)"
              fill="#b3bdc8"
            />
            <path
              id="Path_1614"
              data-name="Path 1614"
              d="M398.112,364.12c-13.4,25.206-33.293,46.007-54.289,65.526L320.61,416.22l6.845-4.182a423.455,423.455,0,0,0,49.186-35.8C383.013,370.8,389.816,364.97,398.112,364.12Z"
              transform="translate(126.373 143.523)"
              fill="#fcf5eb"
            />
            <path
              id="Path_1615"
              data-name="Path 1615"
              d="M788.13,253.711c-7.473,5.577-13.342,13.008-19.895,19.937-.126.125-.251.307-.376.432s-.641.641-.934.976c-3.667,3.778-7.361,7.445-11.153,11.056a55.546,55.546,0,0,0-9.522-5.995,54.373,54.373,0,0,0-18.626-5.786l.432.432a1.982,1.982,0,0,0,.418.418,55.432,55.432,0,0,0,13.607,8.672h0l.934.39c1.269.586,2.551,1.06,3.778,1.52.683.265,1.394.474,2.008.683a49.7,49.7,0,0,0,5.186,1.324.084.084,0,0,1-.084.084,364.17,364.17,0,0,1-40.431,32.9c-2.133,1.492-4.294,2.97-6.469,4.378a1.465,1.465,0,0,1-.335.209c-26.2,17.343-56.338,30.741-87.832,33.711-16.367,1.575-32.986-.084-49.186,2.593a93.41,93.41,0,0,0-27.883,9.48,96.311,96.311,0,0,0-14.583,9.522c-12.338,9.759-18.584,22.111-27.3,34.436-.6.934-1.269,1.826-1.952,2.788a6.7,6.7,0,0,1-.558.725q-7.473,10.024-15.6,19.518a353.907,353.907,0,0,1-84.849,71.549L378.9,499.252l-7.319-4.182-10.233-5.925c13.551-9.132,28.385-16.73,40.724-27.507,13.942-12.241,24.021-27.117,33.711-42.341,9.006-14.234,17.678-28.776,28.608-41.7-6.078,7.18-25.29,12.366-34.143,15.336a74.838,74.838,0,0,1-26.824,4.42,66.9,66.9,0,0,1-7.138-.39c-21.387-2.119-47.053,9.4-68.147,17.218-2.161.85-4.252,1.575-6.288,2.3-.209.084-.432.125-.641.209,3.067-1.785,6.2-3.444,9.271-5.061l22.5-11.711q37.308-19.518,74.741-38.9c3.611-.85,7.18-1.785,10.707-2.9,15.085-4.629,29.277-11.6,43.149-19.128a143.258,143.258,0,0,1,14.5-6.594,94.315,94.315,0,0,0,17.985-9.006c10.456-7.264,21.08-14.151,31.843-20.912,15.461-9.759,31.2-19.17,46.76-28.915,2.2-1.394,4.419-2.788,6.622-4.071a198.585,198.585,0,0,1,18.961-10.512c1.2-.544,2.426-1.1,3.667-1.6a82.5,82.5,0,0,1,15.336-5.019c-4.419,4.921-8.881,9.9-13.258,14.834a.126.126,0,0,1-.084,0q-3.137,3.513-6.288,6.971c-2.593,2.886-5.186,5.828-7.821,8.714L593.379,301.2a3.833,3.833,0,0,0-1.06,1.785c-.167,1.743,2.091,2.593,3.834,2.788,21.038,2.328,40.765.167,58.834-10.373l.335-.223c.474-.293.934-.544,1.394-.85,4.378-2.677,8.672-5.577,12.882-8.49a.433.433,0,0,0,.167-.139c11.307-6.037,22.572-12.2,33.836-18.319a486.463,486.463,0,0,1,57.161-27.033c1.018-.39,2.077-.767,3.137-1.1l4.977,2.928,11.558,6.845Z"
              transform="translate(126.61 94.3)"
              fill="#fcf5eb"
            />
            <path
              id="Path_1616"
              data-name="Path 1616"
              d="M350.62,350.139a199.584,199.584,0,0,1,26.266-5.869Q363.7,347.6,350.62,350.139Z"
              transform="translate(138.202 135.699)"
              fill="#edddc7"
            />
            <path
              id="Path_1617"
              data-name="Path 1617"
              d="M766.25,248.311c-6.037,6.162-15.252,14.067-20.062,18.194-.376.335-.767.683-1.1.934-.85.725-1.394,1.283-1.785,1.575-3.75,3.444-7.529,6.845-11.307,10.247a54.374,54.374,0,0,0-18.626-5.786l.432.432a1.977,1.977,0,0,0,.418.418A55.435,55.435,0,0,0,727.827,283c-14.374,12.8-29.166,25.1-45.324,35.37a2.327,2.327,0,0,1-.335.209q-3.053,1.924-6.162,3.792c-18.278,10.749-37.963,19.853-58.555,24.83-17.692,4.182-35.579.669-53.787,3.1a199.094,199.094,0,0,0-19.964,3.694,7.6,7.6,0,0,0-.892.223c-12.548,3.22-25.374,7.138-36.248,14.193a61.538,61.538,0,0,0-5.772,4.183c-.892.725-1.785,1.492-2.635,2.259A259.555,259.555,0,0,0,469.447,404.6a7.4,7.4,0,0,0-.544.641c-.6.725-1.2,1.394-1.784,2.119-3.067,3.667-6.079,7.361-9.1,11.056-9.9,12.157-19.853,24.356-30.909,35.412a170.791,170.791,0,0,1-20.662,17.817A423.263,423.263,0,0,1,364.619,498.3l-7.319-4.182c11.53-7.779,23.6-14.918,34.31-23.77,14.207-11.683,25.6-26.057,35.537-41.365,2.259-3.485,4.461-6.971,6.594-10.54,1.575-2.677,3.151-5.354,4.67-8.03,5.493-9.648,9.606-18.277,17.692-25.806,2.788-2.551,5.4-5.27,8.03-8.03.167-.181.349-.349.516-.558,6.371-6.762,12.45-13.858,19.044-20.369-22.153,8.463-46.091,21.47-69.206,26.364h-.181c-10.066,2.119-21.554.516-31.926,1.659-2.719.293-5.4.683-8.114,1.1a534.691,534.691,0,0,0,83.65-28.232c1.018-.418,1.994-.892,3.011-1.394a231.168,231.168,0,0,0,27.883-16.117c7.515-4.88,14.876-9.9,22.1-14.5,15.949-10.108,32.149-21.038,46.983-32.066l10.665-7.9q10.4-7.779,20.787-15.475c4.935-3.695,9.871-7.347,14.792-11.014,2.788-2.077,5.66-4.182,8.463-6.288-1.617,1.534-3.193,3.109-4.8,4.684q-6.971,6.748-14.039,13.551c-2.077,2.008-4.182,4-6.246,6.037-5.144,4.935-10.247,9.913-15.336,14.876q-23.589,22.767-47.137,45.575c23.7-3.778,46.718-6.762,69.248-11.725,20.912-4.643,41.448-11.014,61.636-21.386a.153.153,0,0,1,.126,0,2.165,2.165,0,0,1,.39-.209,100.618,100.618,0,0,0,21.6-14.29c5.577-5.061,10.205-11.056,15.6-16.284a46.733,46.733,0,0,1,13.565-8.713c1.575-.725,3.137-1.534,4.8-2.384l3.834-2.035c2.036-1.06,4.029-2.133,6.037-3.193,10.749-5.688,20.912-10.874,32.944-14.876Z"
              transform="translate(140.835 95.155)"
              fill="#faf1e6"
            />
            <path
              id="Path_1618"
              data-name="Path 1618"
              d="M745.388,305.853a88.607,88.607,0,0,1-13.258,8.588,106.327,106.327,0,0,1-14.959,5.995c-1.394.474-2.788.934-4.182,1.394-28.622,9.229-58.081,16.326-86.438,26.266-16.911,5.953-33.53,12.715-50.455,18.626-13.523,4.712-27.033,10.665-36.555,21.847-5.019,5.869-8.979,13.091-12.548,19.937-1.394,2.551-3.193,4.6-1.826,7.57,2.635,5.7,9.689.335,13.858-.418,8.714-1.617,19.044-1.2,27.214-4.81-25.43,11.265-53.661,21.428-75.034,39.037-24.83,20.411-50.985,39.2-77.083,57.942-.976.683-1.994,1.394-3.053,2.091-5.019,3.36-10.679,6.079-16.367,4.712,3.36-2.551,6.706-5.145,10.066-7.7q16.73-12.743,33.334-25.457c24.147-18.4,47.151-39.2,63.727-64.912,4.977-7.738,9.229-15.907,14.583-23.338a99.779,99.779,0,0,1,25-23.938c9.94-6.72,20.536-9.1,30.95-14.374,14.876-7.473,34.854-9.759,51.013-14.151,29.068-7.863,56.882-18.236,85.044-28.608A197.77,197.77,0,0,0,734.988,299.9l3.4,1.966Z"
              transform="translate(155.577 118.21)"
              fill="#faf1e6"
            />
            <path
              id="Path_1619"
              data-name="Path 1619"
              d="M791.074,267.13a13.119,13.119,0,0,1-6.511,12.241l-.753.418-52,30.016,8.546,4.935,12.757,7.347a15.932,15.932,0,0,1,2.635,1.91c-5.27,2.468-10.707,4.684-16.075,6.678C689.3,349.3,638.5,366.088,587.568,383.654c-9.857,3.4-19.895,6.887-28.525,12.784s-15.852,14.625-17.636,24.956c51.682-9.759,100.073-29.626,150.779-43.442-11.683,3.151-23.338,10.122-33.92,15.893s-21.345,10-31.8,15.74c-29.417,16.1-63,22.906-93.409,36.764-33.544,15.336-63.644,36.694-94.636,56.673-9.522,6.162-18.835,13.607-29.277,18.027-1.143-.558-2.245-1.143-3.36-1.785l-16.1-9.313c17.12-13.049,36.123-24.314,53.689-36.43a243.382,243.382,0,0,0,26.14-19.755c20.16-18.236,26.7-46.8,48.336-64.912,25.346-21.219,60.116-25.68,92.252-33.376a373.721,373.721,0,0,0,132.641-60.925c8.365-6.078,16.284-12.924,25.332-18.026a113.221,113.221,0,0,1,23-9.4Z"
              transform="translate(153.598 105.293)"
              fill="#fcf5eb"
            />
            <path
              id="Path_1620"
              data-name="Path 1620"
              d="M353.864,384.747a11.339,11.339,0,0,1-1.018.85C352.679,384.97,353.571,383.994,353.864,384.747Z"
              transform="translate(139.072 151.546)"
              fill="#edddc7"
            />
            <path
              id="Path_1621"
              data-name="Path 1621"
              d="M383.679,372.87q-14.067,17.664-28.106,35.245c-4.838,6.037-9.759,12.2-14.959,18.026L328.54,419.17q16.953-14.471,33.878-29a.39.39,0,0,0,.251.349c.809.5,1.84-.209,2.551-.85C371.4,384.051,377.559,378.488,383.679,372.87Z"
              transform="translate(129.499 146.972)"
              fill="#faf1e6"
            />
            <path
              id="Path_1622"
              data-name="Path 1622"
              d="M650.951,283.444a29.749,29.749,0,0,1-10.108-.586,40.493,40.493,0,0,1-5.1-1.394,49.7,49.7,0,0,0,5.186,1.325,33.356,33.356,0,0,0,4.378.669c-.307-.251-.516-.544-.85-.85-.558-.5-1.157-.976-1.785-1.478a55.542,55.542,0,0,0-9.522-5.995,54.372,54.372,0,0,0-18.626-5.786l.432.432c-3.959-3.527-6.218-6.971-6.72-9.954a6.329,6.329,0,0,1,0-2.788c.641-2.551,3.011-4.336,7.264-4.935a27.687,27.687,0,0,1,7.4.125,58.918,58.918,0,0,1,24.44,10.163,41.664,41.664,0,0,1,3.778,2.97A23.822,23.822,0,0,1,653.5,267.7c.474.474.892.934,1.283,1.394C660.655,276.265,659.372,282.343,650.951,283.444Z"
              transform="translate(239.683 99.296)"
              fill="#ca8138"
            />
            <path
              id="Path_1623"
              data-name="Path 1623"
              d="M421.433,388.693c11.669,6.971,30.8,7.138,42.717.446s95.946-89.017,84.277-95.988S449.763,349.7,437.842,356.376,409.75,381.764,421.433,388.693Z"
              transform="translate(164.521 115.339)"
              fill="#d3a671"
            />
            <path
              id="Path_1624"
              data-name="Path 1624"
              d="M507.76,274.183l3.29,6.343a33.617,33.617,0,0,0-.739,5.7c-.822,18.333,11.153,41.253,26.7,51.194a34.273,34.273,0,0,0,4.949,2.635l3.416,6.594,11.92-6.19h0c5.409-2.788,8.964-9.034,9.383-18.236.823-18.333-11.153-41.253-26.7-51.194-7.752-4.949-14.932-5.744-20.285-3.039h0Z"
              transform="translate(200.141 105.03)"
              fill="#db7500"
            />
            <path
              id="Path_1625"
              data-name="Path 1625"
              d="M557.417,326.647c.823-18.333-11.153-41.253-26.7-51.194s-28.845-3.137-29.668,15.2,11.153,41.253,26.7,51.194S556.595,344.938,557.417,326.647Z"
              transform="translate(197.481 106.771)"
              fill="#f9a42f"
            />
            <ellipse
              id="Ellipse_24"
              data-name="Ellipse 24"
              cx="14.165"
              cy="24.537"
              rx="14.165"
              ry="24.537"
              transform="matrix(0.885, -0.465, 0.465, 0.885, 702.745, 400.342)"
              fill="#ffbf68"
            />
            <path
              id="Path_1626"
              data-name="Path 1626"
              d="M497.33,280.9l3.193,6.176a31.864,31.864,0,0,0-.711,5.577C499,310.5,510.63,332.806,525.771,342.482a33.1,33.1,0,0,0,4.824,2.551l3.332,6.427,11.6-6.106h0c5.256-2.649,8.714-8.783,9.118-17.734.809-17.845-10.819-40.138-25.973-49.814-7.542-4.824-14.527-5.577-19.741-2.956h0Z"
              transform="translate(196.03 107.75)"
              fill="#db7500"
            />
            <ellipse
              id="Ellipse_25"
              data-name="Ellipse 25"
              cx="22.934"
              cy="39.72"
              rx="22.934"
              ry="39.72"
              transform="matrix(0.885, -0.465, 0.465, 0.885, 672.875, 399.47)"
              fill="#f9a42f"
            />
            <path
              id="Path_1627"
              data-name="Path 1627"
              d="M531.608,320.843c.474-10.721-6.511-24.133-15.615-29.947s-16.883-1.84-17.357,8.881,6.511,24.133,15.615,29.947S531.12,331.564,531.608,320.843Z"
              transform="translate(196.536 113.606)"
              fill="#ffbf68"
            />
            <path
              id="Path_1628"
              data-name="Path 1628"
              d="M486.89,287.637,490,293.631a30.274,30.274,0,0,0-.7,5.409c-.781,17.343,10.526,39.037,25.248,48.433a32.718,32.718,0,0,0,4.684,2.5l3.248,6.232,11.279-5.856h0c5.1-2.579,8.477-8.546,8.867-17.246.781-17.357-10.526-39.037-25.262-48.447-7.333-4.684-14.123-5.437-19.2-2.872h0Z"
              transform="translate(191.915 110.495)"
              fill="#db7500"
            />
            <path
              id="Path_1629"
              data-name="Path 1629"
              d="M533.867,337.3c.767-17.357-10.54-39.037-25.262-48.447s-27.3-2.97-28.065,14.374,10.526,39.037,25.248,48.447S533.086,354.645,533.867,337.3Z"
              transform="translate(189.398 112.15)"
              fill="#f9a42f"
            />
            <path
              id="Path_1630"
              data-name="Path 1630"
              d="M520.222,326.479c.46-10.442-6.33-23.478-15.182-29.124S488.631,295.57,488.157,306s6.33,23.464,15.182,29.124S519.748,336.921,520.222,326.479Z"
              transform="translate(192.405 116.183)"
              fill="#ffbf68"
            />
            <path
              id="Path_1631"
              data-name="Path 1631"
              d="M476.45,294.357l3.025,5.828a29.978,29.978,0,0,0-.683,5.256c-.753,16.855,10.233,37.921,24.537,47.067a32.057,32.057,0,0,0,4.559,2.412l3.151,6.065L522,355.3h0c4.977-2.509,8.239-8.365,8.616-16.73.767-16.855-10.219-37.935-24.537-47.067-7.124-4.559-13.719-5.284-18.654-2.788h0Z"
              transform="translate(187.8 113.241)"
              fill="#db7500"
            />
            <path
              id="Path_1632"
              data-name="Path 1632"
              d="M522.088,342.625c.753-16.855-10.233-37.935-24.537-47.067s-26.489-2.886-27.27,13.942,10.219,37.921,24.537,47.067S521.335,359.481,522.088,342.625Z"
              transform="translate(185.353 114.842)"
              fill="#f9a42f"
            />
            <path
              id="Path_1633"
              data-name="Path 1633"
              d="M508.812,332.1c.46-10.136-6.148-22.795-14.75-28.288s-15.949-1.743-16.4,8.365,6.148,22.809,14.75,28.3S508.393,342.238,508.812,332.1Z"
              transform="translate(188.271 118.756)"
              fill="#ffbf68"
            />
            <path
              id="Path_1634"
              data-name="Path 1634"
              d="M466,301.141l2.928,5.577a29.782,29.782,0,0,0-.655,5.1c-.739,16.354,9.926,36.82,23.826,45.687a30.355,30.355,0,0,0,4.419,2.356l3.053,5.883,10.637-5.577h0c4.824-2.426,7.989-8.044,8.365-16.27.725-16.354-9.926-36.82-23.826-45.687-6.971-4.42-13.328-5.131-18.124-2.7h0Z"
              transform="translate(183.681 115.937)"
              fill="#db7500"
            />
            <path
              id="Path_1635"
              data-name="Path 1635"
              d="M510.326,347.941c.725-16.354-9.94-36.806-23.826-45.687s-25.736-2.788-26.489,13.565,9.926,36.82,23.812,45.687S509.587,364.309,510.326,347.941Z"
              transform="translate(181.306 117.529)"
              fill="#f9a42f"
            />
            <path
              id="Path_1636"
              data-name="Path 1636"
              d="M497.446,337.738c.446-9.843-5.967-22.139-14.318-27.465s-15.475-1.687-15.921,8.142,5.981,22.139,14.318,27.479S497.013,347.581,497.446,337.738Z"
              transform="translate(184.148 121.332)"
              fill="#ffbf68"
            />
            <path
              id="Path_1637"
              data-name="Path 1637"
              d="M455.57,307.889l2.788,5.493a29.393,29.393,0,0,0-.641,4.935c-.711,15.866,9.634,35.7,23.1,44.32a30.584,30.584,0,0,0,4.294,2.272l2.956,5.7,10.317-5.354h0c4.684-2.37,7.766-7.807,8.114-15.782.711-15.866-9.62-35.7-23.1-44.307-6.706-4.294-12.924-4.977-17.567-2.635h0Z"
              transform="translate(179.57 118.725)"
              fill="#db7500"
            />
            <path
              id="Path_1638"
              data-name="Path 1638"
              d="M498.542,353.266c.711-15.866-9.634-35.7-23.1-44.307s-24.969-2.719-25.681,13.147,9.634,35.719,23.1,44.321S497.831,369.131,498.542,353.266Z"
              transform="translate(177.266 120.221)"
              fill="#f9a42f"
            />
            <path
              id="Path_1639"
              data-name="Path 1639"
              d="M486.071,343.375c.432-9.55-5.786-21.47-13.942-26.643s-15.015-1.631-15.433,7.9,5.786,21.47,13.942,26.643S485.652,352.9,486.071,343.375Z"
              transform="translate(180.006 123.907)"
              fill="#ffbf68"
            />
            <path
              id="Path_1640"
              data-name="Path 1640"
              d="M445.13,314.586l2.788,5.312a27.583,27.583,0,0,0-.627,4.782c-.683,15.336,9.341,34.6,22.39,42.94a27.362,27.362,0,0,0,4.182,2.2l2.872,5.577,10-5.186h0c4.531-2.3,7.515-7.57,7.863-15.336.683-15.336-9.327-34.6-22.39-42.94-6.5-4.182-12.547-4.824-17.023-2.551h0Z"
              transform="translate(175.455 121.439)"
              fill="#db7500"
            />
            <path
              id="Path_1641"
              data-name="Path 1641"
              d="M486.776,358.594c.683-15.336-9.341-34.6-22.39-42.94S440.2,313.033,439.5,328.41s9.341,34.589,22.39,42.926S486.079,373.972,486.776,358.594Z"
              transform="translate(173.222 122.909)"
              fill="#f9a42f"
            />
            <path
              id="Path_1642"
              data-name="Path 1642"
              d="M474.683,349c.4-9.243-5.577-20.8-13.468-25.806s-14.541-1.589-14.959,7.654,5.577,20.8,13.468,25.82S474.265,358.241,474.683,349Z"
              transform="translate(175.89 126.482)"
              fill="#ffbf68"
            />
            <path
              id="Path_1643"
              data-name="Path 1643"
              d="M434.69,321.308l2.677,5.144a26.006,26.006,0,0,0-.6,4.629c-.669,14.89,9.034,33.46,21.665,41.574a28.173,28.173,0,0,0,4.015,2.133l2.788,5.354L475,375.123h0c4.378-2.217,7.264-7.319,7.6-14.792.669-14.89-9.02-33.46-21.665-41.56-6.288-4.029-12.115-4.67-16.479-2.468h0Z"
              transform="translate(171.34 124.183)"
              fill="#db7500"
            />
            <path
              id="Path_1644"
              data-name="Path 1644"
              d="M475,363.924c.669-14.876-9.034-33.46-21.665-41.56s-23.422-2.551-24.091,12.338,9.034,33.46,21.679,41.56S474.327,378.813,475,363.924Z"
              transform="translate(169.178 125.595)"
              fill="#f9a42f"
            />
            <path
              id="Path_1645"
              data-name="Path 1645"
              d="M463.293,354.635c.4-8.951-5.437-20.132-13.035-24.983s-14.067-1.534-14.471,7.417,5.423,20.132,13.022,24.983S462.888,363.585,463.293,354.635Z"
              transform="translate(171.764 129.057)"
              fill="#ffbf68"
            />
            <path
              id="Path_1646"
              data-name="Path 1646"
              d="M398.247,385.741c11.683,6.971,30.8,7.138,42.717.446s12.115-17.72.446-24.649-30.811-7.138-42.717-.46S386.578,378.812,398.247,385.741Z"
              transform="translate(153.578 140.403)"
              fill="#d3a671"
            />
            <path
              id="Path_1647"
              data-name="Path 1647"
              d="M397.513,413.741c8.63,5.117,22.753,5.27,31.564.321s8.937-13.091.321-18.208-22.753-5.27-31.564-.335S388.9,408.61,397.513,413.741Z"
              transform="translate(154.173 154.479)"
              fill="#d3a671"
            />
            <path
              id="Path_1648"
              data-name="Path 1648"
              d="M459.315,365.45l-5.284-.07a25.44,25.44,0,0,0-3.471-2.468c-11.669-6.971-30.8-7.138-42.717-.446a25.1,25.1,0,0,0-3.444,2.3h-5.493l-.125,9.926h0c-.1,4.489,2.788,9.006,8.63,12.478,11.669,6.971,30.8,7.138,42.717.46,5.925-3.332,8.951-7.738,9.062-12.185h0Z"
              transform="translate(157.185 140.939)"
              fill="#db7500"
            />
            <path
              id="Path_1649"
              data-name="Path 1649"
              d="M407.488,379.995c11.683,6.971,30.811,7.124,42.717.446s12.115-17.734.446-24.663-30.8-7.138-42.717-.446S395.819,373.052,407.488,379.995Z"
              transform="translate(157.218 138.133)"
              fill="#f9a42f"
            />
            <path
              id="Path_1650"
              data-name="Path 1650"
              d="M412.7,373.191c6.971,4.182,18.514,4.294,25.681.279s7.278-10.665.265-14.834-18.528-4.28-25.68-.265S405.67,369.022,412.7,373.191Z"
              transform="translate(160.627 140.099)"
              fill="#ffbf68"
            />
            <path
              id="Path_1651"
              data-name="Path 1651"
              d="M445.032,398.631h-3.9a17.036,17.036,0,0,0-2.565-1.826c-8.616-5.131-22.739-5.27-31.55-.335a17.856,17.856,0,0,0-2.537,1.7H400.4l-.084,7.333h0c-.084,3.318,2.035,6.65,6.371,9.229,8.63,5.117,22.753,5.27,31.55.321,4.392-2.454,6.622-5.716,6.692-8.992h0Z"
              transform="translate(157.792 154.852)"
              fill="#db7500"
            />
            <path
              id="Path_1652"
              data-name="Path 1652"
              d="M406.807,409.392c8.63,5.117,22.753,5.27,31.564.335s8.951-13.091.321-18.222-22.753-5.27-31.55-.335S398.121,404.276,406.807,409.392Z"
              transform="translate(157.83 152.763)"
              fill="#f9a42f"
            />
            <path
              id="Path_1653"
              data-name="Path 1653"
              d="M410.593,404.37a21.01,21.01,0,0,0,18.975.209c5.3-2.97,5.381-7.877.2-10.958a20.913,20.913,0,0,0-18.975-.2C405.5,396.4,405.406,401.289,410.593,404.37Z"
              transform="translate(160.332 154.216)"
              fill="#ffbf68"
            />
            <path
              id="Path_1654"
              data-name="Path 1654"
              d="M340.921,318.879c-32.512-32.275-101.049-42.285-133.6-3.555l-30.672,36.583c-9.522,11.335-19.184,22.892-24.914,36.527a74.8,74.8,0,0,0,1.743,61.023c4.475,9.174,10.8,17.288,17.3,25.165s12.98,15.336,19.769,22.7a49.129,49.129,0,0,0,10.986,9.759c7.821,4.559,17.357,4.684,26.405,4.684,29.6,0,60.576-.349,86.675-14.318,18.877-10.108,33.53-26.489,46.412-43.665,8.937-11.864,17.413-24.677,20.215-39.274,4.81-24.956-7.738-49.786-21.5-71.1C354.123,334.66,348.226,326.156,340.921,318.879Z"
              transform="translate(57.574 114.4)"
              fill="#9ad428"
            />
            <path
              id="Path_1655"
              data-name="Path 1655"
              d="M237.745,313.058a13.345,13.345,0,0,1,1.715.781,17.385,17.385,0,0,1,8.449,11.293,5.841,5.841,0,0,1-.558,4.824,2.035,2.035,0,0,1-1.283.837,2.928,2.928,0,0,1-1.98-.725c-2.147-1.478-4.322-2.942-6.469-4.433s-3.193-2.788-5.27-.4-1.046,5.911-1.129,8.8a48.21,48.21,0,0,1-4.322,18.612c-1.394,3.151-3.262,6.33-3.193,9.759s2.105,6.678,4.071,9.606l22.139,33.084c3.276,4.894,6.636,10,7.5,15.824a39.972,39.972,0,0,1-.321,10.707l-3.9,32.177a115.15,115.15,0,0,0,10.582-15.489c6.971-12.994,8.574-28.065,10.094-42.7a9.3,9.3,0,0,0-.1-3.513c-1.269-4.252-7.333-4.35-10.763-7.18-5.27-4.35-2.677-13.384-6.58-18.988-1.631-2.342-4.182-3.806-6.636-5.3a94.5,94.5,0,0,1-9.634-6.8,15.684,15.684,0,0,1-3.945-4.182c-1.966-3.346-1.394-7.528-.906-11.376q1.757-12.06,3.527-24.119c.39-2.7,1.241-5.939,3.862-6.678s4.8,1.3,6.525,3.179a56.966,56.966,0,0,1,10.86,15.81c1.729,4.071,2.7,8.365,4.266,12.547a95,95,0,0,0,8.518,16.089L284.8,384.537a48.5,48.5,0,0,1,4.74,9.076c1.938,5.409,1.91,11.307,1.506,17.037a135.568,135.568,0,0,1-13.217,49.312c-2.788,5.828-6.385,11.753-12.115,14.792-2.328,1.241-4.907,1.938-7.222,3.207a8.365,8.365,0,0,0-4.657,5.995,8.7,8.7,0,0,1-.376,3.137c-.99,2.022-3.987,1.729-5.995.725-5.8-2.872-9.494-8.895-11.153-15.127s-1.575-12.812-1.631-19.267c-.1-14.165-.878-28.343-2.314-42.438-.544-5.27-1.394-10.888-4.838-14.862-3.207-3.639-8.114-5.242-11.892-8.281s-6.009-6.971-8.365-10.958a24.537,24.537,0,0,1-3.346-7.515c-1.631-8.17,4.907-15.336,8.881-22.683,3.695-6.8,5.3-14.527,8.212-21.707,1.394-3.485,2.886-7.626,6.106-10.066a10.986,10.986,0,0,1,10.624-1.854Z"
              transform="translate(80.278 123.148)"
              fill="#8cc232"
            />
            <path
              id="Path_1656"
              data-name="Path 1656"
              d="M314.235,319.358c-15.684-12.98-35.551-28.79-56.9-29.556-4.489-.167-10.136,2.509-14.234,4.182-6.357,2.607-12.84,5.7-17.106,11.153s-5.577,13.7-1.255,19.03c2.565,3.151,6.678,4.852,8.923,8.24,6.274,9.522-6.525,22.836-1.534,33.084,3.165,6.483,11.906,8.253,16.047,14.151,3.1,4.406,3.067,10.387,5.869,14.987,3.667,6.037,11.153,8.365,17.971,10.191,2.551.683,5.284,1.394,7.807.586,3.29-1.032,5.326-4.182,7.068-7.208l19.016-32.386c3.318-5.66,6.678-11.376,11.237-16.075,2.788-2.858,6.079-5.479,7.459-9.215C327.507,332.561,320.7,324.656,314.235,319.358Z"
              transform="translate(87.536 114.227)"
              fill="#ade92c"
            />
            <path
              id="Path_1657"
              data-name="Path 1657"
              d="M235.815,320.73a10.832,10.832,0,0,0-.349,3.4c.112,1.1.5,2.161.711,3.234a19.408,19.408,0,0,1-.669,7.835c-1.129,4.935-2.356,9.857-3.639,14.764-1.394,5.158-2.788,10.93-.084,15.559,3,5.256,9.926,6.79,14.081,11.153,2.328,2.468,3.639,5.688,5.382,8.616a33.46,33.46,0,0,0,13.189,12.547,4.517,4.517,0,0,0,2.788.7c1.84-.39,2.5-2.607,2.788-4.461,1.3-7.668,2.607-15.447,1.882-23.2-.362-3.778-1.157-7.793.446-11.223a17.315,17.315,0,0,1,5.758-6.009l9.1-6.873a12.283,12.283,0,0,0,3.541-3.5c3.1-5.423-2.872-13.022.572-18.236,2.482-3.778,8.016-3.513,12.1-5.451a66.128,66.128,0,0,0-5.869-10.554c-4.963-7.264-11.265-9.146-19.184-12.227-6.274-2.454-11.014-5.368-18.124-3.778a39.93,39.93,0,0,0-11.613,5.089,27.59,27.59,0,0,0-7.459,5.995,14.7,14.7,0,0,0-2.858,7.71C237.99,314.833,236.526,317.635,235.815,320.73Z"
              transform="translate(90.754 115.323)"
              fill="#b7f03c"
            />
            <path
              id="Path_1658"
              data-name="Path 1658"
              d="M264.587,293.751a16.547,16.547,0,0,0,6.971-2.788l-6.539-.4a42.3,42.3,0,0,0-11.153.279c-1.966.4-3.053,1.129-5.005.516a16.189,16.189,0,0,0-5.981-.934,13.942,13.942,0,0,0-7.975,3.639,60.312,60.312,0,0,0-6.009,6.5,84.583,84.583,0,0,1-14.039,12.84,4.727,4.727,0,0,1-1.924.962,12.024,12.024,0,0,0-1.589.139c-1.645.516-1.394,2.97-.572,4.461a16.591,16.591,0,0,0,7.682,6.65A20.191,20.191,0,0,0,223.6,327.2c1.394.209,1.1.181,2.022-.627s1.185-1.394,2.231-1.575c1.394-.265,2.788.739,4.28.795a5.94,5.94,0,0,0,3.5-1.394c3.388-2.356,7.417-6.19,7.5-10.484a21.541,21.541,0,0,1,4.378-13.091,17.72,17.72,0,0,1,11.418-6.316A47.325,47.325,0,0,0,264.587,293.751Z"
              transform="translate(82.826 114.432)"
              fill="#8cc232"
            />
            <path
              id="Path_1659"
              data-name="Path 1659"
              d="M269.466,397.02a16.605,16.605,0,0,0-5.437.683c-1.617.586-3.5,1.9-5.242.948a2.872,2.872,0,0,1-1.087-1.073c-2.161-3.569,3.444-7.054,4.657-10.024a26.629,26.629,0,0,0,.976-5.27c.376-1.98,1.227-3.862,1.534-5.856a39.618,39.618,0,0,0-.084-6.971,50.72,50.72,0,0,1,1.046-9.829c.7-4,1.464-8.156,3.932-11.376a18.765,18.765,0,0,1,3.3-3.262,47.628,47.628,0,0,1,10.01-5.995c2.217-1,5.061-1.631,6.5-3.792,1.018-1.548.53-2.245-.279-3.667a16.422,16.422,0,0,1-2.008-5.479,10.26,10.26,0,0,1,1.324-7.11,14.82,14.82,0,0,1,4.838-4.252,5.242,5.242,0,0,1,1.255-.613,3.318,3.318,0,0,1,2.9.767,8.14,8.14,0,0,1,1.868,2.468,30.494,30.494,0,0,1,2.091,4.852,11.069,11.069,0,0,1,.683,4.183c-.112,1.812-1.115,3.416-1.3,5.186a6.26,6.26,0,0,1-1.311,3.959c-.948,1.129-.92,2.97-1.394,4.406-.613,1.9-1.394,3.764-2.133,5.577-1.561,3.625-3.3,7.18-4.643,10.9s-2.342,7.961-3.9,11.795c-2.105,5.158-5.3,9.759-7.612,14.876-1.812,3.987-3.109,8.254-5.674,11.795a5.909,5.909,0,0,1-1.394,1.478A6.246,6.246,0,0,1,269.466,397.02Z"
              transform="translate(101.383 123.771)"
              fill="#8cc232"
            />
            <path
              id="Path_1660"
              data-name="Path 1660"
              d="M249.327,290.988c13.649-.2,28.678-3.848,42.006.363-5.409,3.444-12.9,1.157-18.863,4.921a20.773,20.773,0,0,0-9.494,14.973,22.986,22.986,0,0,1-1.115,6.023c-1.952,4.545-7.528,6.148-11.028,9.661-7.724,7.779-2.788,21.135-6.092,31.62-1.2,3.876-3.527,7.319-5.1,11.056s-2.342,8.212-.39,11.781c-5.326,2.719-11.613-.307-17.051-2.788a97.382,97.382,0,0,0-48.7-8.532,15.8,15.8,0,0,1-5.061-.07c-3.527-.836-7.194-4.182-10.177-2.119,2.2-15.336,17.845-24.245,27.1-36.6,1.645-2.175,3.1-4.5,4.712-6.692,9.16-12.436,23.115-20.271,36.639-27.744a44.7,44.7,0,0,1,12.185-5.186A56.586,56.586,0,0,1,249.327,290.988Z"
              transform="translate(62.381 114.045)"
              fill="#c3ff6c"
            />
            <path
              id="Path_1661"
              data-name="Path 1661"
              d="M190.634,333.407a46.874,46.874,0,0,1,0-10.554,12.952,12.952,0,0,1,2.4-7.361c.795-1.115,3.039-4.28,4.517-4.182.962.112,2.105,1.283,2.858,1.812l2.788,1.966a8.6,8.6,0,0,1,3.081,3.262q2.286,3.667,4.252,7.515c.906,1.771,1.394,4.67,3.722,4.684,3.485,0,4.545-5.075,2.942-8.17s-4.629-5.423-5.577-8.769a3.3,3.3,0,0,1,.6-3.4,3.667,3.667,0,0,1,1.868-.725c6.106-.92,13.537,1.729,17.817-2.788a3.137,3.137,0,0,0,.948-1.729c.139-1.394-1.171-2.468-2.384-3.179a34.186,34.186,0,0,0-15-4.573c2.886.181,7.487-2.677,10.289-3.527,3.932-1.185,7.738-1.129,11.85-1.394l28.023-2.133-5.34,2.942c-4.294,2.356-8.839,4.963-10.9,9.62-2.286,5.131-3.025,10.5-6.762,15.141-2.984,3.708-7.222,6.329-9.759,10.317a32.065,32.065,0,0,0-3.708,10.428q-1.785,7.863-3.583,15.754a17.789,17.789,0,0,0-9.006-14.82,35.146,35.146,0,0,0-10.317-3.151Z"
              transform="translate(75.024 114.371)"
              fill="#cfff88"
            />
            <path
              id="Path_1662"
              data-name="Path 1662"
              d="M203.516,304.518c-2.984-3.165-6.664.725-8.686,2.788a38.5,38.5,0,0,0-4.935,6.009,37.126,37.126,0,0,0-5.577,13.83,16.464,16.464,0,0,0-.265,4.447,21.054,21.054,0,0,0,.627,2.928l1.394,5.437c.376-2.537-.655-5.061-1.018-7.6a19.518,19.518,0,0,1,1.6-10.163,59.029,59.029,0,0,1,5.1-9.048c1.812-2.788,3.806-5.758,6.887-7.04C200.24,305.452,201.969,305.285,203.516,304.518Z"
              transform="translate(72.529 119.559)"
              fill="#dcffa9"
            />
            <path
              id="Path_1663"
              data-name="Path 1663"
              d="M238.935,356.259a8.267,8.267,0,0,0,0-2.273,17.528,17.528,0,0,0-.809-2.217,30.116,30.116,0,0,1-.85-5.842,28.079,28.079,0,0,0-3.374-8.6,15.158,15.158,0,0,0-1.952-3.053,11.153,11.153,0,0,0-4.824-2.9c-8.1-2.719-17.134-.293-25.416-2.4-3.555-.92-6.971-2.663-10.693-2.4a14.012,14.012,0,0,0-7.9,3.653,61.761,61.761,0,0,0-6.009,6.5,83.444,83.444,0,0,1-14.039,12.84,4.517,4.517,0,0,1-1.91.962,11.819,11.819,0,0,0-1.589.139c-1.659.516-1.394,2.97-.572,4.475a25.278,25.278,0,0,0,4.88,5.577,66.081,66.081,0,0,0,7.752,6.483,66.293,66.293,0,0,0,11.739,5.842l42.09,17.608c2.788,1.143,5.814,2.286,8.518,1.129a3.123,3.123,0,0,0,1.659-1.464,4.266,4.266,0,0,0,.293-1.394c.265-3.318.153-6.79,1.394-9.857a18.6,18.6,0,0,0,1.046-10.888C237.471,364.415,238.586,360.024,238.935,356.259Z"
              transform="translate(62.414 128.715)"
              fill="#8cc232"
            />
            <path
              id="Path_1664"
              data-name="Path 1664"
              d="M337.084,333.913l-1.213-1.924c-4.587-7.082-15.545-23.506-25.5-18.473a11.8,11.8,0,0,0-4.977,15.252c1.046,2.063,2.788,4.182,2.035,6.4-.586,1.673-2.384,2.509-4,3.221-7.724,3.416-15.419,8.5-18.417,16.4-4.183,11.014,1.743,25.095-5.437,34.38-1.785,2.328-4.308,4.182-5.27,6.971a15.727,15.727,0,0,0-.167,6.845,74.432,74.432,0,0,1-.1,16.242A56.213,56.213,0,0,1,270.764,433a91.34,91.34,0,0,1-7.64,14.346q-5.368,8.741-10.721,17.5c-3.109,5.075-6.329,10.289-11.153,13.844-3.3,2.454-7.194,4-10.763,6.065a41.589,41.589,0,0,0-14.736,14.458,107.35,107.35,0,0,0,52.978.7c5.772-1.394,11.627-3.388,15.935-7.473,2.788-2.649,4.838-6.079,7.919-8.365a42.281,42.281,0,0,1,7.752-3.959,45.52,45.52,0,0,0,18.682-16.172c3.137-4.81,5.368-10.205,9.006-14.639,2.314-2.788,5.144-5.2,7.7-7.835,8.6-8.853,13.816-20.4,18.124-31.954,5.9-15.74,3.137-27.005-2.426-42.592C347.512,355.592,343.344,344.16,337.084,333.913Z"
              transform="translate(85.041 123.206)"
              fill="#a1e044"
            />
            <path
              id="Path_1665"
              data-name="Path 1665"
              d="M333.6,385.884c.781-10.888-4.8-20.815-7.891-30.936-3.29-10.749-6.357-20.662-12.771-30.212-2.663-3.973-5.967-7.989-10.61-9.215-5.7-1.492-12.547,3.067-12.324,8.964.112,2.788,1.645,5.409,2.788,8.016s1.785,5.786.279,8.2c-1.311,2.119-3.89,3-6.162,4a32.233,32.233,0,0,0-12.366,9.648,15.447,15.447,0,0,0-3.6,7.947,22.974,22.974,0,0,0,.488,5.423c1.143,6.971,1.506,14.193-.85,20.8-2.621,7.305-8.463,13.523-9.188,21.247-.572,6.106,2.2,12.157,1.534,18.25-.6,5.577-4.015,10.456-6.176,15.67s-2.788,11.99,1.394,15.838c3.792,3.541,9.759,3,14.806,1.91a45.226,45.226,0,0,0,13.022-4.5c11.418-6.553,16.73-20.2,26.67-28.817,2.593-2.259,5.577-4.182,7.7-6.818a34.255,34.255,0,0,0,4.852-9.313l4.015-10.205C331.164,396.633,333.214,391.391,333.6,385.884Z"
              transform="translate(100.539 124.255)"
              fill="#b5f25a"
            />
            <path
              id="Path_1666"
              data-name="Path 1666"
              d="M244.873,450.221a13.1,13.1,0,0,0,5.34-4.183c1.785-2.621,1.729-6.051,1.534-9.215-.39-6.106-3.137-11.6-9.257-13.649a36.988,36.988,0,0,0-11.53-1.394c-1.771,0-3.792-.293-5.577-.125s-2.328,1.492-3.193,2.788q-1.826,2.9-3.667,5.814c-1.1,1.743-2.2,3.5-3.151,5.34a25.778,25.778,0,0,0-2.788,17.232,4.28,4.28,0,0,0,1.464,2.7,17.622,17.622,0,0,0,2.482.962c1.087.516,1.882,1.617,3.067,1.854a4.379,4.379,0,0,0,1.8-.125l6.092-1.283c4.029-.836,7.779-2.9,11.7-3.973a37.829,37.829,0,0,0,5.688-2.746Z"
              transform="translate(83.62 166.181)"
              fill="#8cc232"
            />
            <path
              id="Path_1667"
              data-name="Path 1667"
              d="M169.545,349.924c2.44-.474,5.005-.572,7.194-1.757,2.97-1.617,4.573-4.88,6.176-7.877,3.764-7.1,10.066-14.485,18.054-13.7,5.005.5,9.1,4.182,13.872,5.73,7.793,2.551,17.762-.181,23.38,5.772,4.7,4.977,3.276,12.966,5.144,19.518,1.3,4.545,4.182,8.365,6.971,12.213q15.336,20.787,29.1,42.661c1.9,3.011,3.834,6.608,2.621,9.954-.809,2.217-2.788,3.736-4.183,5.716-1.9,2.858-2.147,6.483-2.259,9.912a192.165,192.165,0,0,0,2.3,36.011,14.96,14.96,0,0,1,.112,6.525c-1.213,4.182-5.772,6.357-9.843,7.989-8,3.207-16.326,6.455-24.928,5.939-3.444-.2-6.817-1-10.247-1.213-10.707-.669-22.307,4.336-31.731-.711-5.716-3.025-9.09-9.02-13.44-13.8-3.6-3.973-7.933-7.194-11.864-10.833-11.07-10.247-18.64-23.7-25.388-37.141-5.033-10.066-9.759-20.759-9.634-32.066.2-13.774,7.6-27.033,13.7-38.967C157.485,354.469,163.634,351.068,169.545,349.924Z"
              transform="translate(55.557 128.706)"
              fill="#a3db2a"
            />
            <path
              id="Path_1668"
              data-name="Path 1668"
              d="M260.258,387.5l11.725,19.741c1.966,3.318,4.015,7.068,3.179,10.847-.948,4.182-5.061,6.734-7.919,9.954-4.587,5.186-6.009,12.422-9.662,18.291a28.19,28.19,0,0,1-30.95,11.809,83.087,83.087,0,0,0-8.839-2.788c-3.611-.613-7.305,0-10.972.07-11.432.237-23.129-5.4-29.054-15.182-2.565-4.183-4.015-9.048-6.357-13.412-4.294-7.989-11.362-14.067-17.26-20.912s-10.9-15.573-9.676-24.565c.962-7.041,5.577-12.98,10.094-18.459,2.691-3.262,5.577-6.58,9.313-8.449,2.886-1.394,6.19-1.952,8.923-3.667,6.971-4.406,7.933-15.113,15-19.435,4.643-2.788,10.61-2.049,15.838-.558s10.47,3.639,15.893,3.221c2.691-.209,5.381-1.046,8.058-.7,8.727,1.129,12.366,11.279,13.119,18.71s.976,12.338,6.594,17.316S256.508,381.156,260.258,387.5Z"
              transform="translate(56.873 129.861)"
              fill="#ade92c"
            />
            <path
              id="Path_1669"
              data-name="Path 1669"
              d="M330.929,389.866a58.374,58.374,0,0,0-1.757-17.469c-4.684-20.006-13.147-37.642-20.522-56.547,5.368,13.816,10.652,27.786,13.649,42.341,2.593,12.631,4.894,24.886,1.84,37.461-4.461,18.305-8.63,36.332-19.867,52a149.717,149.717,0,0,1-19.63,22.99A253.917,253.917,0,0,1,247,499.336c13.077-.948,20.2-7.612,30.5-15.155a180.481,180.481,0,0,0,15.838-12.547c7.57-6.971,12.91-14.9,18.528-23.3,4.182-6.19,6.845-13.245,9.494-20.229a173.94,173.94,0,0,0,8.449-29.277A67.685,67.685,0,0,0,330.929,389.866Z"
              transform="translate(97.359 124.497)"
              fill="#dcffa9"
            />
            <path
              id="Path_1670"
              data-name="Path 1670"
              d="M187.54,373.006c2.2-4.531,3.527-9.146,5.842-13.621,4.42-8.616,8.839-17.971,14.806-25.625L196.281,349.1c-10.512,13.509-17.413,30.672-20.912,47.4a169.845,169.845,0,0,0-2.579,26.587,189.606,189.606,0,0,0,3.109,39.664c1.561,9.215,1.394,20.09,10.01,25.416.934.586,5.577,1.868,5.911,2.537-6.664-12.547-8.226-27.019-9.369-41.142-1.394-17.064-2.259-34.31-.307-51.361C183.009,390.224,183.929,380.451,187.54,373.006Z"
              transform="translate(68.081 131.556)"
              fill="#dcffa9"
            />
            <path
              id="Path_1671"
              data-name="Path 1671"
              d="M177.805,372.06c-.864,3.1-1.743,6.2-2.384,9.3a169.853,169.853,0,0,0-2.579,26.587,189.607,189.607,0,0,0,3.039,39.706c1.394,8.2,1.478,17.678,7.5,23.436-4.531-11.153-5.842-23.534-6.817-35.621-1.394-17.065-2.259-34.31-.307-51.375C176.634,380.341,177.094,376.159,177.805,372.06Z"
              transform="translate(68.098 146.653)"
              fill="#bbdb89"
            />
            <path
              id="Path_1672"
              data-name="Path 1672"
              d="M291.534,303.727c1.241-.99,1.3-2.551-1.171-2.858-4.322-.544-6.246.167-10.038,2.328a66.333,66.333,0,0,0-11.488,8.463c-10.219,9.2-16.563,22.307-21.108,35.035a53.424,53.424,0,0,0,2.551,41.727,36.251,36.251,0,0,1-2.259-8.937,113.414,113.414,0,0,1-1.52-12.269,56.075,56.075,0,0,1,2.468-19.393c2.008-6.413,5.66-11.53,9.048-17.26a61.878,61.878,0,0,1,5.828-8.658,60.512,60.512,0,0,1,7.654-7.1,73.15,73.15,0,0,1,10.345-7.529c2.788-1.575,5.855-1.826,8.741-3A3.332,3.332,0,0,0,291.534,303.727Z"
              transform="translate(96.434 118.523)"
              fill="#dcffa9"
            />
            <path
              id="Path_1673"
              data-name="Path 1673"
              d="M200.433,302.59l-.767-.516c-1.952-1.269-7.515-2.956-6.608,1.52.5,2.468,5.911,4.629,7.71,6.037a41.687,41.687,0,0,1,8.365,8.978c3.932,5.577,6.218,12.046,9.285,18.124-1.394-2.621-1.561-7.64-2.4-10.624a54.653,54.653,0,0,0-3.945-9.452A36.681,36.681,0,0,0,200.433,302.59Z"
              transform="translate(76.058 118.517)"
              fill="#dcffa9"
            />
            <path
              id="Path_1674"
              data-name="Path 1674"
              d="M183.608,357.622a50.357,50.357,0,0,1,.7-25.262,59.533,59.533,0,0,1-2.788,6.288,28.816,28.816,0,0,0-1.617,7.835,39.705,39.705,0,0,0,.655,12.31c.809,3.806,1.018,7.738,1.8,11.613a31.609,31.609,0,0,1,2.9-4.071A68.424,68.424,0,0,0,183.608,357.622Z"
              transform="translate(70.828 131.005)"
              fill="#dcffa9"
            />
            <path
              id="Path_1675"
              data-name="Path 1675"
              d="M160.854,385.564a50.761,50.761,0,0,1-3.555-16.256c-.39-6.427-.641-14.053,1.91-20.118-3.053,7.25-3.722,16.2-3.193,23.966,1.311,19.518,15.336,35.746,24.746,52.128l-.349-.613,2.677,4.489c-.837-1.394-.125-4.684-.307-6.3a23.038,23.038,0,0,0-1.143-3.932c-1.115-3.639-3.82-6.2-6.288-8.992a87.288,87.288,0,0,1-12.436-19.741C162.151,388.631,161.454,387.1,160.854,385.564Z"
              transform="translate(61.432 137.638)"
              fill="#dcffa9"
            />
            <path
              id="Path_1676"
              data-name="Path 1676"
              d="M204.036,445.736a125.543,125.543,0,0,0,25.708-6.12c8.24-3.151,16.033-7.947,21.582-14.806A94.134,94.134,0,0,1,180.8,440.982c-.823-.139.251,3.527.641,3.9,1.771,1.673,7.333,1.98,9.62,2.035a72.494,72.494,0,0,0,12.98-1.185Z"
              transform="translate(71.144 167.445)"
              fill="#dcffa9"
            />
            <path
              id="Path_1677"
              data-name="Path 1677"
              d="M197.538,428.776a33.209,33.209,0,0,0,12.129-16.925c1.269-4.8,1.994-9.759,4.015-14.318a53.663,53.663,0,0,1,5.2-8.435c5.577-8,11.307-16.186,19.435-21.568-9.759,9.759-21.219,22.585-23.9,36.388-.725,3.792-.906,7.682-1.715,11.474-2.356,10.888-10.289,18.514-20.48,22.237a22.3,22.3,0,0,1-7.459,1.687,8.811,8.811,0,0,1-6.873-2.858c-1.394-1.715-1.464-3.109.265-4.545s3.234-.6,5.34,0C188.28,433.4,193.23,431.829,197.538,428.776Z"
              transform="translate(69.71 144.867)"
              fill="#dcffa9"
            />
            <path
              id="Path_1678"
              data-name="Path 1678"
              d="M200.27,406.187c.613,2.872,1.589,5.953,1.394,8.937a6.163,6.163,0,0,1-.544,2.886c-.125.223-2.022,2.189-2.063,1.84-.976-8.449-2.9-17.065-2.523-25.625.418-9.327,3.6-16.73,7.1-25.165a62.807,62.807,0,0,0-3.36,37.127Z"
              transform="translate(77.448 145.47)"
              fill="#dcffa9"
            />
            <path
              id="Path_1679"
              data-name="Path 1679"
              d="M178.649,438.67a47.207,47.207,0,0,1-18.919-19.8,73.514,73.514,0,0,1-7.57-26.573c1.534,8.142,3.778,16.256,7.947,23.408a44.028,44.028,0,0,0,16.73,16.27c2.9,1.478,6.218,2.3,8.616,4.5a2.789,2.789,0,0,1,.92,1.324C187.558,442.629,180.141,439.479,178.649,438.67Z"
              transform="translate(59.976 154.631)"
              fill="#dcffa9"
            />
            <path
              id="Path_1680"
              data-name="Path 1680"
              d="M261.271,395.64c-1.7-2.788-4.447-4.7-6.971-6.706s-5.117-4.336-6.093-7.445c-.795-2.565-.418-5.34-.864-7.989a13.1,13.1,0,0,0-3.374-6.762c-2.077-2.2-4.824-3.569-7.236-5.326a32.264,32.264,0,0,1-5.953-5.8c-4.28-5.089-5.005-11.153-4.963-17.734.1.321-.572.432-.586.084-.167,1.7,0,3.945-.795,5.479a35.5,35.5,0,0,0-2.454,4.336,19.072,19.072,0,0,0-.265,11.572,23.812,23.812,0,0,0,5.577,9.522,41.489,41.489,0,0,0,4.182,3.667,29.709,29.709,0,0,1,4.183,5.4l4.587,6.26c5.117,6.971,10.289,14.039,13.3,22.125a26.49,26.49,0,0,1,.976,15.935c-.349,1.645-.809,3.248-1.255,4.838a36.252,36.252,0,0,0-1.84,10.47c.125-1.562,2.008-2.97,2.691-4.364,1.171-2.356,2.273-4.754,3.332-7.152C261.075,417.515,266.778,404.633,261.271,395.64Z"
              transform="translate(87.09 133.18)"
              fill="#7eae34"
            />
            <path
              id="Path_1681"
              data-name="Path 1681"
              d="M241.338,305.442a18.034,18.034,0,0,0-1.715-1.032,66.922,66.922,0,0,0-13.76-4.67c-4.071-1.087-8.365-.781-12.548-1.324a20.605,20.605,0,0,0-10.679,2.44c-1.213.655-5.047,2.607-5.284,4.1-.488,2.942,3.513,0,4.182-.558a16.619,16.619,0,0,1,4.657-2.412,26.489,26.489,0,0,1,10.205-1.394c4.768.237,9.4,1.506,14.123,2.133a37.755,37.755,0,0,1,13.175,4.517A23.494,23.494,0,0,0,241.338,305.442Z"
              transform="translate(77.773 117.617)"
              fill="#dcffa9"
            />
            <path
              id="Path_1682"
              data-name="Path 1682"
              d="M208.393,405.919a18.708,18.708,0,0,1,6.065.655c6.72,1.715,13.663,3.681,20.648,2.468a48.278,48.278,0,0,0,10.15-3.4c-1.673.7-3.639,3.011-5.451,3.959a26.98,26.98,0,0,1-8.058,2.719,42.483,42.483,0,0,1-16.911-1.06,21.385,21.385,0,0,0-5.981-.976c-3.039.125-5.828,1.673-8.477,3.207l-5.577,3.193c.53-.307,1.394-3.5,1.868-4.182a10.122,10.122,0,0,1,3.067-3.4,18.612,18.612,0,0,1,8.658-3.179Z"
              transform="translate(76.784 159.889)"
              fill="#dcffa9"
            />
            <path
              id="Path_1683"
              data-name="Path 1683"
              d="M169.532,403.549c-2.872-6.3-5.814-13.314-3.82-19.951.613-2.049,1.673-3.932,2.286-5.981a29.069,29.069,0,0,0,.823-8.365q0-6.567,0-13.133c-.446,7.64-.92,15.447-3.736,22.572a33.017,33.017,0,0,0-2.468,7.041c-.6,3.959,1,7.25,2.286,10.861.906,2.523.767,5.73,2.537,7.835a7.4,7.4,0,0,0,1.673-.641Z"
              transform="translate(64.047 140.37)"
              fill="#dcffa9"
            />
            <path
              id="Path_1684"
              data-name="Path 1684"
              d="M157.93,394.28l3.137,6.776c1.924,4.182,3.9,8.755,2.691,13.175-.4,1.394-1.115,2.788-1.394,4.182a8.365,8.365,0,0,0,2.063,7.445c-1.631-1.715-3.4-1.7-4.057-4.517s1.06-5.354,1.715-8.156a22.641,22.641,0,0,0-4.155-18.9Z"
              transform="translate(62.251 155.411)"
              fill="#dcffa9"
            />
            <path
              id="Path_1685"
              data-name="Path 1685"
              d="M156.66,375.281a20.174,20.174,0,0,0,5.577,8.588c3.011,2.663,6.5,4.963,7.208,9.257-2.928-4.182-7.793-6.274-10.833-10.163-2.412-3.1-4.517-7.6-6.511-11.153-1.645-2.914-2.5-5.939-6.051-7.25a19.518,19.518,0,0,1,10.61,10.721Z"
              transform="translate(57.568 143.697)"
              fill="#dcffa9"
            />
            <path
              id="Path_1686"
              data-name="Path 1686"
              d="M235.2,418.07c-5.577,4.6-12.938,7.626-18.877,11.976-2.691,1.966-16.368,11.265-14.179,15.224,2.523,4.559,6.023-5.158,7.11-6.357a20.217,20.217,0,0,1,2.37-2.133c3.625-2.956,7.57-4.963,11.07-8.072Q228.845,423.27,235.2,418.07Z"
              transform="translate(79.586 164.788)"
              fill="#dcffa9"
            />
            <path
              id="Path_1687"
              data-name="Path 1687"
              d="M268.051,391.054a76.041,76.041,0,0,1-1.087-16.869,74.836,74.836,0,0,1,2.161-14.806c.627-2.51,1.464-4.921,2.258-7.375.265-.836.4-1.9.753-2.691s1.394-1.617,1.589-2.272a86.3,86.3,0,0,0-3.513,28.664c.2,4.029,1.06,7.752,1.213,11.781A35.957,35.957,0,0,0,274,400.172a43.845,43.845,0,0,1,3.639,15.461,78.831,78.831,0,0,1-1.394,15.977,100.094,100.094,0,0,1-2.914,12.91c-1.227,3.722-2.328,7.989-1.255,11.892.4,1.394,3.3,5.953,2.133,7.278a12.937,12.937,0,0,1-4.294,3.722c-1.324-2.37-.92-5.451-1.394-8.072a49.3,49.3,0,0,1-.725-14.527c.809-6.26,2.97-12.547,4.183-18.682,1.143-5.73,2.245-11.85,1.046-17.664a28.951,28.951,0,0,0-1.464-4.433,73.586,73.586,0,0,1-3.513-12.98Z"
              transform="translate(105.195 136.791)"
              fill="#dcffa9"
            />
            <path
              id="Path_1688"
              data-name="Path 1688"
              d="M290.783,349.88a36.584,36.584,0,0,1,6.748,8.365c1.938,3.625,1.673,7.389,2.063,11.4a176.219,176.219,0,0,0,2.537,17.525,53.358,53.358,0,0,0,1.924,8.254c.4,1.115,3.193,5.465,2.984,6.232.795-3.039,1.575-6.065,2.356-9.1-3.109-2.328-3.862-6.608-4.364-10.47s-1.073-8.114-1.617-12.171c-.892-6.748-2.161-14.179-7.459-18.431-2.356-1.882-5.4-2.788-7.194-5.214a35.939,35.939,0,0,1-4.531-9.759C285.875,341.376,287.13,346.227,290.783,349.88Z"
              transform="translate(112.034 132.64)"
              fill="#dcffa9"
            />
            <path
              id="Path_1689"
              data-name="Path 1689"
              d="M299.892,337.555c1.157,1.394,4.182,4.378,3.137,6.274a69.231,69.231,0,0,1-8.63-11.5c-2.147-3.6-3.109-7.821-5.409-11.307A111.835,111.835,0,0,0,299.892,337.555Z"
              transform="translate(113.91 126.535)"
              fill="#dcffa9"
            />
            <path
              id="Path_1690"
              data-name="Path 1690"
              d="M308.93,340.664a3.7,3.7,0,0,0-.53-1.924,4.364,4.364,0,0,1,1.241,3.053,83.258,83.258,0,0,1,.153,17.776,32.064,32.064,0,0,1-1.575,7.9,33.465,33.465,0,0,0-2.245,7.849c-.892,0-1.269-1.129-1.394-2.035a21,21,0,0,1,1.952-8.7,51.137,51.137,0,0,0,1.938-7.71,42.914,42.914,0,0,0,.586-14.039A18.816,18.816,0,0,0,308.93,340.664Z"
              transform="translate(120.055 133.519)"
              fill="#dcffa9"
            />
            <path
              id="Path_1691"
              data-name="Path 1691"
              d="M273.264,424.9c-1.394-4.182.418-9.313,1.394-13.468a24.846,24.846,0,0,1,1.994-4.461,35.719,35.719,0,0,0,3.569-11.823c.474-5.367-.85-10.916.307-16.214,1.074-4.894,3.9-9.215,6.413-13.44a35.733,35.733,0,0,0-4.754,21.61c.209,2.022.586,4.029.627,6.051.112,5.674-2.914,10.317-3.9,15.67a42.443,42.443,0,0,1-2.44,7.612C275.885,417.966,272.776,423.459,273.264,424.9Z"
              transform="translate(107.511 144.063)"
              fill="#dcffa9"
            />
            <path
              id="Path_1692"
              data-name="Path 1692"
              d="M293.476,416.018a4.8,4.8,0,0,1-2.259,2.788c-4.182-11.474-2.314-23.994-1.659-35.816a75.091,75.091,0,0,0,3.318,26.489C293.546,411.612,294.3,413.94,293.476,416.018Z"
              transform="translate(113.746 150.961)"
              fill="#dcffa9"
            />
            <path
              id="Path_1693"
              data-name="Path 1693"
              d="M312.045,387.667a67.094,67.094,0,0,1,3.29-7.277,17.6,17.6,0,0,1,4.406-4.949,66.15,66.15,0,0,1-3.36,6.371c-2.3,4.294-3.848,8.951-6.106,13.258a26.713,26.713,0,0,1-4.824,6.831c-1.785,1.729-3.527,2.607-4.852,4.935a12.2,12.2,0,0,1-2.579,3.778,22.064,22.064,0,0,1,.92-3.9,16.367,16.367,0,0,1,2.133-4.991c1.311-1.84,3.318-2.579,4.74-4.183A38.913,38.913,0,0,0,312.045,387.667Z"
              transform="translate(117.469 147.985)"
              fill="#dcffa9"
            />
            <path
              id="Path_1694"
              data-name="Path 1694"
              d="M299.731,358.716c.307.739.725,2.44,0,3.053-1.046.836-1.171-.558-1.394-1.241a7.611,7.611,0,0,0-1.687-2.788,7.306,7.306,0,0,0-5.089-1.812,22,22,0,0,0-5.451.934l3.179-1.506a4.894,4.894,0,0,1,4.043-.446,15.029,15.029,0,0,1,3.75,1.074A5.228,5.228,0,0,1,299.731,358.716Z"
              transform="translate(112.775 139.796)"
              fill="#dcffa9"
            />
            <path
              id="Path_1695"
              data-name="Path 1695"
              d="M305.832,352.715c-.6-3.29-3.667-5.27-6.051-7.347-.809-.7-1.687-1.3-2.454-2.049a23.059,23.059,0,0,0-2.008-2.189,12.155,12.155,0,0,1,2.537,2.607c.5.683.92,1.394,1.394,2.105A37.512,37.512,0,0,0,305.832,352.715Z"
              transform="translate(116.405 134.461)"
              fill="#dcffa9"
            />
            <path
              id="Path_1696"
              data-name="Path 1696"
              d="M301.352,334.006a30.267,30.267,0,0,1,1.868,13.816c0,.223-.153.5-.363.46a.53.53,0,0,1-.223-.167,6.315,6.315,0,0,1-1.213-5.577,20.4,20.4,0,0,0-.613-7.278,57.037,57.037,0,0,0-5.158-14.151A98.99,98.99,0,0,1,301.352,334.006Z"
              transform="translate(116.535 126.57)"
              fill="#dcffa9"
            />
            <path
              id="Path_1697"
              data-name="Path 1697"
              d="M266.023,325.27a42.537,42.537,0,0,0-.795-6.971,23.559,23.559,0,0,1-1.115-5.814,3.416,3.416,0,0,0-.265-1.631,1.171,1.171,0,0,0-1.394-.641,1.673,1.673,0,0,0-.795,1.171c-.948,3.374-.167,5.172,1.032,8.365a33.614,33.614,0,0,1,2.008,9.871,88.121,88.121,0,0,1-.864,15.559,54.511,54.511,0,0,0,2.189-19.909Z"
              transform="translate(102.971 122.257)"
              fill="#dcffa9"
            />
            <path
              id="Path_1698"
              data-name="Path 1698"
              d="M269.347,305.11c1.757,0,3.959-.125,5.409,1.032-2.482,2.677-5.814.906-8.895,1.52a60.66,60.66,0,0,0-22.111,9.188,14.611,14.611,0,0,1,5.939-4.991c3.332-1.715,6.162-3.792,9.759-5.061a23.264,23.264,0,0,1,3.681-1.464,40.575,40.575,0,0,1,6.218-.223Z"
              transform="translate(96.078 120.25)"
              fill="#dcffa9"
            />
            <path
              id="Path_1699"
              data-name="Path 1699"
              d="M280.519,307.8a12.938,12.938,0,0,0-3.262-4.42c-1.534-1.227-1.91,0-1.2,1.478s1.492,2.328,2.049,3.653l1.729,4.182a9.272,9.272,0,0,1,.892,3.234c0,1.2-.39,2.37-.293,3.555C281.425,315.595,282.164,311.412,280.519,307.8Z"
              transform="translate(108.676 119.384)"
              fill="#dcffa9"
            />
            <path
              id="Path_1700"
              data-name="Path 1700"
              d="M277.117,298.4a28.512,28.512,0,0,0-5.381-1.938,26.486,26.486,0,0,0-6.72-.279c-2.565.139-4.866,1.31-7.389,1.9a46.773,46.773,0,0,1-7.975,1.143,11.7,11.7,0,0,1-3.625-.237c-2.022-.544-3.667-2.008-5.577-2.691,1.394.795,2.482,2.035,3.82,2.914,3.416,2.217,7.57,1.394,11.251.516,3.165-.7,6.385-1.1,9.592-1.506,3.973-.488,6.622.683,10.261,1.98a47.171,47.171,0,0,1,5.73,2.286c.934.474,4.266,3.374,4.824,3.123s.781-1.826.613-2.342c-.293-.864-1.269-1.255-2.022-1.631C282.08,300.44,279.556,299.478,277.117,298.4Z"
              transform="translate(94.777 116.708)"
              fill="#dcffa9"
            />
            <path
              id="Path_1701"
              data-name="Path 1701"
              d="M236.741,364.485c-6.72-4.113-11.725-13.621-11.627-21.512,0-.53,0-1.185-.558-1.394-.725-.223-1.074.85-1.046,1.6.335,7.682-.349,16.242,5.8,21.986a49.767,49.767,0,0,0,4.615,3.4,45.674,45.674,0,0,1,5.855,5.577,39.942,39.942,0,0,1,11.753,19.616c3.165,9.522,6.371,19.518,4.824,29.389a8.365,8.365,0,0,0,1.812-4.252c1.7-7.724,3.332-16.061.125-23.283-1.9-4.266-5.326-7.71-7.152-12s-2.049-9.606-5.158-13.2C243.559,367.58,239.864,366.353,236.741,364.485Z"
              transform="translate(88.1 134.626)"
              fill="#9ad428"
            />
            <path
              id="Path_1702"
              data-name="Path 1702"
              d="M139.355,371.551c-.209,7.152-2.245,16.967-13.551,26.8a35.971,35.971,0,0,1-9.062,5.758,39.174,39.174,0,0,1-7.487,2.4c-.948.223-1.812.418-2.663.544a57.982,57.982,0,0,1-18.793-.125c-2.663-.418-4.907-.948-6.622-1.394-7.459-2.217-33.056-17.037-33.307-41.909a39.7,39.7,0,0,1,.209-4.42c.112-1.074.223-2.022.432-3.1a21.554,21.554,0,0,1,.641-3.736c.209-.962.432-1.91.641-2.788a1.311,1.311,0,0,1,.112-.641c.307-1.06.641-2.147.962-3.207a48.293,48.293,0,0,1,4.378-9.926c.418-.739.962-1.492,1.394-2.245a1.032,1.032,0,0,0,.432-.53c2.565-3.527,6.817-6.092,10.568-8.365a60.091,60.091,0,0,1,14.193-6.3c1.171-.321,2.356-.641,3.527-.85a45.3,45.3,0,0,1,6.511-1.074,33.53,33.53,0,0,1,11.153.851,46.777,46.777,0,0,1,13.021,4.7c8.016,4.489,14.527,13.468,18.584,22.85a56.354,56.354,0,0,1,4.182,14.3c.321,2.356.432,4.378.53,6.092a56.825,56.825,0,0,1,.014,6.315Z"
              transform="translate(18.869 124.674)"
              fill="#ca3116"
            />
            <path
              id="Path_1703"
              data-name="Path 1703"
              d="M124.407,348.7a17.956,17.956,0,0,1-6.3,5.34c-6.971,3.416-15.266,1.812-22.418-1.185A57.425,57.425,0,0,1,81.5,344c-3.1-2.565-6.092-5.66-7.054-9.606a17.5,17.5,0,0,1-.418-5.228,31.1,31.1,0,0,1,1.06-7.793,42,42,0,0,1,6.511-1.074,33.168,33.168,0,0,1,11.153.85,46.7,46.7,0,0,1,13.035,4.7C113.84,330.339,120.35,339.3,124.407,348.7Z"
              transform="translate(29.16 126.194)"
              fill="#f2573d"
            />
            <path
              id="Path_1704"
              data-name="Path 1704"
              d="M109.293,406.4c-.906.209-1.8.376-2.7.558a61.342,61.342,0,0,1-25.318-1.52c-7.891-2.245-36.165-18.765-33.209-46.3.1-1.046.237-2.049.418-3.1a37,37,0,0,1,.655-3.695c.209-.976.418-1.91.655-2.788a1.6,1.6,0,0,1,.181-.586,32.343,32.343,0,0,1,.934-3.262,48.49,48.49,0,0,1,4.392-9.871c.418-.767.906-1.492,1.394-2.217a5.4,5.4,0,0,0,.335-.516c2.565-3.569,6.859-6.134,10.61-8.365A60.118,60.118,0,0,1,81.8,318.47a47.276,47.276,0,0,1,10.038-1.91c-14.262,6.622-25.318,18.989-27.744,41.574-3.011,27.535,25.248,44.056,33.153,46.3a61.426,61.426,0,0,0,12.046,1.966Z"
              transform="translate(18.859 124.777)"
              fill="#b41b00"
            />
            <path
              id="Path_1705"
              data-name="Path 1705"
              d="M116.742,390.756a39.175,39.175,0,0,1-7.487,2.4c-.948.223-1.812.418-2.663.544a57.983,57.983,0,0,1-18.793-.125c-2.663-.418-4.907-.948-6.622-1.394-7.459-2.217-33.056-17.037-33.307-41.909,4.531-.725,9.285,2.412,13.384,6.427a83.651,83.651,0,0,1,9.188,11.153,50.473,50.473,0,0,1,4.935,7.919c2.008,4.42,2.691,4.768,7.264,4.1s9.383,0,14.025.293,8.267,2.97,12.45,5.4a51.585,51.585,0,0,1,7.626,5.2Z"
              transform="translate(18.869 138.023)"
              fill="#ba5240"
            />
            <path
              id="Path_1706"
              data-name="Path 1706"
              d="M67.735,331.848l-2.9-.85a18.541,18.541,0,0,0-4.852-.7,5.187,5.187,0,0,0-2.217.711l-5.577,2.426,2.872-.167a13.341,13.341,0,0,1,2.691.112,18.248,18.248,0,0,1,4.531,1.785,79.014,79.014,0,0,0,8.365,3.262,4.866,4.866,0,0,0,1.073.279,2.649,2.649,0,0,0,2.4-1.073c.516-.823-.084-2.412-.655-3.1a6.97,6.97,0,0,0-3.416-2.036Z"
              transform="translate(20.572 130.193)"
              fill="#5c7300"
            />
            <path
              id="Path_1707"
              data-name="Path 1707"
              d="M73.067,335.681a6.971,6.971,0,0,0-3.513-2.035l-2.3-.655-2.788-.85a18.459,18.459,0,0,0-4.852-.7,5.186,5.186,0,0,0-2.217.711L54.761,333.3c-.85,0-1.7.07-2.551.139l5.577-2.426A5.188,5.188,0,0,1,60,330.3a18.542,18.542,0,0,1,4.852.7l2.9.85L70,332.5a6.971,6.971,0,0,1,3.513,2.036c.572.683,1.171,2.272.655,3.1,0,.084-.181.125-.251.2A4.182,4.182,0,0,0,73.067,335.681Z"
              transform="translate(20.58 130.193)"
              fill="#83a100"
            />
            <path
              id="Path_1708"
              data-name="Path 1708"
              d="M71.162,352.741c.7-1.032,2.579-4.28.446-4.643a11.154,11.154,0,0,0-4.182.46,26.627,26.627,0,0,0-3.081.864,21.878,21.878,0,0,0-2.5,1.213c-.85.418-1.631.864-2.44,1.3-1.269.711-2.788.837-4.1,1.394.153-.07.432-.558.586-.711s.613-.474.892-.753c.488-.516.739-1.2,1.241-1.715a15.754,15.754,0,0,1,9.62-4.587c.572,0,1.952-.237,1.506-1.087s-1.575-.864-2.217-1.087a30.157,30.157,0,0,0-3.109-.85,22.308,22.308,0,0,1-4.252-1.589c-.613-.265-1.227-.39-1.854-.627a4.182,4.182,0,0,0-1.868-.474c5.577-.544,10.679,2.942,16.2,3.569L66.728,332.8a24.759,24.759,0,0,0,6.12,5.284,1.477,1.477,0,0,0,.823.265c.418,0,.683-.488.878-.864,1.8-3.444,3.569-7.18,3.151-11.042A39.454,39.454,0,0,1,77.157,321c0-.376.125-.878.516-.906.655,1.91.948,3.918,1.617,5.855a13.341,13.341,0,0,1,1.046,4.113,36.5,36.5,0,0,1-.293,3.9,8.045,8.045,0,0,1-.725,3.388c-.349.586,0,.99.641.753a10.623,10.623,0,0,0,1.868-1.2,14.708,14.708,0,0,1,9.048-2.788c-1.826-.139-12.338,7.612-13.077,9.425-.46,1.115,0,6.009-4.336,10.289-.92.892-1.785,1.826-2.621,2.788a11.419,11.419,0,0,0-1.785,3.262c-.39.948,0,1.589.125,2.551-.084-.516-.516-.85-.795-1.269a6.622,6.622,0,0,1-.781-1.826,2.691,2.691,0,0,1-.139-1.283c.125-.544.572-.823.85-1.269s.4-.948.725-1.394C69.7,354.512,70.52,353.689,71.162,352.741Z"
              transform="translate(21.802 126.168)"
              fill="maroon"
            />
            <path
              id="Path_1709"
              data-name="Path 1709"
              d="M67.446,339.332c.362-.669.795-1.311,1.185-1.966a25.583,25.583,0,0,0,3.471-9.578c.683-4.489.2-9.243,2.022-13.4a8.853,8.853,0,0,0,0,3.039,19.9,19.9,0,0,0,.2,3.4,51.9,51.9,0,0,0,1.269,6.72c.864,3.736-.335,8.49-1.994,11.864a29.921,29.921,0,0,1-3.081,4.977,2.063,2.063,0,0,1-3.527-.585,4.266,4.266,0,0,1-.2-2.537,6.859,6.859,0,0,1,.655-1.938Z"
              transform="translate(26.284 123.921)"
              fill="#5c7300"
            />
            <path
              id="Path_1710"
              data-name="Path 1710"
              d="M66.733,341.283a6.859,6.859,0,0,1,.725-1.952c.362-.669.795-1.311,1.185-1.966a25.583,25.583,0,0,0,3.471-9.578c.683-4.489.2-9.243,2.022-13.4a8.853,8.853,0,0,0,0,3.039,19.9,19.9,0,0,0,.2,3.4,14.161,14.161,0,0,0,.349,2.286c-.112,1.812-.209,3.653-.474,5.451a26.071,26.071,0,0,1-3.471,9.564c-.4.641-.836,1.3-1.185,1.966a6.483,6.483,0,0,0-.739,1.952,4.378,4.378,0,0,0,.2,2.537,2.148,2.148,0,0,0,.39.474,2.133,2.133,0,0,1-2.4-1.255,4.266,4.266,0,0,1-.265-2.523Z"
              transform="translate(26.272 123.921)"
              fill="#83a100"
            />
            <path
              id="Path_1711"
              data-name="Path 1711"
              d="M69.581,340.5a1.7,1.7,0,0,1-1.255,0,.781.781,0,0,1-.432-.348,1.046,1.046,0,0,1,0-.363c0-.92-.237-1.715.335-2.468a13.942,13.942,0,0,1,2.788-2.314,54.1,54.1,0,0,0,4.824-3.9,27.788,27.788,0,0,1,4.517-3.959,6.622,6.622,0,0,1,1.52-.725,8.365,8.365,0,0,1,1.952-.223h5.577c-3.639,1.91-7.765,3.639-10.847,6.413-.46.418-.878.864-1.311,1.31-1.06,1.087-2.189,2.133-3.179,3.276A12.951,12.951,0,0,1,69.581,340.5Z"
              transform="translate(26.742 128.576)"
              fill="#5c7300"
            />
            <path
              id="Path_1712"
              data-name="Path 1712"
              d="M68.181,337.345a13.94,13.94,0,0,1,2.788-2.314,54.118,54.118,0,0,0,4.824-3.9,27.785,27.785,0,0,1,4.517-3.959,6.621,6.621,0,0,1,1.52-.725,8.36,8.36,0,0,1,1.952-.223h5.577l-1.6.809H85.217a7.517,7.517,0,0,0-1.938.223,5.938,5.938,0,0,0-1.534.725,27.622,27.622,0,0,0-4.517,3.945,54.086,54.086,0,0,1-4.81,3.918,13.522,13.522,0,0,0-2.788,2.3,3.165,3.165,0,0,0-.335,2.37,1.617,1.617,0,0,1-.962,0,.781.781,0,0,1-.432-.349,1.046,1.046,0,0,1,0-.362A3.106,3.106,0,0,1,68.181,337.345Z"
              transform="translate(26.72 128.584)"
              fill="#83a100"
            />
            <path
              id="Path_1713"
              data-name="Path 1713"
              d="M76.184,337.221a1.687,1.687,0,0,0,.613-1.1.739.739,0,0,0-.1-.544,1.143,1.143,0,0,0-.279-.237c-.781-.474-1.394-1.032-2.328-.892a14.109,14.109,0,0,0-3.332,1.3,53.8,53.8,0,0,1-5.73,2.356,27.884,27.884,0,0,0-5.577,2.077,6.455,6.455,0,0,0-1.394.99,8.1,8.1,0,0,0-1.129,1.6c-.934,1.617-1.812,3.276-2.621,4.949,3.416-2.286,6.9-5.075,10.8-6.441.586-.209,1.185-.376,1.785-.544,1.394-.4,2.928-.892,4.406-1.213a13.12,13.12,0,0,0,4.88-2.3Z"
              transform="translate(21.407 131.818)"
              fill="#5c7300"
            />
            <path
              id="Path_1714"
              data-name="Path 1714"
              d="M74.563,335.974a13.121,13.121,0,0,0-3.332,1.3,55.765,55.765,0,0,1-5.744,2.356,27.881,27.881,0,0,0-5.577,2.063,6.429,6.429,0,0,0-1.394,1,6.8,6.8,0,0,0-1.129,1.6c-.39.655-.711,1.394-1.074,2.008-.683.488-1.394.976-2.063,1.394.809-1.673,1.687-3.332,2.621-4.949a8.1,8.1,0,0,1,1.129-1.6,6.457,6.457,0,0,1,1.394-.99,27.884,27.884,0,0,1,5.577-2.077,53.766,53.766,0,0,0,5.73-2.356,14.108,14.108,0,0,1,3.332-1.3c.934-.139,1.548.418,2.328.892a1.143,1.143,0,0,1,.279.237.739.739,0,0,1,.1.544,1.255,1.255,0,0,1-.181.544A2.788,2.788,0,0,0,74.563,335.974Z"
              transform="translate(21.384 131.81)"
              fill="#83a100"
            />
            <path
              id="Path_1715"
              data-name="Path 1715"
              d="M71.152,333.347c-1.032.111-1.394-.92-1.84.139a9.536,9.536,0,0,0-.544,3.388,25.806,25.806,0,0,1-1.241,5.577,27.551,27.551,0,0,1-2.105,4.266c-.46.809-.976,1.575-1.506,2.342a13.634,13.634,0,0,0-1.073,1.854,4.182,4.182,0,0,0,0,3.067,12.549,12.549,0,0,0,1.52,2.788,12.548,12.548,0,0,1,1.6-5.312,17.7,17.7,0,0,1,1.854-2.119,27.159,27.159,0,0,0,1.771-2.4,30.81,30.81,0,0,0,3.876-7.25,7.947,7.947,0,0,0,.544-2.788,5.925,5.925,0,0,0-.516-2.649,1.394,1.394,0,0,0-.223-.363,3.528,3.528,0,0,0-.906-.558A1.993,1.993,0,0,0,71.152,333.347Z"
              transform="translate(24.656 131.258)"
              fill="#5c7300"
            />
            <path
              id="Path_1716"
              data-name="Path 1716"
              d="M69,333.1a1,1,0,0,1,.488.112h0A1.4,1.4,0,0,1,69,333.1Z"
              transform="translate(27.198 131.296)"
              fill="#b3b900"
            />
            <path
              id="Path_1717"
              data-name="Path 1717"
              d="M62.836,350.883a13.633,13.633,0,0,1,1.073-1.854c.53-.767,1.046-1.534,1.506-2.342a27.55,27.55,0,0,0,2.105-4.266,25.807,25.807,0,0,0,1.241-5.577,9.536,9.536,0,0,1,.544-3.388c.418-1.018.809-.1,1.771-.153a.753.753,0,0,0-.209.293,9.857,9.857,0,0,0-.544,3.388,25.807,25.807,0,0,1-1.241,5.577,26.8,26.8,0,0,1-2.105,4.182c-.46.823-.976,1.589-1.506,2.356a13.631,13.631,0,0,0-1.074,1.854,4.182,4.182,0,0,0,0,3.067,5.9,5.9,0,0,0,.321.669,13.524,13.524,0,0,0-.362,1.938,12.546,12.546,0,0,1-1.52-2.788,4.182,4.182,0,0,1,0-2.956Z"
              transform="translate(24.662 131.247)"
              fill="#83a100"
            />
            <path
              id="Path_1718"
              data-name="Path 1718"
              d="M68.251,338.1a66.32,66.32,0,0,1-5.228-6.539,25.352,25.352,0,0,1-1.6-2.44,6.357,6.357,0,0,1-1.129-2.008,2.147,2.147,0,0,1,1.213-2.008,2.787,2.787,0,0,1,1.115-.349c.53,0,.725.613,1.018,1.06a47.54,47.54,0,0,0,4.392,5.577c1.785,1.91,3.792,3.555,5.73,5.312a1.492,1.492,0,0,1,.641,1.032,1.255,1.255,0,0,1-.181.586,5.828,5.828,0,0,1-1.394,1.548C71.109,341.337,69.408,339.217,68.251,338.1Z"
              transform="translate(23.764 128.009)"
              fill="#5c7300"
            />
            <path
              id="Path_1719"
              data-name="Path 1719"
              d="M72.886,338.773a1.255,1.255,0,0,0,.181-.586,1.492,1.492,0,0,0-.641-1.032c-1.924-1.757-3.945-3.4-5.73-5.312a46.387,46.387,0,0,1-4.392-5.507c-.293-.446-.488-1.018-1.018-1.06a1.4,1.4,0,0,0-.307,0l.293-.209a2.788,2.788,0,0,1,1.115-.349c.53,0,.725.613,1.018,1.046a46.53,46.53,0,0,0,4.392,5.577c1.785,1.91,3.806,3.555,5.73,5.312a1.492,1.492,0,0,1,.641,1.032,1.255,1.255,0,0,1-.181.586,5.828,5.828,0,0,1-1.394,1.548,2.008,2.008,0,0,1-1.1.5A5.576,5.576,0,0,0,72.886,338.773Z"
              transform="translate(24.037 127.993)"
              fill="#83a100"
            />
            <path
              id="Path_1720"
              data-name="Path 1720"
              d="M91.178,403.305c-.962,6.622-4.182,14.625-13.231,22.53a37.265,37.265,0,0,1-16.6,8.226c-.85.209-1.812.321-2.663.53a52.629,52.629,0,0,1-13.454.418,59.956,59.956,0,0,1-11.85-1.91C25.527,430.742-2.788,414.305.223,386.757c.112-1.06.223-2.022.432-3.1a21.556,21.556,0,0,1,.641-3.736c.209-.962.432-1.91.641-2.788a1.729,1.729,0,0,1,.209-.641,25.259,25.259,0,0,1,.962-3.3,46.006,46.006,0,0,1,4.378-9.829,24.407,24.407,0,0,1,1.394-2.231,2.941,2.941,0,0,0,.321-.544c2.551-3.513,6.831-6.078,10.568-8.365a65.43,65.43,0,0,1,14.193-6.3A52.133,52.133,0,0,1,44,344.011a32.987,32.987,0,0,1,11.153.85,20.253,20.253,0,0,1,5.117,1.7,10.373,10.373,0,0,1,2.621,1.673l.641.641a21.407,21.407,0,0,0,2.356,2.147l.1.111a25.245,25.245,0,0,0,2.788,2.022,25.245,25.245,0,0,0,2.133,1.394A37.251,37.251,0,0,1,82.981,365.7a48.712,48.712,0,0,1,8,21.136c.321,2.356.432,4.378.53,5.981a45.127,45.127,0,0,1-.335,10.484Z"
              transform="translate(0 135.539)"
              fill="#d53417"
            />
            <path
              id="Path_1721"
              data-name="Path 1721"
              d="M77.74,386.062a18.849,18.849,0,0,1-8.449,8.7c-6.971,3.388-15.336,1.826-22.307-1.213a57.608,57.608,0,0,1-14.276-8.8c-3.081-2.607-6.023-5.716-6.971-9.634a18.892,18.892,0,0,1-.46-5.228,27.646,27.646,0,0,1,2.189-10.944,15.112,15.112,0,0,1,4.182-5.3,18.431,18.431,0,0,1,5.228-5.577,18.361,18.361,0,0,1,10.359-2.286,11.156,11.156,0,0,1,2.412,1.715,5.736,5.736,0,0,0,.669.627,23.056,23.056,0,0,0,2.314,2.161.2.2,0,0,0,.139.1,24.362,24.362,0,0,0,2.788,2.077c.725.488,1.394.934,2.175,1.394a36.457,36.457,0,0,1,11.99,11.153,47.4,47.4,0,0,1,8.016,21.052Z"
              transform="translate(9.954 136.275)"
              fill="#f2573d"
            />
            <path
              id="Path_1722"
              data-name="Path 1722"
              d="M61.413,433.993c-.892.209-1.8.376-2.691.558a61.009,61.009,0,0,1-25.262-1.534C25.5,430.731-2.788,414.21.223,386.675c.1-1.032.237-2.035.4-3.081.181-1.283.39-2.523.669-3.708.209-.962.418-1.9.655-2.788a1.743,1.743,0,0,1,.167-.6c.251-1.1.6-2.175.934-3.248a48.921,48.921,0,0,1,4.406-9.871c.418-.767.906-1.492,1.394-2.217a3.831,3.831,0,0,0,.349-.53c2.565-3.555,6.859-6.12,10.6-8.365a60.9,60.9,0,0,1,14.165-6.26A46.555,46.555,0,0,1,44,344c-14.276,6.608-25.318,18.975-27.744,41.56C13.245,413.095,41.5,429.616,49.4,431.874a64.033,64.033,0,0,0,12.018,2.119Z"
              transform="translate(0 135.593)"
              fill="#bf1d00"
            />
            <path
              id="Path_1723"
              data-name="Path 1723"
              d="M78.392,388.166c-.962,6.622-4.182,14.625-13.231,22.53a37.265,37.265,0,0,1-16.6,8.226c-.85.209-1.812.321-2.663.53a52.631,52.631,0,0,1-13.454.418,75.551,75.551,0,0,1,2.022-13.76c1.394-6.3,3.207-11.85,8.016-16.451A27.075,27.075,0,0,1,59.124,382.3a30.672,30.672,0,0,1,19.267,5.869Z"
              transform="translate(12.787 150.679)"
              fill="#ba5240"
            />
            <path
              id="Path_1724"
              data-name="Path 1724"
              d="M54.792,361.6l2.579-.753a16.731,16.731,0,0,1,4.308-.627,4.782,4.782,0,0,1,1.966.627l4.921,2.161c-.85,0-1.7-.112-2.551-.139a11.152,11.152,0,0,0-2.37.1,16.355,16.355,0,0,0-4.029,1.575,67.562,67.562,0,0,1-7.487,2.9,4.531,4.531,0,0,1-.948.251,2.328,2.328,0,0,1-2.119-.962c-.474-.725.07-2.147.572-2.788a6.079,6.079,0,0,1,3.123-1.812Z"
              transform="translate(19.267 141.986)"
              fill="#5c7300"
            />
            <path
              id="Path_1725"
              data-name="Path 1725"
              d="M50.05,365.016a5.982,5.982,0,0,1,3.123-1.812l1.98-.586,2.579-.753a16.732,16.732,0,0,1,4.308-.627,4.587,4.587,0,0,1,1.966.627l2.342,1.018a20.437,20.437,0,0,1,2.259.125l-4.977-2.161a4.782,4.782,0,0,0-1.966-.627,16.732,16.732,0,0,0-4.308.627l-2.579.753-1.98.586A6.078,6.078,0,0,0,49.673,364c-.5.586-1.046,2.008-.572,2.788,0,.084.153.112.209.181a3.583,3.583,0,0,1,.739-1.952Z"
              transform="translate(19.283 141.986)"
              fill="#83a100"
            />
            <path
              id="Path_1726"
              data-name="Path 1726"
              d="M55.371,381.075c-.7-1.018-2.565-4.28-.446-4.643a11.155,11.155,0,0,1,4.182.46,25.863,25.863,0,0,1,3.081.864A20.686,20.686,0,0,1,64.6,379c.85.418,1.631.864,2.44,1.311,1.269.7,2.788.823,4.182,1.394-.167-.07-.446-.558-.6-.711s-.613-.474-.892-.753c-.488-.516-.739-1.2-1.227-1.7a15.768,15.768,0,0,0-9.634-4.6c-.572,0-1.952-.237-1.506-1.087s1.589-.864,2.231-1.087a26.205,26.205,0,0,1,3.109-.837,23.615,23.615,0,0,0,4.182-1.6c.613-.265,1.227-.39,1.854-.627a4.418,4.418,0,0,1,1.868-.474c-5.577-.544-10.665,2.942-16.2,3.583l5.326-10.624a24.761,24.761,0,0,1-6.079,5.228,1.464,1.464,0,0,1-.809.265c-.432,0-.7-.488-.892-.864-1.8-3.444-3.555-7.18-3.151-11.042a37.42,37.42,0,0,0,.544-5.437c0-.39-.125-.892-.516-.92-.655,1.91-.948,3.932-1.617,5.856a13.342,13.342,0,0,0-1.046,4.113,33.224,33.224,0,0,0,.307,3.9,7.64,7.64,0,0,0,.725,3.388c.335.586-.07.99-.655.753a10.617,10.617,0,0,1-1.868-1.2,14.681,14.681,0,0,0-9.048-2.788c1.826-.139,12.338,7.612,13.077,9.425.46,1.115,0,6.009,4.336,10.289.92.892,1.785,1.84,2.621,2.788a11.419,11.419,0,0,1,1.812,3.332c.39.948,0,1.589-.125,2.565.084-.53.516-.864.809-1.283a6.2,6.2,0,0,0,.767-1.826,2.649,2.649,0,0,0,.139-1.269c-.125-.558-.572-.836-.836-1.283s-.418-.948-.725-1.394C56.835,382.846,56.013,382.023,55.371,381.075Z"
              transform="translate(14.044 137.331)"
              fill="#8b0000"
            />
            <path
              id="Path_1727"
              data-name="Path 1727"
              d="M51.76,368.255c-.321-.6-.7-1.171-1.046-1.743a22.921,22.921,0,0,1-3.1-8.49c-.586-3.987-.153-8.212-1.785-11.892a7.891,7.891,0,0,1,0,2.691,16.88,16.88,0,0,1-.181,3.025,47.86,47.86,0,0,1-1.115,5.967,17.176,17.176,0,0,0,1.826,10.442,25.723,25.723,0,0,0,2.788,4.42,1.812,1.812,0,0,0,3.123-.516,3.9,3.9,0,0,0,.181-2.259,6.051,6.051,0,0,0-.7-1.645Z"
              transform="translate(17.489 136.432)"
              fill="#5c7300"
            />
            <path
              id="Path_1728"
              data-name="Path 1728"
              d="M52.138,369.964a6.051,6.051,0,0,0-.655-1.729c-.321-.6-.7-1.171-1.046-1.743a22.921,22.921,0,0,1-3.1-8.49c-.586-3.987-.153-8.212-1.785-11.892a7.891,7.891,0,0,1,0,2.691,16.881,16.881,0,0,1-.181,3.025c-.07.7-.2,1.394-.307,2.022.1,1.617.181,3.248.418,4.838a22.99,22.99,0,0,0,3.1,8.5c.349.572.725,1.143,1.046,1.743a6.33,6.33,0,0,1,.655,1.729,3.9,3.9,0,0,1-.181,2.259,2.455,2.455,0,0,1-.335.418,1.9,1.9,0,0,0,2.119-1.115,3.9,3.9,0,0,0,.251-2.259Z"
              transform="translate(17.765 136.424)"
              fill="#83a100"
            />
            <path
              id="Path_1729"
              data-name="Path 1729"
              d="M52.974,369.277a1.478,1.478,0,0,0,1.115,0,.865.865,0,0,0,.39-.307,1.185,1.185,0,0,0,0-.321c0-.809.223-1.52-.293-2.189a11.824,11.824,0,0,0-2.426-2.049,46.492,46.492,0,0,1-4.266-3.485,25.272,25.272,0,0,0-4.015-3.5,5.464,5.464,0,0,0-1.394-.641,6.51,6.51,0,0,0-1.729-.2H35.38c3.234,1.687,6.887,3.22,9.62,5.688.418.363.795.767,1.171,1.157.934.962,1.938,1.9,2.788,2.914a11.683,11.683,0,0,0,4.015,2.928Z"
              transform="translate(13.946 140.555)"
              fill="#5c7300"
            />
            <path
              id="Path_1730"
              data-name="Path 1730"
              d="M54.247,366.481a11.822,11.822,0,0,0-2.426-2.049,46.5,46.5,0,0,1-4.266-3.485,25.279,25.279,0,0,0-4.015-3.5,5.465,5.465,0,0,0-1.394-.641,6.509,6.509,0,0,0-1.729-.2H35.44l1.394.711h2.259a6.5,6.5,0,0,1,1.715.209,6.065,6.065,0,0,1,1.394.627,24.58,24.58,0,0,1,4,3.513,48.481,48.481,0,0,0,4.28,3.471,12.187,12.187,0,0,1,2.468,2.077,2.788,2.788,0,0,1,.307,2.105,1.464,1.464,0,0,0,.85,0,.864.864,0,0,0,.39-.307,1.186,1.186,0,0,0,0-.321C54.582,367.861,54.763,367.15,54.247,366.481Z"
              transform="translate(13.97 140.563)"
              fill="#83a100"
            />
            <path
              id="Path_1731"
              data-name="Path 1731"
              d="M47.418,366.359a1.464,1.464,0,0,1-.544-.976.641.641,0,0,1,.084-.474.754.754,0,0,1,.251-.209c.683-.418,1.227-.92,2.063-.795a12.714,12.714,0,0,1,2.956,1.143,45.99,45.99,0,0,0,5.089,2.105,24.481,24.481,0,0,1,5.075,1.84,5.853,5.853,0,0,1,1.213.878,7.278,7.278,0,0,1,1,1.394c.823,1.394,1.6,2.9,2.314,4.392-3.025-2.022-6.12-4.5-9.592-5.716-.516-.181-1.046-.335-1.575-.474-1.3-.362-2.593-.795-3.918-1.087a11.572,11.572,0,0,1-4.419-2.022Z"
              transform="translate(18.471 143.431)"
              fill="#5c7300"
            />
            <path
              id="Path_1732"
              data-name="Path 1732"
              d="M48.812,365.254a11.488,11.488,0,0,1,2.97,1.143,47.56,47.56,0,0,0,5.089,2.091,24.79,24.79,0,0,1,5.005,1.84,5.367,5.367,0,0,1,1.2.892,6.3,6.3,0,0,1,1,1.394c.335.586.627,1.2.948,1.8l1.826,1.255c-.711-1.492-1.492-2.956-2.314-4.392a7.279,7.279,0,0,0-1-1.394A5.858,5.858,0,0,0,62.321,369a24.481,24.481,0,0,0-5.005-1.84,46.006,46.006,0,0,1-5.089-2.105,12.716,12.716,0,0,0-2.956-1.143c-.836-.126-1.394.376-2.063.795a.753.753,0,0,0-.251.209.641.641,0,0,0-.084.474,1.394,1.394,0,0,0,.153.488,2.44,2.44,0,0,1,1.785-.627Z"
              transform="translate(18.471 143.435)"
              fill="#83a100"
            />
            <path
              id="Path_1733"
              data-name="Path 1733"
              d="M49.068,362.924c.92.112,1.241-.809,1.645.125a8.783,8.783,0,0,1,.474,3.011,22.389,22.389,0,0,0,1.1,4.907,23.937,23.937,0,0,0,1.868,3.792,18.8,18.8,0,0,0,1.394,2.091,10.581,10.581,0,0,1,.948,1.631,3.764,3.764,0,0,1,0,2.788A10.846,10.846,0,0,1,55.1,383.7a11.056,11.056,0,0,0-1.394-4.629,16.182,16.182,0,0,0-1.659-1.98A22.932,22.932,0,0,1,50.462,375a26.81,26.81,0,0,1-3.444-6.441,6.971,6.971,0,0,1-.488-2.426,5.437,5.437,0,0,1,.46-2.356,1.157,1.157,0,0,1,.2-.307,2.7,2.7,0,0,1,.809-.5,1.883,1.883,0,0,1,1.073-.042Z"
              transform="translate(18.34 142.935)"
              fill="#5c7300"
            />
            <path
              id="Path_1734"
              data-name="Path 1734"
              d="M48.082,362.81a1.088,1.088,0,0,0-.5.112h0a1.941,1.941,0,0,0,.5-.112Z"
              transform="translate(18.755 143.007)"
              fill="#bec400"
            />
            <path
              id="Path_1735"
              data-name="Path 1735"
              d="M55.721,378.484a10.581,10.581,0,0,0-.948-1.631c-.474-.7-.934-1.394-1.394-2.091a23.938,23.938,0,0,1-1.868-3.792,22.391,22.391,0,0,1-1.1-4.907,8.784,8.784,0,0,0-.474-3.011c-.39-.906-.725-.084-1.575-.125a.544.544,0,0,1,.181.251,9.034,9.034,0,0,1,.488,3.011,21.721,21.721,0,0,0,1.1,4.907,23.7,23.7,0,0,0,1.91,3.778,21.8,21.8,0,0,0,1.394,2.091,10.707,10.707,0,0,1,.948,1.645,3.667,3.667,0,0,1,0,2.788c0,.209-.2.39-.279.6a15.339,15.339,0,0,1,.321,1.715,10.845,10.845,0,0,0,1.394-2.426,3.764,3.764,0,0,0-.1-2.8Z"
              transform="translate(19.062 142.933)"
              fill="#83a100"
            />
            <path
              id="Path_1736"
              data-name="Path 1736"
              d="M52.293,367.15a58.724,58.724,0,0,0,4.643-5.8,24.042,24.042,0,0,0,1.394-2.161,5.494,5.494,0,0,0,.99-1.785,1.882,1.882,0,0,0-1.074-1.785,2.522,2.522,0,0,0-.976-.321c-.474,0-.641.558-.906.948a41.148,41.148,0,0,1-3.9,4.893c-1.589,1.7-3.374,3.151-5.089,4.712a1.394,1.394,0,0,0-.572.92,1.129,1.129,0,0,0,.167.516,4.8,4.8,0,0,0,1.283,1.394C49.867,370.022,51.261,368.14,52.293,367.15Z"
              transform="translate(18.447 140.047)"
              fill="#5c7300"
            />
            <path
              id="Path_1737"
              data-name="Path 1737"
              d="M47.963,367.752a1.129,1.129,0,0,1-.167-.516,1.394,1.394,0,0,1,.586-.92c1.7-1.561,3.485-3.011,5.075-4.712a41.15,41.15,0,0,0,3.9-4.894c.265-.39.432-.906.906-.948h.265l-.265-.181a2.524,2.524,0,0,0-.976-.321c-.474,0-.641.558-.906.948a41.15,41.15,0,0,1-3.9,4.893c-1.589,1.7-3.374,3.151-5.089,4.712a1.394,1.394,0,0,0-.572.92,1.129,1.129,0,0,0,.167.516,4.8,4.8,0,0,0,1.283,1.394,1.631,1.631,0,0,0,.976.446,4.8,4.8,0,0,1-1.283-1.338Z"
              transform="translate(18.455 140.031)"
              fill="#83a100"
            />
            <path
              id="Path_1738"
              data-name="Path 1738"
              d="M137.269,429.45c-.223,7.152-2.245,16.981-13.565,26.8a37.2,37.2,0,0,1-16.549,8.281c-.962.209-1.812.418-2.663.53a57.635,57.635,0,0,1-18.793-.112c-2.663-.418-4.907-.948-6.622-1.394-7.891-2.4-36.081-18.835-33.084-46.426a28.944,28.944,0,0,1,.418-3.1,21.33,21.33,0,0,1,.641-3.736c.223-.962.432-1.924.641-2.788a1.283,1.283,0,0,1,.112-.641l.962-3.207a49.06,49.06,0,0,1,4.378-9.926c.418-.753.962-1.492,1.394-2.245a1.074,1.074,0,0,0,.432-.53c2.565-3.527,6.831-6.093,10.568-8.365A60.62,60.62,0,0,1,79.732,376.3c1.185-.321,2.356-.641,3.527-.864a43.434,43.434,0,0,1,6.511-1.06,33.168,33.168,0,0,1,11.153.85,46.344,46.344,0,0,1,13.021,4.7c8.016,4.489,14.527,13.454,18.584,22.85a56.352,56.352,0,0,1,4.182,14.346c.321,2.342.432,4.378.544,6.079a60.634,60.634,0,0,1,.014,6.246Z"
              transform="translate(18.042 147.511)"
              fill="#e33819"
            />
            <path
              id="Path_1739"
              data-name="Path 1739"
              d="M122.157,408.068a17.79,17.79,0,0,1-6.288,5.34c-6.971,3.416-15.336,1.812-22.418-1.171a57.552,57.552,0,0,1-14.207-8.867c-3.1-2.551-6.079-5.66-7.041-9.606a17.469,17.469,0,0,1-.432-5.228,31.2,31.2,0,0,1,1.074-7.793,45.317,45.317,0,0,1,6.511-1.073,33.545,33.545,0,0,1,11.153.864,45.911,45.911,0,0,1,13.022,4.7C111.589,389.665,118.114,398.629,122.157,408.068Z"
              transform="translate(28.274 149.598)"
              fill="#f2573d"
            />
            <path
              id="Path_1740"
              data-name="Path 1740"
              d="M107.185,464.412c-.906.209-1.8.376-2.7.544a60.842,60.842,0,0,1-25.318-1.52c-7.891-2.286-36.151-18.807-33.181-46.342.112-1.032.251-2.035.418-3.081a37.292,37.292,0,0,1,.655-3.708c.209-.962.418-1.9.655-2.788a1.785,1.785,0,0,1,.181-.586,33.163,33.163,0,0,1,.934-3.248,48.139,48.139,0,0,1,4.392-9.871c.418-.767.906-1.492,1.394-2.217a5.761,5.761,0,0,0,.349-.53c2.551-3.569,6.859-6.12,10.6-8.365a60.9,60.9,0,0,1,14.165-6.26,46.426,46.426,0,0,1,10.038-1.91C75.5,381.138,64.44,393.5,62.014,416.09,59,443.5,87.277,460.006,95.168,462.265A63.612,63.612,0,0,0,107.185,464.412Z"
              transform="translate(18.039 147.626)"
              fill="#cd1f00"
            />
            <path
              id="Path_1741"
              data-name="Path 1741"
              d="M65.649,389.771l-2.914-.85a18.475,18.475,0,0,0-4.852-.711,5.38,5.38,0,0,0-2.217.711l-5.577,2.44q1.394-.125,2.886-.167a13.241,13.241,0,0,1,2.677.111,17.522,17.522,0,0,1,4.531,1.785,82.108,82.108,0,0,0,8.365,3.262,5.79,5.79,0,0,0,1.073.279,2.649,2.649,0,0,0,2.4-1.087c.53-.823-.084-2.412-.655-3.081a6.818,6.818,0,0,0-3.513-2.035Z"
              transform="translate(19.744 153.019)"
              fill="#5c7300"
            />
            <path
              id="Path_1742"
              data-name="Path 1742"
              d="M70.982,393.605a6.971,6.971,0,0,0-3.513-2.035l-2.231-.655-2.914-.85a19.07,19.07,0,0,0-4.852-.711,5.577,5.577,0,0,0-2.217.711l-2.621,1.143c-.864,0-1.715.084-2.565.153l5.577-2.44a5.381,5.381,0,0,1,2.217-.711,18.475,18.475,0,0,1,4.852.711l2.914.85,2.231.641a6.971,6.971,0,0,1,3.513,2.049c.572.669,1.171,2.258.655,3.081,0,.1-.181.125-.251.209a4.029,4.029,0,0,0-.795-2.147Z"
              transform="translate(19.736 153.019)"
              fill="#83a100"
            />
            <path
              id="Path_1743"
              data-name="Path 1743"
              d="M69.052,410.655c.683-1.018,2.565-4.266.432-4.643a11.152,11.152,0,0,0-4.183.474,23.281,23.281,0,0,0-3.067.864,20.916,20.916,0,0,0-2.426,1.241c-.836.4-1.617.85-2.426,1.3-1.283.7-2.788.823-4.113,1.394.167-.084.432-.572.6-.711a10.414,10.414,0,0,0,.878-.753c.488-.516.739-1.213,1.241-1.715a15.684,15.684,0,0,1,9.62-4.587c.586,0,1.952-.237,1.506-1.087s-1.575-.878-2.217-1.087a24.442,24.442,0,0,0-3.109-.85,21.9,21.9,0,0,1-4.182-1.6c-.627-.265-1.241-.39-1.868-.613a4.323,4.323,0,0,0-1.854-.488c5.577-.53,10.665,2.956,16.186,3.583l-5.326-10.61a24.816,24.816,0,0,0,6.093,5.214,1.227,1.227,0,0,0,.809.265c.418,0,.683-.474.878-.85,1.8-3.444,3.569-7.18,3.151-11.042a39.886,39.886,0,0,1-.544-5.451c0-.39.139-.878.516-.906.655,1.9.948,3.918,1.631,5.842a13.5,13.5,0,0,1,1.032,4.182,36.515,36.515,0,0,1-.321,3.932,8.1,8.1,0,0,1-.725,3.4c-.349.572,0,.976.641.753a11.487,11.487,0,0,0,1.868-1.2,14.737,14.737,0,0,1,9.062-2.788c-1.84-.153-12.352,7.612-13.091,9.424-.446,1.1,0,6.009-4.336,10.275-.906.906-1.785,1.84-2.621,2.788A11.154,11.154,0,0,0,67,417.849c-.39.948,0,1.589.125,2.565-.084-.516-.516-.864-.795-1.283a6.539,6.539,0,0,1-.781-1.812,2.9,2.9,0,0,1-.139-1.283c.125-.558.572-.823.85-1.283s.418-.948.725-1.394C67.574,412.426,68.4,411.617,69.052,410.655Z"
              transform="translate(20.998 148.99)"
              fill="#900"
            />
            <path
              id="Path_1744"
              data-name="Path 1744"
              d="M65.359,397.238c.349-.669.781-1.311,1.185-1.952a26.225,26.225,0,0,0,3.471-9.578c.669-4.489.181-9.243,2.008-13.4a9.229,9.229,0,0,0,0,3.039c0,1.143.084,2.286.2,3.416a55.37,55.37,0,0,0,1.269,6.72c.864,3.736-.335,8.477-1.994,11.864a28.9,28.9,0,0,1-3.081,4.963,2.049,2.049,0,0,1-3.527-.585,4.364,4.364,0,0,1-.2-2.538,6.789,6.789,0,0,1,.669-1.952Z"
              transform="translate(25.458 146.751)"
              fill="#5c7300"
            />
            <path
              id="Path_1745"
              data-name="Path 1745"
              d="M64.633,399.189a6.789,6.789,0,0,1,.739-1.952c.349-.669.781-1.311,1.185-1.952a26.225,26.225,0,0,0,3.471-9.578c.669-4.489.181-9.243,2.008-13.4a9.228,9.228,0,0,0,0,3.039c0,1.143.084,2.286.2,3.416.084.767.223,1.52.349,2.272-.112,1.826-.209,3.653-.474,5.451a25.973,25.973,0,0,1-3.471,9.578c-.4.641-.823,1.283-1.185,1.952a7.222,7.222,0,0,0-.739,1.952,4.378,4.378,0,0,0,.2,2.537,1.938,1.938,0,0,0,.39.488,2.161,2.161,0,0,1-2.4-1.269,4.364,4.364,0,0,1-.265-2.538Z"
              transform="translate(25.445 146.751)"
              fill="#83a100"
            />
            <path
              id="Path_1746"
              data-name="Path 1746"
              d="M67.5,398.41a1.673,1.673,0,0,1-1.269,0,.823.823,0,0,1-.432-.349,1.046,1.046,0,0,1,0-.362c0-.906-.251-1.715.321-2.468a13.944,13.944,0,0,1,2.788-2.3,54.074,54.074,0,0,0,4.81-3.918,27.614,27.614,0,0,1,4.517-3.945,6.189,6.189,0,0,1,1.534-.725,7.513,7.513,0,0,1,1.938-.223c1.868,0,3.736,0,5.577.07-3.639,1.9-7.765,3.639-10.833,6.4-.46.418-.892.864-1.394,1.311-1.06,1.087-2.189,2.147-3.179,3.29A12.994,12.994,0,0,1,67.5,398.41Z"
              transform="translate(25.913 151.406)"
              fill="#5c7300"
            />
            <path
              id="Path_1747"
              data-name="Path 1747"
              d="M66.12,395.252a13.945,13.945,0,0,1,2.788-2.3,54.1,54.1,0,0,0,4.81-3.918,27.612,27.612,0,0,1,4.517-3.945,6.187,6.187,0,0,1,1.534-.725,7.516,7.516,0,0,1,1.938-.223c1.868,0,3.736,0,5.577.07l-1.589.809H83.143a7.527,7.527,0,0,0-1.938.237,6.385,6.385,0,0,0-1.534.711,28.383,28.383,0,0,0-4.517,3.959,53.941,53.941,0,0,1-4.81,3.9,14.052,14.052,0,0,0-2.788,2.314,3.22,3.22,0,0,0-.335,2.37,1.618,1.618,0,0,1-.962,0,.822.822,0,0,1-.432-.349,1.046,1.046,0,0,1,0-.363C65.7,396.813,65.507,396,66.12,395.252Z"
              transform="translate(25.895 151.414)"
              fill="#83a100"
            />
            <path
              id="Path_1748"
              data-name="Path 1748"
              d="M74.034,395.127a1.715,1.715,0,0,0,.627-1.087.8.8,0,0,0-.112-.544.767.767,0,0,0-.307-.237c-.781-.488-1.394-1.032-2.328-.892a13.536,13.536,0,0,0-3.332,1.3,60.3,60.3,0,0,1-5.7,2.384A27.883,27.883,0,0,0,57.3,398.11a6.975,6.975,0,0,0-1.394,1,7.71,7.71,0,0,0-1.129,1.6c-.934,1.617-1.8,3.262-2.621,4.949,3.416-2.286,6.971-5.075,10.819-6.455.586-.209,1.171-.362,1.771-.53,1.394-.4,2.928-.892,4.406-1.213a13.147,13.147,0,0,0,4.88-2.342Z"
              transform="translate(20.56 154.648)"
              fill="#5c7300"
            />
            <path
              id="Path_1749"
              data-name="Path 1749"
              d="M72.463,393.886a13.844,13.844,0,0,0-3.332,1.283,52.833,52.833,0,0,1-5.744,2.356A28.5,28.5,0,0,0,57.81,399.6a6.37,6.37,0,0,0-1.394.99,7.932,7.932,0,0,0-1.129,1.6c-.376.655-.711,1.394-1.074,2.022l-2.063,1.394c.823-1.687,1.687-3.332,2.621-4.949a7.711,7.711,0,0,1,1.129-1.6,6.968,6.968,0,0,1,1.394-1,27.885,27.885,0,0,1,5.577-2.063,60.309,60.309,0,0,0,5.8-2.328,13.538,13.538,0,0,1,3.332-1.3c.948-.139,1.548.4,2.328.892a.768.768,0,0,1,.279.237.8.8,0,0,1,.112.544,1.84,1.84,0,0,1-.181.53,2.788,2.788,0,0,0-2.077-.683Z"
              transform="translate(20.556 154.648)"
              fill="#83a100"
            />
            <path
              id="Path_1750"
              data-name="Path 1750"
              d="M69.062,391.254c-1.046.125-1.394-.906-1.854.139a9.969,9.969,0,0,0-.544,3.388,24.622,24.622,0,0,1-1.241,5.577,26.293,26.293,0,0,1-2.091,4.266c-.474.809-.99,1.589-1.52,2.356a12.1,12.1,0,0,0-1.06,1.84,4.182,4.182,0,0,0,0,3.081,12.2,12.2,0,0,0,1.52,2.788,12.547,12.547,0,0,1,1.575-5.214,17.832,17.832,0,0,1,1.854-2.133,24.451,24.451,0,0,0,1.8-2.356,30.808,30.808,0,0,0,3.876-7.25,7.7,7.7,0,0,0,.544-2.788,6.023,6.023,0,0,0-.516-2.663,1.394,1.394,0,0,0-.223-.349,2.9,2.9,0,0,0-.906-.558,2.077,2.077,0,0,0-1.213-.126Z"
              transform="translate(23.831 154.087)"
              fill="#5c7300"
            />
            <path
              id="Path_1751"
              data-name="Path 1751"
              d="M66.92,391a1.073,1.073,0,0,1,.5.1h0a2.607,2.607,0,0,1-.5-.1Z"
              transform="translate(26.378 154.118)"
              fill="#cbd200"
            />
            <path
              id="Path_1752"
              data-name="Path 1752"
              d="M60.748,408.793a12.1,12.1,0,0,1,1.06-1.84c.53-.767,1.046-1.547,1.52-2.356a26.294,26.294,0,0,0,2.091-4.266,25.458,25.458,0,0,0,1.241-5.577,9.968,9.968,0,0,1,.544-3.388c.432-1.018.809-.1,1.771-.139a.683.683,0,0,0-.209.279,10.331,10.331,0,0,0-.544,3.388,24.621,24.621,0,0,1-1.241,5.577,26.3,26.3,0,0,1-2.091,4.266c-.474.809-.99,1.589-1.52,2.356a12.1,12.1,0,0,0-1.06,1.84,4.183,4.183,0,0,0,0,3.067,5.9,5.9,0,0,0,.321.669,14.278,14.278,0,0,0-.362,1.938,12.2,12.2,0,0,1-1.52-2.788,4.266,4.266,0,0,1,0-3.025Z"
              transform="translate(23.836 154.073)"
              fill="#83a100"
            />
            <path
              id="Path_1753"
              data-name="Path 1753"
              d="M66.178,396.026a69.711,69.711,0,0,1-5.228-6.539c-.6-.781-1.074-1.6-1.6-2.44a6.637,6.637,0,0,1-1.115-2.008,2.105,2.105,0,0,1,1.2-2.008,3,3,0,0,1,1.115-.362c.53,0,.725.627,1.018,1.06a44.081,44.081,0,0,0,4.406,5.507c1.785,1.924,3.792,3.555,5.716,5.312a1.617,1.617,0,0,1,.655,1.046,1.255,1.255,0,0,1-.181.586,5.827,5.827,0,0,1-1.394,1.534C69.063,399.247,67.293,397.141,66.178,396.026Z"
              transform="translate(22.952 150.835)"
              fill="#5c7300"
            />
            <path
              id="Path_1754"
              data-name="Path 1754"
              d="M70.8,396.681a1.254,1.254,0,0,0,.181-.586,1.617,1.617,0,0,0-.655-1.046c-1.924-1.757-3.932-3.388-5.716-5.312a44.078,44.078,0,0,1-4.406-5.507c-.293-.432-.488-1.018-1.018-1.06a1.389,1.389,0,0,0-.293.07c.1-.07.181-.153.279-.209a3,3,0,0,1,1.115-.363c.53,0,.725.627,1.018,1.06a44.081,44.081,0,0,0,4.406,5.507c1.785,1.924,3.792,3.555,5.716,5.312a1.617,1.617,0,0,1,.655,1.046,1.255,1.255,0,0,1-.181.586,5.827,5.827,0,0,1-1.394,1.534,1.826,1.826,0,0,1-1.1.5A5.826,5.826,0,0,0,70.8,396.681Z"
              transform="translate(23.213 150.835)"
              fill="#83a100"
            />
            <path
              id="Path_1755"
              data-name="Path 1755"
              d="M669.814,230.859,513.082,321.118l-.042-228.6,20.188-11.627,18.445-10.61L669.786,2.3Z"
              transform="translate(202.223 0.907)"
              fill="#ff9263"
            />
            <path
              id="Path_1756"
              data-name="Path 1756"
              d="M545.965,51.06v9.787L527.52,71.708V61.67Z"
              transform="translate(207.93 20.126)"
              fill="#c95332"
            />
            <path
              id="Path_1757"
              data-name="Path 1757"
              d="M509.07,90.23l5.535,3.193L671.351,3.193,665.816,0Z"
              transform="translate(200.658)"
              fill="#ffba8f"
            />
            <path
              id="Path_1758"
              data-name="Path 1758"
              d="M522.992,60.62l-4.322,2.468.084,228.587,4.266-2.454Z"
              transform="translate(204.442 23.894)"
              fill="#db6c4b"
            />
            <path
              id="Path_1759"
              data-name="Path 1759"
              d="M521.77,60.62l2.217.376L523.3,290.016l-1.506-.795Z"
              transform="translate(205.664 23.894)"
              fill="#c95332"
            />
            <path
              id="Path_1760"
              data-name="Path 1760"
              d="M543.177,321.308,664.218,11.12,517.05,95.829l.042,210.421Z"
              transform="translate(203.803 4.383)"
              fill="#92ffd9"
            />
            <path
              id="Path_1761"
              data-name="Path 1761"
              d="M682.946,232.331,682.932,21.91,535.75,106.633l.056,210.421Z"
              transform="translate(211.174 8.636)"
              fill="#fff"
            />
            <path
              id="Path_1762"
              data-name="Path 1762"
              d="M517.05,95.829l26.071,15.057L690.3,26.163,664.218,11.12Z"
              transform="translate(203.803 4.383)"
              fill="#d8e2ed"
            />
            <path
              id="Path_1763"
              data-name="Path 1763"
              d="M540.022,69.643l-12.492-.878,15.461-9.034,15.447-.92Z"
              transform="translate(207.934 23.181)"
              fill="#b3bbc4"
            />
            <path
              id="Path_1764"
              data-name="Path 1764"
              d="M559.142,61.387l-12.492-.878L562.1,51.46l15.461-.92Z"
              transform="translate(215.47 19.921)"
              fill="#b3bbc4"
            />
            <path
              id="Path_1765"
              data-name="Path 1765"
              d="M565.742,59.007l-12.492-.878,15.461-9.048,15.447-.92Z"
              transform="translate(218.072 18.983)"
              fill="#b3bbc4"
            />
            <path
              id="Path_1766"
              data-name="Path 1766"
              d="M528.41,102.389l26.085,15.057L687.624,24.623,675.578,17.68Z"
              transform="translate(208.281 6.969)"
              fill="#b3bbc4"
            />
            <path
              id="Path_1767"
              data-name="Path 1767"
              d="M513.936,73.483A30.381,30.381,0,0,1,509.07,64.7l.07,228.643a7.225,7.225,0,0,1,.878,2.049.46.46,0,0,0,0,.265,29.762,29.762,0,0,0,3.89,6.385c5.577,7.18,13.816,10.833,20.912,12.659a58.557,58.557,0,0,0,14.416,1.854h0V87.913a57.886,57.886,0,0,1-14.43-1.882C527.766,84.232,519.61,80.635,513.936,73.483Z"
              transform="translate(200.658 25.502)"
              fill="#b24829"
            />
            <path
              id="Path_1768"
              data-name="Path 1768"
              d="M542.043,81.9A57.886,57.886,0,0,1,527.53,80V308.643a58.554,58.554,0,0,0,14.416,1.854h0Z"
              transform="translate(207.934 31.533)"
              fill="#c95332"
            />
            <path
              id="Path_1769"
              data-name="Path 1769"
              d="M509.07,64.71l.07,228.643a7.225,7.225,0,0,1,.878,2.049.46.46,0,0,0,0,.265,29.766,29.766,0,0,0,3.89,6.385V73.479a30.379,30.379,0,0,1-4.838-8.769Z"
              transform="translate(200.658 25.506)"
              fill="#a04326"
            />
            <path
              id="Path_1770"
              data-name="Path 1770"
              d="M555.724,96.609l-4.308,2.482-13.5,7.793.028,228.6,8.741-5.047-.641-1.283,4.266-2.468,1.506.809,3.932-2.286,11.53-6.636,110.864-63.839,16.507-9.508V16.64Z"
              transform="translate(212.029 6.559)"
              fill="#ff9263"
            />
            <path
              id="Path_1771"
              data-name="Path 1771"
              d="M537.94,250l.028,6.929,156.7-90.286V159.73Z"
              transform="translate(212.037 62.96)"
              fill="#a04326"
            />
            <path
              id="Path_1772"
              data-name="Path 1772"
              d="M533.94,104.59l5.535,3.193,156.76-90.23L690.7,14.36Z"
              transform="translate(210.461 5.66)"
              fill="#ffba8f"
            />
            <path
              id="Path_1773"
              data-name="Path 1773"
              d="M549.292,87.919l1.673-.962.948-3.583s-24.663-.6-36.36-17.106L509.07,64.72C513.531,91.39,549.292,87.919,549.292,87.919Z"
              transform="translate(200.658 25.51)"
              fill="#ffba8f"
            />
            <path
              id="Path_1774"
              data-name="Path 1774"
              d="M549.206,231.077a59.641,59.641,0,0,1-14.416-1.868c-7.1-1.826-15.266-5.479-20.912-12.645a29.864,29.864,0,0,1-3.89-6.4.432.432,0,0,1,0-.265,7.222,7.222,0,0,0-.878-2.049v6.971a7.223,7.223,0,0,1,.878,2.049.432.432,0,0,0,0,.265,29.864,29.864,0,0,0,3.89,6.4c5.646,7.166,13.816,10.819,20.912,12.645a59.644,59.644,0,0,0,14.416,1.868h0Z"
              transform="translate(200.673 81.927)"
              fill="#a04326"
            />
            <path
              id="Path_1775"
              data-name="Path 1775"
              d="M537.94,248.982l.028,6.929,156.7-90.286V158.71Z"
              transform="translate(212.037 62.558)"
              fill="#ffdc91"
            />
            <path
              id="Path_1776"
              data-name="Path 1776"
              d="M549.206,230.047a59.253,59.253,0,0,1-14.416-1.854c-7.1-1.84-15.266-5.493-20.912-12.659a30.11,30.11,0,0,1-3.89-6.385.473.473,0,0,1,0-.265,7.333,7.333,0,0,0-.878-2.063v6.971a7.333,7.333,0,0,1,.878,2.063.461.461,0,0,0,0,.265,30.11,30.11,0,0,0,3.89,6.385c5.646,7.166,13.816,10.819,20.912,12.659a59.251,59.251,0,0,0,14.416,1.854h0Z"
              transform="translate(200.673 81.521)"
              fill="#b86e1a"
            />
            <path
              id="Path_1777"
              data-name="Path 1777"
              d="M537.94,120.352l.028,6.929L694.672,37V30.08Z"
              transform="translate(212.037 11.856)"
              fill="#a04326"
            />
            <path
              id="Path_1778"
              data-name="Path 1778"
              d="M549.206,101.417a59.251,59.251,0,0,1-14.416-1.854c-7.1-1.826-15.266-5.479-20.912-12.659a30.113,30.113,0,0,1-3.89-6.385.461.461,0,0,1,0-.265,7.531,7.531,0,0,0-.878-2.063v6.971a7.221,7.221,0,0,1,.878,2.049.461.461,0,0,0,0,.265,30.115,30.115,0,0,0,3.89,6.385c5.646,7.18,13.816,10.833,20.912,12.659a59.25,59.25,0,0,0,14.416,1.854h0V101.4Z"
              transform="translate(200.673 30.82)"
              fill="#a04326"
            />
            <path
              id="Path_1779"
              data-name="Path 1779"
              d="M537.94,119.112l.028,6.943,156.7-90.3V28.84Z"
              transform="translate(212.037 11.368)"
              fill="#ffdc91"
            />
            <path
              id="Path_1780"
              data-name="Path 1780"
              d="M549.206,100.187a59.252,59.252,0,0,1-14.416-1.854c-7.1-1.84-15.266-5.493-20.912-12.659a30.11,30.11,0,0,1-3.89-6.385.473.473,0,0,1,0-.265,7.332,7.332,0,0,0-.878-2.063v6.971a7.333,7.333,0,0,1,.878,2.063.473.473,0,0,0,0,.265,30.111,30.111,0,0,0,3.89,6.385c5.646,7.166,13.816,10.819,20.912,12.659a59.251,59.251,0,0,0,14.416,1.854h0Z"
              transform="translate(200.673 30.335)"
              fill="#b86e1a"
            />
            <path
              id="Path_1781"
              data-name="Path 1781"
              d="M548.008,75.06,543.7,77.542l.07,228.587,4.266-2.468Z"
              transform="translate(214.308 29.586)"
              fill="#db6c4b"
            />
            <path
              id="Path_1782"
              data-name="Path 1782"
              d="M546.79,75.06l2.217.39-.683,229.006-1.506-.795Z"
              transform="translate(215.526 29.586)"
              fill="#c95332"
            />
            <path
              id="Path_1783"
              data-name="Path 1783"
              d="M564.676,141.5a6.248,6.248,0,0,0,1.311-.962,8.358,8.358,0,0,0,1.032-1.1,9.646,9.646,0,0,0,.795-1.171,11.241,11.241,0,0,0,.6-1.129.39.39,0,0,1,.251.279,1.475,1.475,0,0,1,.1.516,3.571,3.571,0,0,1-.223,1.157,6,6,0,0,1-.767,1.394,8.844,8.844,0,0,1-1.394,1.561,11.471,11.471,0,0,1-2.175,1.548,7.766,7.766,0,0,1-3.053,1.157,3.053,3.053,0,0,1-2.189-.46,3.778,3.778,0,0,1-1.3-1.952,10.317,10.317,0,0,1-.432-3.235,15.054,15.054,0,0,1,.446-3.695,13.944,13.944,0,0,1,1.311-3.43,13.509,13.509,0,0,1,5.2-5.381,11.923,11.923,0,0,1,2.022-.948,4.184,4.184,0,0,1,1.394-.265,1.185,1.185,0,0,1,.864.362,1.3,1.3,0,0,1,.279.892,2.924,2.924,0,0,1-.153.892,4.177,4.177,0,0,1-.488.92,4.63,4.63,0,0,1-.795.878,6.358,6.358,0,0,1-1.088.781,4.491,4.491,0,0,0-.112-1.087,1.937,1.937,0,0,0-.362-.823.99.99,0,0,0-.683-.349,1.785,1.785,0,0,0-1.06.321,5.367,5.367,0,0,0-1.617,1.394,6.971,6.971,0,0,0-1.06,1.966,11.926,11.926,0,0,0-.571,2.537,23.356,23.356,0,0,0-.181,3.081,14.415,14.415,0,0,0,.223,2.788,3.584,3.584,0,0,0,.7,1.687,1.492,1.492,0,0,0,1.255.516A4.489,4.489,0,0,0,564.676,141.5Z"
              transform="translate(219.64 49.42)"
              fill="#a04326"
            />
            <path
              id="Path_1784"
              data-name="Path 1784"
              d="M580.573,125.606a16.134,16.134,0,0,1-.446,3.75,14.1,14.1,0,0,1-1.394,3.444,13.608,13.608,0,0,1-2.133,2.97,13.422,13.422,0,0,1-2.914,2.3,7.987,7.987,0,0,1-3.011,1.115,2.886,2.886,0,0,1-2.133-.488,3.806,3.806,0,0,1-1.282-1.966,11.044,11.044,0,0,1-.418-3.262,16.591,16.591,0,0,1,.418-3.736,14.262,14.262,0,0,1,1.283-3.4,13.063,13.063,0,0,1,5.159-5.3,7.389,7.389,0,0,1,2.9-1.073,3.039,3.039,0,0,1,2.147.488,3.708,3.708,0,0,1,1.31,1.924A10.216,10.216,0,0,1,580.573,125.606ZM570.3,131.531a18.512,18.512,0,0,0,.2,2.858,4.907,4.907,0,0,0,.6,1.854,1.506,1.506,0,0,0,1.074.767,2.621,2.621,0,0,0,1.589-.446,5.577,5.577,0,0,0,1.6-1.394,7.43,7.43,0,0,0,1.06-1.98,12.807,12.807,0,0,0,.586-2.537,26.187,26.187,0,0,0,.181-3.081,20.9,20.9,0,0,0-.181-2.858,5.286,5.286,0,0,0-.586-1.854,1.394,1.394,0,0,0-1.06-.753,2.524,2.524,0,0,0-1.589.446,5.5,5.5,0,0,0-1.6,1.394,7.081,7.081,0,0,0-1.073,1.98,12.228,12.228,0,0,0-.6,2.551A23.182,23.182,0,0,0,570.3,131.531Z"
              transform="translate(223.428 47.271)"
              fill="#a04326"
            />
            <path
              id="Path_1785"
              data-name="Path 1785"
              d="M591.954,119.028a15.933,15.933,0,0,1-.446,3.736,13.942,13.942,0,0,1-1.325,3.458,13.616,13.616,0,0,1-2.133,2.97,13.106,13.106,0,0,1-2.914,2.3,7.987,7.987,0,0,1-3.011,1.115,2.886,2.886,0,0,1-2.133-.488,3.82,3.82,0,0,1-1.269-1.966,10.57,10.57,0,0,1-.432-3.262,15.839,15.839,0,0,1,.432-3.736,13.343,13.343,0,0,1,6.427-8.714,7.626,7.626,0,0,1,2.9-1.073,3.192,3.192,0,0,1,2.147.488,3.821,3.821,0,0,1,1.311,1.924,10.317,10.317,0,0,1,.446,3.248Zm-10.275,5.925a18.509,18.509,0,0,0,.2,2.788,4.907,4.907,0,0,0,.6,1.854,1.394,1.394,0,0,0,1.074.753,2.593,2.593,0,0,0,1.589-.432,5.744,5.744,0,0,0,1.6-1.394,7.252,7.252,0,0,0,1.06-1.98,12.816,12.816,0,0,0,.585-2.537,23.5,23.5,0,0,0,.181-3.081,18.8,18.8,0,0,0-.181-2.788,5.285,5.285,0,0,0-.586-1.854,1.492,1.492,0,0,0-1.06-.767,2.788,2.788,0,0,0-1.589.446,5.576,5.576,0,0,0-1.6,1.394,7.083,7.083,0,0,0-1.074,1.98,12.224,12.224,0,0,0-.6,2.551,23.173,23.173,0,0,0-.2,3.067Z"
              transform="translate(227.941 44.675)"
              fill="#a04326"
            />
            <path
              id="Path_1786"
              data-name="Path 1786"
              d="M597.533,112.515c.209-.39.4-.725.544-1.032s.265-.572.362-.809a3.7,3.7,0,0,0,.181-.627,2.631,2.631,0,0,0,0-.53c0-.251-.084-.376-.265-.376a2.2,2.2,0,0,0-.878.349v-1.2l5.479-3.151v1.2a3.524,3.524,0,0,0-.781.6,6.263,6.263,0,0,0-.725.836,12.419,12.419,0,0,0-.711,1.046c-.223.376-.46.795-.7,1.227l-2.663,4.894,3.764,4.684a3.118,3.118,0,0,0,.558.572,1.393,1.393,0,0,0,.544.251,1.129,1.129,0,0,0,.572,0,3.137,3.137,0,0,0,.613-.265h.084v1.241l-1.088.627a15.085,15.085,0,0,1-1.394.725,8.808,8.808,0,0,1-1.018.418,2.9,2.9,0,0,1-.753.139,1.115,1.115,0,0,1-.544-.1,1.1,1.1,0,0,1-.432-.279c-.126-.125-.251-.279-.39-.446l-2.719-3.75-.892,1.311v3.918a2.365,2.365,0,0,0,.084.739.571.571,0,0,0,.223.335.446.446,0,0,0,.335,0,2.7,2.7,0,0,0,.418-.2l.836-.488v1.241l-6.971,4.015v-1.227l.85-.488a2.943,2.943,0,0,0,.4-.279,2.163,2.163,0,0,0,.335-.376,1.869,1.869,0,0,0,.223-.558,3.068,3.068,0,0,0,.084-.767V114.648a2.189,2.189,0,0,0-.084-.7.418.418,0,0,0-.558-.307,2.434,2.434,0,0,0-.4.181l-.85.5V113.1l6.971-4.029V110.3l-.836.488a2.239,2.239,0,0,0-.418.293,1.4,1.4,0,0,0-.335.4,1.956,1.956,0,0,0-.223.572,3.739,3.739,0,0,0-.084.85v5.409Z"
              transform="translate(232.246 41.442)"
              fill="#a04326"
            />
            <path
              id="Path_1787"
              data-name="Path 1787"
              d="M611.577,103.562a5.882,5.882,0,0,1-.168,1.4,6.179,6.179,0,0,1-.53,1.3,7.111,7.111,0,0,1-.794,1.157,11.161,11.161,0,0,1-1.046,1.1v.112a4.391,4.391,0,0,1,1.282-.167,1.924,1.924,0,0,1,.99.293,1.784,1.784,0,0,1,.655.823,3.569,3.569,0,0,1,.223,1.394,6.97,6.97,0,0,1-1.394,4.182,13.94,13.94,0,0,1-4.336,3.625l-6.511,3.764V121.3l.836-.474a3.18,3.18,0,0,0,.418-.293,1.519,1.519,0,0,0,.321-.4,2.314,2.314,0,0,0,.237-.586,4.581,4.581,0,0,0,0-.836V107.549a2.787,2.787,0,0,0,0-.7.6.6,0,0,0-.237-.321.46.46,0,0,0-.335,0,1.4,1.4,0,0,0-.4.181l-.836.474V105.96l5.9-3.4a7.989,7.989,0,0,1,4.336-1.478C611.173,101.331,611.577,102.112,611.577,103.562Zm-6.594,6.79.767-.446a6.963,6.963,0,0,0,1.185-.85,3.7,3.7,0,0,0,.739-.962,3.836,3.836,0,0,0,.4-1.143,7.6,7.6,0,0,0,.111-1.394,4.855,4.855,0,0,0-.126-1.241.962.962,0,0,0-.432-.613,1,1,0,0,0-.767,0,5.58,5.58,0,0,0-1.157.516l-.725.432Zm0,7.933,1.394-.767a6.216,6.216,0,0,0,1.143-.837,3.708,3.708,0,0,0,.767-.99,4.182,4.182,0,0,0,.432-1.241,8.671,8.671,0,0,0,.139-1.561,6.471,6.471,0,0,0-.125-1.394,1.394,1.394,0,0,0-.4-.809.962.962,0,0,0-.753-.181,3.807,3.807,0,0,0-1.157.474l-1.394.795Z"
              transform="translate(236.479 39.842)"
              fill="#a04326"
            />
            <path
              id="Path_1788"
              data-name="Path 1788"
              d="M623.7,100.693a16.051,16.051,0,0,1-.446,3.75,15.031,15.031,0,0,1-1.325,3.458,13.857,13.857,0,0,1-2.133,2.956,13.021,13.021,0,0,1-2.858,2.272,7.808,7.808,0,0,1-3.011,1.129,2.956,2.956,0,0,1-2.133-.5,3.694,3.694,0,0,1-1.269-1.966,10.543,10.543,0,0,1-.432-3.248,15.755,15.755,0,0,1,.432-3.736,13.56,13.56,0,0,1,1.269-3.416,13.064,13.064,0,0,1,5.158-5.3,7.627,7.627,0,0,1,2.9-1.073,3.109,3.109,0,0,1,2.147.488,3.792,3.792,0,0,1,1.311,1.924,10.224,10.224,0,0,1,.39,3.262Zm-10.275,5.939a18.785,18.785,0,0,0,.2,2.788,4.992,4.992,0,0,0,.6,1.854,1.534,1.534,0,0,0,1.074.753,2.621,2.621,0,0,0,1.589-.446,5.576,5.576,0,0,0,1.6-1.394,7.429,7.429,0,0,0,1.059-1.98,12.8,12.8,0,0,0,.586-2.537,23.282,23.282,0,0,0,.181-3.067,18.664,18.664,0,0,0-.181-2.788,5.369,5.369,0,0,0-.586-1.868,1.394,1.394,0,0,0-1.06-.753,2.524,2.524,0,0,0-1.59.446,5.31,5.31,0,0,0-1.6,1.394,7.171,7.171,0,0,0-1.074,1.994,11.892,11.892,0,0,0-.6,2.537,23.383,23.383,0,0,0-.2,3.067Z"
              transform="translate(240.475 37.441)"
              fill="#a04326"
            />
            <path
              id="Path_1789"
              data-name="Path 1789"
              d="M635.114,94.106a16.131,16.131,0,0,1-.446,3.75,14.684,14.684,0,0,1-1.324,3.444,14.079,14.079,0,0,1-2.133,2.97,13.423,13.423,0,0,1-2.914,2.3,7.988,7.988,0,0,1-3.011,1.115,2.941,2.941,0,0,1-2.147-.488,3.876,3.876,0,0,1-1.269-1.966,11.043,11.043,0,0,1-.418-3.262,16.588,16.588,0,0,1,.418-3.736,14.26,14.26,0,0,1,1.283-3.4,13.063,13.063,0,0,1,5.158-5.3,7.32,7.32,0,0,1,2.9-1.074,3.039,3.039,0,0,1,2.147.488,3.792,3.792,0,0,1,1.31,1.924A10.22,10.22,0,0,1,635.114,94.106Zm-10.275,5.925a18.533,18.533,0,0,0,.2,2.788,4.912,4.912,0,0,0,.6,1.854,1.506,1.506,0,0,0,1.074.767,2.621,2.621,0,0,0,1.589-.446,5.574,5.574,0,0,0,1.6-1.394,7.432,7.432,0,0,0,1.06-1.98,12.8,12.8,0,0,0,.586-2.537A26.173,26.173,0,0,0,631.726,96a20.6,20.6,0,0,0-.181-2.788,5.267,5.267,0,0,0-.586-1.868,1.394,1.394,0,0,0-1.06-.753,2.523,2.523,0,0,0-1.589.446,5.314,5.314,0,0,0-1.6,1.394,7.281,7.281,0,0,0-1.074,1.98,12.232,12.232,0,0,0-.6,2.551A23.194,23.194,0,0,0,624.839,100.031Z"
              transform="translate(244.953 34.855)"
              fill="#a04326"
            />
            <path
              id="Path_1790"
              data-name="Path 1790"
              d="M640.646,87.6c.209-.39.39-.725.544-1.032a6.158,6.158,0,0,0,.348-.809,2.87,2.87,0,0,0,.2-.627,2.512,2.512,0,0,0,0-.53c0-.251-.1-.376-.265-.376a2.091,2.091,0,0,0-.878.362v-1.2l5.479-3.165v1.2a3.526,3.526,0,0,0-.781.6,6.327,6.327,0,0,0-.739.836c-.223.321-.46.669-.7,1.046s-.46.795-.7,1.227l-2.663,4.907,3.862,4.67a3.137,3.137,0,0,0,.572.572,1.309,1.309,0,0,0,1.115.265,2.467,2.467,0,0,0,.613-.265h.084V96.5l-1.087.627a13.6,13.6,0,0,1-1.394.725,9.952,9.952,0,0,1-1.018.418,3,3,0,0,1-.753.153,1.728,1.728,0,0,1-.558-.1,1.4,1.4,0,0,1-.362-.293,4.187,4.187,0,0,1-.39-.446l-2.719-3.75-.892,1.311v3.918a2.372,2.372,0,0,0,.084.739.572.572,0,0,0,.223.335.39.39,0,0,0,.335,0,2.707,2.707,0,0,0,.418-.2l.836-.488V100.7l-6.971,4.015v-1.227l.85-.488a2.944,2.944,0,0,0,.4-.279,1.464,1.464,0,0,0,.335-.376,1.923,1.923,0,0,0,.223-.544,4.181,4.181,0,0,0,0-.781V89.672a2.781,2.781,0,0,0,0-.7.39.39,0,0,0-.558-.293,1.658,1.658,0,0,0-.4.181l-.85.488V88.125l6.971-4.029v1.227l-.836.488a2.243,2.243,0,0,0-.418.293,1.4,1.4,0,0,0-.335.4,1.9,1.9,0,0,0-.223.586,3.514,3.514,0,0,0-.084.837v5.409Z"
              transform="translate(249.305 31.62)"
              fill="#a04326"
            />
            <path
              id="Path_1791"
              data-name="Path 1791"
              d="M563.886,140.877a7.293,7.293,0,0,0,1.394-.948,11,11,0,0,0,1.032-1.115,12.415,12.415,0,0,0,.795-1.171c.223-.39.418-.767.6-1.129a.5.5,0,0,1,.251.279,1.506,1.506,0,0,1,.084.53,3.57,3.57,0,0,1-.223,1.143,5.833,5.833,0,0,1-.767,1.394,9.358,9.358,0,0,1-1.394,1.561,12.716,12.716,0,0,1-2.161,1.547,8.282,8.282,0,0,1-3.067,1.157,3,3,0,0,1-2.175-.474,3.723,3.723,0,0,1-1.311-1.938,10.447,10.447,0,0,1-.432-3.234,15.582,15.582,0,0,1,.446-3.695,14.658,14.658,0,0,1,1.311-3.444,13.764,13.764,0,0,1,2.189-3,12.94,12.94,0,0,1,3.011-2.37,11.7,11.7,0,0,1,2.035-.962,3.751,3.751,0,0,1,1.394-.251,1.171,1.171,0,0,1,.85.349,1.3,1.3,0,0,1,.293.892,2.58,2.58,0,0,1-.167.892,3.679,3.679,0,0,1-.488.92,4.627,4.627,0,0,1-.795.878,5.42,5.42,0,0,1-1.087.781,5.58,5.58,0,0,0-.1-1.087,1.687,1.687,0,0,0-.376-.809.976.976,0,0,0-.683-.362,1.952,1.952,0,0,0-1.06.321,5.756,5.756,0,0,0-1.617,1.394,7.348,7.348,0,0,0-1.046,1.966,11.907,11.907,0,0,0-.641,2.565,25.99,25.99,0,0,0-.181,3.081,14.425,14.425,0,0,0,.223,2.788,3.457,3.457,0,0,0,.7,1.687,1.394,1.394,0,0,0,1.255.516,4.182,4.182,0,0,0,1.91-.655Z"
              transform="translate(219.356 49.176)"
              fill="#ffdc91"
            />
            <path
              id="Path_1792"
              data-name="Path 1792"
              d="M579.784,124.985a15.337,15.337,0,0,1-.446,3.75,14.989,14.989,0,0,1-1.311,3.458,13.941,13.941,0,0,1-2.147,2.956,12.059,12.059,0,0,1-2.914,2.3,7.807,7.807,0,0,1-3.011,1.129,3,3,0,0,1-2.133-.5,3.778,3.778,0,0,1-1.269-1.966,10.474,10.474,0,0,1-.432-3.248,15.758,15.758,0,0,1,.432-3.736,14.334,14.334,0,0,1,1.269-3.416,13.217,13.217,0,0,1,5.172-5.3,7.458,7.458,0,0,1,2.9-1.074,3.081,3.081,0,0,1,2.133.488,3.708,3.708,0,0,1,1.311,1.924A9.841,9.841,0,0,1,579.784,124.985Zm-10.261,5.939a18.812,18.812,0,0,0,.181,2.788,4.991,4.991,0,0,0,.6,1.854,1.533,1.533,0,0,0,1.073.753,2.524,2.524,0,0,0,1.589-.446,5.578,5.578,0,0,0,1.6-1.394,7.337,7.337,0,0,0,1.06-1.994,12.816,12.816,0,0,0,.586-2.537,23.3,23.3,0,0,0,.181-3.067,18.7,18.7,0,0,0-.181-2.858,5.369,5.369,0,0,0-.586-1.868,1.394,1.394,0,0,0-1.059-.753,2.468,2.468,0,0,0-1.575.446,5.367,5.367,0,0,0-1.617,1.394,7.543,7.543,0,0,0-1.074,1.994,11.886,11.886,0,0,0-.6,2.537,23.485,23.485,0,0,0-.181,3.151Z"
              transform="translate(223.144 47.027)"
              fill="#ffdc91"
            />
            <path
              id="Path_1793"
              data-name="Path 1793"
              d="M591.2,118.4a15.341,15.341,0,0,1-.46,3.75,14.986,14.986,0,0,1-1.311,3.458,13.938,13.938,0,0,1-2.147,2.956,12.717,12.717,0,0,1-2.914,2.3A8.115,8.115,0,0,1,581.354,132a3,3,0,0,1-2.133-.5,3.7,3.7,0,0,1-1.269-1.966,11.013,11.013,0,0,1-.432-3.262,16.738,16.738,0,0,1,.432-3.736,13.665,13.665,0,0,1,1.269-3.4,13.216,13.216,0,0,1,5.172-5.3,7.249,7.249,0,0,1,2.9-1.073,3.081,3.081,0,0,1,2.133.488,3.708,3.708,0,0,1,1.311,1.924,9.76,9.76,0,0,1,.46,3.234Zm-10.219,5.939a18.929,18.929,0,0,0,.181,2.788,4.906,4.906,0,0,0,.6,1.84,1.534,1.534,0,0,0,1.074.767,2.621,2.621,0,0,0,1.589-.446,5.366,5.366,0,0,0,1.6-1.394,7.057,7.057,0,0,0,1.06-1.98,11.9,11.9,0,0,0,.585-2.537,23.4,23.4,0,0,0,.181-3.067,18.672,18.672,0,0,0-.181-2.788,5.089,5.089,0,0,0-.585-1.868,1.394,1.394,0,0,0-1.06-.753,2.468,2.468,0,0,0-1.575.446,5.368,5.368,0,0,0-1.617,1.394,7.684,7.684,0,0,0-1.074,1.98,12.224,12.224,0,0,0-.6,2.551A23.515,23.515,0,0,0,580.978,124.344Z"
              transform="translate(227.638 44.434)"
              fill="#ffdc91"
            />
            <path
              id="Path_1794"
              data-name="Path 1794"
              d="M596.791,111.9c.223-.39.4-.725.544-1.032s.265-.558.363-.795a6.266,6.266,0,0,0,.2-.641,2.46,2.46,0,0,0,0-.53q0-.376-.251-.376a2.259,2.259,0,0,0-.892.362v-1.2l5.479-3.165v1.2a3.888,3.888,0,0,0-.781.6,6.264,6.264,0,0,0-.725.837,12.38,12.38,0,0,0-.7,1.046c-.237.39-.474.795-.711,1.241l-2.649,4.894,3.75,4.67a2.792,2.792,0,0,0,.572.572,1.394,1.394,0,0,0,.544.265,1.254,1.254,0,0,0,.558,0,2.341,2.341,0,0,0,.627-.265h0V120.8l-1.074.627a13.6,13.6,0,0,1-1.394.725c-.432.181-.739.321-1.018.418a2.969,2.969,0,0,1-.767.153,1.31,1.31,0,0,1-.544-.1,1.476,1.476,0,0,1-.432-.293,4.185,4.185,0,0,1-.376-.446l-2.788-3.75-.892,1.394v3.778a2.532,2.532,0,0,0,.084.753.655.655,0,0,0,.223.321.39.39,0,0,0,.335,0,1.813,1.813,0,0,0,.418-.181l.851-.5v1.241l-6.971,4.029v-1.241l.85-.488.4-.279a1.394,1.394,0,0,0,.321-.376,1.923,1.923,0,0,0,.223-.544,3.188,3.188,0,0,0,.084-.781V113.972a2.189,2.189,0,0,0-.084-.7.46.46,0,0,0-.223-.293.418.418,0,0,0-.321,0,1.4,1.4,0,0,0-.4.181l-.85.488v-1.227l6.971-4.015v1.213l-.85.488-.418.293a1.913,1.913,0,0,0-.335.4,2.343,2.343,0,0,0-.223.586,3.51,3.51,0,0,0-.084.837v5.409Z"
              transform="translate(231.915 41.198)"
              fill="#ffdc91"
            />
            <path
              id="Path_1795"
              data-name="Path 1795"
              d="M610.813,102.922a5.577,5.577,0,0,1-.7,2.788,6.971,6.971,0,0,1-.809,1.171,10.952,10.952,0,0,1-1.046,1.1v.112a4.058,4.058,0,0,1,1.283-.181,1.937,1.937,0,0,1,1,.293,1.757,1.757,0,0,1,.641.823,3.582,3.582,0,0,1,.237,1.394,6.971,6.971,0,0,1-1.394,4.182,13.76,13.76,0,0,1-4.336,3.625l-6.5,3.764v-1.283l.823-.474a2.243,2.243,0,0,0,.418-.293,1.618,1.618,0,0,0,.335-.4,2.443,2.443,0,0,0,.223-.572,3.6,3.6,0,0,0,.084-.837V106.979a2.243,2.243,0,0,0-.084-.7.585.585,0,0,0-.237-.321.488.488,0,0,0-.321,0,1.812,1.812,0,0,0-.418.181l-.823.474V105.4l5.883-3.416a8.142,8.142,0,0,1,4.336-1.478C610.325,100.691,610.813,101.472,610.813,102.922Zm-6.608,6.79.767-.446a6.509,6.509,0,0,0,1.185-.85,4.1,4.1,0,0,0,.753-.962,3.693,3.693,0,0,0,.391-1.143,7.543,7.543,0,0,0,.125-1.394,4.839,4.839,0,0,0-.139-1.241.907.907,0,0,0-.432-.613,1.074,1.074,0,0,0-.767,0,6.032,6.032,0,0,0-1.157.53l-.725.418Zm0,7.947,1.394-.781a5.742,5.742,0,0,0,1.143-.823,4.1,4.1,0,0,0,1.2-2.231,7.7,7.7,0,0,0,.139-1.575,6.569,6.569,0,0,0-.126-1.394,1.269,1.269,0,0,0-.4-.795.864.864,0,0,0-.739-.181,3.443,3.443,0,0,0-1.171.46l-1.394.795Z"
              transform="translate(236.184 39.617)"
              fill="#ffdc91"
            />
            <path
              id="Path_1796"
              data-name="Path 1796"
              d="M622.964,100.064a15.25,15.25,0,0,1-.446,3.75,14.194,14.194,0,0,1-1.394,3.458,13.613,13.613,0,0,1-2.133,2.97,12.658,12.658,0,0,1-2.914,2.286,7.654,7.654,0,0,1-3.011,1.129,2.969,2.969,0,0,1-2.133-.5,3.694,3.694,0,0,1-1.269-1.966,10.417,10.417,0,0,1-.432-3.248,15.842,15.842,0,0,1,.432-3.736A13.764,13.764,0,0,1,611,100.817a13.258,13.258,0,0,1,2.091-2.97,12.829,12.829,0,0,1,3.025-2.356,7.459,7.459,0,0,1,2.9-1.074,3.1,3.1,0,0,1,2.133.488,3.764,3.764,0,0,1,1.31,1.924,9.9,9.9,0,0,1,.5,3.234ZM612.7,106a18.688,18.688,0,0,0,.181,2.788,4.992,4.992,0,0,0,.6,1.854,1.492,1.492,0,0,0,1.073.753,2.524,2.524,0,0,0,1.589-.446,5.311,5.311,0,0,0,1.6-1.394,7.33,7.33,0,0,0,1.06-1.994,12.807,12.807,0,0,0,.586-2.537,23.126,23.126,0,0,0,.181-3.067,18.668,18.668,0,0,0-.181-2.858,5.366,5.366,0,0,0-.586-1.868,1.505,1.505,0,0,0-1.059-.753,2.468,2.468,0,0,0-1.576.446,5.577,5.577,0,0,0-1.617,1.394,7.544,7.544,0,0,0-1.073,1.994,11.817,11.817,0,0,0-.6,2.551A23.109,23.109,0,0,0,612.7,106Z"
              transform="translate(240.136 37.205)"
              fill="#ffdc91"
            />
            <path
              id="Path_1797"
              data-name="Path 1797"
              d="M634.344,93.484a15.337,15.337,0,0,1-.446,3.75,14.98,14.98,0,0,1-1.31,3.458,13.943,13.943,0,0,1-2.147,2.956,12.062,12.062,0,0,1-2.914,2.3,7.724,7.724,0,0,1-3.011,1.129,2.956,2.956,0,0,1-2.133-.5,3.778,3.778,0,0,1-1.269-1.966,10.413,10.413,0,0,1-.432-3.248,15.752,15.752,0,0,1,.432-3.736,14.334,14.334,0,0,1,1.269-3.416,13.333,13.333,0,0,1,2.147-2.956,13.158,13.158,0,0,1,3.025-2.342,7.458,7.458,0,0,1,2.9-1.073,3.1,3.1,0,0,1,2.133.488,3.708,3.708,0,0,1,1.31,1.924A9.842,9.842,0,0,1,634.344,93.484Zm-10.261,5.939a18.8,18.8,0,0,0,.181,2.788,4.994,4.994,0,0,0,.6,1.854,1.533,1.533,0,0,0,1.073.753,2.523,2.523,0,0,0,1.589-.446,5.312,5.312,0,0,0,1.6-1.394,7.336,7.336,0,0,0,1.06-1.994,12.811,12.811,0,0,0,.586-2.537,23.261,23.261,0,0,0,.181-3.067,18.668,18.668,0,0,0-.181-2.858,5.367,5.367,0,0,0-.586-1.868,1.394,1.394,0,0,0-1.06-.753,2.468,2.468,0,0,0-1.575.446,5.368,5.368,0,0,0-1.617,1.394,7.54,7.54,0,0,0-1.073,1.994,11.828,11.828,0,0,0-.6,2.551,23.129,23.129,0,0,0-.181,3.137Z"
              transform="translate(244.649 34.611)"
              fill="#ffdc91"
            />
            <path
              id="Path_1798"
              data-name="Path 1798"
              d="M639.88,86.989c.223-.39.4-.739.544-1.032s.265-.572.362-.809a6.269,6.269,0,0,0,.2-.641,3.828,3.828,0,0,0,0-.516c0-.265-.084-.39-.265-.39a2.313,2.313,0,0,0-.878.362v-1.2l5.479-3.165v1.2a4.013,4.013,0,0,0-.781.6,8.674,8.674,0,0,0-.725.837,10.724,10.724,0,0,0-.7,1.06c-.237.376-.474.781-.711,1.227l-2.663,4.894,3.764,4.67a2.791,2.791,0,0,0,.572.572,1.311,1.311,0,0,0,.544.265,1.255,1.255,0,0,0,.558,0,3,3,0,0,0,.628-.279h0V95.87l-1.088.627a12.29,12.29,0,0,1-1.394.725,7.644,7.644,0,0,1-1.032.418,3,3,0,0,1-.753.153,1.3,1.3,0,0,1-.976-.39,3.987,3.987,0,0,1-.377-.432l-2.5-3.82-.906,1.394v3.9a2.534,2.534,0,0,0,.084.753.529.529,0,0,0,.223.321.39.39,0,0,0,.335,0,2.105,2.105,0,0,0,.418-.181l.85-.488v1.227l-6.971,4.029v-1.241l.85-.488a1.982,1.982,0,0,0,.39-.279,1.462,1.462,0,0,0,.335-.376,1.925,1.925,0,0,0,.209-.655,3.189,3.189,0,0,0,.084-.781V89.066a2.287,2.287,0,0,0-.084-.711.5.5,0,0,0-.223-.293.46.46,0,0,0-.334,0,2.343,2.343,0,0,0-.391.181l-.85.488V87.5l6.971-4.015V84.7l-.85.5a2.794,2.794,0,0,0-.418.279,1.908,1.908,0,0,0-.335.4,2.049,2.049,0,0,0-.223.586,3.507,3.507,0,0,0-.084.837v5.4Z"
              transform="translate(248.998 31.376)"
              fill="#ffdc91"
            />
            <path
              id="Path_1799"
              data-name="Path 1799"
              d="M536.49,74.972V56.388l18.417-11.1V64.139Z"
              transform="translate(211.466 17.852)"
              fill="#00a3e2"
            />
            <path
              id="Path_1800"
              data-name="Path 1800"
              d="M574.045,37.02V55.855L561.567,63.2,555.6,66.716v-18.6Z"
              transform="translate(218.998 14.592)"
              fill="#68ba51"
            />
            <path
              id="Path_1801"
              data-name="Path 1801"
              d="M572.358,38.03V55.457L559.88,62.8V45.558Z"
              transform="translate(220.685 14.99)"
              fill="#22722e"
            />
            <path
              id="Path_1802"
              data-name="Path 1802"
              d="M562.21,64.332v-18.6L580.627,34.65V53.485Z"
              transform="translate(221.604 13.658)"
              fill="#f44038"
            />
            <path
              id="Path_1803"
              data-name="Path 1803"
              d="M466.244,187.632a6.539,6.539,0,0,1,3.918.265,3.89,3.89,0,0,1,1.115.446,3.526,3.526,0,0,1,.767.809c.628.781,1.6,1.115,2.008,2.049a3.848,3.848,0,0,1,0,2.412,4.266,4.266,0,0,1-3.1,3.3,6.4,6.4,0,0,1-2.872-.474,4.614,4.614,0,0,1-3.109-2.063,20.564,20.564,0,0,1-1.129-1.812,3.695,3.695,0,0,1,2.4-4.935Z"
              transform="translate(182.726 73.886)"
              fill="#ebdeff"
            />
            <path
              id="Path_1804"
              data-name="Path 1804"
              d="M474.283,196.662a151.189,151.189,0,0,1-1.129,15.866,12.409,12.409,0,0,1-1.143,4.378,12.7,12.7,0,0,1-3.611,3.708c-5.577,4.294-11.153,8.365-16.563,12.673-4.921,3.959-9.634,8.267-12.283,14.137a22.474,22.474,0,0,0,21.916,31.689,19.852,19.852,0,0,1,4.545-.1,17.414,17.414,0,0,1,5.451,2.454c14.179,7.807,34.157,2.091,42.076-12.018a27.383,27.383,0,0,1,2.858-4.712c1-1.2,2.3-2.147,3.29-3.36,3.973-4.866,2.035-12.283-1.394-17.511-6.72-10.094-17.009-12.31-26.28-18.835-6.218-4.378-5.354-5.828-6.009-13.733-.265-3.193-.7-6.385-1.157-9.55a32.955,32.955,0,0,1,0-10.205,4.016,4.016,0,0,1-2.384,1.757,7.251,7.251,0,0,1-3,.167,7.849,7.849,0,0,1-3.36-1.1,4.308,4.308,0,0,1-1.98-2.858C474.046,191.922,474.325,194.236,474.283,196.662Z"
              transform="translate(172.47 74.698)"
              fill="#e0c9ff"
            />
            <path
              id="Path_1805"
              data-name="Path 1805"
              d="M462.54,215.874a9.01,9.01,0,0,0,1.868-2.245,12.1,12.1,0,0,0,1.129-4.392,150.562,150.562,0,0,0,1.129-15.866c0-.265,0-.516,0-.781s-.335-.125-.488-.223a4.308,4.308,0,0,1-1.98-2.858c0,2.412.307,4.726.265,7.152a151.164,151.164,0,0,1-1.129,15.866,16.386,16.386,0,0,1-.795,3.346Z"
              transform="translate(182.317 74.698)"
              fill="#a699ba"
            />
            <path
              id="Path_1806"
              data-name="Path 1806"
              d="M496.242,241.822a15.645,15.645,0,0,0-1.882,2.928c.948-1.032,2.049-1.924,2.942-3.011a9.212,9.212,0,0,0,1.394-2.4C497.859,240.163,496.995,240.929,496.242,241.822Z"
              transform="translate(194.86 94.339)"
              fill="#a699ba"
            />
            <path
              id="Path_1807"
              data-name="Path 1807"
              d="M473.708,263.431a17.484,17.484,0,0,0-5.465-2.454,19.865,19.865,0,0,0-4.545.1,22.488,22.488,0,0,1-21.916-31.689,25.935,25.935,0,0,1,1.394-2.426,27.422,27.422,0,0,0-3.611,5.7,22.474,22.474,0,0,0,21.916,31.689,19.855,19.855,0,0,1,4.545-.1,17.411,17.411,0,0,1,5.451,2.454c14.1,7.71,33.976,2.133,41.978-11.809C504.407,266.387,486.646,270.556,473.708,263.431Z"
              transform="translate(172.474 89.46)"
              fill="#a699ba"
            />
            <path
              id="Path_1808"
              data-name="Path 1808"
              d="M461.063,230.546a155.144,155.144,0,0,1,9.215-20.076l-7.236,12.91c-1.966,3.5-4.419,6.469-6.316,9.968-3.945,7.291-6.9,15.684-5.186,23.8a34.385,34.385,0,0,0,1.882,5.842,17.314,17.314,0,0,0,2.858,5.131,6.622,6.622,0,0,0,5.144,2.426c-.781-3.234-2.788-6.051-3.862-9.188-2.454-6.9-2.914-13.2-.418-20.187C458.414,237.614,459.7,234.073,461.063,230.546Z"
              transform="translate(177.786 82.96)"
              fill="#c1afd6"
            />
            <path
              id="Path_1809"
              data-name="Path 1809"
              d="M494.236,241.748a33.459,33.459,0,0,1,6.594,11.4c.669,1.994,1.6,4.712,1.074,6.831a8.056,8.056,0,0,1-.669,2.342,4.509,4.509,0,0,1-.795.99c-.139.139-.878.53-.906.669a20.689,20.689,0,0,0-2.44-15.2,40.857,40.857,0,0,0-2.789-4.182c-.739-.962-1.561-1.84-2.384-2.788q-5.27-5.549-10.847-10.833a39.566,39.566,0,0,1-5.577-6.58,32.066,32.066,0,0,1-5.3-18.124c.767,4.28,1.143,8.7,3.109,12.673a42.159,42.159,0,0,0,7.765,10.359C485.258,233.647,490.207,237.217,494.236,241.748Z"
              transform="translate(185.336 81.308)"
              fill="#c1afd6"
            />
            <path
              id="Path_1810"
              data-name="Path 1810"
              d="M473.841,206.39c-2.091,4.266-5.828,9.285-9.759,11.739a125.571,125.571,0,0,0-10.219,7.361c-6.734,5.117-14.039,11.767-14.5,20.815a20.326,20.326,0,0,0,1.394,8.128,22.655,22.655,0,0,0,5.228,8.491,24.708,24.708,0,0,0,4.183,3.694c1.938,1.115,4.406,1.115,6.5,1.785a16.186,16.186,0,0,1-4.559-2.565,20.759,20.759,0,0,1-8.56-14.862c-.558-5.66,1.492-10.3,4.419-14.973,3.067-4.921,7.7-8.058,11.906-11.892a108.405,108.405,0,0,0,7.975-8.03A40.432,40.432,0,0,0,473.841,206.39Z"
              transform="translate(173.177 81.352)"
              fill="#c1a7e6"
            />
            <path
              id="Path_1811"
              data-name="Path 1811"
              d="M498.537,267.787c2.482-4.712,1.046-10.219-1.115-14.764-2.482-5.158-6.65-8.811-10.54-12.952-.836-.878-1.771-1.715-2.663-2.551-3.653-3.36-7.068-6.817-10.582-10.359-1.617-1.631-2.677-4.545-3.695-6.622-2.008-4.1-.976-8.867-1-13.272a61.454,61.454,0,0,1,.739-9.466q-1.185,7.975-2.245,15.977c-.823,6.33-2.105,12.729-1.394,19.114a25.291,25.291,0,0,0,7.487,15.336c4.029,3.862,9.383,6.4,12.548,11.014a16.328,16.328,0,0,1,2.245,4.907c.878,3.332-.906,6.316-1.018,9.55C491.44,275.2,496.738,271.259,498.537,267.787Z"
              transform="translate(183.615 77.966)"
              fill="#ebdeff"
            />
            <path
              id="Path_1812"
              data-name="Path 1812"
              d="M481.012,223.916c1.84,1.561,3.9,2.788,5.8,4.294a64.489,64.489,0,0,1,5.061,4.5c4.071,3.89,8.281,8.016,10.024,13.37.739,2.342,1,4.866,2.258,6.971a12.548,12.548,0,0,0,1.548-6.72,20.814,20.814,0,0,0-1.547-7.528,27.882,27.882,0,0,0-8.881-11.07,45.77,45.77,0,0,0-8.226-5.577c-2.565-1.2-5.716-2.147-8.03-3.764a24.664,24.664,0,0,1-3.932-3.973c-.906-1.032-2.719-2.621-3.137-3.932.809,2.551,1.561,5.967,3.388,7.989A59.423,59.423,0,0,0,481.012,223.916Z"
              transform="translate(186.026 82.968)"
              fill="#ebdeff"
            />
            <path
              id="Path_1813"
              data-name="Path 1813"
              d="M460.133,232.236c-.934,2.468-1.854,4.935-2.565,7.473a46.369,46.369,0,0,0-1.715,13.482,13.629,13.629,0,0,0,.4,3.527,17.01,17.01,0,0,0,1.645,3.541c2.788,4.991,5.953,10.3,11.153,12.547a1.186,1.186,0,0,0,.753.125c.613-.2.474-1.115.181-1.7-1.311-2.788-2.719-5.437-3.764-8.281a49.2,49.2,0,0,1-2.607-19.044c.4-10.414,3.109-20.536,5.27-30.672a22.643,22.643,0,0,0,.739-8.184c.279,1.84-1.088,4.963-1.575,6.762q-1,3.709-2.272,7.305C464.218,223.676,461.792,227.8,460.133,232.236Z"
              transform="translate(179.678 80.823)"
              fill="#ebdeff"
            />
            <path
              id="Path_1814"
              data-name="Path 1814"
              d="M471.162,203.517a42.334,42.334,0,0,0-.6-6.762c0-.376-.474-5.312-2.077-3.959-.432.376-1.394.892-1.617,1.394a5.325,5.325,0,0,0,0,2.049c0,1.575,0,3.151.1,4.712.084,3.221.223,6.441.39,9.662a24.034,24.034,0,0,0,1.506,8.365c.711-.293.878-1.2.962-1.952l1-9.132C470.967,206.459,471.134,205,471.162,203.517Z"
              transform="translate(183.984 75.901)"
              fill="#ebdeff"
            />
            <path
              id="Path_1815"
              data-name="Path 1815"
              d="M394,478.862c4.559,27.883-10.136,53.494-31.048,56.91s-42.522-16.242-47.095-44.111,8.365-61.65,29.208-65.08S389.43,451.049,394,478.862Z"
              transform="translate(124.139 168.03)"
              fill="#f7f7f7"
            />
            <path
              id="Path_1816"
              data-name="Path 1816"
              d="M370.425,527.887c-20.912,3.43-42.522-16.228-47.081-44.111-3.179-19.393,2.091-41.63,12.645-54.526-15.336,10.108-23.98,37.81-20.132,61.343,4.573,27.883,26.2,47.541,47.095,44.111a33.571,33.571,0,0,0,20.2-12.143A30.979,30.979,0,0,1,370.425,527.887Z"
              transform="translate(124.141 169.195)"
              fill="#dfe5e6"
            />
            <path
              id="Path_1817"
              data-name="Path 1817"
              d="M435.647,530.182c-25.095,12.98-53.982,6.971-63.713-11.878s2.259-45.464,27.34-58.443,61.19-11.223,70.935,7.6S460.742,517.2,435.647,530.182Z"
              transform="translate(145.274 177.956)"
              fill="#f7f7f7"
            />
            <path
              id="Path_1818"
              data-name="Path 1818"
              d="M446.178,515.673c-25.1,12.98-54,6.971-63.727-11.878-6.525-12.547-3.262-28.692,7.11-41.825-18.277,14.053-25.973,36.011-17.608,52.2,9.759,18.807,38.646,24.858,63.727,11.878a76.2,76.2,0,0,0,22.711-18.515,71.559,71.559,0,0,1-12.213,8.142Z"
              transform="translate(145.282 182.092)"
              fill="#dfe5e6"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ProteinIsometricSVG = (customStyles) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="779.38"
      height="708.9"
      viewBox="0 0 779.38 708.9"
    >
      <g id="Food-2" transform="translate(0.009 -0.029)">
        <g id="Layer_2" data-name="Layer 2" transform="translate(-0.009 0.029)">
          <g
            id="Layer_2-2"
            data-name="Layer 2"
            transform="translate(67.962 298.15)"
          >
            <ellipse
              id="Ellipse_26"
              data-name="Ellipse 26"
              cx="355.709"
              cy="205.375"
              rx="355.709"
              ry="205.375"
              fill="#fff"
              opacity="0.15"
            />
            <ellipse
              id="Ellipse_27"
              data-name="Ellipse 27"
              cx="225.501"
              cy="130.208"
              rx="225.501"
              ry="130.208"
              transform="translate(130.208 75.167)"
              fill="#fff"
              opacity="0.2"
            />
            <ellipse
              id="Ellipse_28"
              data-name="Ellipse 28"
              cx="95.315"
              cy="55.019"
              rx="95.315"
              ry="55.019"
              transform="translate(260.394 150.355)"
              fill="#fff"
              opacity="0.3"
            />
          </g>
          <g id="Layer_1" data-name="Layer 1">
            <path
              id="Path_1819"
              data-name="Path 1819"
              d="M466.415,318.9l-33.389-19.279-20.741-11.97c-6.907-4.7-17.838-7.182-31.652-6.843l-9.173-5.3c-7.923-5.36-22.012-7.309-39.956-4.534a137.431,137.431,0,0,0-25.3,6.525l-.424-.254c-.911-3.792-34.173-28.368-59.638-44.66l-65.295-25.868c-2.924-1.589-6.356-3.263-10.063-5.085a3.581,3.581,0,0,1-.572-.275c-1.25-.572-2.415-1.25-3.75-1.907a8.792,8.792,0,0,0-3.326-2.669c-15.677-7.712-37.859-22.965-58.261-32.69L106,163.081l.381-.36c.53-.487,1.038-1,1.547-1.5l.191-.212,1.631-1.78a54.257,54.257,0,0,0,11.631-21.991c-9.661-10.826-28.156-16.419-45.1-24.618v-.36a6.546,6.546,0,0,0-3.411-3.347c-1.631-.911-3.517-1.653-5.233-2.5a6.759,6.759,0,0,0-1.991-.805,9.534,9.534,0,0,0-2.8,0l-4.64.53a5.72,5.72,0,0,0-1.97.424,3.325,3.325,0,0,0-.953.72L49.9,112.447a.911.911,0,0,0-.3.424c0,.381.636.636.784,1a.813.813,0,0,1-.148.826c-.424,1.271,1.208,2.479,3.135,3.093s4.237.847,6.165,1.335a11.356,11.356,0,0,0,3.369.572,7.86,7.86,0,0,0,1.441-.212l1.165-.233a68.239,68.239,0,0,1,12.711,8.474c4.746,3.729,9.745,7.9,15.317,11.546-8.029,1.419-11.44,4.873-12.711,9.279-.169.614-.275,1.208-.381,1.8a36.845,36.845,0,0,0-4.046,1.165A19.068,19.068,0,0,0,68.1,157c-.466.339-.932.678-1.4,1.059-2.119-3.008-9.046-5.741-10.784-6.674l1.123-1.356c.784-.869,0-1.949-1.525-2.288L45.9,145.624a18.246,18.246,0,0,0-1.525-1.737A42.16,42.16,0,0,0,32.3,140.222a34.942,34.942,0,0,0-4.64-.339c-2.119-1.547-7.945-2.8-19.279,4.364-8.771,5.529-12.139,13.6-2.818,18.813,8.6,4.809,24.575,9.745,27.541,8.029l12.1,7.224A15.72,15.72,0,0,0,41.28,194.33a8.75,8.75,0,0,0-3.326,4.873c-1.017,5.89,7.309,16.122,15.677,24.109a4.513,4.513,0,0,0,1.695.466c4.237,3.941,8.6,7.817,12.224,11.334,15.127,9.873,33.9,18.538,52.837,27.33a30.275,30.275,0,0,0,5.487,7.2,16.312,16.312,0,0,0,2.86,1.758l3.453,1.822,3.983,1.462a1.97,1.97,0,0,0,1.356,0,.805.805,0,0,0,.339-.233l4.237,1.25a2.119,2.119,0,0,0,1.314,0,1.081,1.081,0,0,0,.487-.36l4.237,1.25c1.059.275,2.119-.254,2.119-1a1.292,1.292,0,0,0-.614-.869l2.479.7a1.885,1.885,0,0,0,1.8-.339c.487-.487.36-1.292-1.123-1.97l-3.474-1.313-4.237-2.436-1.991-2.119,1.758.805a34.981,34.981,0,0,0,5.8,1.886,7.139,7.139,0,0,0,2.627,0c.975-.233,1.356-.72.72-1.25a5.179,5.179,0,0,0-.72-.4l-4.788-1.97a55.213,55.213,0,0,0-5.974-4.576,22.16,22.16,0,0,0-10.3-3.877l-2.309-1.631c-16.144-12.118-25.635-19.915-39.787-27.541a18.219,18.219,0,0,0-3.962-9.851l12.288,5.021q7.246,2.924,15.677,6.186l5.72,2.119c6.631,2.436,9.025,4.237,12.711,4.068l.53.233,3.6,1.61,1.314.593c.869.847,1.737,1.674,2.627,2.479s1.843,1.589,2.839,2.352a61.444,61.444,0,0,0,6.356,4.237,63.115,63.115,0,0,0,6.949,3.813,65.987,65.987,0,0,0,7.479,2.8c1.949,1,3.9,2.119,5.826,3.051,3.9,2.119,7.8,4.237,11.737,6.356,5.932,3.263,11.949,6.568,18.241,9.724,4.237,2.119,8.474,4.11,12.923,6,7.945,10.063,24.109,23.092,38.41,32.753,1.059.7,2.119,1.4,3.114,2.119-.275.508-.593,1.017-.847,1.525-4.555,9.809-1.758,17.627,6.356,22.309l10.593,6.144c-.53,7.309,3.072,13.22,10,17.224l11.864,6.843,75.76,43.749,13.389,7.733c9.6,5.551,25.55,7.415,45.528,4.237a164.868,164.868,0,0,0,39.151-11.356Zm-193.7-23.94c-10.741-9.3-24.046-20.465-34.829-30.147l-26.376-19.237c7.1,2.119,13.834,4.237,19.385,6.08,12.711,10.593,41.122,29.427,54.532,35.232A119.714,119.714,0,0,0,272.713,294.963Z"
              transform="translate(0.009 117.951)"
              fill="#1d1d1b"
              opacity="0.15"
            />
            <g
              id="Group_42"
              data-name="Group 42"
              transform="translate(416.803 294.427)"
              opacity="0.15"
            >
              <path
                id="Path_1820"
                data-name="Path 1820"
                d="M337.13,187.894l-27.542-15.8L299,166.051l-.4-.191c-30.719-17.605-43.982-8.729-64.4-18.156a3.517,3.517,0,0,0-1.822-2.33l-9.025-5.212a13.856,13.856,0,0,0-8.665-.805c-7.606,1.165-15.4,5.7-17.436,10.084a3.538,3.538,0,0,0,1.631,5.085l8.474,4.915a8.9,8.9,0,0,0,4.385,1.25c16.249,11.758.932,19.427,31.4,37.139l.805.487,10.487,6.038,55.4,31.885,10.487,6.038c3.453,2.33,9.216,3.369,16.546,2.712Z"
                transform="translate(-196.728 -139.003)"
                fill="#1d1d1b"
              />
            </g>
            <path
              id="Path_1821"
              data-name="Path 1821"
              d="M247.76,138.7l.127,88.493c-.381,5.021,2.733,10.084,9.364,13.9,12.5,7.2,32.774,7.182,45.274,0,6.25-3.623,9.364-8.347,9.364-13.072l-.064-89.4Z"
              transform="translate(277.158 154.996)"
              fill="#fff"
            />
            <path
              id="Path_1822"
              data-name="Path 1822"
              d="M302.4,135.314c12.5,7.2,12.521,18.9,0,26.143s-32.774,7.267-45.274,0-12.542-18.919,0-26.143a36.486,36.486,0,0,1,6.356-2.86C275.708,128.3,291.809,129.212,302.4,135.314Z"
              transform="translate(277.132 145.252)"
              fill="#fff"
            />
            <path
              id="Path_1823"
              data-name="Path 1823"
              d="M302.425,157.446c-12.5,7.246-32.774,7.267-45.3,0-6.059-3.5-9.173-8.051-9.343-12.711V208.61c-.381,5.021,2.733,10.084,9.364,13.9,12.521,7.2,32.8,7.182,45.274,0,6.25-3.6,9.385-8.347,9.364-13.072V144.29C311.831,149.1,308.674,153.845,302.425,157.446Z"
              transform="translate(277.152 161.339)"
              fill="#489dc7"
            />
            <path
              id="Path_1824"
              data-name="Path 1824"
              d="M302.446,160.338c-12.5,7.246-32.774,7.267-45.3,0-6.08-3.5-9.173-8.051-9.364-12.711V199.3c-.381,5.021,2.754,10.084,9.364,13.9,12.521,7.2,32.8,7.182,45.3,0,6.25-3.6,9.364-8.347,9.364-13.072V147.16C311.831,151.99,308.674,156.736,302.446,160.338Z"
              transform="translate(277.152 164.549)"
              fill="#224a5e"
            />
            <path
              id="Path_1825"
              data-name="Path 1825"
              d="M277.54,206.428a41.545,41.545,0,0,1-20.487-4.809c-4.852-2.775-7.479-6.356-7.2-9.809V154.332a27.541,27.541,0,0,0,2.86,1.843,54.236,54.236,0,0,0,49.617,0,32.2,32.2,0,0,0,2.881-1.886V192.3c0,3.284-2.627,6.673-7.2,9.343A41.736,41.736,0,0,1,277.54,206.428Z"
              transform="translate(279.474 172.524)"
              fill="#489dc7"
            />
            <path
              id="Path_1826"
              data-name="Path 1826"
              d="M255.619,171.53c-.36,1.483-.72,2.966-1.059,4.449a36.622,36.622,0,0,0,35.338.106c-.36-1.483-.7-2.966-1.059-4.428a32.309,32.309,0,0,1-33.219-.127Z"
              transform="translate(284.764 191.809)"
              fill="#224a5e"
            />
            <path
              id="Path_1827"
              data-name="Path 1827"
              d="M279.036,171.51c0,6.822-4.682,12.372-10.593,12.372s-10.593-5.508-10.593-12.33,4.682-12.351,10.487-12.372S279.015,164.667,279.036,171.51Z"
              transform="translate(288.444 177.994)"
              fill="#fff"
            />
            <path
              id="Path_1828"
              data-name="Path 1828"
              d="M279.706,115.627l-12.711-4.237c-1.547,23.3-19.237,20.847-19.194,57.774h63.981c0-36.927-17.669-34.427-19.216-57.774Z"
              transform="translate(277.202 124.537)"
              fill="#fff"
            />
            <path
              id="Path_1829"
              data-name="Path 1829"
              d="M256.13,105.811v10.042a6.907,6.907,0,0,0,4.237,6.186,22.224,22.224,0,0,0,20.148,0,7.119,7.119,0,0,0,4.237-5.826V105.79Z"
              transform="translate(286.52 118.273)"
              fill="#cc3837"
            />
            <path
              id="Path_1830"
              data-name="Path 1830"
              d="M280.455,104.278c5.572,3.2,5.572,8.474,0,11.631a22.266,22.266,0,0,1-20.169,0c-5.572-3.2-5.572-8.474,0-11.631A22.224,22.224,0,0,1,280.455,104.278Z"
              transform="translate(286.495 113.875)"
              fill="#ea4a49"
            />
            <path
              id="Path_1831"
              data-name="Path 1831"
              d="M318.985,214.578,296.444,201.57l-53.663,31.1,27.8,16.059,41.482,23.94,53.685-31.1-46.757-26.991Z"
              transform="translate(271.587 225.411)"
              fill="#1d1d1b"
              opacity="0.15"
            />
            <path
              id="Path_1832"
              data-name="Path 1832"
              d="M384.142,232.322l-58.155,19.067a8.262,8.262,0,0,1-7.309-1.525l-29.152-26.059a2.267,2.267,0,0,1,.869-4.237L348.55,200.5a8.241,8.241,0,0,1,7.309,1.525l29.194,26.08a2.267,2.267,0,0,1-.911,4.216Z"
              transform="translate(322.571 223.895)"
              fill="#6d6d6d"
            />
            <path
              id="Path_1833"
              data-name="Path 1833"
              d="M384.23,231.782,326.1,250.849a8.241,8.241,0,0,1-7.309-1.525l-29.173-25.868a2.267,2.267,0,0,1,.89-4.237l58.134-19.067a8.241,8.241,0,0,1,7.309,1.525l29.173,26.037a2.267,2.267,0,0,1-.89,4.068Z"
              transform="translate(322.673 223.503)"
              fill="silver"
            />
            <path
              id="Path_1834"
              data-name="Path 1834"
              d="M312.682,203.842l5.085-1.674a1.271,1.271,0,0,1,1.25.4,4.089,4.089,0,0,1,1.165,3.517,1.356,1.356,0,0,1-.741,1.038l-5.085,1.674h-.127a2.627,2.627,0,0,1-1.547-5Z"
              transform="translate(347.952 226.042)"
              fill="#fff"
            />
            <path
              id="Path_1835"
              data-name="Path 1835"
              d="M315.515,203.688a4.089,4.089,0,0,1,1.165,3.517,1.356,1.356,0,0,1-.742,1.038l4.11-1.356,2.119-.72h.169a2.627,2.627,0,0,0-1.758-4.936l-2.288.763-4.11,1.356a1.271,1.271,0,0,1,1.335.339Z"
              transform="translate(351.453 224.924)"
              fill="#cf4518"
            />
            <path
              id="Path_1836"
              data-name="Path 1836"
              d="M316.615,207.279l5.085-1.674a1.313,1.313,0,0,1,1.25.4,4.11,4.11,0,0,1,1.165,3.517,1.313,1.313,0,0,1-.741,1.059l-5.085,1.674h-.106a2.63,2.63,0,0,1-1.568-5.021Z"
              transform="translate(352.111 229.892)"
              fill="#fff"
            />
            <path
              id="Path_1837"
              data-name="Path 1837"
              d="M319.268,207.132a4.11,4.11,0,0,1,1.165,3.517,1.314,1.314,0,0,1-.741,1.059l4.11-1.356,2.119-.72h.169a2.648,2.648,0,0,0,1.547-3.22,2.606,2.606,0,0,0-3.284-1.716l-2.182.784-4.11,1.356a1.314,1.314,0,0,1,1.208.3Z"
              transform="translate(355.793 228.768)"
              fill="#cf4518"
            />
            <path
              id="Path_1838"
              data-name="Path 1838"
              d="M320.336,210.732l5.085-1.674a1.292,1.292,0,0,1,1.25.381,4.089,4.089,0,0,1,1.165,3.538,1.271,1.271,0,0,1-.741,1.038l-5.085,1.674H321.9a2.627,2.627,0,0,1-1.568-5Z"
              transform="translate(356.483 233.748)"
              fill="#fff"
            />
            <path
              id="Path_1839"
              data-name="Path 1839"
              d="M323.155,210.569a4.089,4.089,0,0,1,1.165,3.538,1.271,1.271,0,0,1-.741,1.038l4.11-1.356,2.119-.72h.169a2.618,2.618,0,0,0-1.737-4.936l-2.309.763-4.11,1.356a1.292,1.292,0,0,1,1.335.318Z"
              transform="translate(359.999 232.619)"
              fill="#cf4518"
            />
            <path
              id="Path_1840"
              data-name="Path 1840"
              d="M324.255,214.169l5.085-1.674a1.314,1.314,0,0,1,1.25.4,4.046,4.046,0,0,1,1.165,3.517,1.271,1.271,0,0,1-.742,1.059l-5.085,1.674h-.106a2.63,2.63,0,0,1-1.568-5.021Z"
              transform="translate(360.657 237.599)"
              fill="#fff"
            />
            <path
              id="Path_1841"
              data-name="Path 1841"
              d="M326.975,214a4.047,4.047,0,0,1,1.165,3.517,1.271,1.271,0,0,1-.742,1.059l4.11-1.356,2.119-.72h.169a2.627,2.627,0,0,0-1.737-4.936l-2.309.742-4.11,1.356A1.313,1.313,0,0,1,326.975,214Z"
              transform="translate(364.272 236.497)"
              fill="#cf4518"
            />
            <path
              id="Path_1842"
              data-name="Path 1842"
              d="M303.719,206.819l5.085-1.674a1.314,1.314,0,0,1,1.25.4,4.047,4.047,0,0,1,1.165,3.517,1.271,1.271,0,0,1-.742,1.059l-5.085,1.674h0a2.63,2.63,0,1,1-1.568-5.021Z"
              transform="translate(337.805 229.377)"
              fill="#fff"
            />
            <path
              id="Path_1843"
              data-name="Path 1843"
              d="M306.495,206.649a4.046,4.046,0,0,1,1.165,3.517,1.271,1.271,0,0,1-.742,1.059l4.11-1.356,2.119-.72h.169a2.627,2.627,0,0,0-1.737-4.936l-2.309.741-4.11,1.356A1.314,1.314,0,0,1,306.495,206.649Z"
              transform="translate(341.364 228.276)"
              fill="#cf4518"
            />
            <path
              id="Path_1844"
              data-name="Path 1844"
              d="M307.5,210.273l5.085-1.674a1.292,1.292,0,0,1,1.271.4A4.067,4.067,0,0,1,315,212.518a1.271,1.271,0,0,1-.742,1.038l-5.085,1.674h-.106a2.627,2.627,0,0,1-1.568-5Z"
              transform="translate(342.121 233.233)"
              fill="#fff"
            />
            <path
              id="Path_1845"
              data-name="Path 1845"
              d="M310.381,210.13a4.067,4.067,0,0,1,1.144,3.517,1.271,1.271,0,0,1-.742,1.038l4.131-1.356,2.119-.72a.233.233,0,0,0,.169,0,2.618,2.618,0,0,0-1.737-4.936l-2.288.763-4.237,1.356A1.292,1.292,0,0,1,310.381,210.13Z"
              transform="translate(345.592 232.104)"
              fill="#cf4518"
            />
            <path
              id="Path_1846"
              data-name="Path 1846"
              d="M311.429,213.71l5.063-1.674a1.335,1.335,0,0,1,1.271.4,4.089,4.089,0,0,1,1.144,3.517,1.271,1.271,0,0,1-.741,1.059l-5.064,1.674h-.127a2.627,2.627,0,1,1-1.547-5.021Z"
              transform="translate(346.302 237.083)"
              fill="#fff"
            />
            <path
              id="Path_1847"
              data-name="Path 1847"
              d="M314.2,213.539a4.089,4.089,0,0,1,1.144,3.517,1.271,1.271,0,0,1-.741,1.059l4.131-1.356,2.119-.72h.169a2.627,2.627,0,0,0-1.737-4.936l-2.288.742L312.76,213.2A1.335,1.335,0,0,1,314.2,213.539Z"
              transform="translate(349.865 235.983)"
              fill="#cf4518"
            />
            <path
              id="Path_1848"
              data-name="Path 1848"
              d="M315.132,217.163l5.063-1.674a1.292,1.292,0,0,1,1.271.4,4.067,4.067,0,0,1,1.144,3.517,1.271,1.271,0,0,1-.742,1.038l-5.063,1.674h-.127a2.627,2.627,0,0,1-1.547-5Z"
              transform="translate(350.692 240.94)"
              fill="#fff"
            />
            <path
              id="Path_1849"
              data-name="Path 1849"
              d="M317.965,217.02a4.068,4.068,0,0,1,1.144,3.517,1.271,1.271,0,0,1-.742,1.038l4.131-1.356,2.119-.72a.4.4,0,0,0,.169,0,2.585,2.585,0,0,0,1.547-3.22,2.627,2.627,0,0,0-3.284-1.716l-2.288.763-4.131,1.356A1.292,1.292,0,0,1,317.965,217.02Z"
              transform="translate(354.194 239.811)"
              fill="#cf4518"
            />
            <path
              id="Path_1850"
              data-name="Path 1850"
              d="M294.652,209.813l5.063-1.674a1.292,1.292,0,0,1,1.271.4,4.068,4.068,0,0,1,1.144,3.517,1.335,1.335,0,0,1-.742,1.059l-5.063,1.652H296.2a2.627,2.627,0,0,1-1.547-5Z"
              transform="translate(327.784 232.718)"
              fill="#fff"
            />
            <path
              id="Path_1851"
              data-name="Path 1851"
              d="M297.485,209.67a4.068,4.068,0,0,1,1.144,3.517,1.335,1.335,0,0,1-.742,1.059l4.131-1.356,2.119-.742a.234.234,0,0,0,.169,0,2.618,2.618,0,0,0-1.737-4.936l-2.288.763-4.131,1.356a1.292,1.292,0,0,1,1.335.339Z"
              transform="translate(331.286 231.589)"
              fill="#cf4518"
            />
            <path
              id="Path_1852"
              data-name="Path 1852"
              d="M298.589,213.247l5.063-1.674a1.4,1.4,0,0,1,1.271.4,4.11,4.11,0,0,1,1.165,3.517,1.335,1.335,0,0,1-.763,1.059l-5.063,1.674h-.127a2.627,2.627,0,1,1-1.547-5.021Z"
              transform="translate(331.94 236.572)"
              fill="#fff"
            />
            <path
              id="Path_1853"
              data-name="Path 1853"
              d="M301.316,213.087a4.11,4.11,0,0,1,1.165,3.517,1.334,1.334,0,0,1-.763,1.059l4.131-1.356,2.119-.72h.169a2.627,2.627,0,0,0-1.758-4.936l-2.288.742-4.131,1.356a1.4,1.4,0,0,1,1.356.339Z"
              transform="translate(335.547 235.461)"
              fill="#cf4518"
            />
            <path
              id="Path_1854"
              data-name="Path 1854"
              d="M302.292,216.7l5.085-1.674a1.271,1.271,0,0,1,1.25.4,4.089,4.089,0,0,1,1.165,3.517,1.356,1.356,0,0,1-.741,1.038l-5.085,1.674h-.127a2.627,2.627,0,0,1-1.547-5Z"
              transform="translate(336.329 240.426)"
              fill="#fff"
            />
            <path
              id="Path_1855"
              data-name="Path 1855"
              d="M305.125,216.56a4.089,4.089,0,0,1,1.165,3.517,1.356,1.356,0,0,1-.742,1.038l4.11-1.356,2.119-.72h.169a2.585,2.585,0,0,0,1.525-3.22,2.627,2.627,0,0,0-3.284-1.716l-2.288.763-4.11,1.356A1.271,1.271,0,0,1,305.125,216.56Z"
              transform="translate(339.831 239.296)"
              fill="#cf4518"
            />
            <path
              id="Path_1856"
              data-name="Path 1856"
              d="M306.229,220.139l5.085-1.674a1.313,1.313,0,0,1,1.25.4,4.11,4.11,0,0,1,1.165,3.517,1.356,1.356,0,0,1-.742,1.059l-5.085,1.674h-.127a2.627,2.627,0,1,1-1.547-5.021Z"
              transform="translate(340.485 244.277)"
              fill="#fff"
            />
            <path
              id="Path_1857"
              data-name="Path 1857"
              d="M308.945,219.977a4.11,4.11,0,0,1,1.165,3.517,1.356,1.356,0,0,1-.742,1.059l4.11-1.356,2.119-.72h.169a2.627,2.627,0,0,0-1.758-4.936l-2.288.741-4.11,1.356a1.314,1.314,0,0,1,1.335.339Z"
              transform="translate(344.104 243.168)"
              fill="#cf4518"
            />
            <path
              id="Path_1858"
              data-name="Path 1858"
              d="M380.25,218.961l-52.964,30.613a8.263,8.263,0,0,1-7.457,0l-33.9-19.554a2.267,2.267,0,0,1,0-4.237L338.9,195.17a8.262,8.262,0,0,1,7.457,0l33.9,19.554a2.267,2.267,0,0,1,0,4.237Z"
              transform="translate(318.221 217.257)"
              fill="#878787"
            />
            <path
              id="Path_1859"
              data-name="Path 1859"
              d="M380.25,218.5l-52.964,30.613a8.263,8.263,0,0,1-7.457,0l-33.9-19.554a2.267,2.267,0,0,1,0-4.237L338.9,194.71a8.262,8.262,0,0,1,7.457,0l33.9,19.554a2.267,2.267,0,0,1,0,4.237Z"
              transform="translate(318.221 216.742)"
              fill="#dadada"
            />
            <path
              id="Path_1860"
              data-name="Path 1860"
              d="M306.547,199.663l4.618-2.669a1.314,1.314,0,0,1,1.314.127,4.089,4.089,0,0,1,1.864,3.2,1.313,1.313,0,0,1-.53,1.186l-4.618,2.669h-.106a2.648,2.648,0,0,1-3.517-1A2.606,2.606,0,0,1,306.547,199.663Z"
              transform="translate(341.46 220.157)"
              fill="#fff"
            />
            <path
              id="Path_1861"
              data-name="Path 1861"
              d="M309.365,198.953a4.089,4.089,0,0,1,1.864,3.2,1.314,1.314,0,0,1-.53,1.186l3.771-2.119,1.991-1.165h.148a2.627,2.627,0,0,0-2.712-4.491l-2.119,1.208-3.75,2.119A1.314,1.314,0,0,1,309.365,198.953Z"
              transform="translate(344.574 218.346)"
              fill="#e94e1b"
            />
            <path
              id="Path_1862"
              data-name="Path 1862"
              d="M311.016,202.253l4.64-2.669a1.271,1.271,0,0,1,1.292.127,4.089,4.089,0,0,1,1.864,3.22,1.335,1.335,0,0,1-.508,1.186l-4.64,2.669h-.106a2.627,2.627,0,1,1-2.542-4.6Z"
              transform="translate(346.397 223.054)"
              fill="#fff"
            />
            <path
              id="Path_1863"
              data-name="Path 1863"
              d="M313.794,201.592a4.089,4.089,0,0,1,1.864,3.22A1.335,1.335,0,0,1,315.15,206l3.75-2.119,1.991-1.144.169-.106a2.614,2.614,0,1,0-2.712-4.47l-2.118,1.208-3.75,2.119a1.271,1.271,0,0,1,1.314.106Z"
              transform="translate(349.552 221.172)"
              fill="#e94e1b"
            />
            <path
              id="Path_1864"
              data-name="Path 1864"
              d="M315.342,204.859l4.64-2.691a1.314,1.314,0,0,1,1.314.148,4.047,4.047,0,0,1,1.843,3.2,1.335,1.335,0,0,1-.508,1.186l-4.618,2.669h-.106a2.627,2.627,0,0,1-2.542-4.576Z"
              transform="translate(351.478 225.956)"
              fill="#fff"
            />
            <path
              id="Path_1865"
              data-name="Path 1865"
              d="M318.255,204.215a4.046,4.046,0,0,1,1.843,3.2,1.334,1.334,0,0,1-.508,1.186l3.75-2.119,2.013-1.165.148-.106a2.614,2.614,0,0,0-2.712-4.47l-2.119,1.208-3.75,2.119a1.314,1.314,0,0,1,1.335.148Z"
              transform="translate(354.518 224.058)"
              fill="#e94e1b"
            />
            <path
              id="Path_1866"
              data-name="Path 1866"
              d="M319.877,207.473,324.5,204.8a1.314,1.314,0,0,1,1.313.127,4.237,4.237,0,0,1,1.864,3.2,1.335,1.335,0,0,1-.53,1.186l-4.618,2.669h-.106a2.648,2.648,0,0,1-3.517-1,2.606,2.606,0,0,1,.975-3.517Z"
              transform="translate(356.371 228.893)"
              fill="#fff"
            />
            <path
              id="Path_1867"
              data-name="Path 1867"
              d="M322.7,206.723a4.237,4.237,0,0,1,1.864,3.2,1.335,1.335,0,0,1-.53,1.186l3.771-2.119,1.991-1.165h.148a2.627,2.627,0,0,0-2.712-4.491l-2.118,1.208-3.75,2.119a1.314,1.314,0,0,1,1.335.064Z"
              transform="translate(359.496 227.037)"
              fill="#e94e1b"
            />
            <path
              id="Path_1868"
              data-name="Path 1868"
              d="M298.253,204.473l4.618-2.669a1.313,1.313,0,0,1,1.313.127,4.089,4.089,0,0,1,1.864,3.22,1.271,1.271,0,0,1-.508,1.165l-4.64,2.691H300.8a2.627,2.627,0,0,1-2.542-4.576Z"
              transform="translate(332.339 225.538)"
              fill="#fff"
            />
            <path
              id="Path_1869"
              data-name="Path 1869"
              d="M301.156,203.671a4.089,4.089,0,0,1,1.864,3.22,1.271,1.271,0,0,1-.508,1.165l3.75-2.119,1.991-1.144h.169a2.627,2.627,0,0,0-2.733-4.47l-2.119,1.208-3.771,2.119a1.314,1.314,0,0,1,1.356.021Z"
              transform="translate(335.368 223.691)"
              fill="#e94e1b"
            />
            <path
              id="Path_1870"
              data-name="Path 1870"
              d="M302.8,207.013l4.64-2.669a1.313,1.313,0,0,1,1.313.127,4.11,4.11,0,0,1,1.843,3.22,1.335,1.335,0,0,1-.508,1.186l-4.64,2.669h-.106a2.627,2.627,0,1,1-2.542-4.6Z"
              transform="translate(337.203 228.379)"
              fill="#fff"
            />
            <path
              id="Path_1871"
              data-name="Path 1871"
              d="M305.595,206.3a4.11,4.11,0,0,1,1.843,3.22,1.335,1.335,0,0,1-.508,1.186l3.75-2.119,2.013-1.144h.148a2.614,2.614,0,0,0-2.712-4.47l-2.119,1.208-3.75,2.119a1.314,1.314,0,0,1,1.335,0Z"
              transform="translate(340.357 226.553)"
              fill="#e94e1b"
            />
            <path
              id="Path_1872"
              data-name="Path 1872"
              d="M307.133,209.616l4.64-2.669a1.271,1.271,0,0,1,1.314.127,4.089,4.089,0,0,1,1.843,3.2,1.313,1.313,0,0,1-.508,1.186l-4.618,2.669h-.127a2.627,2.627,0,0,1-2.542-4.576Z"
              transform="translate(342.272 231.284)"
              fill="#fff"
            />
            <path
              id="Path_1873"
              data-name="Path 1873"
              d="M310.035,208.893a4.089,4.089,0,0,1,1.843,3.2,1.313,1.313,0,0,1-.508,1.186l3.75-2.119,2.013-1.165h.148a2.627,2.627,0,0,0-2.712-4.491l-2.119,1.208-3.75,2.119a1.271,1.271,0,0,1,1.335.064Z"
              transform="translate(345.324 229.464)"
              fill="#e94e1b"
            />
            <path
              id="Path_1874"
              data-name="Path 1874"
              d="M311.613,212.2l4.618-2.669a1.313,1.313,0,0,1,1.314.127,4.088,4.088,0,0,1,1.864,3.22,1.292,1.292,0,0,1-.53,1.165l-4.619,2.691h-.106a2.627,2.627,0,0,1-2.542-4.576Z"
              transform="translate(347.284 234.184)"
              fill="#fff"
            />
            <path
              id="Path_1875"
              data-name="Path 1875"
              d="M314.486,211.509a4.089,4.089,0,0,1,1.864,3.22,1.292,1.292,0,0,1-.53,1.165l3.771-2.119,1.991-1.165h.148a2.614,2.614,0,1,0-2.712-4.47l-2.119,1.208-3.771,2.119A1.313,1.313,0,0,1,314.486,211.509Z"
              transform="translate(350.279 232.336)"
              fill="#e94e1b"
            />
            <path
              id="Path_1876"
              data-name="Path 1876"
              d="M290.136,209.182l4.619-2.669a1.314,1.314,0,0,1,1.313.127,4.089,4.089,0,0,1,1.864,3.22,1.335,1.335,0,0,1-.508,1.186l-4.64,2.669h-.106a2.627,2.627,0,1,1-2.542-4.6Z"
              transform="translate(323.041 230.806)"
              fill="#fff"
            />
            <path
              id="Path_1877"
              data-name="Path 1877"
              d="M292.936,208.475a4.089,4.089,0,0,1,1.864,3.22,1.335,1.335,0,0,1-.508,1.186l3.75-2.119,1.991-1.144.169-.106a2.627,2.627,0,0,0-2.733-4.47l-2.119,1.208-3.771,2.119A1.314,1.314,0,0,1,292.936,208.475Z"
              transform="translate(326.174 228.971)"
              fill="#e94e1b"
            />
            <path
              id="Path_1878"
              data-name="Path 1878"
              d="M294.473,211.788l4.64-2.691a1.335,1.335,0,0,1,1.314.148,4.047,4.047,0,0,1,1.843,3.2,1.334,1.334,0,0,1-.508,1.186l-4.64,2.669h-.106a2.627,2.627,0,0,1-2.542-4.576Z"
              transform="translate(328.111 233.709)"
              fill="#fff"
            />
            <path
              id="Path_1879"
              data-name="Path 1879"
              d="M297.375,211.145a4.047,4.047,0,0,1,1.843,3.2,1.334,1.334,0,0,1-.508,1.186l3.75-2.119,2.013-1.165.148-.106a2.614,2.614,0,1,0-2.712-4.47l-2.119,1.208L296.04,211a1.335,1.335,0,0,1,1.335.148Z"
              transform="translate(331.162 231.81)"
              fill="#e94e1b"
            />
            <path
              id="Path_1880"
              data-name="Path 1880"
              d="M298.983,214.373,303.6,211.7a1.313,1.313,0,0,1,1.314.127,4.237,4.237,0,0,1,1.864,3.2,1.313,1.313,0,0,1-.53,1.186l-4.618,2.606h-.106a2.648,2.648,0,0,1-3.517-1,2.606,2.606,0,0,1,.975-3.453Z"
              transform="translate(333.029 236.612)"
              fill="#fff"
            />
            <path
              id="Path_1881"
              data-name="Path 1881"
              d="M301.815,213.653a4.237,4.237,0,0,1,1.864,3.2,1.313,1.313,0,0,1-.53,1.186l3.75-2.119,2.013-1.165h.148a2.627,2.627,0,0,0-2.712-4.491l-2.119,1.208-3.75,2.119a1.314,1.314,0,0,1,1.335.064Z"
              transform="translate(336.129 234.789)"
              fill="#e94e1b"
            />
            <path
              id="Path_1882"
              data-name="Path 1882"
              d="M303.363,216.963l4.618-2.669a1.314,1.314,0,0,1,1.314.127,4.089,4.089,0,0,1,1.864,3.22,1.335,1.335,0,0,1-.508,1.186l-4.64,2.669h-.106a2.627,2.627,0,0,1-2.542-4.576Z"
              transform="translate(338.055 239.509)"
              fill="#fff"
            />
            <path
              id="Path_1883"
              data-name="Path 1883"
              d="M306.266,216.255a4.089,4.089,0,0,1,1.864,3.22,1.335,1.335,0,0,1-.508,1.186l3.75-2.119,1.991-1.144.169-.106a2.627,2.627,0,0,0-2.733-4.47l-2.119,1.208-3.771,2.119A1.314,1.314,0,0,1,306.266,216.255Z"
              transform="translate(341.084 237.674)"
              fill="#e94e1b"
            />
            <path
              id="Path_1884"
              data-name="Path 1884"
              d="M288.13,296.457l53.219-30.719V194.13L288.13,224.849Z"
              transform="translate(322.315 217.088)"
              fill="#ea4a49"
            />
            <path
              id="Path_1885"
              data-name="Path 1885"
              d="M288.13,281.289l53.219-30.719V207.69L288.13,238.409Z"
              transform="translate(322.315 232.256)"
              fill="#f9b233"
            />
            <path
              id="Path_1886"
              data-name="Path 1886"
              d="M269.93,198.12v71.608l38.558,22.266V220.386l-35.507-20.508Z"
              transform="translate(301.956 221.552)"
              fill="#ea4a49"
            />
            <path
              id="Path_1887"
              data-name="Path 1887"
              d="M269.93,214.339l3.051,1.758,35.507,20.508,53.219-30.719L326.2,185.378l-3.051-1.758Z"
              transform="translate(301.956 205.332)"
              fill="#f9cc7d"
            />
            <path
              id="Path_1888"
              data-name="Path 1888"
              d="M288.13,248.133l53.219-30.719V194.13L288.13,224.849Z"
              transform="translate(322.315 217.088)"
              fill="#f9b233"
            />
            <path
              id="Path_1889"
              data-name="Path 1889"
              d="M269.93,211.68v42.88l38.558,22.266v-42.88Z"
              transform="translate(301.956 236.719)"
              fill="#de9f2d"
            />
            <path
              id="Path_1890"
              data-name="Path 1890"
              d="M269.93,198.13V221.2l38.558,22.245V220.375Z"
              transform="translate(301.956 221.563)"
              fill="#de9f2d"
            />
            <path
              id="Path_1891"
              data-name="Path 1891"
              d="M299.6,231.558l25.529-14.724V214.27L299.6,228.994Z"
              transform="translate(335.145 239.617)"
              fill="#fff"
            />
            <path
              id="Path_1892"
              data-name="Path 1892"
              d="M303.21,229.321,321.091,219V216.44L303.21,226.757Z"
              transform="translate(339.183 242.044)"
              fill="#fff"
            />
            <path
              id="Path_1893"
              data-name="Path 1893"
              d="M301.91,233.09l20.635-11.906V218.62L301.91,230.526Z"
              transform="translate(337.729 244.482)"
              fill="#fff"
            />
            <path
              id="Path_1894"
              data-name="Path 1894"
              d="M304.21,232.463l15.762-9.11V220.79L304.21,229.9Z"
              transform="translate(340.301 246.91)"
              fill="#fff"
            />
            <path
              id="Path_1895"
              data-name="Path 1895"
              d="M302.48,236.741l19.427-11.207V222.97L302.48,234.177Z"
              transform="translate(338.366 249.348)"
              fill="#fff"
            />
            <path
              id="Path_1896"
              data-name="Path 1896"
              d="M299.113,234.895v2.563L272.44,222.184V219.62Z"
              transform="translate(304.764 245.601)"
              fill="#fff"
            />
            <path
              id="Path_1897"
              data-name="Path 1897"
              d="M299.113,237.086v2.564l-26.673-15.3V221.79Z"
              transform="translate(304.764 248.028)"
              fill="#fff"
            />
            <path
              id="Path_1898"
              data-name="Path 1898"
              d="M299.113,239.245v2.564L272.44,226.533V223.97Z"
              transform="translate(304.764 250.467)"
              fill="#fff"
            />
            <path
              id="Path_1899"
              data-name="Path 1899"
              d="M299.113,243.988l-26.673-15.3V226.15l26.673,15.275Z"
              transform="translate(304.764 252.905)"
              fill="#fff"
            />
            <path
              id="Path_1900"
              data-name="Path 1900"
              d="M299.113,243.595v2.563L272.44,230.883V228.32Z"
              transform="translate(304.764 255.333)"
              fill="#fff"
            />
            <ellipse
              id="Ellipse_29"
              data-name="Ellipse 29"
              cx="12.627"
              cy="7.288"
              rx="12.627"
              ry="7.288"
              transform="translate(611.317 495.846) rotate(-60)"
              fill="#ea4a49"
            />
            <path
              id="Path_1901"
              data-name="Path 1901"
              d="M294.21,212.1a3.982,3.982,0,0,1,.614-2.119,4.236,4.236,0,0,1,1.5-1.589l2.839-1.653a1.462,1.462,0,0,1,1.5-.148,1.441,1.441,0,0,1,.636,1.377v10.593l-2.839,1.631v-4.089l-1.419.826v4.089l-2.839,1.631Zm4.237-2.458-1.419.805v4.11l1.419-.826Z"
              transform="translate(329.115 230.872)"
              fill="#fff"
            />
            <path
              id="Path_1902"
              data-name="Path 1902"
              d="M306.9,207.69a.974.974,0,0,1,.424.911v4.089a4.238,4.238,0,0,1-.614,2.119,4.364,4.364,0,0,1-1.5,1.589l-4.979,2.86V206.164l4.979-2.86a1.419,1.419,0,0,1,1.5-.169,1.5,1.5,0,0,1,.614,1.4v1.229a2.861,2.861,0,0,1-.424,1.377,4.452,4.452,0,0,1-.318.466.932.932,0,0,1,.318.085Zm-2.415-1.547-1.419.826v2.394l1.419-.826Zm0,4.915-1.419.826v3.263l1.419-.826Z"
              transform="translate(335.849 227.003)"
              fill="#fff"
            />
            <path
              id="Path_1903"
              data-name="Path 1903"
              d="M306.268,205.148a4.088,4.088,0,0,1,.614-2.119,4.046,4.046,0,0,1,1.5-1.589l2.839-1.631a1.292,1.292,0,0,1,2.119,1.229V203.5l-2.818,1.631v-2.436l-1.419.826v8.178l1.419-.805v-2.458l2.818-1.652v2.458a3.983,3.983,0,0,1-.614,2.119,4.047,4.047,0,0,1-1.5,1.589l-2.839,1.652a1.462,1.462,0,0,1-1.5.148,1.419,1.419,0,0,1-.614-1.377Z"
              transform="translate(342.587 223.082)"
              fill="#fff"
            />
            <path
              id="Path_1904"
              data-name="Path 1904"
              d="M261.875,184.156l-11.356-6.589A7.858,7.858,0,0,0,249.9,177l-39.342-22.711c.191,0,.339.254.53.36l-13.961-8.114-.212-.106a70.908,70.908,0,0,0-34.554-8.241,10.254,10.254,0,0,0-.932-.636l-9.025-5.254.636.445c-3.58-2.458-9.978-3.39-18.156-2.119-15.3,2.373-30.974,11.419-35.02,20.211a7.076,7.076,0,0,0,2.924,10l8.983,5.233a14.137,14.137,0,0,0,1.5.72c.127,7.14,4.852,14.258,14.258,19.7l32.457,18.877,18.071,10.593c.17,0,.4.191.572.275l13.644,7.923c5.169,3.008,13.771,4.025,24.576,2.352,21.419-3.347,43.325-16.059,49.066-28.368C268.654,192.016,266.981,187.143,261.875,184.156Z"
              transform="translate(110.59 145.412)"
              fill="#1d1d1b"
              opacity="0.15"
            />
            <circle
              id="Ellipse_30"
              data-name="Ellipse 30"
              cx="40.062"
              cy="40.062"
              r="40.062"
              transform="translate(295.096 248.482) rotate(-6.17)"
              fill="#cc3837"
            />
            <path
              id="Path_1905"
              data-name="Path 1905"
              d="M221.439,134.3l-.233,75c0,5.911-3.9,11.8-11.652,16.313-15.614,9.068-40.973,9.068-56.672,0-7.9-4.555-11.843-10.593-11.822-16.525l.3-75.082c0,5.974,3.941,11.97,11.843,16.525,15.7,9.068,41.058,9.068,56.651,0C217.6,146.1,221.439,140.186,221.439,134.3Z"
              transform="translate(157.805 149.828)"
              fill="#ea4a49"
            />
            <path
              id="Path_1906"
              data-name="Path 1906"
              d="M221.439,141.538v45.422c-.805,5.212-4.788,10.826-11.631,14.83-15.614,9.068-40.973,9.068-56.672,0-7.881-4.555-12.076-11.419-12.076-17.372l.254-43.028c0,5.953,3.941,11.906,11.822,16.461,15.7,9.068,41.058,9.068,56.672,0C217.6,153.275,221.439,147.428,221.439,141.538Z"
              transform="translate(157.806 158.095)"
              fill="#ededed"
            />
            <path
              id="Path_1907"
              data-name="Path 1907"
              d="M221.439,141.538v45.422c-.805,5.212-4.788,10.826-11.631,14.83-15.614,9.068-40.973,9.068-56.672,0-7.881-4.555-12.076-11.419-12.076-17.372l.254-43.028c0,5.953,3.941,11.906,11.822,16.461,15.7,9.068,41.058,9.068,56.672,0C217.6,153.275,221.439,147.428,221.439,141.538Z"
              transform="translate(157.806 158.095)"
              fill="#fff"
            />
            <path
              id="Path_1908"
              data-name="Path 1908"
              d="M209.521,129.931c15.7,9.046,15.783,23.749.169,32.817s-40.952,9.067-56.651,0-15.8-23.749-.191-32.817S193.738,120.863,209.521,129.931Z"
              transform="translate(157.965 137.67)"
              fill="#cc3837"
            />
            <path
              id="Path_1909"
              data-name="Path 1909"
              d="M142.434,151a56.07,56.07,0,0,0,6.356,4.915,6.038,6.038,0,0,1,2.119,2.415,7.034,7.034,0,0,1,.869,3.263v6.5a2.585,2.585,0,0,1-.869,2.246,1.7,1.7,0,0,1-2.119-.127c-.953-.636-1.886-1.292-2.818-1.991v6.5c-1.229-.911-2.436-1.886-3.6-2.924Zm5.487,8.178c-.636-.445-1.271-.89-1.886-1.356v6.5c.614.466,1.25.911,1.886,1.335Z"
              transform="translate(159.271 168.844)"
              fill="#21749e"
            />
            <path
              id="Path_1910"
              data-name="Path 1910"
              d="M147.785,154.66a56.562,56.562,0,0,0,7.182,3.114,4.47,4.47,0,0,1,2.225,1.885,5.318,5.318,0,0,1,.932,3.03v6.5a2.119,2.119,0,0,1-.636,1.652,1.4,1.4,0,0,1-1.483.3c.7,1.97,1.419,3.919,2.119,5.847V179.6c-1.419-.4-2.818-.869-4.237-1.4v-2.606c-.678-1.991-1.377-4-2.119-6.017v7.8q-2.119-.89-4.068-1.907Zm6.123,6.631c-.678-.254-1.377-.53-2.119-.826v5.212l2.119.826Z"
              transform="translate(165.233 172.938)"
              fill="#21749e"
            />
            <path
              id="Path_1911"
              data-name="Path 1911"
              d="M153.632,160.444a3.411,3.411,0,0,1,.953-2.542,2.415,2.415,0,0,1,2.288-.657c1.441.275,2.9.487,4.343.636a3.453,3.453,0,0,1,2.33,1.335,4.407,4.407,0,0,1,.953,2.818v13.008a3.962,3.962,0,0,1-.953,2.712,2.585,2.585,0,0,1-2.33.932c-1.441-.148-2.9-.36-4.343-.636a3.5,3.5,0,0,1-2.288-1.61,5.106,5.106,0,0,1-.953-2.987Zm6.5,1.208a11.083,11.083,0,0,1-2.119-.318v13.008c.72.127,1.441.233,2.119.318Z"
              transform="translate(171.864 175.755)"
              fill="#21749e"
            />
            <path
              id="Path_1912"
              data-name="Path 1912"
              d="M162.294,161.906H159.54v-3.9a56.78,56.78,0,0,0,9.851-.678v3.919c-.89.127-1.8.254-2.712.339v16.949c-1.462.169-2.924.254-4.385.3Z"
              transform="translate(178.477 175.925)"
              fill="#21749e"
            />
            <path
              id="Path_1913"
              data-name="Path 1913"
              d="M165,158.619a54.742,54.742,0,0,0,9.6-2.669v3.9a52.65,52.65,0,0,1-5.275,1.695v3.9c1.419-.381,2.818-.805,4.237-1.314v3.9c-1.4.508-2.8.932-4.237,1.335v5.191c1.78-.487,3.538-1.038,5.275-1.695v3.9a54.741,54.741,0,0,1-9.6,2.606Z"
              transform="translate(184.584 174.381)"
              fill="#21749e"
            />
            <path
              id="Path_1914"
              data-name="Path 1914"
              d="M170,156.722c1.377-.551,2.733-1.165,4.089-1.822v20.8c-1.356.657-2.712,1.271-4.089,1.822Z"
              transform="translate(190.177 173.207)"
              fill="#21749e"
            />
            <path
              id="Path_1915"
              data-name="Path 1915"
              d="M172.85,158.28a32.333,32.333,0,0,0,3.411-2.119l3.3,6.822v-9.11c1.229-.911,2.436-1.886,3.6-2.924v20.8c-1.017.911-2.119,1.758-3.135,2.585-1.08-2.224-2.119-4.47-3.284-6.779v9.089c-1.271.847-2.585,1.631-3.9,2.352Z"
              transform="translate(193.365 168.788)"
              fill="#21749e"
            />
            <path
              id="Path_1916"
              data-name="Path 1916"
              d="M191.536,154.039A34.978,34.978,0,0,0,156.6,119.21h-.72a34.872,34.872,0,0,1,45.4,33.156l.233,75.019c0,4.237-3.368,8.665-9.258,12.076l-.508.275Z"
              transform="translate(174.383 131.463)"
              fill="#fff"
              opacity="0.5"
            />
            <g
              id="Group_43"
              data-name="Group 43"
              transform="translate(310.497 227.408)"
            >
              <path
                id="Path_1917"
                data-name="Path 1917"
                d="M203.773,115.32v10.445c0,4.237-2.775,8.474-8.3,11.631-11.144,6.483-29.236,6.483-40.444,0-5.635-3.241-8.474-7.521-8.474-11.779V115.15c0,4.237,2.8,8.474,8.474,11.8,11.207,6.356,29.321,6.356,40.444,0C201,123.73,203.773,119.535,203.773,115.32Z"
                transform="translate(-146.55 -98.665)"
                fill="#c6c6c6"
              />
              <path
                id="Path_1918"
                data-name="Path 1918"
                d="M195.321,112.223c11.207,6.356,11.25,16.949.127,23.431s-29.236,6.356-40.444,0-11.25-16.949-.127-23.431S184.114,105.761,195.321,112.223Z"
                transform="translate(-146.531 -107.369)"
                fill="#fff"
              />
            </g>
            <path
              id="Path_1919"
              data-name="Path 1919"
              d="M314.539,181.55V296.229c.932,11.716-6.356,23.622-21.864,32.584-29.3,16.949-76.777,16.949-106.056,0-14.639-8.474-21.97-19.533-21.97-30.613V181.55Z"
              transform="translate(184.193 203.017)"
              fill="#3c3c3b"
            />
            <path
              id="Path_1920"
              data-name="Path 1920"
              d="M186.594,173.8c-29.279,16.949-29.279,44.3,0,61.227s76.756,16.949,106.056,0,29.279-44.321,0-61.227S215.915,156.871,186.594,173.8Z"
              transform="translate(184.176 180.154)"
              fill="#878787"
            />
            <path
              id="Path_1921"
              data-name="Path 1921"
              d="M297.048,164.86v20.465c.784,9.936-5.4,20.021-18.538,27.542-24.809,14.322-65.04,14.322-89.849,0-12.394-7.161-18.6-16.546-18.6-25.931V164.86Z"
              transform="translate(190.244 184.348)"
              fill="#3c3c3b"
            />
            <ellipse
              id="Ellipse_31"
              data-name="Ellipse 31"
              cx="63.515"
              cy="36.673"
              rx="63.515"
              ry="36.673"
              transform="translate(360.326 312.535)"
              fill="#878787"
            />
            <path
              id="Path_1922"
              data-name="Path 1922"
              d="M292.587,306.132a98.915,98.915,0,0,1-36.016,11.546,128.514,128.514,0,0,1-33.9,0,99.043,99.043,0,0,1-36.016-11.546c-14.639-8.474-21.948-19.533-21.948-30.613V188c0,11.08,7.309,22.16,21.948,30.613,29.3,16.949,76.777,16.949,106.056,0,13.919-8.029,21.186-18.41,21.885-28.94v83.853C315.4,285.264,308.116,297.17,292.587,306.132Z"
              transform="translate(184.26 210.232)"
              fill="#fff"
            />
            <path
              id="Path_1923"
              data-name="Path 1923"
              d="M292.621,289.925a80.023,80.023,0,0,1-12.987,6,108.772,108.772,0,0,1-23.05,5.551,128.364,128.364,0,0,1-33.9,0,108.578,108.578,0,0,1-23.029-5.551,81.325,81.325,0,0,1-13.029-6c-14.618-8.474-21.948-19.533-21.948-30.613V193c0,11.1,7.33,22.181,21.948,30.635,29.3,16.949,76.777,16.949,106.056,0,13.919-8.029,21.186-18.432,21.885-28.94v62.646C315.438,269.078,308.15,280.963,292.621,289.925Z"
              transform="translate(184.226 215.824)"
              fill="#cc3837"
            />
            <path
              id="Path_1924"
              data-name="Path 1924"
              d="M261.62,259.842a35.356,35.356,0,0,1-.3,4.513,108.77,108.77,0,0,1-23.05,5.551,128.361,128.361,0,0,1-33.9,0,108.578,108.578,0,0,1-23.029-5.551,31.778,31.778,0,0,1-.3-4.513c0-21.334,18.05-38.622,40.253-38.622S261.62,238.508,261.62,259.842Z"
              transform="translate(202.537 247.391)"
              fill="#f9b233"
            />
            <path
              id="Path_1925"
              data-name="Path 1925"
              d="M273.279,233.852a19.744,19.744,0,0,0-5.339-11.08,25.789,25.789,0,0,0-2.987-2.669c-1.419-1.462-2.818-2.966-4.237-4.513a4.491,4.491,0,0,0-4.343-.3l-.445.212-.487.254-.318.233a1.273,1.273,0,0,0-.275.191l-.318.233-.212.169-.53.508A15.274,15.274,0,0,1,250,219.213a1.335,1.335,0,0,0-.932,1.314c0,.551.636.847,1.292.614l.508-.212c-.275.508-.572,1-.869,1.483a.677.677,0,0,0,.381,1.1,1.208,1.208,0,0,0,.89-.169c-.254.487-.106.975.381,1.08a1.335,1.335,0,0,0,1.186-.445.636.636,0,0,0,.508.742,1.462,1.462,0,0,0,1.4-.763.551.551,0,0,0,.466.551l1.462.17a1.25,1.25,0,0,0,1.356-.551l.381-.53a19.067,19.067,0,0,0,2.712.106c.784,6.356-1.038,10.021,1.208,12.839-3.6-2.818-10.381,1.08-10.826,4.788-2.119-2.246-9.7-.911-10.084,2.669-1.737-1.97-7.775-2.288-8.962.4v-2.966c.318-.36.636-.763,1-1.229a11.019,11.019,0,0,0,1.758-4.131h.169a1.378,1.378,0,0,0,.572-.106c.826-.36,1.038-1.314,1.229-2.564s.127-2.818-.89-2.8l.191-3.517a5.72,5.72,0,0,0-.3-1.8,15.385,15.385,0,0,0,2.479-2.5h-1.229A9.386,9.386,0,0,0,239,219.806a6.08,6.08,0,0,1-4.407,1.695c-.17,0,.593-.89.4-.847a8.9,8.9,0,0,1-4.407.275,12.456,12.456,0,0,0-2.691-.36h-.445c.572-.445,0-1.547,0-1.4-1.186,1.25-2.881.932-7.055,1.78a8.813,8.813,0,0,0-3.369,1.589l-.487.424a5.53,5.53,0,0,0-1.928,4.237c0,1.165.127,2.309.191,3.474-1.017,0-1.25,1.292-1,2.8s.466,2.119,1.292,2.563a1.4,1.4,0,0,0,.572.127h.191a10.592,10.592,0,0,0,1.695,4.131l.953,1.208v3.072c-1.271-2.119-7.14-2.648-8.962-.424-.678-1.737-4.385-4.809-10.084-2.669,0,0-3.686-8.644-10.826-4.788,2.246-2.818.424-6.546,1.208-12.839h.466a19.455,19.455,0,0,0,2.246-.106l.381.53a1.25,1.25,0,0,0,1.356.551l1.462-.169a.487.487,0,0,0,.4-.614,1.547,1.547,0,0,0,1.441.826.636.636,0,0,0,.53-.742,1.313,1.313,0,0,0,1.165.445c.508-.106.657-.593.4-1.08a1.208,1.208,0,0,0,.89.169c.508,0,.636-.614.381-1.1s-.593-.975-.869-1.483l.508.212c.657.233,1.25,0,1.292-.593a1.356,1.356,0,0,0-.932-1.335,15.275,15.275,0,0,1-3.792-2.119,6,6,0,0,0-.551-.509.826.826,0,0,0-.212-.169l-.3-.233-.275-.212-.318-.212-.424-.233a3.305,3.305,0,0,0-.508-.233,4.555,4.555,0,0,0-4.364.3q-2.119,2.309-4.237,4.513a24.151,24.151,0,0,0-3.03,2.521,20.571,20.571,0,0,0-5.614,13.22A34.935,34.935,0,0,0,188.3,248.449a21.525,21.525,0,0,0,9.152,3.432,58.277,58.277,0,0,0,4.11,8.792,29.356,29.356,0,0,0,2.309,3.5l.466.657a19.067,19.067,0,0,1,4.237,11.483v.7a128.361,128.361,0,0,0,33.9,0q0-.35,0-.7a19.936,19.936,0,0,1,4.64-12.139,32.326,32.326,0,0,0,2.33-3.5,58.267,58.267,0,0,0,4.089-8.792,21.525,21.525,0,0,0,9.152-3.432,34.893,34.893,0,0,0,10.932-12.457C273.47,235.251,273.406,234.53,273.279,233.852Z"
              transform="translate(198.399 240.288)"
              fill="#3c3c3b"
            />
            <path
              id="Path_1926"
              data-name="Path 1926"
              d="M254.9,59.623c-15.063,11.207-32.584,18.389-45.613,18.3L202.3,49.454a18.3,18.3,0,0,1,15.741-.254c5.72-4.83,11.779-7.224,18.665-3.58.424-6.864,1.695-13.94,2.691-20.381,1.059-6.758,1.8-12.839.932-17.478h13.008C254.756,26.149,260.243,42.844,254.9,59.623Z"
              transform="translate(226.307 8.619)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1927"
              data-name="Path 1927"
              d="M210.518,183.273a21.186,21.186,0,0,1-9.258-10.593V157.49l-19.7,1.441.593,16.207a24.469,24.469,0,0,0-2.119,10.4,80.061,80.061,0,0,0,29.046,11.589c6.61-.17,11.292-1.737,11.949-6.356C220.221,187.383,216.239,185.328,210.518,183.273Z"
              transform="translate(201.394 176.104)"
              fill="#224a5e"
            />
            <path
              id="Path_1928"
              data-name="Path 1928"
              d="M221.1,176.026c-2.563,5-9.152,6.229-13.622,5.424-10.445-1.843-23.686-6.97-27.372-10.72v2.945c3.135,4.237,17.5,8.644,28.241,11.186,5.593.847,8.474-.508,10.826-2.733a6.1,6.1,0,0,0,1.928-6.038Z"
              transform="translate(201.486 190.914)"
              fill="#dadada"
            />
            <path
              id="Path_1929"
              data-name="Path 1929"
              d="M231.737,168.683a21.334,21.334,0,0,1-9.258-10.593V142.9L202.8,144.319l.572,16.207a25.169,25.169,0,0,0-2.119,10.423,79.891,79.891,0,0,0,29.067,11.568c6.61-.148,11.292-1.737,11.928-6.356C241.335,172.772,237.458,170.653,231.737,168.683Z"
              transform="translate(225.132 159.784)"
              fill="#224a5e"
            />
            <path
              id="Path_1930"
              data-name="Path 1930"
              d="M242.324,161.425c-2.542,5-9.131,6.229-13.622,5.445-10.423-1.864-23.686-6.97-27.372-10.72v2.924c3.114,4.237,17.478,8.644,28.219,11.186,5.614.847,8.474-.487,10.826-2.733a6.059,6.059,0,0,0,1.928-6.038Z"
              transform="translate(225.222 174.605)"
              fill="#dadada"
            />
            <path
              id="Path_1931"
              data-name="Path 1931"
              d="M226.7,80.75l12.033,64.6c-1.61,31.1-6.991,75.061-10.254,79.15,0,1.059,0,3.22-.106,4.237-.191,5.911-19.533,5.953-19.66,1.843,0-1.1,0-1.1-.148-3.369-4.237-5.487-1.462-50.57,2.288-71.671-4.555-17.457-15.19-44.85-14.957-61.312Z"
              transform="translate(219.135 90.264)"
              fill="#3c83a6"
            />
            <path
              id="Path_1932"
              data-name="Path 1932"
              d="M226.818,119.035l-6.907,59.32c-7.012,32.414-14.194,77.116-17.944,80.7a18.094,18.094,0,0,1-.784,5.381c-2.394,3.2-12.945,9.152-19.7,2.966-.381-.318.106-5.445-.191-5.89a14.132,14.132,0,0,1-1.271-5.106c-1.758-15.084,2.458-55.337,10.8-77.646-2.712-17.838-1.928-36.4-2.9-53.367a55.38,55.38,0,0,1,.381-30.55l.508-1.78,4.83-1.08,2.945-.657,12.457-2.754c.869-.17,1.758-.4,2.627-.593,8.3-1.843,16.779-3.75,21.631-4.873,1.949-.4,3.284-.741,3.792-.869l7.2-6.356a2.817,2.817,0,0,0,0,.593C246.52,99.078,245.143,108.993,226.818,119.035Z"
              transform="translate(200.942 84.817)"
              fill="#489dc7"
            />
            <path
              id="Path_1933"
              data-name="Path 1933"
              d="M240.236,80.307c-1.822,10.212-27.245,24.512-46.227,22.33a24.406,24.406,0,0,1-2.818-.445h-.3a23.5,23.5,0,0,1-6.589-2.479,2.638,2.638,0,0,0-.127-.932c-.233-1.631-.53-4.11-.72-5.614a6.04,6.04,0,0,0-.148-1.314,23.622,23.622,0,0,0,8.729,1.822A54.639,54.639,0,0,0,204.92,92.51c.869-.17,1.758-.4,2.627-.593,13.05-3.178,26.546-10.36,31.969-19.6a30.45,30.45,0,0,1,.424,3.369c.106,1.441.106,2.775.233,4.089a2.82,2.82,0,0,0,.064.53Z"
              transform="translate(205.065 80.835)"
              fill="#418db3"
            />
            <path
              id="Path_1934"
              data-name="Path 1934"
              d="M247.962,121.76a10.084,10.084,0,0,1-.763,4.555,26.715,26.715,0,0,1-10.678,11.356c-10.212,6.631-25.148,10.974-36.376,9.512a22.523,22.523,0,0,1-3.284-.636,18.2,18.2,0,0,1-5.063-2.119,6.359,6.359,0,0,1-1-.741c-2.331-2.119-1.949-5.191-3.326-11.483-1.483-7.521-2.839-14.449-3.962-20.762-2.394-13.474-4.068-24.321-5.127-32.711-.233-1.886-.424-3.665-.614-5.339-.275-2.373-.487-4.513-.657-6.356s-.233-3.157-.3-4.47c0-1.631,2.119-10.593,2.119-11.589a33.9,33.9,0,0,1,19.385-15.7c12.055-6.949,16.949-5.8,23.749-6.356,3.008-.254,12.711-2.9,14.639-1.525C253.47,38.881,245.822,94.79,247.962,121.76Z"
              transform="translate(197.806 30.145)"
              fill="#cc3837"
            />
            <path
              id="Path_1935"
              data-name="Path 1935"
              d="M211.225,19.494l-23.876-.784L186.9,44.62c-.254.593,6.25,13.347,18.855,9.385C211.14,52.311,211.183,44.514,211.225,19.494Z"
              transform="translate(209.077 20.868)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1936"
              data-name="Path 1936"
              d="M202.442,41.333c-11.631,0-11.271-18.643-11.271-18.643l20.317,4.046S214.263,40.3,202.442,41.333Z"
              transform="translate(213.857 25.32)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1937"
              data-name="Path 1937"
              d="M225.315,38.031l-2.119.72c.127,2.8,2.818,15.826-5.275,16.313-3.559.169-9.809,1.229-15.614-5.932a15.763,15.763,0,0,1-2.627-4.618,14.172,14.172,0,0,1-.847-4.6h-.36c-3.538.148-9.512,2.966-10.911,0a36.841,36.841,0,0,1-3.432-13.008,24.046,24.046,0,0,1,0-4.237c1.78-15.889,12.987-16.694,20.084-17.288a17.669,17.669,0,0,1,16.377,8.474,25,25,0,0,1,3.284,10.593,24.393,24.393,0,0,1-.826,2.606l3.517,7.606a2.331,2.331,0,0,1-1.25,3.369Z"
              transform="translate(205.877 5.911)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1938"
              data-name="Path 1938"
              d="M191.185,45.992c14.491,1.907,5.4-13.75,5.4-13.75s2.288-1.441,3.538-.106c2.33-.212,3.051-.805,5.148-1.144-1.356-7.415-6.1-21.885,14-19.364.212-2.839-1.886-7.394-15.572-6.779-10.593.466-20.614,6.589-20.444,17.2C183.494,31.883,187.858,46.141,191.185,45.992Z"
              transform="translate(205.008 5.301)"
              fill="#1d1d1b"
            />
            <path
              id="Path_1939"
              data-name="Path 1939"
              d="M188.5,21.357c.233,3.326,3.284,6.885,5.445,6.716s1.758-2.86,1.568-6.165c-.127-2.119.212-5.36-2.119-5.847S188.185,16.506,188.5,21.357Z"
              transform="translate(210.847 17.776)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1940"
              data-name="Path 1940"
              d="M198.577,173.04a212.408,212.408,0,0,0-13.283,78.493l-3.178-.678a210.861,210.861,0,0,1,13.474-78.832,12.437,12.437,0,0,0,.424-6.991c-3.962-18.2-3.411-36.228-2.521-49.871a14.067,14.067,0,0,0-.424-4.6,73.028,73.028,0,0,1-.784-24.173,22.184,22.184,0,0,0,3.114.508,70.294,70.294,0,0,0,.784,22.881,18.113,18.113,0,0,1,.572,5.445c-.89,13.453-1.441,31.185,2.458,49.024a15.89,15.89,0,0,1-.636,8.792Z"
              transform="translate(203.675 96.573)"
              fill="#fff"
            />
            <path
              id="Path_1941"
              data-name="Path 1941"
              d="M196.3,117.267a47.16,47.16,0,0,1-1.059-26.249,54.311,54.311,0,0,1,1.61-5.7,44.66,44.66,0,0,1-9.3-3.008c.191,1.525.466,3.729.678,5.233a55.379,55.379,0,0,0-.381,30.55c.975,16.949.191,35.529,2.9,53.367-8.22,22.309-12.457,62.562-10.741,77.561,4-31.63,8.9-61.079,19.067-77.561a164.549,164.549,0,0,1-2.775-54.193Z"
              transform="translate(200.951 92.009)"
              fill="#1d1d1b"
              opacity="0.2"
            />
            <path
              id="Path_1942"
              data-name="Path 1942"
              d="M217.853,9.565a53.355,53.355,0,0,0,2.225,4.894,5.848,5.848,0,0,0,1.377,2.458,5.148,5.148,0,0,0,1.038.614c1.059.487,2.119,1,3.2,1.377a14.257,14.257,0,0,0,4.068.975,9.513,9.513,0,0,0,3.856-.53,6.546,6.546,0,0,0,3.051-2.119,8.6,8.6,0,0,0,1.377-5.3c0-1.864-.4-3.686-.53-5.529a4.682,4.682,0,0,0-.339-1.949,4.745,4.745,0,0,0-1.653-1.589L232.3.752a3.538,3.538,0,0,0-1.568-.72,3.644,3.644,0,0,0-1.25.169L221.2,2.32a1.4,1.4,0,0,0-.593.275c-.4.36-.275,1-.551,1.462a2.542,2.542,0,0,1-.911.72,4.47,4.47,0,0,0-1.292,4.788Z"
              transform="translate(243.444 -0.029)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1943"
              data-name="Path 1943"
              d="M220.8,10.065c.466,1.61,5.445,1.949,6.356,6.144a6.885,6.885,0,0,0,5.424.212,5.063,5.063,0,0,1-3.5-4.513c-.191-3.135,2.013-5.212,3.729-7.9L227.539,5.3V8.285a4.682,4.682,0,0,1-.4,2.648c-1.165,1.716-4.237-.53-5.89-1.419a1.483,1.483,0,0,1-.445-.741,13.9,13.9,0,0,1-.678-2.119,2.583,2.583,0,0,1,0-1.059c.318-1.271,2.373-1.864,2.119-3.114-.3,1.356-2.394,1.716-2.733,3.072a28.492,28.492,0,0,0,1.292,4.513Z"
              transform="translate(245.558 2.713)"
              fill="#171715"
              opacity="0.1"
            />
            <path
              id="Path_1944"
              data-name="Path 1944"
              d="M218.073,29.859a18.474,18.474,0,0,0-15.783.254L209.3,58.587a61.121,61.121,0,0,0,23.071-5.36c3.411-5.678.254-25.042-5.953-28.177a22.457,22.457,0,0,0-8.347,4.809Z"
              transform="translate(226.296 27.96)"
              fill="#cc3837"
            />
            <path
              id="Path_1945"
              data-name="Path 1945"
              d="M223.625,40.6a16.8,16.8,0,0,0-5.085-4.237c.424-6.864,1.695-13.94,2.691-20.381C221.972,25.556,221.739,34.348,223.625,40.6Z"
              transform="translate(244.473 17.814)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1946"
              data-name="Path 1946"
              d="M169.826,95.13l-.4,3.5v.254L169,103.329l.381,3.157c0,1.652-1,2.373-1.78,2.246a.932.932,0,0,1-.826-.741l-.847-3.729-.17-3.835a14.617,14.617,0,0,1,.106-3.411l1.186-.572,2.373-1.123Z"
              transform="translate(185.372 106.349)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1947"
              data-name="Path 1947"
              d="M166.4,94.73l2.479.191v12.118c0,1.652-1,2.373-1.78,2.246a7.817,7.817,0,0,0-.678-3.962,4.958,4.958,0,0,0-.233-3.432A10.8,10.8,0,0,0,166.55,97C166.487,96.213,166.444,95.472,166.4,94.73Z"
              transform="translate(185.915 105.902)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1948"
              data-name="Path 1948"
              d="M166.564,96.663l2.119-.339,2.839-.487.763-.127-.847,2.733-1.08,3.665v4.724l.7,3.263c.191,1.8-.932,2.648-1.78,2.521a1.059,1.059,0,0,1-.826-.7l-1.5-4.555-.424-5.275a37.243,37.243,0,0,1,.042-5.424Z"
              transform="translate(186.198 106.998)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1949"
              data-name="Path 1949"
              d="M167.619,95.58l2.881.233v2.775l-1.08,3.665v4.724l.7,3.263c.191,1.8-.932,2.648-1.78,2.521a8.919,8.919,0,0,0-.784-4.809,5.572,5.572,0,0,0-.275-3.983c.742-1.271.487-4.237.36-7.394C167.64,96.173,167.619,95.877,167.619,95.58Z"
              transform="translate(187.135 106.853)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1950"
              data-name="Path 1950"
              d="M167.78,98.391,170.6,97.9l2.479-.424h.551V97.8l-1.822,6.229v4.915l.72,3.39a2.627,2.627,0,0,1-.551,2.119,1.25,1.25,0,0,1-2.119-.212l-1.568-4.746-.445-5.487A37.373,37.373,0,0,1,167.78,98.391Z"
              transform="translate(187.609 108.978)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1951"
              data-name="Path 1951"
              d="M169.2,96.86l2.542,1.314.466.233-1.822,6.229v4.915l.72,3.39a2.627,2.627,0,0,1-.551,2.119,8.326,8.326,0,0,0-1.08-4.237,12.71,12.71,0,0,0-.657-5.445,16.25,16.25,0,0,0,.424-6.822Z"
              transform="translate(188.857 108.285)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1952"
              data-name="Path 1952"
              d="M171.215,85.83c.763,2.373,3.877,3.877,6.97,3.813a7.627,7.627,0,0,0,4.237-1.271l-1.1,10.784a14.83,14.83,0,0,1,2.119,9.83l-.975.741-3.707,2.839-.763.169-3.75.869a14.279,14.279,0,0,1-8.474-6.165,39.681,39.681,0,0,1,4.724-11.377Z"
              transform="translate(185.446 95.947)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1953"
              data-name="Path 1953"
              d="M169.4,98.9l4.513-.763.742-.127h.614l-.508,1.716-.466,1.589-.932,3.241v4.915l.72,3.39c.17,1.525-.551,2.394-1.313,2.606a1.123,1.123,0,0,1-1.4-.7l-1.568-4.746-.424-5.487A37.163,37.163,0,0,1,169.4,98.9Z"
              transform="translate(189.377 109.571)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1954"
              data-name="Path 1954"
              d="M176.074,96.726c.36.127.72.254,1.1.424a56.1,56.1,0,0,1-1.123,8.008l.784,4.746a2.756,2.756,0,0,1,0,.826,1.08,1.08,0,0,1-1.652.826,3.411,3.411,0,0,1-1.547-1.483,21.694,21.694,0,0,1-1.462-5.254L171.964,103l-.148-1.25-.106-.847-.127-.975-.233-2.013a4.068,4.068,0,0,1,4.724-1.186Z"
              transform="translate(191.687 107.783)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1955"
              data-name="Path 1955"
              d="M173.351,97.54v2.606a12.711,12.711,0,0,0,.932,5.487,10,10,0,0,0,1.822,4.661,3.411,3.411,0,0,1-1.547-1.483,21.694,21.694,0,0,1-1.462-5.254l-.212-1.822-.932,3.241v4.915l.72,3.39c.169,1.525-.551,2.394-1.314,2.606a5.4,5.4,0,0,0-.148-5.529,7.479,7.479,0,0,0-.551-5.318,13.219,13.219,0,0,0,2.119-4.555l.508-1.949A1.994,1.994,0,0,1,173.351,97.54Z"
              transform="translate(190.915 109.045)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1956"
              data-name="Path 1956"
              d="M175.854,87l-1.1,10.784a14.83,14.83,0,0,1,2.119,9.83,56.093,56.093,0,0,1-1.123,8.008l.784,4.746a2.754,2.754,0,0,1,0,.826,20.318,20.318,0,0,0-1.8-6.1,11.8,11.8,0,0,0,1.144-6.737l-.127-1.165a10.169,10.169,0,0,0-3.39-9.068c2.119-2.754,1.292-6.97-.678-9.788A7.627,7.627,0,0,0,175.854,87Z"
              transform="translate(192.056 97.255)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_1957"
              data-name="Path 1957"
              d="M185.079,39.536c-10.339,8.474-14.173,34.533-18.771,52.6-1.144,18.6,1,38.134,3.178,57.816,0,6.97,10.254,4.343,11.843-.869,2.8-21.44,5.106-34.723,4.64-50.592,9.11-9.873,9.47-20.381,14.83-35.846C203.489,47.629,195.82,34.748,185.079,39.536Z"
              transform="translate(185.691 43.027)"
              fill="#ffbb7d"
            />
            <path
              id="Path_1958"
              data-name="Path 1958"
              d="M199.379,63.838c3.813-14.83-1.695-33.9-16.377-23.431-6.462,5.3-11.885,20.338-15.042,33.156,0,4.809,19.067,12.711,25.635,10.084C195.586,78.2,197.7,69.982,199.379,63.838Z"
              transform="translate(187.895 41.775)"
              fill="#cc3837"
            />
            <g
              id="Group_44"
              data-name="Group 44"
              transform="translate(107.899 424.008)"
              opacity="0.15"
            >
              <path
                id="Path_1959"
                data-name="Path 1959"
                d="M183.181,252.629,124.412,218.5h-.127a44.491,44.491,0,0,0-25.783-4.64,3.729,3.729,0,0,0-.72-.53l-8.792-5.106A26.97,26.97,0,0,0,69.541,206.3l-1.991-1.144a2.733,2.733,0,0,0-1.08-4.068c-2.733-1.589-8.072-1.059-11.928,1.165s-4.746,5.3-2.119,6.885a10.8,10.8,0,0,0,7.076.614l1.97,1.144c-3.051,3.644-1.991,8.157,3.263,11.207l8.792,5.106a7.143,7.143,0,0,0,1.144.508c-1.5,5.191,1.186,10.7,8.093,14.7l68.006,39.49c3.072,1.8,8.22,2.394,14.661,1.4a53.6,53.6,0,0,0,17.648-6.144Z"
                transform="translate(-50.921 -200.167)"
                fill="#1d1d1b"
              />
            </g>
            <path
              id="Path_1960"
              data-name="Path 1960"
              d="M134.35,194.148c9.364,5.424,9.428,14.194,0,19.6s-24.47,5.424-33.9,0-9.428-14.173,0-19.6S124.965,188.724,134.35,194.148Z"
              transform="translate(104.475 212.558)"
              fill="#489dc7"
            />
            <path
              id="Path_1961"
              data-name="Path 1961"
              d="M93.47,209.185a23.919,23.919,0,1,0,23.982-23.855A23.919,23.919,0,0,0,93.47,209.185Z"
              transform="translate(104.572 207.245)"
              fill="#21749e"
            />
            <path
              id="Path_1962"
              data-name="Path 1962"
              d="M141.464,196.717l-.212,78.747c0,3.517-2.33,7.034-6.949,9.724-9.322,5.424-24.47,5.424-33.9,0-4.724-2.712-7.076-6.356-7.076-9.851l.233-78.747c0,3.559,2.352,7.14,7.055,9.851,9.364,5.424,24.533,5.424,33.9,0C139.24,203.814,141.464,200.234,141.464,196.717Z"
              transform="translate(104.416 219.84)"
              fill="#489dc7"
            />
            <path
              id="Path_1963"
              data-name="Path 1963"
              d="M141.3,206.015l-.127,41.461c0,3.538-2.309,7.055-6.928,9.745-9.322,5.4-24.47,5.4-33.9,0a12.711,12.711,0,0,1-6.97-8.474l.127-44.066c0,3.58,2.352,7.14,7.055,9.851,9.385,5.4,24.533,5.4,33.9,0A12.711,12.711,0,0,0,141.3,206.015Z"
              transform="translate(104.472 228.889)"
              fill="#489dc7"
            />
            <path
              id="Path_1964"
              data-name="Path 1964"
              d="M141.3,206.015l-.127,41.461c0,3.538-2.309,7.055-6.928,9.745-9.322,5.4-24.47,5.4-33.9,0a12.711,12.711,0,0,1-6.97-8.474l.127-44.066c0,3.58,2.352,7.14,7.055,9.851,9.385,5.4,24.533,5.4,33.9,0A12.711,12.711,0,0,0,141.3,206.015Z"
              transform="translate(104.472 228.889)"
              fill="#ea4a49"
            />
            <path
              id="Path_1965"
              data-name="Path 1965"
              d="M141.3,206.015l-.127,41.461c0,3.538-2.309,7.055-6.928,9.745-9.322,5.4-24.47,5.4-33.9,0a12.711,12.711,0,0,1-6.97-8.474l.127-44.066c0,3.58,2.352,7.14,7.055,9.851,9.385,5.4,24.533,5.4,33.9,0A12.711,12.711,0,0,0,141.3,206.015Z"
              transform="translate(104.472 228.889)"
              fill="#ea4a49"
            />
            <path
              id="Path_1966"
              data-name="Path 1966"
              d="M119.261,207.486a20.72,20.72,0,0,0-16.631-20.232,20.635,20.635,0,0,1,24.7,20.232l.233,78.747c0,2.479-1.991,5.063-5.466,7.076a23.312,23.312,0,0,1-2.627,1.271Z"
              transform="translate(114.819 208.944)"
              fill="#fff"
              opacity="0.5"
            />
            <path
              id="Path_1967"
              data-name="Path 1967"
              d="M121.889,180.665c5.466,3.135,5.487,8.241,0,11.377a21.652,21.652,0,0,1-19.66,0c-5.466-3.157-5.487-8.262,0-11.419A21.694,21.694,0,0,1,121.889,180.665Z"
              transform="translate(109.775 199.368)"
              fill="#21749e"
            />
            <path
              id="Path_1968"
              data-name="Path 1968"
              d="M98.15,189.407a13.919,13.919,0,1,0,13.94-13.877A13.919,13.919,0,0,0,98.15,189.407Z"
              transform="translate(109.807 196.283)"
              fill="#fff"
            />
            <path
              id="Path_1969"
              data-name="Path 1969"
              d="M125.978,182.144v10.19a6.907,6.907,0,0,1-4.046,5.657,21.631,21.631,0,0,1-19.682,0,7.012,7.012,0,0,1-4.11-5.741V182.08a6.928,6.928,0,0,0,4.11,5.741,21.652,21.652,0,0,0,19.66,0,6.864,6.864,0,0,0,4.068-5.678Z"
              transform="translate(109.796 203.61)"
              fill="#c6c6c6"
            />
            <path
              id="Path_1970"
              data-name="Path 1970"
              d="M111.712,181.89c0,4.237-9.152,4.47-9.152,0V171.7h9.152Z"
              transform="translate(114.74 191.999)"
              fill="#dadada"
            />
            <path
              id="Path_1971"
              data-name="Path 1971"
              d="M117.011,175.62c0,3.157-3.6,5.72-8.051,5.72s-8.051-2.563-8.051-5.72,3.623-5.72,8.051-5.72S117.011,172.464,117.011,175.62Z"
              transform="translate(112.895 189.985)"
              fill="#fff"
            />
            <path
              id="Path_1972"
              data-name="Path 1972"
              d="M109.587,173.429c0,1.144-1.419,2.119-3.2,2.119s-3.178-.911-3.178-2.119,1.419-2.119,3.178-2.119S109.587,172.285,109.587,173.429Z"
              transform="translate(115.467 191.563)"
              fill="#3c3c3b"
            />
            <path
              id="Path_1973"
              data-name="Path 1973"
              d="M113.734,212.27,101.87,232.142l8.008-.148-7.118,17.055L121,226.359l-10.381,1.78,12.9-13.5L113.437,218.8Z"
              transform="translate(113.969 237.379)"
              fill="#fff"
            />
            <g
              id="Group_45"
              data-name="Group 45"
              transform="translate(375.955 560.655)"
              opacity="0.15"
            >
              <path
                id="Path_1974"
                data-name="Path 1974"
                d="M334.8,277l.36-2.013c-.636-.572-1.907-2.754-2.8-2.987-1.928-.53-2.246-2.246-5.424-1.25.275-1.822-1.038-3.6-3.6-4.788a13.089,13.089,0,0,0-2.754-.953c-4.83-1.165-11.737.763-14.152,3.475-1.652,1.907.148,4.555,1.589,5.974L290.9,284.8a1.459,1.459,0,0,0-.508.106c-4.428,1.5-15.169,3.517-31.122,5.127-10.953,1.1-43.155-3.03-62.731,6.991a60.21,60.21,0,0,0-14.7,9.957c-.784.763-15.868,21.376,14.83,41.1,20,12.711,38.389,23.559,68.239,21.186,9.428-.763,37.266-59.32,38.558-61.439a106.5,106.5,0,0,1,18.877-23.792c4.364,0,6.673.572,10.783-2.119C336.283,279.949,336.41,278.4,334.8,277Z"
                transform="translate(-177.447 -264.666)"
              />
            </g>
            <path
              id="Path_1975"
              data-name="Path 1975"
              d="M263.61,277.846l-.932.593-5.042,3.157L249.48,286.7l-7.161,4.513L240.9,289.54l-7.669-9.046,2.458-1.525,16.822-10.55,3.686-2.288Z"
              transform="translate(260.905 297.626)"
              fill="#f0d8af"
            />
            <path
              id="Path_1976"
              data-name="Path 1976"
              d="M298.522,282.389a140.292,140.292,0,0,0-8.178,12.415c-9.322,16.271-7.013,27.965-15.635,45.952-5.106,8.644-11.8,17.288-22.923,21.97-.233,0-2.288.381-2.542.4-17.266,1.653-33.9-3.347-45.041-13.474a42.541,42.541,0,0,1-11.673-17.2c-4.894-13.516-5.657-31.313,8.2-45.422a55.971,55.971,0,0,1,15-10.593c18.474-9.343,36.016-5.127,44.257-3.623,12.076,2.225,20.635,2.288,24.47,1.314a.529.529,0,0,1,.4,0,.657.657,0,0,1,.254,1.017.932.932,0,0,0,.8,1.568l4.385-.551a.657.657,0,0,1,.636,1l-2.119,3.432a.932.932,0,0,0,.869,1.441h1.292l7.14-.487a.657.657,0,0,1,.636.4.636.636,0,0,1-.233.445Z"
              transform="translate(211.777 302.574)"
              fill="#634e42"
            />
            <path
              id="Path_1977"
              data-name="Path 1977"
              d="M261.341,286.551c-4.131,2.754-10.593,1.568-13.771.381-1.123-.4-2.119-.932-3.241-1.229a5.974,5.974,0,0,0-1.843-.254c-.212-4.025,1.949-6.356.339-10.084a8.474,8.474,0,0,1-.381-1.61c-.381-2.521-.466-7.013,1.589-9.343,2.945-3.369,8.728-4.237,11.631-1.144a9.641,9.641,0,0,1,1.547,2.119,10.19,10.19,0,0,1,.36,8.22,6.1,6.1,0,0,1,5.911,2.458,5.423,5.423,0,0,1,1.123,2.521A7.563,7.563,0,0,1,261.341,286.551Z"
              transform="translate(270.97 292.289)"
              fill="#f0d8af"
            />
            <path
              id="Path_1978"
              data-name="Path 1978"
              d="M251.766,355.319l-1.78.3h-.763c-25.253,2.415-49.024-9.406-56.714-30.677-4.894-13.517-5.657-31.313,8.2-45.422l.169-.148C234.352,262.377,274.372,344.493,251.766,355.319Z"
              transform="translate(211.755 309.854)"
              fill="#eab2b2"
            />
            <path
              id="Path_1979"
              data-name="Path 1979"
              d="M241.125,351.4c-22.415,0-41.016-11.4-47.371-29-3.39-9.385-6.928-27.287,7.267-42.011a17.86,17.86,0,0,1,7.818-1.843c18.008,0,38.283,27.669,43.706,51.46,2.415,10.593,1.144,18.326-3.369,20.8l-1.208.212H247.4A48.6,48.6,0,0,1,241.125,351.4Z"
              transform="translate(213.35 311.507)"
              fill="#ea4a49"
            />
            <path
              id="Path_1980"
              data-name="Path 1980"
              d="M203.515,292.595c-3.157,0-4.385,2.5-3.5,5.529.614,2.119,3.072,3.538,4.237,5.424a9.555,9.555,0,0,0,5.763,4.809c3.708,1.017,4.237-2.712,4.385-5.339a9.957,9.957,0,0,0-3.369-8.474C208.514,292.446,206.481,292.573,203.515,292.595Z"
              transform="translate(223.44 327.219)"
              fill="#f0d8af"
            />
            <g
              id="Group_46"
              data-name="Group 46"
              transform="translate(410.317 596.191)"
              opacity="0.3"
            >
              <path
                id="Path_1981"
                data-name="Path 1981"
                d="M200.382,289.41c-1.08,2.119-2.733,3.813-3.708,5.953a13.961,13.961,0,0,0-.275,8.474c1.08,3.877,4.089,7.034,6.356,10.233a20.741,20.741,0,0,0,14.555,7.817,7.542,7.542,0,0,0,7.881-9.279,7.076,7.076,0,0,1-8.22,7.712,21.694,21.694,0,0,1-11.334-5.953,64.077,64.077,0,0,1-4.576-5.8,16.948,16.948,0,0,1-3.538-6.356,12.352,12.352,0,0,1,.212-7.118C198.6,293.118,199.81,291.423,200.382,289.41Z"
                transform="translate(-191.201 -272.524)"
                fill="#fff"
              />
              <path
                id="Path_1982"
                data-name="Path 1982"
                d="M225.894,316.489a22.928,22.928,0,0,0-.911-4.47,29.875,29.875,0,0,0-1.441-3.517,18.769,18.769,0,0,1-.7-3.919c-.191-1.4-.424-2.8-.72-4.237a13.178,13.178,0,0,0-8.093-9.089c-4.131-1.758-10.19-2.458-13.94.572a14.364,14.364,0,0,1,10.974-.233,16.779,16.779,0,0,1,7.479,5.254,13.432,13.432,0,0,1,2.119,6.525,45.427,45.427,0,0,0,.869,5.127c.445,1.631,1.419,3.093,1.928,4.724,1.08,3.517,1.4,7.076-1.25,9.957a7.521,7.521,0,0,1-4.7,2.119c-1.038.148-2.691.4-3.58-.339a2.5,2.5,0,0,0,1.462.7,8.728,8.728,0,0,0,7.606-1.61A8.962,8.962,0,0,0,225.894,316.489Z"
                transform="translate(-186.482 -272.147)"
                fill="#fff"
              />
              <path
                id="Path_1983"
                data-name="Path 1983"
                d="M242.592,323.853c-.932-3.835-3.538-7.012-5.233-10.487a59.808,59.808,0,0,1-3.453-12.394,19.533,19.533,0,0,0-10-12.5,30.826,30.826,0,0,0-17.415-3.326c-5.233.424-12.224,2.458-12.711,8.6-.254,2.881,0,5.89,0,8.771v5.127c.339-4.237.487-8.474.847-12.711a7.118,7.118,0,0,1,4.237-6.356,21.82,21.82,0,0,1,7.224-1.8c9.83-.974,22.669,3.178,25.7,13.665a125.129,125.129,0,0,0,3.538,12.711,27.539,27.539,0,0,0,1.949,3.771,28.978,28.978,0,0,1,3.75,6.949,30.125,30.125,0,0,1,1.144,7.775c0,2.648-.551,5.72-3.135,7.055a13.771,13.771,0,0,1-7.9.741,16.271,16.271,0,0,1-6.1-2.352h0a15.742,15.742,0,0,0,6.356,2.86,13.537,13.537,0,0,0,8.093-.551C244.88,336.818,243.736,328.492,242.592,323.853Z"
                transform="translate(-193.667 -277.476)"
                fill="#fff"
              />
              <path
                id="Path_1984"
                data-name="Path 1984"
                d="M205.839,310.544c-2.225-2.119-4.64-4-6.716-6.356a42.9,42.9,0,0,1-2.881-3.3,6.356,6.356,0,0,1-1.462-2.733,6.356,6.356,0,0,0,1.038,3.559,27.736,27.736,0,0,0,2.627,4,58.991,58.991,0,0,0,6.5,6.716c4,3.813,8.474,8.665,14.364,8.75C213.614,319.59,210.076,314.548,205.839,310.544Z"
                transform="translate(-192.422 -262.748)"
                fill="#fff"
              />
              <path
                id="Path_1985"
                data-name="Path 1985"
                d="M199.024,284.745a29.386,29.386,0,0,1,4.64-1.059,24.637,24.637,0,0,1,8.178.3c4.513,1.525,8.326,4.724,12.267,7.5-3.072-4.11-7.288-8.474-12.478-9.576a17.392,17.392,0,0,0-8.665.169,28.938,28.938,0,0,0-4.915,1.949,6.356,6.356,0,0,0-3.2,2.754,8.241,8.241,0,0,1,4.174-2.034Z"
                transform="translate(-192.343 -281.44)"
                fill="#fff"
              />
            </g>
            <path
              id="Path_1986"
              data-name="Path 1986"
              d="M312.671,277.3c-4.131,2.754-10.593,1.568-13.771.381l-8.157,5.106a.635.635,0,0,1,0,.636,140.259,140.259,0,0,0-8.262,12.415c-9.322,16.271-7.013,27.965-15.635,45.952-5.106,8.644-11.8,17.288-22.923,21.97-.233,0-2.288.381-2.542.4-17.266,1.652-33.9-3.347-45.041-13.474,19.194,8.474,37.266,8.6,54.193,0,15.826-17.944,23.431-37.965,16.822-61.545l5.042,7.839c4.576-1.716,7.839-5.487,9.809-11.271.3-.869.572-1.78.805-2.754,3.072-.339,8.686-3.517,12.711-6.356a16.717,16.717,0,0,0,4.682-4.237,14.148,14.148,0,0,0,3.6,2.352c6.186,2.754,12.118-.636,11.991-5.085A7.542,7.542,0,0,1,312.671,277.3Z"
              transform="translate(219.64 301.541)"
              opacity="0.2"
            />
            <path
              id="Path_1987"
              data-name="Path 1987"
              d="M251.327,271.509l-3.517.466c3.03-1.758,4.046-4.7,3.157-8.665a10.148,10.148,0,0,1,.36,8.2Z"
              transform="translate(277.214 294.471)"
              opacity="0.2"
            />
            <path
              id="Path_1988"
              data-name="Path 1988"
              d="M152.582,261.068a13.284,13.284,0,0,0-5.106-4.555c-8.178-4.724-22.584-7.267-28.728-3.729s-1.737,11.864,6.356,16.589l-1.674.975a16.016,16.016,0,0,0-4.11-3.22c-8.178-4.724-22.584-7.267-28.728-3.708s-1.737,11.864,6.356,16.588a25.168,25.168,0,0,0,5.551,2.373l-5.36,3.093,12.372,11.059,50.168-28.961Z"
              transform="translate(98.129 280.845)"
              fill="#1d1d1b"
              opacity="0.15"
            />
            <path
              id="Path_1989"
              data-name="Path 1989"
              d="M241.624,304.9a2.775,2.775,0,0,1,0,5.275l-40.253,23.3a10.063,10.063,0,0,1-9.131,0L100.8,280.769a2.8,2.8,0,0,1,0-5.3l40.253-23.3a10.063,10.063,0,0,1,9.131,0Z"
              transform="translate(110.651 280.784)"
              fill="#fff"
            />
            <path
              id="Path_1990"
              data-name="Path 1990"
              d="M245.5,302.681l-.953-9.491a3.093,3.093,0,0,1-1.885,2.839l-40.253,23.3a10.063,10.063,0,0,1-9.131,0l-91.459-52.71a3.135,3.135,0,0,1-1.886-2.9L98,280.986a3.962,3.962,0,0,0,2.415,3.707l91.459,52.795a12.86,12.86,0,0,0,11.695,0l40.253-23.3a3.9,3.9,0,0,0,2.373-3.644C246.025,307.871,245.75,305.265,245.5,302.681Z"
              transform="translate(109.639 294.93)"
              fill="#c6c6c6"
            />
            <path
              id="Path_1991"
              data-name="Path 1991"
              d="M127.151,270.827c0,9.428-5.763,13.9-12.881,13.9s-12.86-4.47-12.86-13.9,5.763-20.317,12.86-20.317S127.151,261.378,127.151,270.827Z"
              transform="translate(113.454 280.154)"
              fill="#f0d8af"
            />
            <path
              id="Path_1992"
              data-name="Path 1992"
              d="M104.482,254.23a27.542,27.542,0,0,0-1.864,9.724c0,9.449,5.763,13.9,12.86,13.9a12.076,12.076,0,0,0,10.868-5.678,11.906,11.906,0,0,1-12.076,8.474c-7.1,0-12.86-4.47-12.86-13.9A27.944,27.944,0,0,1,104.482,254.23Z"
              transform="translate(113.454 284.315)"
              opacity="0.1"
            />
            <path
              id="Path_1993"
              data-name="Path 1993"
              d="M112.67,257.234c-1.5.593-2.288-1.271-3.2-2.246s-1.419-2.8-.424-3.114C111.462,251.069,115,256.344,112.67,257.234Z"
              transform="translate(121.388 281.586)"
              fill="#fff"
            />
            <path
              id="Path_1994"
              data-name="Path 1994"
              d="M138.591,263.616c0,9.449-5.763,13.919-12.881,13.919s-12.86-4.47-12.86-13.919,5.763-20.3,12.86-20.3S138.591,254.167,138.591,263.616Z"
              transform="translate(126.25 272.111)"
              fill="#e3cca5"
            />
            <path
              id="Path_1995"
              data-name="Path 1995"
              d="M115.962,247a27.542,27.542,0,0,0-1.864,9.724c0,9.449,5.763,13.9,12.86,13.9a12.076,12.076,0,0,0,10.868-5.678,11.907,11.907,0,0,1-12.076,8.474c-7.1,0-12.86-4.47-12.86-13.919a27.923,27.923,0,0,1,3.072-12.5Z"
              transform="translate(126.295 276.228)"
              opacity="0.1"
            />
            <path
              id="Path_1996"
              data-name="Path 1996"
              d="M124.2,250.053c-1.5.593-2.288-1.271-3.2-2.267s-1.419-2.775-.424-3.114C122.887,243.888,126.425,249.163,124.2,250.053Z"
              transform="translate(134.285 273.535)"
              fill="#fff"
            />
            <path
              id="Path_1997"
              data-name="Path 1997"
              d="M147.921,269.1c0,9.428-5.763,13.9-12.86,13.9s-12.881-4.47-12.881-13.9,5.763-20.317,12.881-20.317S147.921,259.648,147.921,269.1Z"
              transform="translate(136.687 278.219)"
              fill="#e3cca5"
            />
            <path
              id="Path_1998"
              data-name="Path 1998"
              d="M125.2,252.5a27.543,27.543,0,0,0-1.864,9.724c0,9.449,5.763,13.9,12.86,13.9a12.076,12.076,0,0,0,10.974-5.614,11.906,11.906,0,0,1-12.055,8.474c-7.118,0-12.881-4.47-12.881-13.9A27.944,27.944,0,0,1,125.2,252.5Z"
              transform="translate(136.743 282.38)"
              opacity="0.1"
            />
            <path
              id="Path_1999"
              data-name="Path 1999"
              d="M133.459,255.5c-1.525.593-2.309-1.271-3.22-2.246s-1.419-2.8-.4-3.114C132.23,249.339,135.768,254.614,133.459,255.5Z"
              transform="translate(144.624 279.651)"
              fill="#fff"
            />
            <path
              id="Path_2000"
              data-name="Path 2000"
              d="M157.211,274.557c0,9.449-5.763,13.9-12.86,13.9s-12.881-4.449-12.881-13.9,5.763-20.317,12.881-20.317S157.211,265.108,157.211,274.557Z"
              transform="translate(147.078 284.326)"
              fill="#e3cca5"
            />
            <path
              id="Path_2001"
              data-name="Path 2001"
              d="M134.542,258a28.092,28.092,0,0,0-1.864,9.724c0,9.449,5.763,13.9,12.86,13.9a12.076,12.076,0,0,0,10.868-5.678,11.907,11.907,0,0,1-12.055,8.474c-7.118,0-12.881-4.449-12.881-13.9A28.028,28.028,0,0,1,134.542,258Z"
              transform="translate(147.078 288.532)"
              opacity="0.1"
            />
            <path
              id="Path_2002"
              data-name="Path 2002"
              d="M142.749,260.985c-1.525.572-2.309-1.292-3.22-2.267s-1.419-2.8-.4-3.114C141.6,254.8,145.058,260.074,142.749,260.985Z"
              transform="translate(155.015 285.759)"
              fill="#fff"
            />
            <path
              id="Path_2003"
              data-name="Path 2003"
              d="M166.5,280.017c0,9.449-5.763,13.9-12.86,13.9s-12.881-4.449-12.881-13.9,5.763-20.317,12.881-20.317S166.5,270.568,166.5,280.017Z"
              transform="translate(157.47 290.434)"
              fill="#e3cca5"
            />
            <path
              id="Path_2004"
              data-name="Path 2004"
              d="M143.832,263.42a28.092,28.092,0,0,0-1.864,9.724c0,9.449,5.763,13.919,12.86,13.919a12.1,12.1,0,0,0,10.868-5.7,11.885,11.885,0,0,1-12.055,8.474c-7.118,0-12.881-4.449-12.881-13.9a28.029,28.029,0,0,1,3.072-12.521Z"
              transform="translate(157.47 294.595)"
              opacity="0.1"
            />
            <path
              id="Path_2005"
              data-name="Path 2005"
              d="M152.034,266.445c-1.525.572-2.309-1.292-3.22-2.267s-1.4-2.775-.4-3.114C150.826,260.259,154.343,265.534,152.034,266.445Z"
              transform="translate(165.412 291.866)"
              fill="#fff"
            />
            <path
              id="Path_2006"
              data-name="Path 2006"
              d="M175.78,285.477c0,9.449-5.763,13.9-12.86,13.9s-12.86-4.449-12.86-13.9,5.763-20.317,12.86-20.317S175.78,276.028,175.78,285.477Z"
              transform="translate(167.873 296.541)"
              fill="#e3cca5"
            />
            <path
              id="Path_2007"
              data-name="Path 2007"
              d="M153.132,268.89a27.541,27.541,0,0,0-1.886,9.7c0,9.449,5.763,13.919,12.881,13.919a12.076,12.076,0,0,0,10.847-5.7,11.864,11.864,0,0,1-12.055,8.474c-7.1,0-12.86-4.449-12.86-13.9a27.541,27.541,0,0,1,3.072-12.5Z"
              transform="translate(167.873 300.713)"
              opacity="0.1"
            />
            <path
              id="Path_2008"
              data-name="Path 2008"
              d="M161.324,271.881c-1.5.593-2.309-1.292-3.22-2.267s-1.4-2.775-.4-3.114C160.116,265.737,163.633,271.012,161.324,271.881Z"
              transform="translate(175.803 297.955)"
              fill="#fff"
            />
            <path
              id="Path_2009"
              data-name="Path 2009"
              d="M136.441,276.287c0,9.449-5.763,13.9-12.86,13.9s-12.881-4.449-12.881-13.9,5.763-20.317,12.881-20.317S136.441,266.838,136.441,276.287Z"
              transform="translate(123.846 286.261)"
              fill="#f0d8af"
            />
            <path
              id="Path_2010"
              data-name="Path 2010"
              d="M113.772,259.69a28.093,28.093,0,0,0-1.864,9.724c0,9.449,5.763,13.9,12.86,13.9a12.076,12.076,0,0,0,10.868-5.678,11.907,11.907,0,0,1-12.055,8.474c-7.118,0-12.881-4.449-12.881-13.9A28.028,28.028,0,0,1,113.772,259.69Z"
              transform="translate(123.846 290.422)"
              opacity="0.1"
            />
            <path
              id="Path_2011"
              data-name="Path 2011"
              d="M121.979,262.715c-1.525.572-2.309-1.292-3.22-2.267s-1.419-2.8-.4-3.114C120.771,256.529,124.288,261.8,121.979,262.715Z"
              transform="translate(131.782 287.694)"
              fill="#fff"
            />
            <path
              id="Path_2012"
              data-name="Path 2012"
              d="M145.72,281.727c0,9.449-5.763,13.9-12.86,13.9S120,291.218,120,281.727s5.763-20.317,12.881-20.317S145.72,272.321,145.72,281.727Z"
              transform="translate(134.248 292.346)"
              fill="#f0d8af"
            />
            <path
              id="Path_2013"
              data-name="Path 2013"
              d="M123.062,265.15a28.092,28.092,0,0,0-1.864,9.724c0,9.449,5.763,13.919,12.86,13.919a12.1,12.1,0,0,0,10.868-5.7,11.885,11.885,0,0,1-12.055,8.474c-7.118,0-12.881-4.449-12.881-13.9a28.028,28.028,0,0,1,3.072-12.521Z"
              transform="translate(134.237 296.53)"
              opacity="0.1"
            />
            <path
              id="Path_2014"
              data-name="Path 2014"
              d="M131.264,268.175c-1.525.572-2.309-1.292-3.22-2.267s-1.4-2.775-.4-3.114C130.056,261.989,133.573,267.264,131.264,268.175Z"
              transform="translate(142.179 293.801)"
              fill="#fff"
            />
            <path
              id="Path_2015"
              data-name="Path 2015"
              d="M155.01,287.207c0,9.449-5.763,13.9-12.86,13.9s-12.86-4.449-12.86-13.9,5.741-20.317,12.86-20.317S155.01,277.716,155.01,287.207Z"
              transform="translate(144.64 298.476)"
              fill="#f0d8af"
            />
            <path
              id="Path_2016"
              data-name="Path 2016"
              d="M132.341,270.62a27.881,27.881,0,0,0-1.864,9.7c0,9.449,5.763,13.919,12.881,13.919a12.076,12.076,0,0,0,10.847-5.7,11.885,11.885,0,0,1-12.055,8.474c-7.118,0-12.86-4.449-12.86-13.9a27.838,27.838,0,0,1,3.051-12.5Z"
              transform="translate(144.64 302.648)"
              opacity="0.1"
            />
            <path
              id="Path_2017"
              data-name="Path 2017"
              d="M140.554,273.635c-1.5.593-2.309-1.292-3.22-2.267s-1.4-2.775-.4-3.114C139.346,267.449,142.863,272.724,140.554,273.635Z"
              transform="translate(152.57 299.909)"
              fill="#fff"
            />
            <path
              id="Path_2018"
              data-name="Path 2018"
              d="M164.3,292.656c0,9.449-5.763,13.9-12.86,13.9s-12.86-4.449-12.86-13.9,5.763-20.3,12.86-20.3S164.3,283.207,164.3,292.656Z"
              transform="translate(155.031 304.595)"
              fill="#f0d8af"
            />
            <path
              id="Path_2019"
              data-name="Path 2019"
              d="M141.622,276.08a27.541,27.541,0,0,0-1.885,9.724c0,9.428,5.763,13.9,12.881,13.9a12.076,12.076,0,0,0,10.847-5.7,11.864,11.864,0,0,1-12.055,8.474c-7.1,0-12.86-4.449-12.86-13.9a27.649,27.649,0,0,1,3.072-12.5Z"
              transform="translate(154.998 308.756)"
              opacity="0.1"
            />
            <path
              id="Path_2020"
              data-name="Path 2020"
              d="M149.847,279.1c-1.5.593-2.288-1.292-3.22-2.267s-1.4-2.775-.4-3.114C148.639,272.909,152.156,278.184,149.847,279.1Z"
              transform="translate(162.959 306.016)"
              fill="#fff"
            />
            <g
              id="Group_47"
              data-name="Group 47"
              transform="translate(517.63 533.693)"
              opacity="0.15"
            >
              <path
                id="Path_2021"
                data-name="Path 2021"
                d="M366.668,276.685c1.631-.593,3.284-1.229,5.042-1.949a87.837,87.837,0,0,1-10.4-.826c-.678-5.233-4.724-9.364-11.61-11.8h-.191l-1.377-.466h-.212a25.423,25.423,0,0,1-12.987-9.512l-2.585-.191-4.83,1.716c2.987,3.474,6.758,7.415,3.94,12.1a10.042,10.042,0,0,0-2.839,2.563,48.332,48.332,0,0,1-4.237,6.229,18.9,18.9,0,0,1-3.5-1.123l-3.729-.318a6.949,6.949,0,0,0,1.822,7.33,82.623,82.623,0,0,1-7.245,6.207c-5.89,2.309-9.555,4.852-11.017,7.415a204.908,204.908,0,0,1-52.053,20.465c-1.441.381-2.881.763-4.343,1.1l2.733,3.22,2.246.106h.53a128.959,128.959,0,0,0,29.088-2.119c-4.089,1.822-8.368,3.58-12.86,5.212-1.4.53-2.839,1.038-4.237,1.525l4.6,2.881a20.931,20.931,0,0,0,2.542-.106h.614a136.836,136.836,0,0,0,52.159-13.156c3.072-1.525,5.932-3.051,8.623-4.555a89.722,89.722,0,0,0,27.542-5.085c18.622-6.695,26.885-16.419,16.165-23.114-.805-.53-1.652-1-2.5-1.441A39.841,39.841,0,0,0,366.668,276.685Zm-45.931-2.246a17.54,17.54,0,0,0,2.987.847c-.763.911-1.547,1.822-2.394,2.712a8.093,8.093,0,0,1-.593-3.559Z"
                transform="translate(-244.32 -251.94)"
                fill="#1d1d1b"
              />
            </g>
            <path
              id="Path_2022"
              data-name="Path 2022"
              d="M316.786,272.191a.868.868,0,0,1,0,.233l-2.373-1.314-7.733-4.237c5.953-5.89,7.415-14.406,8.9-21.673h4.491l1.314,1.822a55.464,55.464,0,0,0-4.64,23.58Z"
              transform="translate(343.064 274.214)"
              fill="#b68225"
            />
            <path
              id="Path_2023"
              data-name="Path 2023"
              d="M298.639,310.449c-16.5,0-28.664-6.779-36.545-16.25a1.592,1.592,0,0,1-.3-.36c-.424-.487-.8-.975-1.186-1.483l1.4-6.737c1.144.275,2.331.53,3.5.742a95.717,95.717,0,0,0,88.747-27.9A12.5,12.5,0,0,1,358.234,256c3.919-1.949,6.356-1.356,8.728,1.78a16.337,16.337,0,0,1,1.229,1.949l.106.148v1.483a.3.3,0,0,1,0,.233C368.467,284.094,341.752,310.216,298.639,310.449Z"
              transform="translate(291.531 285.043)"
              fill="#e3a22e"
            />
            <path
              id="Path_2024"
              data-name="Path 2024"
              d="M266.373,271.89l-1,4.767-3.284,1.313c-.53-.593-1.017-1.208-1.483-1.843l1.4-6.737c1.144.275,2.331.53,3.5.742Z"
              transform="translate(291.531 301.273)"
              fill="#1d1d1b"
              opacity="0.75"
            />
            <path
              id="Path_2025"
              data-name="Path 2025"
              d="M262.13,287.657c12.9,14.173,34.66,15.72,52.032,10.762a86.355,86.355,0,0,0,31.779-15.847c8.474-6.991,14.067-16.694,19.258-26.313a75.611,75.611,0,0,1-16.207,27.1c-9.216,9.6-21.546,14.639-33.9,18.283a61.437,61.437,0,0,1-24.512,1.928C280.011,302.085,268.486,296.81,262.13,287.657Z"
              transform="translate(293.232 286.586)"
              fill="#1d1d1b"
              opacity="0.3"
            />
            <path
              id="Path_2026"
              data-name="Path 2026"
              d="M367.692,271.439c.148,22.5-26.567,48.727-69.68,48.854-16.5,0-28.664-6.78-36.545-16.25a1.591,1.591,0,0,1-.3-.36l3.877-2.691c10.911,10.741,25,14.83,42.033,12.5,16.271-2.733,30.02-8.178,39.109-16.949a67.011,67.011,0,0,0,19.067-26.334c.318-.826.678-1.652,1-2.479l.953-7.966,4.915-13.686a55.465,55.465,0,0,0-4.64,23.58l.106.148v1.483a.874.874,0,0,1,0,.233Z"
              transform="translate(292.158 275.198)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_2027"
              data-name="Path 2027"
              d="M319.508,271.387v.254l-2.818-.847-9.11-2.8a39.109,39.109,0,0,0,6.928-22.817h4.555L320.376,247c-2.119,9.195-2.881,16.271-1.271,22.732A10.4,10.4,0,0,0,319.508,271.387Z"
              transform="translate(344.071 274.192)"
              fill="#cc922a"
            />
            <path
              id="Path_2028"
              data-name="Path 2028"
              d="M306.795,326.167c-17.436,3.623-31.779-.869-42.244-8.983a2.94,2.94,0,0,1-.4-.318c-.551-.4-1.059-.847-1.568-1.292v-7.267h3.877c37.88-.339,73.578-24.554,87.857-47.88a30.127,30.127,0,0,1,3.686-3.39c3.707-2.839,6.5-2.754,9.618,0a19.56,19.56,0,0,1,1.737,1.758l.127.127a13.26,13.26,0,0,1,.36,1.525.381.381,0,0,1,0,.254C374.992,283.965,352.45,316.739,306.795,326.167Z"
              transform="translate(293.735 285.109)"
              fill="#f9b233"
            />
            <path
              id="Path_2029"
              data-name="Path 2029"
              d="M267.729,281.749v5.169l-3.2,2.119c-.678-.508-1.335-1.038-1.97-1.61V280.16h3.877Z"
              transform="translate(293.713 313.319)"
              fill="#1d1d1b"
              opacity="0.75"
            />
            <path
              id="Path_2030"
              data-name="Path 2030"
              d="M263.87,310.5c16.737,11.906,40.126,8.856,57.435,0a93.216,93.216,0,0,0,30.253-23.2c7.521-9.068,11.228-20.275,14.618-31.355a78.555,78.555,0,0,1-11.207,31.524c-7.669,11.885-19.618,19.745-31.906,26.143a67.052,67.052,0,0,1-25.529,7.246C285.946,321.6,272.62,318.618,263.87,310.5Z"
              transform="translate(295.178 286.239)"
              fill="#1d1d1b"
              opacity="0.3"
            />
            <path
              id="Path_2031"
              data-name="Path 2031"
              d="M369.079,270.7c5.085,23.3-17.5,56.015-63.112,65.443-17.436,3.623-31.779-.869-42.244-8.983a2.941,2.941,0,0,1-.4-.318l3.6-3.623c13.9,8.792,29.66,9.894,47.223,3.94,16.631-6.356,30.02-14.83,37.711-25.995a70.105,70.105,0,0,0,14.427-31.313c.169-.932.36-1.886.508-2.8l-.72-8.474L369.8,246.02c-2.119,9.195-2.881,16.271-1.271,22.732l.127.127a13.245,13.245,0,0,1,.36,1.525s0,.17,0,.254Z"
              transform="translate(294.563 275.131)"
              fill="#1d1d1b"
              opacity="0.1"
            />
            <path
              id="Path_2032"
              data-name="Path 2032"
              d="M284.8,292.355c0,16.949,13.728,27.732,30.656,27.732A30.74,30.74,0,0,0,336.3,312.1a29.66,29.66,0,0,0,9.809-22.224c0-16.949-11-27.542-30.656-22.054a36.235,36.235,0,0,0-7.246-2.119c-14.025-2.5-22.224,6.779-23.3,22.923Q284.8,290.406,284.8,292.355Z"
              transform="translate(318.59 296.697)"
              fill="#ea4a49"
            />
            <path
              id="Path_2033"
              data-name="Path 2033"
              d="M305.043,268.539c1.462,2.9,5.529,3.326,10.911,2.5-5,.89-9.618,4.428-14.152,8.474.636-4.64-2.119-8.707-6.631-11.652C299.45,267.8,302.479,270.721,305.043,268.539Z"
              transform="translate(330.189 299.56)"
              fill="#1d1d1b"
              opacity="0.2"
            />
            <path
              id="Path_2034"
              data-name="Path 2034"
              d="M284.86,288.616c25.148-4.47,26.376-15.889,23.3-22.923C294.118,263.193,285.919,272.473,284.86,288.616Z"
              transform="translate(318.657 296.685)"
              fill="#1d1d1b"
              opacity="0.2"
            />
            <path
              id="Path_2035"
              data-name="Path 2035"
              d="M308.5,262.278c3.962,1.25,13.622,26.525-25.423,23.58a49.763,49.763,0,0,0,8.474-13.474C294.16,266.749,302.359,260.329,308.5,262.278Z"
              transform="translate(316.666 292.919)"
              fill="#95c11f"
            />
            <path
              id="Path_2036"
              data-name="Path 2036"
              d="M315.673,285.607c1.907-10,.593-20.974-5.593-28.537l-1.886,2.648c-1.313,12.1-23.008,29.406-22.52,29s21.546-15.423,23.6-27.351a39.066,39.066,0,0,1,5.212,24.237Z"
              transform="translate(319.559 287.492)"
              fill="#634e42"
            />
            <path
              id="Path_2037"
              data-name="Path 2037"
              d="M315.105,281.717c-3.58,1-4.957-3.475-6.822-5.89s-2.606-6.674-.254-7.2C313.728,267.4,320.592,280.107,315.105,281.717Z"
              transform="translate(342.923 300.322)"
              fill="#fff"
            />
            <path
              id="Path_2038"
              data-name="Path 2038"
              d="M284.8,278.07c0,16.949,13.728,27.732,30.656,27.732a30.74,30.74,0,0,0,20.847-7.987C313.4,306.819,295.817,299.108,284.8,278.07Z"
              transform="translate(318.59 310.982)"
              fill="#1d1d1b"
              opacity="0.2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
